import { jsx as e, jsxs as O, Fragment as eI } from "@emotion/react/jsx-runtime";
import { useDisclosure as UI, useMediaQuery as yA } from "@mantine/hooks";
import Cb, { useEffect as II, useMemo as Rg, useState as nI, createContext as _g, forwardRef as Ab, useImperativeHandle as ti, lazy as cb, useRef as HI, Suspense as hA, useContext as bb, useCallback as Gi, useLayoutEffect as Zi, isValidElement as lb, cloneElement as ib, Fragment as nb } from "react";
import { N as Xi, I as di, L as eb } from "./LoginModal-09e35d85.mjs";
import { w as $A, x as UC, y as ai, z as JA, B as ub, D as Vi, E as si, F as mi, G as tb, J as Wi, K as oi, L as ri, N as yi, P as hi, Q as Ji, C as vg, T as vI, U as xi, V as Bi, W as xA, X as LC, Y as BA, Z as Ri, _ as VC, a as sI, e as bI, $ as vi, a0 as uA, a1 as Ni, a2 as Dg, a3 as pi, a4 as Fi, a5 as Yi, a6 as Gb, t as VI, a7 as fg, a8 as SC, a9 as Hi, aa as yI, ab as zi, ac as Ui, ad as Li, u as MI, ae as RA, af as Yg, ag as Ic, ah as ng, ai as Si, aj as ZI, ak as hI, S as E, al as fi, am as Zb, an as Ti, ao as ki, ap as wi, h as vA, aq as Xb, ar as db, as as Qi, at as Oi, au as Di, v as sC, av as ab, aw as Ei, ax as Pi, ay as ji, az as Mi, aA as Vb, aB as Ki, aC as sb, aD as mb, n as Wb, aE as ob, aF as _i, aG as gc } from "./StickyHeaderSkeleton-c9e3c21f.mjs";
import { keyframes as rb, css as CI } from "@emotion/react";
import { TextInput as qi, Button as mC, COLOR_PALETTE as P, Flex as NA, OptimizeImage as $i, Text as cI, Modal as qI, Icon as K, Stack as PI, Radio as qC, Group as BI, desktopFirstQuery as pA, Box as gI, Alert as yb, Popover as $C, ActionIcon as Hg, Menu as ZC, Indicator as eg, Avatar as fC, useShowNotification as hb, Divider as Jb, NavLink as xb, Ellipsis as Bb, Drawer as In, Anchor as Rb } from "@inflearn/ds-react";
import { useMutation as zg, useQuery as FA, useQueryClient as gn } from "@tanstack/react-query";
import { IsomorphicFetch as Cn } from "@inflearn/datasource-rest";
import { jsx as tA, Fragment as An } from "react/jsx-runtime";
import "react-hook-form";
import { ErrorBoundary as vb } from "react-error-boundary";
import IC from "dayjs";
import { useFeature as Nb } from "@hackler/react-sdk";
import { UnstyledButton as cn, Collapse as bn, Burger as ln } from "@mantine/core";
var nn = 1 / 0, Cc = $A ? $A.prototype : void 0, Ac = Cc ? Cc.toString : void 0;
function pb(I) {
  if (typeof I == "string")
    return I;
  if (UC(I))
    return ai(I, pb) + "";
  if (JA(I))
    return Ac ? Ac.call(I) : "";
  var g = I + "";
  return g == "0" && 1 / I == -nn ? "-0" : g;
}
var en = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, un = /^\w*$/;
function tn(I, g) {
  if (UC(I))
    return !1;
  var C = typeof I;
  return C == "number" || C == "symbol" || C == "boolean" || I == null || JA(I) ? !0 : un.test(I) || !en.test(I) || g != null && I in Object(g);
}
var Gn = "Expected a function";
function YA(I, g) {
  if (typeof I != "function" || g != null && typeof g != "function")
    throw new TypeError(Gn);
  var C = function() {
    var A = arguments, c = g ? g.apply(this, A) : A[0], b = C.cache;
    if (b.has(c))
      return b.get(c);
    var l = I.apply(this, A);
    return C.cache = b.set(c, l) || b, l;
  };
  return C.cache = new (YA.Cache || ub)(), C;
}
YA.Cache = ub;
var Zn = 500;
function Xn(I) {
  var g = YA(I, function(A) {
    return C.size === Zn && C.clear(), A;
  }), C = g.cache;
  return g;
}
var dn = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, an = /\\(\\)?/g, Vn = Xn(function(I) {
  var g = [];
  return I.charCodeAt(0) === 46 && g.push(""), I.replace(dn, function(C, A, c, b) {
    g.push(c ? b.replace(an, "$1") : A || C);
  }), g;
});
const sn = Vn;
function mn(I) {
  return I == null ? "" : pb(I);
}
function Wn(I, g) {
  return UC(I) ? I : tn(I, g) ? [I] : sn(mn(I));
}
var on = 1 / 0;
function rn(I) {
  if (typeof I == "string" || JA(I))
    return I;
  var g = I + "";
  return g == "0" && 1 / I == -on ? "-0" : g;
}
function yn(I, g, C) {
  g = Wn(g, I);
  for (var A = -1, c = g.length, b = !1; ++A < c; ) {
    var l = rn(g[A]);
    if (!(b = I != null && C(I, l)))
      break;
    I = I[l];
  }
  return b || ++A != c ? b : (c = I == null ? 0 : I.length, !!c && Vi(c) && si(l, c) && (UC(I) || mi(I)));
}
var hn = Object.prototype, Jn = hn.hasOwnProperty;
function xn(I, g) {
  return I != null && Jn.call(I, g);
}
function og(I, g) {
  return I != null && yn(I, g, xn);
}
function IA(I) {
  return I == null;
}
function Fb(I) {
  const {
    setSnapshot: g
  } = tb(), C = I == null ? void 0 : I.options, A = Wi({
    options: {
      ...C,
      onSuccess: (c) => {
        var b, l, i, u;
        if ((b = C == null ? void 0 : C.onSuccess) == null || b.call(C, c), !c) {
          g({
            profile: void 0
          });
          return;
        }
        g({
          logo: (i = (l = c.data) == null ? void 0 : l.group) == null ? void 0 : i.logoUrl,
          profile: {
            thumbnail: (u = c == null ? void 0 : c.data) == null ? void 0 : u.thumbnail
          }
        });
      },
      onError: (c) => {
        var b;
        (b = C == null ? void 0 : C.onError) == null || b.call(C, c), g({
          profile: void 0
        });
      }
    }
  });
  return {
    ...A,
    data: A.data ? {
      ...A.data,
      isB2b: oi(A.data),
      isGroupManager: ri(A.data),
      isGroupUser: yi(A.data),
      isPartner: hi(A.data)
    } : null
  };
}
function Bn() {
  var l, i;
  const {
    data: I,
    isLoading: g
  } = Fb(), C = ((l = I == null ? void 0 : I.managedGroup) == null ? void 0 : l.id) || ((i = I == null ? void 0 : I.group) == null ? void 0 : i.id) || 0, {
    data: A,
    isInitialLoading: c
  } = Ji({
    queryKey: [vI.V1_GROUP_ID_NOTICE_EXPOSURE(String(C))],
    url: vI.V1_GROUP_ID_NOTICE_EXPOSURE(String(C)),
    options: {
      suspense: !1,
      useErrorBoundary: !1,
      enabled: !!C
    }
  }), b = vg.get("checked_gr_noti_id");
  return {
    isShowGroupNotice: (I == null ? void 0 : I.isB2b) && !b && !!(A != null && A.hasNotice),
    groupNotice: A,
    isLoadingForGroupNotice: c || g
  };
}
function CX() {
  const {
    isShowGroupNotice: I,
    groupNotice: g
  } = Bn(), [C, A] = UI(!1);
  return II(() => {
    I && A.open();
  }, [I]), /* @__PURE__ */ e(Rn, { id: g == null ? void 0 : g.id, body: g == null ? void 0 : g.body, title: g == null ? void 0 : g.title, isOpened: C, onClose: A.close });
}
function Rn({
  isOpened: I,
  id: g,
  title: C,
  body: A,
  onClose: c
}) {
  return IA(g) || IA(C) || IA(A) ? null : /* @__PURE__ */ e(Xi, { id: g, isOpened: I, title: C, body: A, onClose: c });
}
function cc(I, g) {
  var C = Object.keys(I);
  if (Object.getOwnPropertySymbols) {
    var A = Object.getOwnPropertySymbols(I);
    g && (A = A.filter(function(c) {
      return Object.getOwnPropertyDescriptor(I, c).enumerable;
    })), C.push.apply(C, A);
  }
  return C;
}
function gC(I) {
  for (var g = 1; g < arguments.length; g++) {
    var C = arguments[g] != null ? arguments[g] : {};
    g % 2 ? cc(Object(C), !0).forEach(function(A) {
      vn(I, A, C[A]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(I, Object.getOwnPropertyDescriptors(C)) : cc(Object(C)).forEach(function(A) {
      Object.defineProperty(I, A, Object.getOwnPropertyDescriptor(C, A));
    });
  }
  return I;
}
function vn(I, g, C) {
  return g in I ? Object.defineProperty(I, g, { value: C, enumerable: !0, configurable: !0, writable: !0 }) : I[g] = C, I;
}
var Nn = {
  debug: !1,
  containerId: null,
  dataLayerName: "dataLayer",
  dataLayer: void 0,
  preview: void 0,
  auth: void 0,
  execution: "async"
  // assumesPageview: true,
}, CC;
function pn() {
  var I = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, g = "https://www.googletagmanager.com/gtm.js";
  return {
    name: "google-tag-manager",
    config: gC(gC({}, Nn), I),
    initialize: function(A) {
      var c = A.config, b = c.containerId, l = c.dataLayerName, i = c.customScriptSrc, u = c.preview, n = c.auth, t = c.execution;
      if (!b)
        throw new Error("No google tag manager containerId defined");
      if (u && !n)
        throw new Error("When enabling preview mode, both preview and auth parameters must be defined");
      var X = i || g;
      lc(b, X) || (function(y, s, B, m, x) {
        y[m] = y[m] || [], y[m].push({
          "gtm.start": (/* @__PURE__ */ new Date()).getTime(),
          event: "gtm.js"
        });
        var v = s.getElementsByTagName(B)[0], G = s.createElement(B), V = m != "dataLayer" ? "&l=" + m : "", d = u ? "&gtm_preview=" + u + "&gtm_auth=" + n + "&gtm_cookies_win=x" : "";
        t && (G[t] = !0), G.src = "".concat(X, "?id=") + x + V + d, v.parentNode.insertBefore(G, v);
      }(window, document, "script", l, b), CC = l, c.dataLayer = window[l]);
    },
    page: function(A) {
      var c = A.payload;
      A.options, A.instance;
      var b = A.config;
      typeof b.dataLayer < "u" && b.dataLayer.push(c.properties);
    },
    track: function(A) {
      var c = A.payload;
      A.options;
      var b = A.config;
      if (typeof b.dataLayer < "u") {
        var l = c.anonymousId, i = c.userId, u = c.properties, n = u;
        i && (n.userId = i), l && (n.anonymousId = l), u.category || (n.category = "All"), b.debug && console.log("dataLayer push", gC({
          event: c.event
        }, n)), b.dataLayer.push(gC({
          event: c.event
        }, n));
      }
    },
    loaded: function() {
      var A = !!CC && !!(window[CC] && Array.prototype.push !== window[CC].push);
      return lc(I.containerId, I.customScriptSrc || g) && A;
    }
  };
}
var bc = {};
function lc(I, g) {
  var C = bc[I];
  if (!C) {
    var A = g.replace(/^https?:\/\//, "").replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    C = new RegExp(A + ".*[?&]id=" + I), bc[I] = C;
  }
  var c = document.querySelectorAll("script[src]");
  return !!Object.keys(c).filter(function(b) {
    return (c[b].src || "").match(C);
  }).length;
}
var AX = pn;
function ic(I, g, C, A, c) {
  for (g = g.split ? g.split(".") : g, A = 0; A < g.length; A++)
    I = I ? I[g[A]] : c;
  return I === c ? C : I;
}
var AC = "undefined", nc = "object", Yb = "any", Hb = "*", cg = "__", WC = typeof process < "u" ? process : {};
WC.env && WC.env.NODE_ENV;
var oI = typeof document < "u";
WC.versions != null && WC.versions.node != null;
typeof Deno < "u" && Deno.core;
oI && window.name === "nodejs" || typeof navigator < "u" && navigator.userAgent !== void 0 && (navigator.userAgent.includes("Node.js") || navigator.userAgent.includes("jsdom"));
function zb(I, g) {
  return g.charAt(0)[I]() + g.slice(1);
}
var Fn = zb.bind(null, "toUpperCase"), Yn = zb.bind(null, "toLowerCase");
function Hn(I) {
  return Ub(I) ? Fn("null") : typeof I == "object" ? fn(I) : Object.prototype.toString.call(I).slice(8, -1);
}
function oC(I, g) {
  g === void 0 && (g = !0);
  var C = Hn(I);
  return g ? Yn(C) : C;
}
function qg(I, g) {
  return typeof g === I;
}
var xI = qg.bind(null, "function"), rg = qg.bind(null, "string"), Vg = qg.bind(null, "undefined"), zn = qg.bind(null, "boolean");
qg.bind(null, "symbol");
function Ub(I) {
  return I === null;
}
function Un(I) {
  return oC(I) === "number" && !isNaN(I);
}
function Ln(I) {
  return oC(I) === "array";
}
function tI(I) {
  if (!Sn(I))
    return !1;
  for (var g = I; Object.getPrototypeOf(g) !== null; )
    g = Object.getPrototypeOf(g);
  return Object.getPrototypeOf(I) === g;
}
function Sn(I) {
  return I && (typeof I == "object" || I !== null);
}
function fn(I) {
  return xI(I.constructor) ? I.constructor.name : null;
}
function Tn(I) {
  return I instanceof Error || rg(I.message) && I.constructor && Un(I.constructor.stackTraceLimit);
}
function Lb(I, g) {
  if (typeof g != "object" || Ub(g))
    return !1;
  if (g instanceof I)
    return !0;
  var C = oC(new I(""));
  if (Tn(g))
    for (; g; ) {
      if (oC(g) === C)
        return !0;
      g = Object.getPrototypeOf(g);
    }
  return !1;
}
Lb.bind(null, TypeError);
Lb.bind(null, SyntaxError);
function TC(I, g) {
  var C = I instanceof Element || I instanceof HTMLDocument;
  return C && g ? kn(I, g) : C;
}
function kn(I, g) {
  return g === void 0 && (g = ""), I && I.nodeName === g.toUpperCase();
}
function kC(I) {
  var g = [].slice.call(arguments, 1);
  return function() {
    return I.apply(void 0, [].slice.call(arguments).concat(g));
  };
}
kC(TC, "form");
kC(TC, "button");
kC(TC, "input");
kC(TC, "select");
function ec(I) {
  try {
    return decodeURIComponent(I.replace(/\+/g, " "));
  } catch {
    return null;
  }
}
function wn() {
  if (oI) {
    var I = navigator, g = I.languages;
    return I.userLanguage || (g && g.length ? g[0] : I.language);
  }
}
function Qn() {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone;
  } catch {
  }
}
function On(I) {
  return function(g) {
    for (var C, A = /* @__PURE__ */ Object.create(null), c = /([^&=]+)=?([^&]*)/g; C = c.exec(g); ) {
      var b = ec(C[1]), l = ec(C[2]);
      b.substring(b.length - 2) === "[]" ? (A[b = b.substring(0, b.length - 2)] || (A[b] = [])).push(l) : A[b] = l === "" || l;
    }
    for (var i in A) {
      var u = i.split("[");
      u.length > 1 && (Dn(A, u.map(function(n) {
        return n.replace(/[?[\]\\ ]/g, "");
      }), A[i]), delete A[i]);
    }
    return A;
  }(function(g) {
    if (g) {
      var C = g.match(/\?(.*)/);
      return C && C[1] ? C[1].split("#")[0] : "";
    }
    return oI && window.location.search.substring(1);
  }(I));
}
function Dn(I, g, C) {
  for (var A = g.length - 1, c = 0; c < A; ++c) {
    var b = g[c];
    if (b === "__proto__" || b === "constructor")
      break;
    b in I || (I[b] = {}), I = I[b];
  }
  I[g[A]] = C;
}
function wC() {
  for (var I = "", g = 0, C = 4294967295 * Math.random() | 0; g++ < 36; ) {
    var A = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx"[g - 1], c = 15 & C;
    I += A == "-" || A == "4" ? A : (A == "x" ? c : 3 & c | 8).toString(16), C = g % 8 == 0 ? 4294967295 * Math.random() | 0 : C >> 4;
  }
  return I;
}
var Tg = "global", Ng = cg + "global" + cg, pg = typeof self === nc && self.self === self && self || typeof global === nc && global.global === global && global || void 0;
function bg(I) {
  return pg[Ng][I];
}
function lg(I, g) {
  return pg[Ng][I] = g;
}
function Ug(I) {
  delete pg[Ng][I];
}
function Lg(I, g, C) {
  var A;
  try {
    if (HA(I)) {
      var c = window[I];
      A = c[g].bind(c);
    }
  } catch {
  }
  return A || C;
}
pg[Ng] || (pg[Ng] = {});
var cC = {};
function HA(I) {
  if (typeof cC[I] !== AC)
    return cC[I];
  try {
    var g = window[I];
    g.setItem(AC, AC), g.removeItem(AC);
  } catch {
    return cC[I] = !1;
  }
  return cC[I] = !0;
}
function Q() {
  return Q = Object.assign || function(I) {
    for (var g = 1; g < arguments.length; g++) {
      var C = arguments[g];
      for (var A in C)
        Object.prototype.hasOwnProperty.call(C, A) && (I[A] = C[A]);
    }
    return I;
  }, Q.apply(this, arguments);
}
var wI = "function", YI = "undefined", En = "@@redux/" + Math.random().toString(36), uc = /* @__PURE__ */ function() {
  return typeof Symbol === wI && Symbol.observable || "@@observable";
}(), bC = " != " + wI;
function Sb(I, g, C) {
  var A;
  if (typeof g === wI && typeof C === YI && (C = g, g = void 0), typeof C !== YI) {
    if (typeof C !== wI)
      throw new Error("enhancer" + bC);
    return C(Sb)(I, g);
  }
  if (typeof I !== wI)
    throw new Error("reducer" + bC);
  var c = I, b = g, l = [], i = l, u = !1;
  function n() {
    i === l && (i = l.slice());
  }
  function t() {
    return b;
  }
  function X(s) {
    if (typeof s !== wI)
      throw new Error("Listener" + bC);
    var B = !0;
    return n(), i.push(s), function() {
      if (B) {
        B = !1, n();
        var m = i.indexOf(s);
        i.splice(m, 1);
      }
    };
  }
  function y(s) {
    if (!tI(s))
      throw new Error("Act != obj");
    if (typeof s.type === YI)
      throw new Error("ActType " + YI);
    if (u)
      throw new Error("Dispatch in reducer");
    try {
      u = !0, b = c(b, s);
    } finally {
      u = !1;
    }
    for (var B = l = i, m = 0; m < B.length; m++)
      (0, B[m])();
    return s;
  }
  return y({ type: "@@redux/INIT" }), (A = { dispatch: y, subscribe: X, getState: t, replaceReducer: function(s) {
    if (typeof s !== wI)
      throw new Error("next reducer" + bC);
    c = s, y({ type: "@@redux/INIT" });
  } })[uc] = function() {
    var s, B = X;
    return (s = { subscribe: function(m) {
      if (typeof m != "object")
        throw new TypeError("Observer != obj");
      function x() {
        m.next && m.next(t());
      }
      return x(), { unsubscribe: B(x) };
    } })[uc] = function() {
      return this;
    }, s;
  }, A;
}
function Pn(I, g) {
  var C = g && g.type;
  return "action " + (C && C.toString() || "?") + "reducer " + I + " returns " + YI;
}
function Fg() {
  var I = [].slice.call(arguments);
  return I.length === 0 ? function(g) {
    return g;
  } : I.length === 1 ? I[0] : I.reduce(function(g, C) {
    return function() {
      return g(C.apply(void 0, [].slice.call(arguments)));
    };
  });
}
function jn() {
  var I = arguments;
  return function(g) {
    return function(C, A, c) {
      var b, l = g(C, A, c), i = l.dispatch, u = { getState: l.getState, dispatch: function(n) {
        return i(n);
      } };
      return b = [].slice.call(I).map(function(n) {
        return n(u);
      }), Q({}, l, { dispatch: i = Fg.apply(void 0, b)(l.dispatch) });
    };
  };
}
var EI = cg + "anon_id", Cg = cg + "user_id", yg = cg + "user_traits", TI = "userId", sg = "anonymousId", XC = ["bootstrap", "params", "campaign", "initializeStart", "initialize", "initializeEnd", "ready", "resetStart", "reset", "resetEnd", "pageStart", "page", "pageEnd", "pageAborted", "trackStart", "track", "trackEnd", "trackAborted", "identifyStart", "identify", "identifyEnd", "identifyAborted", "userIdChanged", "registerPlugins", "enablePlugin", "disablePlugin", "online", "offline", "setItemStart", "setItem", "setItemEnd", "setItemAborted", "removeItemStart", "removeItem", "removeItemEnd", "removeItemAborted"], GA = ["name", "EVENTS", "config", "loaded"], w = XC.reduce(function(I, g) {
  return I[g] = g, I;
}, { registerPluginType: function(I) {
  return "registerPlugin:" + I;
}, pluginReadyType: function(I) {
  return "ready:" + I;
} }), tc = /^utm_/, Gc = /^an_prop_/, Zc = /^an_trait_/;
function Mn(I) {
  var g = I.storage.setItem;
  return function(C) {
    return function(A) {
      return function(c) {
        if (c.type === w.bootstrap) {
          var b = c.params, l = c.user, i = c.persistedUser, u = c.initialUser, n = i.userId === l.userId;
          i.anonymousId !== l.anonymousId && g(EI, l.anonymousId), n || g(Cg, l.userId), u.traits && g(yg, Q({}, n && i.traits ? i.traits : {}, u.traits));
          var t = Object.keys(c.params);
          if (t.length) {
            var X = b.an_uid, y = b.an_event, s = t.reduce(function(B, m) {
              if (m.match(tc) || m.match(/^(d|g)clid/)) {
                var x = m.replace(tc, "");
                B.campaign[x === "campaign" ? "name" : x] = b[m];
              }
              return m.match(Gc) && (B.props[m.replace(Gc, "")] = b[m]), m.match(Zc) && (B.traits[m.replace(Zc, "")] = b[m]), B;
            }, { campaign: {}, props: {}, traits: {} });
            C.dispatch(Q({ type: w.params, raw: b }, s, X ? { userId: X } : {})), X && setTimeout(function() {
              return I.identify(X, s.traits);
            }, 0), y && setTimeout(function() {
              return I.track(y, s.props);
            }, 0), Object.keys(s.campaign).length && C.dispatch({ type: w.campaign, campaign: s.campaign });
          }
        }
        return A(c);
      };
    };
  };
}
function Kn(I) {
  return function(g, C) {
    if (g === void 0 && (g = {}), C === void 0 && (C = {}), C.type === w.setItemEnd) {
      if (C.key === EI)
        return Q({}, g, { anonymousId: C.value });
      if (C.key === Cg)
        return Q({}, g, { userId: C.value });
    }
    switch (C.type) {
      case w.identify:
        return Object.assign({}, g, { userId: C.userId, traits: Q({}, g.traits, C.traits) });
      case w.reset:
        return [Cg, EI, yg].forEach(function(A) {
          I.removeItem(A);
        }), Object.assign({}, g, { userId: null, anonymousId: null, traits: {} });
      default:
        return g;
    }
  };
}
function Xc(I) {
  return { userId: I.getItem(Cg), anonymousId: I.getItem(EI), traits: I.getItem(yg) };
}
var ZA = function(I) {
  return cg + "TEMP" + cg + I;
};
function _n(I) {
  var g = I.storage, C = g.setItem, A = g.removeItem, c = g.getItem;
  return function(b) {
    return function(l) {
      return function(i) {
        var u = i.userId, n = i.traits, t = i.options;
        if (i.type === w.reset && ([Cg, yg, EI].forEach(function(s) {
          A(s);
        }), [TI, sg, "traits"].forEach(function(s) {
          Ug(ZA(s));
        })), i.type === w.identify) {
          c(EI) || C(EI, wC());
          var X = c(Cg), y = c(yg) || {};
          X && X !== u && b.dispatch({ type: w.userIdChanged, old: { userId: X, traits: y }, new: { userId: u, traits: n }, options: t }), u && C(Cg, u), n && C(yg, Q({}, y, n));
        }
        return l(i);
      };
    };
  };
}
var Sg = {};
function dc(I, g) {
  Sg[I] && xI(Sg[I]) && (Sg[I](g), delete Sg[I]);
}
function fb(I, g, C) {
  return new Promise(function(A, c) {
    return g() ? A(I) : C < 1 ? c(Q({}, I, { queue: !0 })) : new Promise(function(b) {
      return setTimeout(b, 10);
    }).then(function(b) {
      return fb(I, g, C - 10).then(A, c);
    });
  });
}
function qn(I) {
  return { abort: I };
}
function Tb(I, g, C) {
  var A = {}, c = g(), b = I.getState(), l = b.plugins, i = b.queue, u = b.user;
  if (!b.context.offline && i && i.actions && i.actions.length) {
    var n = i.actions.reduce(function(X, y, s) {
      return l[y.plugin].loaded ? (X.process.push(y), X.processIndex.push(s)) : (X.requeue.push(y), X.requeueIndex.push(s)), X;
    }, { processIndex: [], process: [], requeue: [], requeueIndex: [] });
    if (n.processIndex && n.processIndex.length) {
      n.processIndex.forEach(function(X) {
        var y = i.actions[X], s = y.plugin, B = y.payload.type, m = c[s][B];
        if (m && xI(m)) {
          var x, v = function(d, Z) {
            return d === void 0 && (d = {}), Z === void 0 && (Z = {}), [TI, sg].reduce(function(r, h) {
              return d.hasOwnProperty(h) && Z[h] && Z[h] !== d[h] && (r[h] = Z[h]), r;
            }, d);
          }(y.payload, u), G = A[v.meta.rid];
          if (!G && (x = m({ payload: v, config: l[s].config, instance: C, abort: qn })) && tI(x) && x.abort)
            return void (A[v.meta.rid] = !0);
          if (!G) {
            var V = B + ":" + s;
            I.dispatch(Q({}, v, { type: V, _: { called: V, from: "queueDrain" } }));
          }
        }
      });
      var t = i.actions.filter(function(X, y) {
        return !~n.processIndex.indexOf(y);
      });
      i.actions = t;
    }
  }
}
var gA = function(I) {
  var g = I.data, C = I.action, A = I.instance, c = I.state, b = I.allPlugins, l = I.allMatches, i = I.store, u = I.EVENTS;
  try {
    var n = c.plugins, t = c.context, X = C.type, y = X.match(hg), s = g.exact.map(function(x) {
      return x.pluginName;
    });
    y && (s = l.during.map(function(x) {
      return x.pluginName;
    }));
    var B = function(x, v) {
      return function(G, V, d) {
        var Z = V.config, r = V.name, h = r + "." + G.type;
        d && (h = d.event);
        var o = G.type.match(hg) ? function(F, R, z, D, _) {
          return function(H, J) {
            var N = D ? D.name : F, U = J && Eg(J) ? J : z;
            if (D && (!(U = J && Eg(J) ? J : [F]).includes(F) || U.length !== 1))
              throw new Error("Method " + R + " can only abort " + F + " plugin. " + JSON.stringify(U) + " input valid");
            return Q({}, _, { abort: { reason: H, plugins: U, caller: R, _: N } });
          };
        }(r, h, v, d, G) : function(F, R) {
          return function() {
            throw new Error(F.type + " action not cancellable. Remove abort in " + R);
          };
        }(G, h);
        return { payload: $n(G), instance: x, config: Z || {}, abort: o };
      };
    }(A, s), m = g.exact.reduce(function(x, v) {
      var G = v.pluginName, V = v.methodName, d = !1;
      return V.match(/^initialize/) || V.match(/^reset/) || (d = !n[G].loaded), t.offline && V.match(/^(page|track|identify)/) && (d = !0), x["" + G] = d, x;
    }, {});
    return Promise.resolve(g.exact.reduce(function(x, v, G) {
      try {
        var V = v.pluginName;
        return Promise.resolve(x).then(function(d) {
          function Z() {
            return Promise.resolve(d);
          }
          var r = function() {
            if (g.namespaced && g.namespaced[V])
              return Promise.resolve(g.namespaced[V].reduce(function(h, o, F) {
                try {
                  return Promise.resolve(h).then(function(R) {
                    return o.method && xI(o.method) ? (function(H, J) {
                      var N = rc(H);
                      if (N && N.name === J) {
                        var U = rc(N.method);
                        throw new Error([J + " plugin is calling method " + H, "Plugins cant call self", "Use " + N.method + " " + (U ? "or " + U.method : "") + " in " + J + " plugin insteadof " + H].join(`
`));
                      }
                    }(o.methodName, o.pluginName), Promise.resolve(o.method({ payload: R, instance: A, abort: (z = R, D = V, _ = o.pluginName, function(H, J) {
                      return Q({}, z, { abort: { reason: H, plugins: J || [D], caller: X, from: _ || D } });
                    }), config: sc(o.pluginName, n, b), plugins: n })).then(function(H) {
                      var J = tI(H) ? H : {};
                      return Promise.resolve(Q({}, R, J));
                    })) : R;
                    var z, D, _;
                  });
                } catch (R) {
                  return Promise.reject(R);
                }
              }, Promise.resolve(C))).then(function(h) {
                d[V] = h;
              });
            d[V] = C;
          }();
          return r && r.then ? r.then(Z) : Z();
        });
      } catch (d) {
        return Promise.reject(d);
      }
    }, Promise.resolve({}))).then(function(x) {
      return Promise.resolve(g.exact.reduce(function(v, G, V) {
        try {
          var d = g.exact.length === V + 1, Z = G.pluginName, r = b[Z];
          return Promise.resolve(v).then(function(h) {
            var o = x[Z] ? x[Z] : {};
            if (y && (o = h), AA(o, Z))
              return CA({ data: o, method: X, instance: A, pluginName: Z, store: i }), Promise.resolve(h);
            if (AA(h, Z))
              return d && CA({ data: h, method: X, instance: A, store: i }), Promise.resolve(h);
            if (m.hasOwnProperty(Z) && m[Z] === !0)
              return i.dispatch({ type: "queue", plugin: Z, payload: o, _: { called: "queue", from: "queueMechanism" } }), Promise.resolve(h);
            var F = B(x[Z], b[Z]);
            return Promise.resolve(r[X]({ abort: F.abort, payload: o, instance: A, config: sc(Z, n, b), plugins: n })).then(function(R) {
              var z = tI(R) ? R : {}, D = Q({}, h, z), _ = x[Z];
              if (AA(_, Z))
                CA({ data: _, method: X, instance: A, pluginName: Z, store: i });
              else {
                var H = X + ":" + Z;
                (H.match(/:/g) || []).length < 2 && !X.match(ac) && !X.match(Vc) && A.dispatch(Q({}, y ? D : o, { type: H, _: { called: H, from: "submethod" } }));
              }
              return Promise.resolve(D);
            });
          });
        } catch (h) {
          return Promise.reject(h);
        }
      }, Promise.resolve(C))).then(function(v) {
        if (!(X.match(hg) || X.match(/^registerPlugin/) || X.match(Vc) || X.match(ac) || X.match(/^params/) || X.match(/^userIdChanged/))) {
          if (u.plugins.includes(X), v._ && v._.originalAction === X)
            return v;
          var G = Q({}, v, { _: { originalAction: v.type, called: v.type, from: "engineEnd" } });
          kb(v, g.exact.length) && !X.match(/End$/) && (G = Q({}, G, { type: v.type + "Aborted" })), i.dispatch(G);
        }
        return v;
      });
    });
  } catch (x) {
    return Promise.reject(x);
  }
}, hg = /Start$/, ac = /^bootstrap/, Vc = /^ready/;
function CA(I) {
  var g = I.pluginName, C = I.method + "Aborted" + (g ? ":" + g : "");
  I.store.dispatch(Q({}, I.data, { type: C, _: { called: C, from: "abort" } }));
}
function sc(I, g, C) {
  var A = g[I] || C[I];
  return A && A.config ? A.config : {};
}
function mc(I, g) {
  return g.reduce(function(C, A) {
    return A[I] ? C.concat({ methodName: I, pluginName: A.name, method: A[I] }) : C;
  }, []);
}
function Wc(I, g) {
  var C = I.replace(hg, ""), A = g ? ":" + g : "";
  return ["" + I + A, "" + C + A, C + "End" + A];
}
function AA(I, g) {
  var C = I.abort;
  return !!C && (C === !0 || oc(C, g) || C && oc(C.plugins, g));
}
function kb(I, g) {
  var C = I.abort;
  if (!C)
    return !1;
  if (C === !0 || rg(C))
    return !0;
  var A = C.plugins;
  return Eg(C) && C.length === g || Eg(A) && A.length === g;
}
function Eg(I) {
  return Array.isArray(I);
}
function oc(I, g) {
  return !(!I || !Eg(I)) && I.includes(g);
}
function rc(I) {
  var g = I.match(/(.*):(.*)/);
  return !!g && { method: g[1], name: g[2] };
}
function $n(I) {
  return Object.keys(I).reduce(function(g, C) {
    return C === "type" || (g[C] = tI(I[C]) ? Object.assign({}, I[C]) : I[C]), g;
  }, {});
}
function Ie(I, g, C) {
  var A = {};
  return function(c) {
    return function(b) {
      return function(l) {
        try {
          var i, u = function(d) {
            return i ? d : b(X);
          }, n = l.type, t = l.plugins, X = l;
          if (l.abort)
            return Promise.resolve(b(l));
          if (n === w.enablePlugin && c.dispatch({ type: w.initializeStart, plugins: t, disabled: [], fromEnable: !0, meta: l.meta }), n === w.disablePlugin && setTimeout(function() {
            return dc(l.meta.rid, { payload: l });
          }, 0), n === w.initializeEnd) {
            var y = g(), s = Object.keys(y), B = s.filter(function(d) {
              return t.includes(d);
            }).map(function(d) {
              return y[d];
            }), m = [], x = [], v = l.disabled, G = B.map(function(d) {
              var Z = d.loaded, r = d.name, h = d.config;
              return fb(d, function() {
                return Z({ config: h });
              }, 1e4).then(function(o) {
                return A[r] || (c.dispatch({ type: w.pluginReadyType(r), name: r, events: Object.keys(d).filter(function(F) {
                  return !GA.includes(F);
                }) }), A[r] = !0), m = m.concat(r), d;
              }).catch(function(o) {
                if (o instanceof Error)
                  throw new Error(o);
                return x = x.concat(o.name), o;
              });
            });
            Promise.all(G).then(function(d) {
              var Z = { plugins: m, failed: x, disabled: v };
              setTimeout(function() {
                s.length === G.length + v.length && c.dispatch(Q({}, { type: w.ready }, Z));
              }, 0);
            });
          }
          var V = function() {
            if (n !== w.bootstrap)
              return /^ready:([^:]*)$/.test(n) && setTimeout(function() {
                return Tb(c, g, I);
              }, 0), Promise.resolve(function(d, Z, r, h, o) {
                try {
                  var F = xI(Z) ? Z() : Z, R = d.type, z = R.replace(hg, "");
                  if (d._ && d._.called)
                    return Promise.resolve(d);
                  var D = r.getState(), _ = (N = F, (U = D.plugins) === void 0 && (U = {}), (Y = d.options) === void 0 && (Y = {}), Object.keys(N).filter(function(a) {
                    var W = Y.plugins || {};
                    return zn(W[a]) ? W[a] : W.all !== !1 && (!U[a] || U[a].enabled !== !1);
                  }).map(function(a) {
                    return N[a];
                  }));
                  R === w.initializeStart && d.fromEnable && (_ = Object.keys(D.plugins).filter(function(a) {
                    var W = D.plugins[a];
                    return d.plugins.includes(a) && !W.initialized;
                  }).map(function(a) {
                    return F[a];
                  }));
                  var H = _.map(function(a) {
                    return a.name;
                  }), J = function(a, W, p) {
                    var L = Wc(a).map(function(T) {
                      return mc(T, W);
                    });
                    return W.reduce(function(T, k) {
                      var q = k.name, j = Wc(a, q).map(function(AI) {
                        return mc(AI, W);
                      }), $ = j[0], M = j[1], lI = j[2];
                      return $.length && (T.beforeNS[q] = $), M.length && (T.duringNS[q] = M), lI.length && (T.afterNS[q] = lI), T;
                    }, { before: L[0], beforeNS: {}, during: L[1], duringNS: {}, after: L[2], afterNS: {} });
                  }(R, _);
                  return Promise.resolve(gA({ action: d, data: { exact: J.before, namespaced: J.beforeNS }, state: D, allPlugins: F, allMatches: J, instance: r, store: h, EVENTS: o })).then(function(a) {
                    function W() {
                      var T = function() {
                        if (R.match(hg))
                          return Promise.resolve(gA({ action: Q({}, p, { type: z + "End" }), data: { exact: J.after, namespaced: J.afterNS }, state: D, allPlugins: F, allMatches: J, instance: r, store: h, EVENTS: o })).then(function(k) {
                            k.meta && k.meta.hasCallback && dc(k.meta.rid, { payload: k });
                          });
                      }();
                      return T && T.then ? T.then(function() {
                        return a;
                      }) : a;
                    }
                    if (kb(a, H.length))
                      return a;
                    var p, L = function() {
                      if (R !== z)
                        return Promise.resolve(gA({ action: Q({}, a, { type: z }), data: { exact: J.during, namespaced: J.duringNS }, state: D, allPlugins: F, allMatches: J, instance: r, store: h, EVENTS: o })).then(function(T) {
                          p = T;
                        });
                      p = a;
                    }();
                    return L && L.then ? L.then(W) : W();
                  });
                } catch (a) {
                  return Promise.reject(a);
                }
                var N, U, Y;
              }(l, g, I, c, C)).then(function(d) {
                return i = 1, b(d);
              });
          }();
          return Promise.resolve(V && V.then ? V.then(u) : u(V));
        } catch (d) {
          return Promise.reject(d);
        }
      };
    };
  };
}
function ge(I) {
  return function(g) {
    return function(C) {
      return function(A) {
        var c = A.type, b = A.key, l = A.value, i = A.options;
        if (c === w.setItem || c === w.removeItem) {
          if (A.abort)
            return C(A);
          c === w.setItem ? I.setItem(b, l, i) : I.removeItem(b, i);
        }
        return C(A);
      };
    };
  };
}
var Ce = function() {
  var I = this;
  this.before = [], this.after = [], this.addMiddleware = function(g, C) {
    I[C] = I[C].concat(g);
  }, this.removeMiddleware = function(g, C) {
    var A = I[C].findIndex(function(c) {
      return c === g;
    });
    A !== -1 && (I[C] = [].concat(I[C].slice(0, A), I[C].slice(A + 1)));
  }, this.dynamicMiddlewares = function(g) {
    return function(C) {
      return function(A) {
        return function(c) {
          var b = { getState: C.getState, dispatch: function(i) {
            return C.dispatch(i);
          } }, l = I[g].map(function(i) {
            return i(b);
          });
          return Fg.apply(void 0, l)(A)(c);
        };
      };
    };
  };
};
function Ae(I) {
  return function(g, C) {
    g === void 0 && (g = {});
    var A = {};
    if (C.type === "initialize:aborted")
      return g;
    if (/^registerPlugin:([^:]*)$/.test(C.type)) {
      var c = yc(C.type, "registerPlugin"), b = I()[c];
      if (!b || !c)
        return g;
      var l = C.enabled, i = b.config;
      return A[c] = { enabled: l, initialized: !!l && !b.initialize, loaded: !!l && !!b.loaded({ config: i }), config: i }, Q({}, g, A);
    }
    if (/^initialize:([^:]*)$/.test(C.type)) {
      var u = yc(C.type, w.initialize), n = I()[u];
      return n && u ? (A[u] = Q({}, g[u], { initialized: !0, loaded: !!n.loaded({ config: n.config }) }), Q({}, g, A)) : g;
    }
    if (/^ready:([^:]*)$/.test(C.type))
      return A[C.name] = Q({}, g[C.name], { loaded: !0 }), Q({}, g, A);
    switch (C.type) {
      case w.disablePlugin:
        return Q({}, g, hc(C.plugins, !1, g));
      case w.enablePlugin:
        return Q({}, g, hc(C.plugins, !0, g));
      default:
        return g;
    }
  };
}
function yc(I, g) {
  return I.substring(g.length + 1, I.length);
}
function hc(I, g, C) {
  return I.reduce(function(A, c) {
    return A[c] = Q({}, C[c], { enabled: g }), A;
  }, C);
}
function wb(I) {
  try {
    return JSON.parse(JSON.stringify(I));
  } catch {
  }
  return I;
}
var ce = { last: {}, history: [] };
function be(I, g) {
  I === void 0 && (I = ce);
  var C = g.options, A = g.meta;
  if (g.type === w.track) {
    var c = wb(Q({ event: g.event, properties: g.properties }, Object.keys(C).length && { options: C }, { meta: A }));
    return Q({}, I, { last: c, history: I.history.concat(c) });
  }
  return I;
}
var le = { actions: [] };
function ie(I, g) {
  I === void 0 && (I = le);
  var C = g.payload;
  switch (g.type) {
    case "queue":
      var A;
      return A = C && C.type && C.type === w.identify ? [g].concat(I.actions) : I.actions.concat(g), Q({}, I, { actions: A });
    case "dequeue":
      return [];
    default:
      return I;
  }
}
var Qb = /#.*$/;
function ne(I) {
  var g = /(http[s]?:\/\/)?([^\/\s]+\/)(.*)/g.exec(I);
  return "/" + (g && g[3] ? g[3].split("?")[0].replace(Qb, "") : "");
}
var Ob, Db, Eb, Pb, ee = function(I) {
  if (I === void 0 && (I = {}), !oI)
    return I;
  var g = document, C = g.title, A = g.referrer, c = window, b = c.location, l = c.innerWidth, i = c.innerHeight, u = b.hash, n = b.search, t = function(y) {
    var s = function() {
      if (oI) {
        for (var B, m = document.getElementsByTagName("link"), x = 0; B = m[x]; x++)
          if (B.getAttribute("rel") === "canonical")
            return B.getAttribute("href");
      }
    }();
    return s ? s.match(/\?/) ? s : s + y : window.location.href.replace(Qb, "");
  }(n), X = { title: C, url: t, path: ne(t), hash: u, search: n, width: l, height: i };
  return A && A !== "" && (X.referrer = A), Q({}, X, I);
}, ue = { last: {}, history: [] };
function te(I, g) {
  I === void 0 && (I = ue);
  var C = g.options;
  if (g.type === w.page) {
    var A = wb(Q({ properties: g.properties, meta: g.meta }, Object.keys(C).length && { options: C }));
    return Q({}, I, { last: A, history: I.history.concat(A) });
  }
  return I;
}
Ob = function() {
  if (!oI)
    return !1;
  var I = navigator.appVersion;
  return ~I.indexOf("Win") ? "Windows" : ~I.indexOf("Mac") ? "MacOS" : ~I.indexOf("X11") ? "UNIX" : ~I.indexOf("Linux") ? "Linux" : "Unknown OS";
}(), Db = oI ? document.referrer : null, Eb = wn(), Pb = Qn();
var Jc = { initialized: !1, sessionId: wC(), app: null, version: null, debug: !1, offline: !!oI && !navigator.onLine, os: { name: Ob }, userAgent: oI ? navigator.userAgent : "node", library: { name: "analytics", version: "0.12.14" }, timezone: Pb, locale: Eb, campaign: {}, referrer: Db };
function Ge(I, g) {
  I === void 0 && (I = Jc);
  var C = I.initialized, A = g.campaign;
  switch (g.type) {
    case w.campaign:
      return Q({}, I, { campaign: A });
    case w.offline:
      return Q({}, I, { offline: !0 });
    case w.online:
      return Q({}, I, { offline: !1 });
    default:
      return C ? I : Q({}, Jc, I, { initialized: !0 });
  }
}
var Ze = ["plugins", "reducers", "storage"];
function Xe(I, g, C) {
  if (oI) {
    var A = window[(C ? "add" : "remove") + "EventListener"];
    I.split(" ").forEach(function(c) {
      A(c, g);
    });
  }
}
function de(I) {
  var g = Xe.bind(null, "online offline", function(C) {
    return Promise.resolve(!navigator.onLine).then(I);
  });
  return g(!0), function(C) {
    return g(!1);
  };
}
function jb() {
  return lg("analytics", []), function(I) {
    return function(g, C, A) {
      var c = I(g, C, A), b = c.dispatch;
      return Object.assign(c, { dispatch: function(l) {
        return pg[Ng].analytics.push(l.action || l), b(l);
      } });
    };
  };
}
function xc(I) {
  return function() {
    return Fg(Fg.apply(null, arguments), jb());
  };
}
function cA(I) {
  return I ? Ln(I) ? I : [I] : [];
}
function Bc(I, g, C) {
  I === void 0 && (I = {});
  var A, c, b = wC();
  return g && (Sg[b] = (A = g, c = function(l) {
    for (var i, u = l || Array.prototype.slice.call(arguments), n = 0; n < u.length; n++)
      if (xI(u[n])) {
        i = u[n];
        break;
      }
    return i;
  }(C), function(l) {
    c && c(l), A(l);
  })), Q({}, I, { rid: b, ts: (/* @__PURE__ */ new Date()).getTime() }, g ? { hasCallback: !0 } : {});
}
function ae(I) {
  I === void 0 && (I = {});
  var g = I.reducers || {}, C = I.initialUser || {}, A = (I.plugins || []).reduce(function(a, W) {
    if (xI(W))
      return a.middlewares = a.middlewares.concat(W), a;
    if (W.NAMESPACE && (W.name = W.NAMESPACE), !W.name)
      throw new Error("https://lytics.dev/errors/1");
    W.config || (W.config = {});
    var p = W.EVENTS ? Object.keys(W.EVENTS).map(function(k) {
      return W.EVENTS[k];
    }) : [];
    a.pluginEnabled[W.name] = !(W.enabled === !1 || W.config.enabled === !1), delete W.enabled, W.methods && (a.methods[W.name] = Object.keys(W.methods).reduce(function(k, q) {
      var j;
      return k[q] = (j = W.methods[q], function() {
        for (var $ = Array.prototype.slice.call(arguments), M = new Array(j.length), lI = 0; lI < $.length; lI++)
          M[lI] = $[lI];
        return M[M.length] = Z, j.apply({ instance: Z }, M);
      }), k;
    }, {}), delete W.methods);
    var L = Object.keys(W).concat(p), T = new Set(a.events.concat(L));
    if (a.events = Array.from(T), a.pluginsArray = a.pluginsArray.concat(W), a.plugins[W.name])
      throw new Error(W.name + "AlreadyLoaded");
    return a.plugins[W.name] = W, a.plugins[W.name].loaded || (a.plugins[W.name].loaded = function() {
      return !0;
    }), a;
  }, { plugins: {}, pluginEnabled: {}, methods: {}, pluginsArray: [], middlewares: [], events: [] }), c = I.storage ? I.storage : { getItem: bg, setItem: lg, removeItem: Ug }, b = function(a) {
    return function(W, p, L) {
      return p.getState("user")[W] || (L && tI(L) && L[W] ? L[W] : Xc(a)[W] || bg(ZA(W)) || null);
    };
  }(c), l = A.plugins, i = A.events.filter(function(a) {
    return !GA.includes(a);
  }).sort(), u = new Set(i.concat(XC).filter(function(a) {
    return !GA.includes(a);
  })), n = Array.from(u).sort(), t = function() {
    return l;
  }, X = new Ce(), y = X.addMiddleware, s = X.removeMiddleware, B = X.dynamicMiddlewares, m = function() {
    throw new Error("Abort disabled inListener");
  }, x = On(), v = Xc(c), G = Q({}, v, C, x.an_uid ? { userId: x.an_uid } : {}, x.an_aid ? { anonymousId: x.an_aid } : {});
  G.anonymousId || (G.anonymousId = wC());
  var V = Q({ enable: function(a, W) {
    return new Promise(function(p) {
      J.dispatch({ type: w.enablePlugin, plugins: cA(a), _: { originalAction: w.enablePlugin } }, p, [W]);
    });
  }, disable: function(a, W) {
    return new Promise(function(p) {
      J.dispatch({ type: w.disablePlugin, plugins: cA(a), _: { originalAction: w.disablePlugin } }, p, [W]);
    });
  } }, A.methods), d = !1, Z = { identify: function(a, W, p, L) {
    try {
      var T = rg(a) ? a : null, k = tI(a) ? a : W, q = p || {}, j = Z.user();
      lg(ZA(TI), T);
      var $ = T || k.userId || b(TI, Z, k);
      return Promise.resolve(new Promise(function(M) {
        J.dispatch(Q({ type: w.identifyStart, userId: $, traits: k || {}, options: q, anonymousId: j.anonymousId }, j.id && j.id !== T && { previousId: j.id }), M, [W, p, L]);
      }));
    } catch (M) {
      return Promise.reject(M);
    }
  }, track: function(a, W, p, L) {
    try {
      var T = tI(a) ? a.event : a;
      if (!T || !rg(T))
        throw new Error("EventMissing");
      var k = tI(a) ? a : W || {}, q = tI(p) ? p : {};
      return Promise.resolve(new Promise(function(j) {
        J.dispatch({ type: w.trackStart, event: T, properties: k, options: q, userId: b(TI, Z, W), anonymousId: b(sg, Z, W) }, j, [W, p, L]);
      }));
    } catch (j) {
      return Promise.reject(j);
    }
  }, page: function(a, W, p) {
    try {
      var L = tI(a) ? a : {}, T = tI(W) ? W : {};
      return Promise.resolve(new Promise(function(k) {
        J.dispatch({ type: w.pageStart, properties: ee(L), options: T, userId: b(TI, Z, L), anonymousId: b(sg, Z, L) }, k, [a, W, p]);
      }));
    } catch (k) {
      return Promise.reject(k);
    }
  }, user: function(a) {
    if (a === TI || a === "id")
      return b(TI, Z);
    if (a === sg || a === "anonId")
      return b(sg, Z);
    var W = Z.getState("user");
    return a ? ic(W, a) : W;
  }, reset: function(a) {
    return new Promise(function(W) {
      J.dispatch({ type: w.resetStart }, W, a);
    });
  }, ready: function(a) {
    return d && a({ plugins: V, instance: Z }), Z.on(w.ready, function(W) {
      a(W), d = !0;
    });
  }, on: function(a, W) {
    if (!a || !xI(W))
      return !1;
    if (a === w.bootstrap)
      throw new Error(".on disabled for " + a);
    var p = /Start$|Start:/;
    if (a === "*") {
      var L = function(j) {
        return function($) {
          return function(M) {
            return M.type.match(p) && W({ payload: M, instance: Z, plugins: l }), $(M);
          };
        };
      }, T = function(j) {
        return function($) {
          return function(M) {
            return M.type.match(p) || W({ payload: M, instance: Z, plugins: l }), $(M);
          };
        };
      };
      return y(L, lC), y(T, iC), function() {
        s(L, lC), s(T, iC);
      };
    }
    var k = a.match(p) ? lC : iC, q = function(j) {
      return function($) {
        return function(M) {
          return M.type === a && W({ payload: M, instance: Z, plugins: l, abort: m }), $(M);
        };
      };
    };
    return y(q, k), function() {
      return s(q, k);
    };
  }, once: function(a, W) {
    if (!a || !xI(W))
      return !1;
    if (a === w.bootstrap)
      throw new Error(".once disabled for " + a);
    var p = Z.on(a, function(L) {
      W({ payload: L.payload, instance: Z, plugins: l, abort: m }), p();
    });
    return p;
  }, getState: function(a) {
    var W = J.getState();
    return a ? ic(W, a) : Object.assign({}, W);
  }, dispatch: function(a) {
    var W = rg(a) ? { type: a } : a;
    if (XC.includes(W.type))
      throw new Error("reserved action " + W.type);
    var p = Q({}, W, { _: Q({ originalAction: W.type }, a._ || {}) });
    J.dispatch(p);
  }, enablePlugin: V.enable, disablePlugin: V.disable, plugins: V, storage: { getItem: c.getItem, setItem: function(a, W, p) {
    J.dispatch({ type: w.setItemStart, key: a, value: W, options: p });
  }, removeItem: function(a, W) {
    J.dispatch({ type: w.removeItemStart, key: a, options: W });
  } }, setAnonymousId: function(a, W) {
    Z.storage.setItem(EI, a, W);
  }, events: { core: XC, plugins: i } }, r = A.middlewares.concat([function(a) {
    return function(W) {
      return function(p) {
        return p.meta || (p.meta = Bc()), W(p);
      };
    };
  }, B(lC), Ie(Z, t, { all: n, plugins: i }), ge(c), Mn(Z), _n(Z), B(iC)]), h = { context: Ge, user: Kn(c), page: te, track: be, plugins: Ae(t), queue: ie }, o = Fg, F = Fg;
  if (oI && I.debug) {
    var R = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__;
    R && (o = R({ trace: !0, traceLimit: 25 })), F = function() {
      return arguments.length === 0 ? jb() : tI(typeof arguments[0]) ? xc() : xc().apply(null, arguments);
    };
  }
  var z, D = function(a) {
    return Object.keys(a).reduce(function(W, p) {
      return Ze.includes(p) || (W[p] = a[p]), W;
    }, {});
  }(I), _ = A.pluginsArray.reduce(function(a, W) {
    var p = W.name, L = W.config, T = W.loaded, k = A.pluginEnabled[p];
    return a[p] = { enabled: k, initialized: !!k && !W.initialize, loaded: !!T({ config: L }), config: L }, a;
  }, {}), H = { context: D, user: G, plugins: _ }, J = Sb(function(a) {
    for (var W = Object.keys(a), p = {}, L = 0; L < W.length; L++) {
      var T = W[L];
      typeof a[T] === wI && (p[T] = a[T]);
    }
    var k, q = Object.keys(p);
    try {
      (function(j) {
        Object.keys(j).forEach(function($) {
          var M = j[$];
          if (typeof M(void 0, { type: "@@redux/INIT" }) === YI || typeof M(void 0, { type: En }) === YI)
            throw new Error("reducer " + $ + " " + YI);
        });
      })(p);
    } catch (j) {
      k = j;
    }
    return function(j, $) {
      if (j === void 0 && (j = {}), k)
        throw k;
      for (var M = !1, lI = {}, AI = 0; AI < q.length; AI++) {
        var XI = q[AI], SI = j[XI], fI = (0, p[XI])(SI, $);
        if (typeof fI === YI) {
          var ui = Pn(XI, $);
          throw new Error(ui);
        }
        lI[XI] = fI, M = M || fI !== SI;
      }
      return M ? lI : j;
    };
  }(Q({}, h, g)), H, F(o(jn.apply(void 0, r))));
  J.dispatch = (z = J.dispatch, function(a, W, p) {
    var L = Q({}, a, { meta: Bc(a.meta, W, cA(p)) });
    return z.apply(null, [L]);
  });
  var N = Object.keys(l);
  J.dispatch({ type: w.bootstrap, plugins: N, config: D, params: x, user: G, initialUser: C, persistedUser: v });
  var U = N.filter(function(a) {
    return A.pluginEnabled[a];
  }), Y = N.filter(function(a) {
    return !A.pluginEnabled[a];
  });
  return J.dispatch({ type: w.registerPlugins, plugins: N, enabled: A.pluginEnabled }), A.pluginsArray.map(function(a, W) {
    var p = a.bootstrap, L = a.config, T = a.name;
    p && xI(p) && p({ instance: Z, config: L, payload: a }), J.dispatch({ type: w.registerPluginType(T), name: T, enabled: A.pluginEnabled[T], plugin: a }), A.pluginsArray.length === W + 1 && J.dispatch({ type: w.initializeStart, plugins: U, disabled: Y });
  }), de(function(a) {
    J.dispatch({ type: a ? w.offline : w.online });
  }), function(a, W, p) {
    setInterval(function() {
      return Tb(a, W, p);
    }, 3e3);
  }(J, t, Z), Z;
}
var lC = "before", iC = "after", kg = "cookie", Ig = _b(), Mb = QC, Ve = QC;
function Kb(I) {
  return Ig ? QC(I, "", -1) : Ug(I);
}
function _b() {
  if (Ig !== void 0)
    return Ig;
  var I = "cookiecookie";
  try {
    QC(I, I), Ig = document.cookie.indexOf(I) !== -1, Kb(I);
  } catch {
    Ig = !1;
  }
  return Ig;
}
function QC(I, g, C, A, c, b) {
  if (typeof window < "u") {
    var l = arguments.length > 1;
    return Ig === !1 && (l ? lg(I, g) : bg(I)), l ? document.cookie = I + "=" + encodeURIComponent(g) + (C ? "; expires=" + new Date(+/* @__PURE__ */ new Date() + 1e3 * C).toUTCString() + (A ? "; path=" + A : "") + (c ? "; domain=" + c : "") + (b ? "; secure" : "") : "") : decodeURIComponent((("; " + document.cookie).split("; " + I + "=")[1] || "").split(";")[0]);
  }
}
var wg = "localStorage", se = HA.bind(null, "localStorage");
Lg("localStorage", "getItem", bg);
Lg("localStorage", "setItem", lg);
Lg("localStorage", "removeItem", Ug);
var Qg = "sessionStorage", me = HA.bind(null, "sessionStorage");
Lg("sessionStorage", "getItem", bg);
Lg("sessionStorage", "setItem", lg);
Lg("sessionStorage", "removeItem", Ug);
function Jg(I) {
  var g = I;
  try {
    if ((g = JSON.parse(I)) === "true")
      return !0;
    if (g === "false")
      return !1;
    if (tI(g))
      return g;
    parseFloat(g) === g && (g = parseFloat(g));
  } catch {
  }
  if (g !== null && g !== "")
    return g;
}
var We = se(), oe = me(), re = _b();
function qb(I, g) {
  if (I) {
    var C = zA(g), A = !fA(C), c = UA(C) ? Jg(localStorage.getItem(I)) : void 0;
    if (A && !Vg(c))
      return c;
    var b = LA(C) ? Jg(Mb(I)) : void 0;
    if (A && b)
      return b;
    var l = SA(C) ? Jg(sessionStorage.getItem(I)) : void 0;
    if (A && l)
      return l;
    var i = bg(I);
    return A ? i : { localStorage: c, sessionStorage: l, cookie: b, global: i };
  }
}
function ye(I, g, C) {
  if (I && !Vg(g)) {
    var A = {}, c = zA(C), b = JSON.stringify(g), l = !fA(c);
    return UA(c) && (A[wg] = nC(wg, g, Jg(localStorage.getItem(I))), localStorage.setItem(I, b), l) ? A[wg] : LA(c) && (A[kg] = nC(kg, g, Jg(Mb(I))), Ve(I, b), l) ? A[kg] : SA(c) && (A[Qg] = nC(Qg, g, Jg(sessionStorage.getItem(I))), sessionStorage.setItem(I, b), l) ? A[Qg] : (A[Tg] = nC(Tg, g, bg(I)), lg(I, g), l ? A[Tg] : A);
  }
}
function he(I, g) {
  if (I) {
    var C = zA(g), A = qb(I, Hb), c = {};
    return !Vg(A.localStorage) && UA(C) && (localStorage.removeItem(I), c[wg] = A.localStorage), !Vg(A.cookie) && LA(C) && (Kb(I), c[kg] = A.cookie), !Vg(A.sessionStorage) && SA(C) && (sessionStorage.removeItem(I), c[Qg] = A.sessionStorage), !Vg(A.global) && OC(C, Tg) && (Ug(I), c[Tg] = A.global), c;
  }
}
function zA(I) {
  return I ? rg(I) ? I : I.storage : Yb;
}
function UA(I) {
  return We && OC(I, wg);
}
function LA(I) {
  return re && OC(I, kg);
}
function SA(I) {
  return oe && OC(I, Qg);
}
function fA(I) {
  return I === Hb || I === "all";
}
function OC(I, g) {
  return I === Yb || I === g || fA(I);
}
function nC(I, g, C) {
  return { location: I, current: g, previous: C };
}
var Je = { setItem: ye, getItem: qb, removeItem: he };
function xe(I, g, C) {
  return g in I ? Object.defineProperty(I, g, {
    value: C,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : I[g] = C, I;
}
function Rc(I, g) {
  var C = Object.keys(I);
  if (Object.getOwnPropertySymbols) {
    var A = Object.getOwnPropertySymbols(I);
    g && (A = A.filter(function(c) {
      return Object.getOwnPropertyDescriptor(I, c).enumerable;
    })), C.push.apply(C, A);
  }
  return C;
}
function vc(I) {
  for (var g = 1; g < arguments.length; g++) {
    var C = arguments[g] != null ? arguments[g] : {};
    g % 2 ? Rc(Object(C), !0).forEach(function(A) {
      xe(I, A, C[A]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(I, Object.getOwnPropertyDescriptors(C)) : Rc(Object(C)).forEach(function(A) {
      Object.defineProperty(I, A, Object.getOwnPropertyDescriptor(C, A));
    });
  }
  return I;
}
function cX() {
  var I = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, g = {
    storage: Je
  };
  return ae(vc(vc({}, g), I));
}
var bX = {
  prefix: "far",
  iconName: "trash-can",
  icon: [448, 512, [61460, "trash-alt"], "f2ed", "M170.5 51.6L151.5 80h145l-19-28.4c-1.5-2.2-4-3.6-6.7-3.6H177.1c-2.7 0-5.2 1.3-6.7 3.6zm147-26.6L354.2 80H368h48 8c13.3 0 24 10.7 24 24s-10.7 24-24 24h-8V432c0 44.2-35.8 80-80 80H112c-44.2 0-80-35.8-80-80V128H24c-13.3 0-24-10.7-24-24S10.7 80 24 80h8H80 93.8l36.7-55.1C140.9 9.4 158.4 0 177.1 0h93.7c18.7 0 36.2 9.4 46.6 24.9zM80 128V432c0 17.7 14.3 32 32 32H336c17.7 0 32-14.3 32-32V128H80zm80 64V400c0 8.8-7.2 16-16 16s-16-7.2-16-16V192c0-8.8 7.2-16 16-16s16 7.2 16 16zm80 0V400c0 8.8-7.2 16-16 16s-16-7.2-16-16V192c0-8.8 7.2-16 16-16s16 7.2 16 16zm80 0V400c0 8.8-7.2 16-16 16s-16-7.2-16-16V192c0-8.8 7.2-16 16-16s16 7.2 16 16z"]
}, Be = {
  prefix: "far",
  iconName: "pen-to-square",
  icon: [512, 512, ["edit"], "f044", "M441 58.9L453.1 71c9.4 9.4 9.4 24.6 0 33.9L424 134.1 377.9 88 407 58.9c9.4-9.4 24.6-9.4 33.9 0zM209.8 256.2L344 121.9 390.1 168 255.8 302.2c-2.9 2.9-6.5 5-10.4 6.1l-58.5 16.7 16.7-58.5c1.1-3.9 3.2-7.5 6.1-10.4zM373.1 25L175.8 222.2c-8.7 8.7-15 19.4-18.3 31.1l-28.6 100c-2.4 8.4-.1 17.4 6.1 23.6s15.2 8.5 23.6 6.1l100-28.6c11.8-3.4 22.5-9.7 31.1-18.3L487 138.9c28.1-28.1 28.1-73.7 0-101.8L474.9 25C446.8-3.1 401.2-3.1 373.1 25zM88 64C39.4 64 0 103.4 0 152V424c0 48.6 39.4 88 88 88H360c48.6 0 88-39.4 88-88V312c0-13.3-10.7-24-24-24s-24 10.7-24 24V424c0 22.1-17.9 40-40 40H88c-22.1 0-40-17.9-40-40V152c0-22.1 17.9-40 40-40H200c13.3 0 24-10.7 24-24s-10.7-24-24-24H88z"]
}, lX = Be, iX = {
  prefix: "far",
  iconName: "angle-right",
  icon: [320, 512, [8250], "f105", "M273 239c9.4 9.4 9.4 24.6 0 33.9L113 433c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l143-143L79 113c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0L273 239z"]
}, nX = {
  prefix: "far",
  iconName: "link-simple",
  icon: [576, 512, [], "e1cd", "M0 256C0 167.6 71.6 96 160 96h72c13.3 0 24 10.7 24 24s-10.7 24-24 24H160C98.1 144 48 194.1 48 256s50.1 112 112 112h72c13.3 0 24 10.7 24 24s-10.7 24-24 24H160C71.6 416 0 344.4 0 256zm576 0c0 88.4-71.6 160-160 160H344c-13.3 0-24-10.7-24-24s10.7-24 24-24h72c61.9 0 112-50.1 112-112s-50.1-112-112-112H344c-13.3 0-24-10.7-24-24s10.7-24 24-24h72c88.4 0 160 71.6 160 160zM184 232H392c13.3 0 24 10.7 24 24s-10.7 24-24 24H184c-13.3 0-24-10.7-24-24s10.7-24 24-24z"]
}, eX = {
  prefix: "far",
  iconName: "folder",
  icon: [512, 512, [128193, 128447, 61716, "folder-blank"], "f07b", "M0 96C0 60.7 28.7 32 64 32H196.1c19.1 0 37.4 7.6 50.9 21.1L289.9 96H448c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM64 80c-8.8 0-16 7.2-16 16V416c0 8.8 7.2 16 16 16H448c8.8 0 16-7.2 16-16V160c0-8.8-7.2-16-16-16H286.6c-10.6 0-20.8-4.2-28.3-11.7L213.1 87c-4.5-4.5-10.6-7-17-7H64z"]
}, uX = {
  prefix: "far",
  iconName: "user",
  icon: [448, 512, [128100, 62144], "f007", "M304 128a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zM96 128a128 128 0 1 1 256 0A128 128 0 1 1 96 128zM49.3 464H398.7c-8.9-63.3-63.3-112-129-112H178.3c-65.7 0-120.1 48.7-129 112zM0 482.3C0 383.8 79.8 304 178.3 304h91.4C368.2 304 448 383.8 448 482.3c0 16.4-13.3 29.7-29.7 29.7H29.7C13.3 512 0 498.7 0 482.3z"]
}, Re = {
  prefix: "far",
  iconName: "language",
  icon: [640, 512, [], "f1ab", "M64 64C28.7 64 0 92.7 0 128V384c0 35.3 28.7 64 64 64H272h32 16H576c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H320 304 272 64zm512 48c8.8 0 16 7.2 16 16V384c0 8.8-7.2 16-16 16H320V112H576zM178.3 175.9l64 144c4.5 10.1-.1 21.9-10.2 26.4s-21.9-.1-26.4-10.2L196.8 316H123.2l-8.9 20.1c-4.5 10.1-16.3 14.6-26.4 10.2s-14.6-16.3-10.2-26.4l64-144c3.2-7.2 10.4-11.9 18.3-11.9s15.1 4.7 18.3 11.9zM179 276l-19-42.8L141 276h38zM456 164c-11 0-20 9-20 20v4H384c-11 0-20 9-20 20s9 20 20 20h72 35.1c-7.3 16.7-17.4 31.9-29.8 45l-.5-.5-14.6-14.6c-7.8-7.8-20.5-7.8-28.3 0s-7.8 20.5 0 28.3L430 298.3c-5.9 3.6-12.1 6.9-18.5 9.8l-3.6 1.6c-10.1 4.5-14.6 16.3-10.2 26.4s16.3 14.6 26.4 10.2l3.6-1.6c12-5.3 23.4-11.8 34-19.4c4.3 3 8.6 5.8 13.1 8.5l18.9 11.3c9.5 5.7 21.8 2.6 27.4-6.9s2.6-21.8-6.9-27.4l-18.9-11.3c-.9-.5-1.8-1.1-2.7-1.6c17.2-18.8 30.7-40.9 39.6-65.4L534 228h2c11 0 20-9 20-20s-9-20-20-20H520 476v-4c0-11-9-20-20-20z"]
}, ve = {
  prefix: "far",
  iconName: "xmark",
  icon: [384, 512, [128473, 10005, 10006, 10060, 215, "close", "multiply", "remove", "times"], "f00d", "M345 137c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-119 119L73 103c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l119 119L39 375c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l119-119L311 409c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-119-119L345 137z"]
}, tX = ve, GX = {
  prefix: "far",
  iconName: "angle-left",
  icon: [320, 512, [8249], "f104", "M47 239c-9.4 9.4-9.4 24.6 0 33.9L207 433c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L97.9 256 241 113c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L47 239z"]
}, ZX = {
  prefix: "far",
  iconName: "thumbs-up",
  icon: [512, 512, [128077, 61575], "f164", "M323.8 34.8c-38.2-10.9-78.1 11.2-89 49.4l-5.7 20c-3.7 13-10.4 25-19.5 35l-51.3 56.4c-8.9 9.8-8.2 25 1.6 33.9s25 8.2 33.9-1.6l51.3-56.4c14.1-15.5 24.4-34 30.1-54.1l5.7-20c3.6-12.7 16.9-20.1 29.7-16.5s20.1 16.9 16.5 29.7l-5.7 20c-5.7 19.9-14.7 38.7-26.6 55.5c-5.2 7.3-5.8 16.9-1.7 24.9s12.3 13 21.3 13L448 224c8.8 0 16 7.2 16 16c0 6.8-4.3 12.7-10.4 15c-7.4 2.8-13 9-14.9 16.7s.1 15.8 5.3 21.7c2.5 2.8 4 6.5 4 10.6c0 7.8-5.6 14.3-13 15.7c-8.2 1.6-15.1 7.3-18 15.1s-1.6 16.7 3.6 23.3c2.1 2.7 3.4 6.1 3.4 9.9c0 6.7-4.2 12.6-10.2 14.9c-11.5 4.5-17.7 16.9-14.4 28.8c.4 1.3 .6 2.8 .6 4.3c0 8.8-7.2 16-16 16H286.5c-12.6 0-25-3.7-35.5-10.7l-61.7-41.1c-11-7.4-25.9-4.4-33.3 6.7s-4.4 25.9 6.7 33.3l61.7 41.1c18.4 12.3 40 18.8 62.1 18.8H384c34.7 0 62.9-27.6 64-62c14.6-11.7 24-29.7 24-50c0-4.5-.5-8.8-1.3-13c15.4-11.7 25.3-30.2 25.3-51c0-6.5-1-12.8-2.8-18.7C504.8 273.7 512 257.7 512 240c0-35.3-28.6-64-64-64l-92.3 0c4.7-10.4 8.7-21.2 11.8-32.2l5.7-20c10.9-38.2-11.2-78.1-49.4-89zM32 192c-17.7 0-32 14.3-32 32V448c0 17.7 14.3 32 32 32H96c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32H32z"]
}, Ne = Object.defineProperty, pe = (I, g, C) => g in I ? Ne(I, g, { enumerable: !0, configurable: !0, writable: !0, value: C }) : I[g] = C, gg = (I, g, C) => (pe(I, typeof g != "symbol" ? g + "" : g, C), C), NI = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function KI(I) {
  return I && I.__esModule && Object.prototype.hasOwnProperty.call(I, "default") ? I.default : I;
}
var DC = { exports: {} };
function Fe(I) {
  try {
    return JSON.stringify(I);
  } catch {
    return '"[Circular]"';
  }
}
var Ye = He;
function He(I, g, C) {
  var A = C && C.stringify || Fe, c = 1;
  if (typeof I == "object" && I !== null) {
    var b = g.length + c;
    if (b === 1)
      return I;
    var l = new Array(b);
    l[0] = A(I);
    for (var i = 1; i < b; i++)
      l[i] = A(g[i]);
    return l.join(" ");
  }
  if (typeof I != "string")
    return I;
  var u = g.length;
  if (u === 0)
    return I;
  for (var n = "", t = 1 - c, X = -1, y = I && I.length || 0, s = 0; s < y; ) {
    if (I.charCodeAt(s) === 37 && s + 1 < y) {
      switch (X = X > -1 ? X : 0, I.charCodeAt(s + 1)) {
        case 100:
        case 102:
          if (t >= u || g[t] == null)
            break;
          X < s && (n += I.slice(X, s)), n += Number(g[t]), X = s + 2, s++;
          break;
        case 105:
          if (t >= u || g[t] == null)
            break;
          X < s && (n += I.slice(X, s)), n += Math.floor(Number(g[t])), X = s + 2, s++;
          break;
        case 79:
        case 111:
        case 106:
          if (t >= u || g[t] === void 0)
            break;
          X < s && (n += I.slice(X, s));
          var B = typeof g[t];
          if (B === "string") {
            n += "'" + g[t] + "'", X = s + 2, s++;
            break;
          }
          if (B === "function") {
            n += g[t].name || "<anonymous>", X = s + 2, s++;
            break;
          }
          n += A(g[t]), X = s + 2, s++;
          break;
        case 115:
          if (t >= u)
            break;
          X < s && (n += I.slice(X, s)), n += String(g[t]), X = s + 2, s++;
          break;
        case 37:
          X < s && (n += I.slice(X, s)), n += "%", X = s + 2, s++, t--;
          break;
      }
      ++t;
    }
    ++s;
  }
  return X === -1 ? I : (X < y && (n += I.slice(X)), n);
}
const Nc = Ye;
DC.exports = zI;
const Pg = Me().console || {}, ze = {
  mapHttpRequest: eC,
  mapHttpResponse: eC,
  wrapRequestSerializer: bA,
  wrapResponseSerializer: bA,
  wrapErrorSerializer: bA,
  req: eC,
  res: eC,
  err: Fc,
  errWithCause: Fc
};
function rC(I, g) {
  return I === "silent" ? 1 / 0 : g.levels.values[I];
}
const TA = Symbol("pino.logFuncs"), XA = Symbol("pino.hierarchy"), Ue = {
  error: "log",
  fatal: "error",
  warn: "error",
  info: "log",
  debug: "log",
  trace: "log"
};
function pc(I, g) {
  const C = {
    logger: g,
    parent: I[XA]
  };
  g[XA] = C;
}
function Le(I, g, C) {
  const A = {};
  g.forEach((c) => {
    A[c] = C[c] ? C[c] : Pg[c] || Pg[Ue[c] || "log"] || jg;
  }), I[TA] = A;
}
function Se(I, g) {
  return Array.isArray(I) ? I.filter(function(C) {
    return C !== "!stdSerializers.err";
  }) : I === !0 ? Object.keys(g) : !1;
}
function zI(I) {
  I = I || {}, I.browser = I.browser || {};
  const g = I.browser.transmit;
  if (g && typeof g.send != "function")
    throw Error("pino: transmit option must have a send function");
  const C = I.browser.write || Pg;
  I.browser.write && (I.browser.asObject = !0);
  const A = I.serializers || {}, c = Se(I.browser.serialize, A);
  let b = I.browser.serialize;
  Array.isArray(I.browser.serialize) && I.browser.serialize.indexOf("!stdSerializers.err") > -1 && (b = !1);
  const l = Object.keys(I.customLevels || {}), i = ["error", "fatal", "warn", "info", "debug", "trace"].concat(l);
  typeof C == "function" && i.forEach(function(m) {
    C[m] = C;
  }), (I.enabled === !1 || I.browser.disabled) && (I.level = "silent");
  const u = I.level || "info", n = Object.create(C);
  n.log || (n.log = jg), Le(n, i, C), pc({}, n), Object.defineProperty(n, "levelVal", {
    get: X
  }), Object.defineProperty(n, "level", {
    get: y,
    set: s
  });
  const t = {
    transmit: g,
    serialize: c,
    asObject: I.browser.asObject,
    formatters: I.browser.formatters,
    levels: i,
    timestamp: Ee(I)
  };
  n.levels = fe(I), n.level = u, n.setMaxListeners = n.getMaxListeners = n.emit = n.addListener = n.on = n.prependListener = n.once = n.prependOnceListener = n.removeListener = n.removeAllListeners = n.listeners = n.listenerCount = n.eventNames = n.write = n.flush = jg, n.serializers = A, n._serialize = c, n._stdErrSerialize = b, n.child = B, g && (n._logEvent = dA());
  function X() {
    return rC(this.level, this);
  }
  function y() {
    return this._level;
  }
  function s(m) {
    if (m !== "silent" && !this.levels.values[m])
      throw Error("unknown level " + m);
    this._level = m, $I(this, t, n, "error"), $I(this, t, n, "fatal"), $I(this, t, n, "warn"), $I(this, t, n, "info"), $I(this, t, n, "debug"), $I(this, t, n, "trace"), l.forEach((x) => {
      $I(this, t, n, x);
    });
  }
  function B(m, x) {
    if (!m)
      throw new Error("missing bindings for child Pino");
    x = x || {}, c && m.serializers && (x.serializers = m.serializers);
    const v = x.serializers;
    if (c && v) {
      var G = Object.assign({}, A, v), V = I.browser.serialize === !0 ? Object.keys(G) : c;
      delete m.serializers, EC([m], V, G, this._stdErrSerialize);
    }
    function d(r) {
      this._childLevel = (r._childLevel | 0) + 1, this.bindings = m, G && (this.serializers = G, this._serialize = V), g && (this._logEvent = dA(
        [].concat(r._logEvent.bindings, m)
      ));
    }
    d.prototype = this;
    const Z = new d(this);
    return pc(this, Z), Z.level = this.level, Z;
  }
  return n;
}
function fe(I) {
  const g = I.customLevels || {}, C = Object.assign({}, zI.levels.values, g), A = Object.assign({}, zI.levels.labels, Te(g));
  return {
    values: C,
    labels: A
  };
}
function Te(I) {
  const g = {};
  return Object.keys(I).forEach(function(C) {
    g[I[C]] = C;
  }), g;
}
zI.levels = {
  values: {
    fatal: 60,
    error: 50,
    warn: 40,
    info: 30,
    debug: 20,
    trace: 10
  },
  labels: {
    10: "trace",
    20: "debug",
    30: "info",
    40: "warn",
    50: "error",
    60: "fatal"
  }
};
zI.stdSerializers = ze;
zI.stdTimeFunctions = Object.assign({}, { nullTime: $b, epochTime: Il, unixTime: Pe, isoTime: je });
function ke(I) {
  const g = [];
  I.bindings && g.push(I.bindings);
  let C = I[XA];
  for (; C.parent; )
    C = C.parent, C.logger.bindings && g.push(C.logger.bindings);
  return g.reverse();
}
function $I(I, g, C, A) {
  if (Object.defineProperty(I, A, {
    value: rC(I.level, C) > rC(A, C) ? jg : C[TA][A],
    writable: !0,
    enumerable: !0,
    configurable: !0
  }), !g.transmit && I[A] === jg)
    return;
  I[A] = Qe(I, g, C, A);
  const c = ke(I);
  c.length !== 0 && (I[A] = we(c, I[A]));
}
function we(I, g) {
  return function() {
    return g.apply(this, [...I, ...arguments]);
  };
}
function Qe(I, g, C, A) {
  return function(c) {
    return function() {
      const b = g.timestamp(), l = new Array(arguments.length), i = Object.getPrototypeOf && Object.getPrototypeOf(this) === Pg ? Pg : this;
      for (var u = 0; u < l.length; u++)
        l[u] = arguments[u];
      if (g.serialize && !g.asObject && EC(l, this._serialize, this.serializers, this._stdErrSerialize), g.asObject || g.formatters ? c.call(i, Oe(this, A, l, b, g.formatters)) : c.apply(i, l), g.transmit) {
        const n = g.transmit.level || I._level, t = C.levels.values[n], X = C.levels.values[A];
        if (X < t)
          return;
        De(this, {
          ts: b,
          methodLevel: A,
          methodValue: X,
          transmitLevel: n,
          transmitValue: C.levels.values[g.transmit.level || I._level],
          send: g.transmit.send,
          val: rC(I._level, C)
        }, l);
      }
    };
  }(I[TA][A]);
}
function Oe(I, g, C, A, c = {}) {
  const {
    level: b = () => I.levels.values[g],
    log: l = (X) => X
  } = c;
  I._serialize && EC(C, I._serialize, I.serializers, I._stdErrSerialize);
  const i = C.slice();
  let u = i[0];
  const n = {};
  A && (n.time = A), n.level = b(g, I.levels.values[g]);
  let t = (I._childLevel | 0) + 1;
  if (t < 1 && (t = 1), u !== null && typeof u == "object") {
    for (; t-- && typeof i[0] == "object"; )
      Object.assign(n, i.shift());
    u = i.length ? Nc(i.shift(), i) : void 0;
  } else
    typeof u == "string" && (u = Nc(i.shift(), i));
  return u !== void 0 && (n.msg = u), l(n);
}
function EC(I, g, C, A) {
  for (const c in I)
    if (A && I[c] instanceof Error)
      I[c] = zI.stdSerializers.err(I[c]);
    else if (typeof I[c] == "object" && !Array.isArray(I[c]))
      for (const b in I[c])
        g && g.indexOf(b) > -1 && b in C && (I[c][b] = C[b](I[c][b]));
}
function De(I, g, C) {
  const A = g.send, c = g.ts, b = g.methodLevel, l = g.methodValue, i = g.val, u = I._logEvent.bindings;
  EC(
    C,
    I._serialize || Object.keys(I.serializers),
    I.serializers,
    I._stdErrSerialize === void 0 ? !0 : I._stdErrSerialize
  ), I._logEvent.ts = c, I._logEvent.messages = C.filter(function(n) {
    return u.indexOf(n) === -1;
  }), I._logEvent.level.label = b, I._logEvent.level.value = l, A(b, I._logEvent, i), I._logEvent = dA(u);
}
function dA(I) {
  return {
    ts: 0,
    messages: [],
    bindings: I || [],
    level: { label: "", value: 0 }
  };
}
function Fc(I) {
  const g = {
    type: I.constructor.name,
    msg: I.message,
    stack: I.stack
  };
  for (const C in I)
    g[C] === void 0 && (g[C] = I[C]);
  return g;
}
function Ee(I) {
  return typeof I.timestamp == "function" ? I.timestamp : I.timestamp === !1 ? $b : Il;
}
function eC() {
  return {};
}
function bA(I) {
  return I;
}
function jg() {
}
function $b() {
  return !1;
}
function Il() {
  return Date.now();
}
function Pe() {
  return Math.round(Date.now() / 1e3);
}
function je() {
  return new Date(Date.now()).toISOString();
}
function Me() {
  function I(g) {
    return typeof g < "u" && g;
  }
  try {
    return typeof globalThis < "u" || Object.defineProperty(Object.prototype, "globalThis", {
      get: function() {
        return delete Object.prototype.globalThis, this.globalThis = this;
      },
      configurable: !0
    }), globalThis;
  } catch {
    return I(self) || I(window) || I(this) || {};
  }
}
DC.exports.default = zI;
DC.exports.pino = zI;
var Ke = DC.exports;
const gl = /* @__PURE__ */ KI(Ke);
var yC = {
  error: 3,
  warn: 4,
  info: 6,
  debug: 7
}, _e = class {
  constructor() {
    gg(this, "logger"), gg(this, "defaultLogLevelMap"), this.defaultLogLevelMap = yC, this.logger = gl(), this.logger.levels = {
      labels: xA(this.defaultLogLevelMap),
      values: this.defaultLogLevelMap
    };
  }
  debug(I) {
    this.log("debug", I);
  }
  info(I) {
    this.log("info", I);
  }
  warn(I) {
    this.log("warn", I);
  }
  error(I) {
    this.log("error", I);
  }
  log(I, g) {
    if (this.isLogLevelKey(I)) {
      this.logger[I](g);
      return;
    }
    let C = this.findLoggerTypeForSyslogLevel(I);
    C && this.logger[C](g);
  }
  isLogLevelKey(I) {
    return typeof I == "string" && LC(Object.keys(this.defaultLogLevelMap), I);
  }
  findLoggerTypeForSyslogLevel(I) {
    let g = this.logger.levels.labels[I];
    return this.isLogLevelKey(g) ? g : null;
  }
};
new _e();
var Cl = (I) => Ri(I) && !VC(I), qe = (I) => typeof I == "number" && LC(Object.values(yC), I), Mg = class extends Error {
  constructor(I, g) {
    var C;
    super(I.message), gg(this, "statusCode"), gg(this, "errorCode"), gg(this, "data"), gg(this, "name"), this.errorDTO = I, this.info = g, this.statusCode = this.errorDTO.statusCode, this.data = this.errorDTO.data, this.errorCode = (C = this.errorDTO) == null ? void 0 : C.errorCode, this.name = this.info.handled ? "HandledApiError" : "UnhandledApiError";
  }
  get code() {
    var I;
    return this.errorCode || typeof this.data != "string" && ((I = this.data) == null ? void 0 : I.code) || "";
  }
  static createError(I, g, C) {
    return qe(C) ? new Iu(I, g, C) : ["NOT_FOUND", "UNAUTHORIZED"].some((A) => A === I.statusCode) ? new $e(I, g) : new Mg(I, g);
  }
  isErrorResponse(I) {
    return Cl(I) && og(I, "data") && og(I, "statusCode") && og(I, "message") && I.statusCode !== "OK";
  }
  logMessage() {
    let {
      status: I,
      handled: g,
      url: C
    } = this.info, A = g ? "HANDLED" : "UNHANDLED", c = this.isErrorResponse(this.info.extra) ? `${this.info.extra.statusCode}: ${this.info.extra.message}` : "", b = `${I} error ${c}`;
    return {
      level: "error",
      message: `fetch: [${A} ${b}] *url: ${C} *data: ${this.info.extra ? JSON.stringify(this.info.extra) : ""}`
    };
  }
}, $e = class extends Mg {
  logMessage() {
    return {
      ...super.logMessage(),
      level: "info"
    };
  }
}, Iu = class extends Mg {
  constructor(I, g, C) {
    super(I, g), gg(this, "customLogLevel"), this.customLogLevel = C;
  }
  isLogLevelKey(I) {
    return LC(Object.keys(yC), I);
  }
  logMessage() {
    let I = super.logMessage(), g = xA(yC)[this.customLogLevel];
    return {
      ...I,
      level: this.isLogLevelKey(g) ? g : "error"
    };
  }
}, gu = 10 * 1e3, $g = class extends Cn {
  static from(I) {
    return new $g({
      timeout: gu,
      ...I
    });
  }
  afterRequest(I, g, C, A) {
    if (this.isErrorResponse(A)) {
      let c = Mg.createError(A, {
        status: I,
        url: C.path,
        handled: !0,
        extra: A
      }, Number(g.get("goose-level"))), {
        level: b,
        message: l
      } = c.logMessage();
      throw console[b](l), c;
    }
    return A;
  }
  performError(I) {
    if (I instanceof Mg) {
      let {
        level: g,
        message: C
      } = I.logMessage();
      console[g](C);
      return;
    }
    if (I instanceof DOMException && I.name === "AbortError") {
      console.error(`[CustomAbortError] ${I.message}`);
      return;
    }
    console.info(I);
  }
  isErrorResponse(I) {
    return Cl(I) && og(I, "data") && og(I, "statusCode") && og(I, "message") && I.statusCode !== "OK";
  }
};
const Cu = {
  MODE: "development",
  CDN_URL: "https://cdn.devinflearn.com",
  SITE_URL: "https://www.devinflearn.com",
  MIXPANEL_TOKEN: "2df837e504078b475f90b32d9a268c01",
  HACKLE_BROWSER_SDK_KEY: "ygFNanOzYS2M5JgfrE5gUk69EbkFIzZ4",
  PUBLIC_UCC_API_URL: "https://ucc-api.devinflearn.com",
  PUBLIC_COURSE_API_URL: "https://course-api.devinflearn.com",
  PUBLIC_ACCOUNT_API_URL: "https://account-api.devinflearn.com",
  PUBLIC_PAYMENT_API_URL: "https://payment-api.devinflearn.com",
  COOKIE_DOMAIN: ".devinflearn.com",
  CDN_INTEGRATION_URL: "https://cdn.devinflab.com"
}, Au = {
  MODE: "localhost",
  CDN_URL: "https://cdn.devinflearn.com",
  SITE_URL: "https://www.devinflearn.com",
  MIXPANEL_TOKEN: "2df837e504078b475f90b32d9a268c01",
  HACKLE_BROWSER_SDK_KEY: "ygFNanOzYS2M5JgfrE5gUk69EbkFIzZ4",
  PUBLIC_UCC_API_URL: "https://ucc-api.devinflearn.com",
  PUBLIC_COURSE_API_URL: "https://course-api.devinflearn.com",
  PUBLIC_ACCOUNT_API_URL: "https://account-api.devinflearn.com",
  PUBLIC_PAYMENT_API_URL: "https://payment-api.devinflearn.com",
  COOKIE_DOMAIN: "localhost",
  CDN_INTEGRATION_URL: "https://cdn.devinflab.com"
}, Yc = {
  MODE: "production",
  CDN_URL: "https://cdn.inflearn.com",
  SITE_URL: "https://www.inflearn.com",
  MIXPANEL_TOKEN: "c05d8cc017a29af05e50c0d43d848d2d",
  HACKLE_BROWSER_SDK_KEY: "rb1wDPCB39swIGfTAhDcz0QXvmh6hayS",
  PUBLIC_UCC_API_URL: "https://ucc-api.inflearn.com",
  PUBLIC_COURSE_API_URL: "https://course-api.inflearn.com",
  PUBLIC_ACCOUNT_API_URL: "https://account-api.inflearn.com",
  PUBLIC_PAYMENT_API_URL: "https://payment-api.inflearn.com",
  COOKIE_DOMAIN: ".inflearn.com",
  CDN_INTEGRATION_URL: "https://cdn.inflearn.com"
};
function cu() {
  return typeof window < "u" && window != null && window.env ? window.env : process.env.NEXT_PUBLIC_ENV || process.env.APP_ENV;
}
function bu() {
  const I = cu();
  return I ? I === "localhost" ? Au : I === "production" ? Yc : Cu : (console.error("app-shell env is not defined"), Yc);
}
const ug = bu(), lu = ug.CDN_URL, iu = ug.MIXPANEL_TOKEN, nu = ug.PUBLIC_COURSE_API_URL, eu = ug.PUBLIC_ACCOUNT_API_URL, uu = ug.PUBLIC_UCC_API_URL, tu = ug.COOKIE_DOMAIN, Gu = ug.PUBLIC_PAYMENT_API_URL;
new $g({
  baseUrl: nu,
  credentials: "include"
});
const Zu = new $g({
  baseUrl: eu,
  credentials: "include"
}), Xu = new $g({
  baseUrl: uu,
  credentials: "include"
});
new $g({
  baseUrl: Gu,
  credentials: "include"
});
var mg = { ko: "ko", en: "en", ja: "ja", vi: "vi" }, ig = mg.ko, kA = Object.values(mg), hC = { exports: {} };
hC.exports;
(function(I, g) {
  (function(C, A) {
    I.exports = A();
  })(NI, function() {
    var C = 1e3, A = 6e4, c = 36e5, b = "millisecond", l = "second", i = "minute", u = "hour", n = "day", t = "week", X = "month", y = "quarter", s = "year", B = "date", m = "Invalid Date", x = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, v = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, G = { name: "en", weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"), ordinal: function(H) {
      var J = ["th", "st", "nd", "rd"], N = H % 100;
      return "[" + H + (J[(N - 20) % 10] || J[N] || J[0]) + "]";
    } }, V = function(H, J, N) {
      var U = String(H);
      return !U || U.length >= J ? H : "" + Array(J + 1 - U.length).join(N) + H;
    }, d = { s: V, z: function(H) {
      var J = -H.utcOffset(), N = Math.abs(J), U = Math.floor(N / 60), Y = N % 60;
      return (J <= 0 ? "+" : "-") + V(U, 2, "0") + ":" + V(Y, 2, "0");
    }, m: function H(J, N) {
      if (J.date() < N.date())
        return -H(N, J);
      var U = 12 * (N.year() - J.year()) + (N.month() - J.month()), Y = J.clone().add(U, X), a = N - Y < 0, W = J.clone().add(U + (a ? -1 : 1), X);
      return +(-(U + (N - Y) / (a ? Y - W : W - Y)) || 0);
    }, a: function(H) {
      return H < 0 ? Math.ceil(H) || 0 : Math.floor(H);
    }, p: function(H) {
      return { M: X, y: s, w: t, d: n, D: B, h: u, m: i, s: l, ms: b, Q: y }[H] || String(H || "").toLowerCase().replace(/s$/, "");
    }, u: function(H) {
      return H === void 0;
    } }, Z = "en", r = {};
    r[Z] = G;
    var h = "$isDayjsObject", o = function(H) {
      return H instanceof D || !(!H || !H[h]);
    }, F = function H(J, N, U) {
      var Y;
      if (!J)
        return Z;
      if (typeof J == "string") {
        var a = J.toLowerCase();
        r[a] && (Y = a), N && (r[a] = N, Y = a);
        var W = J.split("-");
        if (!Y && W.length > 1)
          return H(W[0]);
      } else {
        var p = J.name;
        r[p] = J, Y = p;
      }
      return !U && Y && (Z = Y), Y || !U && Z;
    }, R = function(H, J) {
      if (o(H))
        return H.clone();
      var N = typeof J == "object" ? J : {};
      return N.date = H, N.args = arguments, new D(N);
    }, z = d;
    z.l = F, z.i = o, z.w = function(H, J) {
      return R(H, { locale: J.$L, utc: J.$u, x: J.$x, $offset: J.$offset });
    };
    var D = function() {
      function H(N) {
        this.$L = F(N.locale, null, !0), this.parse(N), this.$x = this.$x || N.x || {}, this[h] = !0;
      }
      var J = H.prototype;
      return J.parse = function(N) {
        this.$d = function(U) {
          var Y = U.date, a = U.utc;
          if (Y === null)
            return /* @__PURE__ */ new Date(NaN);
          if (z.u(Y))
            return /* @__PURE__ */ new Date();
          if (Y instanceof Date)
            return new Date(Y);
          if (typeof Y == "string" && !/Z$/i.test(Y)) {
            var W = Y.match(x);
            if (W) {
              var p = W[2] - 1 || 0, L = (W[7] || "0").substring(0, 3);
              return a ? new Date(Date.UTC(W[1], p, W[3] || 1, W[4] || 0, W[5] || 0, W[6] || 0, L)) : new Date(W[1], p, W[3] || 1, W[4] || 0, W[5] || 0, W[6] || 0, L);
            }
          }
          return new Date(Y);
        }(N), this.init();
      }, J.init = function() {
        var N = this.$d;
        this.$y = N.getFullYear(), this.$M = N.getMonth(), this.$D = N.getDate(), this.$W = N.getDay(), this.$H = N.getHours(), this.$m = N.getMinutes(), this.$s = N.getSeconds(), this.$ms = N.getMilliseconds();
      }, J.$utils = function() {
        return z;
      }, J.isValid = function() {
        return this.$d.toString() !== m;
      }, J.isSame = function(N, U) {
        var Y = R(N);
        return this.startOf(U) <= Y && Y <= this.endOf(U);
      }, J.isAfter = function(N, U) {
        return R(N) < this.startOf(U);
      }, J.isBefore = function(N, U) {
        return this.endOf(U) < R(N);
      }, J.$g = function(N, U, Y) {
        return z.u(N) ? this[U] : this.set(Y, N);
      }, J.unix = function() {
        return Math.floor(this.valueOf() / 1e3);
      }, J.valueOf = function() {
        return this.$d.getTime();
      }, J.startOf = function(N, U) {
        var Y = this, a = !!z.u(U) || U, W = z.p(N), p = function(lI, AI) {
          var XI = z.w(Y.$u ? Date.UTC(Y.$y, AI, lI) : new Date(Y.$y, AI, lI), Y);
          return a ? XI : XI.endOf(n);
        }, L = function(lI, AI) {
          return z.w(Y.toDate()[lI].apply(Y.toDate("s"), (a ? [0, 0, 0, 0] : [23, 59, 59, 999]).slice(AI)), Y);
        }, T = this.$W, k = this.$M, q = this.$D, j = "set" + (this.$u ? "UTC" : "");
        switch (W) {
          case s:
            return a ? p(1, 0) : p(31, 11);
          case X:
            return a ? p(1, k) : p(0, k + 1);
          case t:
            var $ = this.$locale().weekStart || 0, M = (T < $ ? T + 7 : T) - $;
            return p(a ? q - M : q + (6 - M), k);
          case n:
          case B:
            return L(j + "Hours", 0);
          case u:
            return L(j + "Minutes", 1);
          case i:
            return L(j + "Seconds", 2);
          case l:
            return L(j + "Milliseconds", 3);
          default:
            return this.clone();
        }
      }, J.endOf = function(N) {
        return this.startOf(N, !1);
      }, J.$set = function(N, U) {
        var Y, a = z.p(N), W = "set" + (this.$u ? "UTC" : ""), p = (Y = {}, Y[n] = W + "Date", Y[B] = W + "Date", Y[X] = W + "Month", Y[s] = W + "FullYear", Y[u] = W + "Hours", Y[i] = W + "Minutes", Y[l] = W + "Seconds", Y[b] = W + "Milliseconds", Y)[a], L = a === n ? this.$D + (U - this.$W) : U;
        if (a === X || a === s) {
          var T = this.clone().set(B, 1);
          T.$d[p](L), T.init(), this.$d = T.set(B, Math.min(this.$D, T.daysInMonth())).$d;
        } else
          p && this.$d[p](L);
        return this.init(), this;
      }, J.set = function(N, U) {
        return this.clone().$set(N, U);
      }, J.get = function(N) {
        return this[z.p(N)]();
      }, J.add = function(N, U) {
        var Y, a = this;
        N = Number(N);
        var W = z.p(U), p = function(k) {
          var q = R(a);
          return z.w(q.date(q.date() + Math.round(k * N)), a);
        };
        if (W === X)
          return this.set(X, this.$M + N);
        if (W === s)
          return this.set(s, this.$y + N);
        if (W === n)
          return p(1);
        if (W === t)
          return p(7);
        var L = (Y = {}, Y[i] = A, Y[u] = c, Y[l] = C, Y)[W] || 1, T = this.$d.getTime() + N * L;
        return z.w(T, this);
      }, J.subtract = function(N, U) {
        return this.add(-1 * N, U);
      }, J.format = function(N) {
        var U = this, Y = this.$locale();
        if (!this.isValid())
          return Y.invalidDate || m;
        var a = N || "YYYY-MM-DDTHH:mm:ssZ", W = z.z(this), p = this.$H, L = this.$m, T = this.$M, k = Y.weekdays, q = Y.months, j = Y.meridiem, $ = function(AI, XI, SI, fI) {
          return AI && (AI[XI] || AI(U, a)) || SI[XI].slice(0, fI);
        }, M = function(AI) {
          return z.s(p % 12 || 12, AI, "0");
        }, lI = j || function(AI, XI, SI) {
          var fI = AI < 12 ? "AM" : "PM";
          return SI ? fI.toLowerCase() : fI;
        };
        return a.replace(v, function(AI, XI) {
          return XI || function(SI) {
            switch (SI) {
              case "YY":
                return String(U.$y).slice(-2);
              case "YYYY":
                return z.s(U.$y, 4, "0");
              case "M":
                return T + 1;
              case "MM":
                return z.s(T + 1, 2, "0");
              case "MMM":
                return $(Y.monthsShort, T, q, 3);
              case "MMMM":
                return $(q, T);
              case "D":
                return U.$D;
              case "DD":
                return z.s(U.$D, 2, "0");
              case "d":
                return String(U.$W);
              case "dd":
                return $(Y.weekdaysMin, U.$W, k, 2);
              case "ddd":
                return $(Y.weekdaysShort, U.$W, k, 3);
              case "dddd":
                return k[U.$W];
              case "H":
                return String(p);
              case "HH":
                return z.s(p, 2, "0");
              case "h":
                return M(1);
              case "hh":
                return M(2);
              case "a":
                return lI(p, L, !0);
              case "A":
                return lI(p, L, !1);
              case "m":
                return String(L);
              case "mm":
                return z.s(L, 2, "0");
              case "s":
                return String(U.$s);
              case "ss":
                return z.s(U.$s, 2, "0");
              case "SSS":
                return z.s(U.$ms, 3, "0");
              case "Z":
                return W;
            }
            return null;
          }(AI) || W.replace(":", "");
        });
      }, J.utcOffset = function() {
        return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
      }, J.diff = function(N, U, Y) {
        var a, W = this, p = z.p(U), L = R(N), T = (L.utcOffset() - this.utcOffset()) * A, k = this - L, q = function() {
          return z.m(W, L);
        };
        switch (p) {
          case s:
            a = q() / 12;
            break;
          case X:
            a = q();
            break;
          case y:
            a = q() / 3;
            break;
          case t:
            a = (k - T) / 6048e5;
            break;
          case n:
            a = (k - T) / 864e5;
            break;
          case u:
            a = k / c;
            break;
          case i:
            a = k / A;
            break;
          case l:
            a = k / C;
            break;
          default:
            a = k;
        }
        return Y ? a : z.a(a);
      }, J.daysInMonth = function() {
        return this.endOf(X).$D;
      }, J.$locale = function() {
        return r[this.$L];
      }, J.locale = function(N, U) {
        if (!N)
          return this.$L;
        var Y = this.clone(), a = F(N, U, !0);
        return a && (Y.$L = a), Y;
      }, J.clone = function() {
        return z.w(this.$d, this);
      }, J.toDate = function() {
        return new Date(this.valueOf());
      }, J.toJSON = function() {
        return this.isValid() ? this.toISOString() : null;
      }, J.toISOString = function() {
        return this.$d.toISOString();
      }, J.toString = function() {
        return this.$d.toUTCString();
      }, H;
    }(), _ = D.prototype;
    return R.prototype = _, [["$ms", b], ["$s", l], ["$m", i], ["$H", u], ["$W", n], ["$M", X], ["$y", s], ["$D", B]].forEach(function(H) {
      _[H[1]] = function(J) {
        return this.$g(J, H[0], H[1]);
      };
    }), R.extend = function(H, J) {
      return H.$i || (H(J, D, R), H.$i = !0), R;
    }, R.locale = F, R.isDayjs = o, R.unix = function(H) {
      return R(1e3 * H);
    }, R.en = r[Z], R.Ls = r, R.p = {}, R;
  });
})(hC, hC.exports);
var PC = hC.exports;
const LI = /* @__PURE__ */ KI(PC);
var JC = { exports: {} };
JC.exports;
(function(I, g) {
  (function(C, A) {
    I.exports = A();
  })(NI, function() {
    return { name: "en", weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"), ordinal: function(C) {
      var A = ["th", "st", "nd", "rd"], c = C % 100;
      return "[" + C + (A[(c - 20) % 10] || A[c] || A[0]) + "]";
    } };
  });
})(JC, JC.exports);
JC.exports;
var xC = { exports: {} };
xC.exports;
(function(I, g) {
  (function(C, A) {
    I.exports = A(PC);
  })(NI, function(C) {
    function A(l) {
      return l && typeof l == "object" && "default" in l ? l : { default: l };
    }
    var c = A(C), b = { name: "ko", weekdays: "일요일_월요일_화요일_수요일_목요일_금요일_토요일".split("_"), weekdaysShort: "일_월_화_수_목_금_토".split("_"), weekdaysMin: "일_월_화_수_목_금_토".split("_"), months: "1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월".split("_"), monthsShort: "1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월".split("_"), ordinal: function(l) {
      return l + "일";
    }, formats: { LT: "A h:mm", LTS: "A h:mm:ss", L: "YYYY.MM.DD.", LL: "YYYY년 MMMM D일", LLL: "YYYY년 MMMM D일 A h:mm", LLLL: "YYYY년 MMMM D일 dddd A h:mm", l: "YYYY.MM.DD.", ll: "YYYY년 MMMM D일", lll: "YYYY년 MMMM D일 A h:mm", llll: "YYYY년 MMMM D일 dddd A h:mm" }, meridiem: function(l) {
      return l < 12 ? "오전" : "오후";
    }, relativeTime: { future: "%s 후", past: "%s 전", s: "몇 초", m: "1분", mm: "%d분", h: "한 시간", hh: "%d시간", d: "하루", dd: "%d일", M: "한 달", MM: "%d달", y: "일 년", yy: "%d년" } };
    return c.default.locale(b, null, !0), b;
  });
})(xC, xC.exports);
xC.exports;
var BC = { exports: {} };
BC.exports;
(function(I, g) {
  (function(C, A) {
    I.exports = A(PC);
  })(NI, function(C) {
    function A(l) {
      return l && typeof l == "object" && "default" in l ? l : { default: l };
    }
    var c = A(C), b = { name: "vi", weekdays: "chủ nhật_thứ hai_thứ ba_thứ tư_thứ năm_thứ sáu_thứ bảy".split("_"), months: "tháng 1_tháng 2_tháng 3_tháng 4_tháng 5_tháng 6_tháng 7_tháng 8_tháng 9_tháng 10_tháng 11_tháng 12".split("_"), weekStart: 1, weekdaysShort: "CN_T2_T3_T4_T5_T6_T7".split("_"), monthsShort: "Th01_Th02_Th03_Th04_Th05_Th06_Th07_Th08_Th09_Th10_Th11_Th12".split("_"), weekdaysMin: "CN_T2_T3_T4_T5_T6_T7".split("_"), ordinal: function(l) {
      return l;
    }, formats: { LT: "HH:mm", LTS: "HH:mm:ss", L: "DD/MM/YYYY", LL: "D MMMM [năm] YYYY", LLL: "D MMMM [năm] YYYY HH:mm", LLLL: "dddd, D MMMM [năm] YYYY HH:mm", l: "DD/M/YYYY", ll: "D MMM YYYY", lll: "D MMM YYYY HH:mm", llll: "ddd, D MMM YYYY HH:mm" }, relativeTime: { future: "%s tới", past: "%s trước", s: "vài giây", m: "một phút", mm: "%d phút", h: "một giờ", hh: "%d giờ", d: "một ngày", dd: "%d ngày", M: "một tháng", MM: "%d tháng", y: "một năm", yy: "%d năm" } };
    return c.default.locale(b, null, !0), b;
  });
})(BC, BC.exports);
BC.exports;
var RC = { exports: {} };
RC.exports;
(function(I, g) {
  (function(C, A) {
    I.exports = A(PC);
  })(NI, function(C) {
    function A(l) {
      return l && typeof l == "object" && "default" in l ? l : { default: l };
    }
    var c = A(C), b = { name: "ja", weekdays: "日曜日_月曜日_火曜日_水曜日_木曜日_金曜日_土曜日".split("_"), weekdaysShort: "日_月_火_水_木_金_土".split("_"), weekdaysMin: "日_月_火_水_木_金_土".split("_"), months: "1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月".split("_"), monthsShort: "1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月".split("_"), ordinal: function(l) {
      return l + "日";
    }, formats: { LT: "HH:mm", LTS: "HH:mm:ss", L: "YYYY/MM/DD", LL: "YYYY年M月D日", LLL: "YYYY年M月D日 HH:mm", LLLL: "YYYY年M月D日 dddd HH:mm", l: "YYYY/MM/DD", ll: "YYYY年M月D日", lll: "YYYY年M月D日 HH:mm", llll: "YYYY年M月D日(ddd) HH:mm" }, meridiem: function(l) {
      return l < 12 ? "午前" : "午後";
    }, relativeTime: { future: "%s後", past: "%s前", s: "数秒", m: "1分", mm: "%d分", h: "1時間", hh: "%d時間", d: "1日", dd: "%d日", M: "1ヶ月", MM: "%dヶ月", y: "1年", yy: "%d年" } };
    return c.default.locale(b, null, !0), b;
  });
})(RC, RC.exports);
RC.exports;
var vC = { exports: {} };
vC.exports;
(function(I, g) {
  (function(C, A) {
    I.exports = A();
  })(NI, function() {
    var C = { LTS: "h:mm:ss A", LT: "h:mm A", L: "MM/DD/YYYY", LL: "MMMM D, YYYY", LLL: "MMMM D, YYYY h:mm A", LLLL: "dddd, MMMM D, YYYY h:mm A" };
    return function(A, c, b) {
      var l = c.prototype, i = l.format;
      b.en.formats = C, l.format = function(u) {
        u === void 0 && (u = "YYYY-MM-DDTHH:mm:ssZ");
        var n = this.$locale().formats, t = function(X, y) {
          return X.replace(/(\[[^\]]+])|(LTS?|l{1,4}|L{1,4})/g, function(s, B, m) {
            var x = m && m.toUpperCase();
            return B || y[m] || C[m] || y[x].replace(/(\[[^\]]+])|(MMMM|MM|DD|dddd)/g, function(v, G, V) {
              return G || V.slice(1);
            });
          });
        }(u, n === void 0 ? {} : n);
        return i.call(this, t);
      };
    };
  });
})(vC, vC.exports);
var du = vC.exports;
const au = /* @__PURE__ */ KI(du);
var NC = { exports: {} };
NC.exports;
(function(I, g) {
  (function(C, A) {
    I.exports = A();
  })(NI, function() {
    var C = { year: 0, month: 1, day: 2, hour: 3, minute: 4, second: 5 }, A = {};
    return function(c, b, l) {
      var i, u = function(y, s, B) {
        B === void 0 && (B = {});
        var m = new Date(y), x = function(v, G) {
          G === void 0 && (G = {});
          var V = G.timeZoneName || "short", d = v + "|" + V, Z = A[d];
          return Z || (Z = new Intl.DateTimeFormat("en-US", { hour12: !1, timeZone: v, year: "numeric", month: "2-digit", day: "2-digit", hour: "2-digit", minute: "2-digit", second: "2-digit", timeZoneName: V }), A[d] = Z), Z;
        }(s, B);
        return x.formatToParts(m);
      }, n = function(y, s) {
        for (var B = u(y, s), m = [], x = 0; x < B.length; x += 1) {
          var v = B[x], G = v.type, V = v.value, d = C[G];
          d >= 0 && (m[d] = parseInt(V, 10));
        }
        var Z = m[3], r = Z === 24 ? 0 : Z, h = m[0] + "-" + m[1] + "-" + m[2] + " " + r + ":" + m[4] + ":" + m[5] + ":000", o = +y;
        return (l.utc(h).valueOf() - (o -= o % 1e3)) / 6e4;
      }, t = b.prototype;
      t.tz = function(y, s) {
        y === void 0 && (y = i);
        var B, m = this.utcOffset(), x = this.toDate(), v = x.toLocaleString("en-US", { timeZone: y }), G = Math.round((x - new Date(v)) / 1e3 / 60), V = 15 * -Math.round(x.getTimezoneOffset() / 15) - G;
        if (!Number(V))
          B = this.utcOffset(0, s);
        else if (B = l(v, { locale: this.$L }).$set("millisecond", this.$ms).utcOffset(V, !0), s) {
          var d = B.utcOffset();
          B = B.add(m - d, "minute");
        }
        return B.$x.$timezone = y, B;
      }, t.offsetName = function(y) {
        var s = this.$x.$timezone || l.tz.guess(), B = u(this.valueOf(), s, { timeZoneName: y }).find(function(m) {
          return m.type.toLowerCase() === "timezonename";
        });
        return B && B.value;
      };
      var X = t.startOf;
      t.startOf = function(y, s) {
        if (!this.$x || !this.$x.$timezone)
          return X.call(this, y, s);
        var B = l(this.format("YYYY-MM-DD HH:mm:ss:SSS"), { locale: this.$L });
        return X.call(B, y, s).tz(this.$x.$timezone, !0);
      }, l.tz = function(y, s, B) {
        var m = B && s, x = B || s || i, v = n(+l(), x);
        if (typeof y != "string")
          return l(y).tz(x);
        var G = function(r, h, o) {
          var F = r - 60 * h * 1e3, R = n(F, o);
          if (h === R)
            return [F, h];
          var z = n(F -= 60 * (R - h) * 1e3, o);
          return R === z ? [F, R] : [r - 60 * Math.min(R, z) * 1e3, Math.max(R, z)];
        }(l.utc(y, m).valueOf(), v, x), V = G[0], d = G[1], Z = l(V).utcOffset(d);
        return Z.$x.$timezone = x, Z;
      }, l.tz.guess = function() {
        return Intl.DateTimeFormat().resolvedOptions().timeZone;
      }, l.tz.setDefault = function(y) {
        i = y;
      };
    };
  });
})(NC, NC.exports);
var Vu = NC.exports;
const su = /* @__PURE__ */ KI(Vu);
var pC = { exports: {} };
pC.exports;
(function(I, g) {
  (function(C, A) {
    I.exports = A();
  })(NI, function() {
    return function(C, A, c) {
      c.updateLocale = function(b, l) {
        var i = c.Ls[b];
        if (i)
          return (l ? Object.keys(l) : []).forEach(function(u) {
            i[u] = l[u];
          }), i;
      };
    };
  });
})(pC, pC.exports);
var mu = pC.exports;
const Wu = /* @__PURE__ */ KI(mu);
var FC = { exports: {} };
FC.exports;
(function(I, g) {
  (function(C, A) {
    I.exports = A();
  })(NI, function() {
    var C = "minute", A = /[+-]\d\d(?::?\d\d)?/g, c = /([+-]|\d\d)/g;
    return function(b, l, i) {
      var u = l.prototype;
      i.utc = function(m) {
        var x = { date: m, utc: !0, args: arguments };
        return new l(x);
      }, u.utc = function(m) {
        var x = i(this.toDate(), { locale: this.$L, utc: !0 });
        return m ? x.add(this.utcOffset(), C) : x;
      }, u.local = function() {
        return i(this.toDate(), { locale: this.$L, utc: !1 });
      };
      var n = u.parse;
      u.parse = function(m) {
        m.utc && (this.$u = !0), this.$utils().u(m.$offset) || (this.$offset = m.$offset), n.call(this, m);
      };
      var t = u.init;
      u.init = function() {
        if (this.$u) {
          var m = this.$d;
          this.$y = m.getUTCFullYear(), this.$M = m.getUTCMonth(), this.$D = m.getUTCDate(), this.$W = m.getUTCDay(), this.$H = m.getUTCHours(), this.$m = m.getUTCMinutes(), this.$s = m.getUTCSeconds(), this.$ms = m.getUTCMilliseconds();
        } else
          t.call(this);
      };
      var X = u.utcOffset;
      u.utcOffset = function(m, x) {
        var v = this.$utils().u;
        if (v(m))
          return this.$u ? 0 : v(this.$offset) ? X.call(this) : this.$offset;
        if (typeof m == "string" && (m = function(Z) {
          Z === void 0 && (Z = "");
          var r = Z.match(A);
          if (!r)
            return null;
          var h = ("" + r[0]).match(c) || ["-", 0, 0], o = h[0], F = 60 * +h[1] + +h[2];
          return F === 0 ? 0 : o === "+" ? F : -F;
        }(m), m === null))
          return this;
        var G = Math.abs(m) <= 16 ? 60 * m : m, V = this;
        if (x)
          return V.$offset = G, V.$u = m === 0, V;
        if (m !== 0) {
          var d = this.$u ? this.toDate().getTimezoneOffset() : -1 * this.utcOffset();
          (V = this.local().add(G + d, C)).$offset = G, V.$x.$localOffset = d;
        } else
          V = this.utc();
        return V;
      };
      var y = u.format;
      u.format = function(m) {
        var x = m || (this.$u ? "YYYY-MM-DDTHH:mm:ss[Z]" : "");
        return y.call(this, x);
      }, u.valueOf = function() {
        var m = this.$utils().u(this.$offset) ? 0 : this.$offset + (this.$x.$localOffset || this.$d.getTimezoneOffset());
        return this.$d.valueOf() - 6e4 * m;
      }, u.isUTC = function() {
        return !!this.$u;
      }, u.toISOString = function() {
        return this.toDate().toISOString();
      }, u.toString = function() {
        return this.toDate().toUTCString();
      };
      var s = u.toDate;
      u.toDate = function(m) {
        return m === "s" && this.$offset ? i(this.format("YYYY-MM-DD HH:mm:ss:SSS")).toDate() : s.call(this);
      };
      var B = u.diff;
      u.diff = function(m, x, v) {
        if (m && this.$u === m.$u)
          return B.call(this, m, x, v);
        var G = this.local(), V = i(m).local();
        return B.call(G, V, x, v);
      };
    };
  });
})(FC, FC.exports);
var ou = FC.exports;
const ru = /* @__PURE__ */ KI(ou);
var yu = () => {
  let [I, g] = nI(!1);
  return II(() => {
    g(!0);
  }, []), I;
};
function hu({ children: I }) {
  let g = yu();
  return tA(An, { children: g ? I : null });
}
var Ju = { [mg.ko]: "82", [mg.en]: "1", [mg.ja]: "81", [mg.vi]: "84" }, xu = { ko: "ko-KR", en: "en-US", ja: "ja-JP", vi: "vi-VN" };
function Bu() {
  let { i18n: I } = BA();
  return Rg(() => {
    let g = I.language || ig;
    return { lang: g, locale: xu[g], countryCode: Ju[g], isKo: g === ig };
  }, [I.language]);
}
LI.extend(su);
LI.extend(ru);
LI.extend(Wu);
LI.extend(au);
LI.updateLocale("ko", { formats: { L: "YYYY. MM. DD.", LL: "YYYY년 MM월 DD일", LT: "A h:mm" } });
var Hc = { L2: { ko: "YY.MM.DD.", en: "MM/DD/YY", ja: "YY/MM/DD", vi: "DD/MM/YY" } };
function XX({ dateTime: I, locale: g, format: C = "L", ...A }) {
  let c = C.split(" ").map((b) => b in Hc ? Hc[b][g] : b).join(" ");
  return tA("time", { dateTime: I, ...A, children: tA(hu, { children: LI(I).locale(g).format(c) }) });
}
const Ru = "Paypal", vu = {
  "010부터 다시 입력해 주세요.": "Please re-enter starting with 010.",
  "2자 이상 입력": "Enter at least 2 characters",
  "2자 이상 입력해 주세요.": "Please enter at least 2 characters.",
  Paypal: Ru,
  "Paypal 링크": "Paypal Link",
  "YYYY년 MM월 DD일": "YYYY-MM-DD",
  "{{label}} 입력": "Enter {{label}}",
  "{{runningHour}}시간_one": "{{runningHour}} hour",
  "{{runningHour}}시간_other": "{{runningHour}} hours",
  "{{runningMinute}}분_one": "{{runningMinute}} minute",
  "{{runningMinute}}분_other": "{{runningMinute}} minutes",
  "{{titleType}} 실명 확인": "{{titleType}} Real Name Verification",
  "{{titleType}}에는 실명이 꼭 필요해요!": "{{titleType}} requires your real name!",
  "감사합니다. 이제 {{realname}}님의 실명이 적힌 수료증을 확인할 수 있습니다.": "Thank you. You can now view the certificate with {{realname}}'s real name.",
  "강의 난이도": "Course Difficulty",
  "강의 난이도가 아쉬워요!": "The course difficulty was disappointing!",
  "강의 퀄리티": "Course Quality",
  "강의 퀄리티가 만족스럽지 않아요.": "The course quality is unsatisfactory.",
  "강의 폴더": "Lecture folder",
  "강의 폴더가 없어요": "No lecture folder exists.",
  "강의 폴더에 추가했어요.": "Added to lecture folder.",
  "강의 폴더에서 제거했어요.": "Removed from lecture folder.",
  "같은 문제가 계속 발생한다면 서비스에 문의해주세요.": "If the problem persists, please contact support.",
  개인: "Individual",
  "견적서(국내송금)": "Quotation (Domestic Transfer)",
  "견적서(해외송금)": "Quotation (International Transfer)",
  계약자명: "Contractor Name",
  "계좌 인증에 실패했습니다. 고객센터에 문의해주세요.": "Account verification failed. Please contact customer support.",
  계좌번호: "Account Number",
  "계좌번호를 다시 확인해주세요. 오류가 지속되면 고객센터로 문의해주세요.": "Please double-check the account number. If the issue continues, contact support.",
  "고유번호가 부여된 단체는 입력이 불가합니다.": "Organizations with assigned unique IDs cannot be entered.",
  교육시간: "Duration",
  "나만의 카테고리를 구성해보세요!": "Create your own category!",
  "내 강의 폴더로 이동": "Go to my lecture folder",
  "내 정산정보": "My Settlement Info",
  "내용을 입력해 주세요.": "Please enter the content.",
  다시입력: "Re-enter",
  "다운 가능한 이미지가 없습니다. 반복될 경우 고객센터에 문의해주세요.": "No downloadable image is available. If the problem persists, please contact customer service.",
  "다음에 할게요": "I'll do it later.",
  다음으로: "Next",
  "더 나은 강의를 위해 개선해야할 점을 작성해 주세요!": "Please write what needs to be improved for a better course!",
  "더 이상 선택할 수 없어요.": "You can't select any more.",
  등록하기: "Register",
  "로그인 하기": "Sign in",
  "링크 복사에 실패했습니다. 반복될 경우 고객센터에 문의해주세요.": "Failed to copy the link. If the problem persists, please contact customer service.",
  "링크가 복사되었습니다": "Link has been copied.",
  "링크드인 수료증 추가": "Add certificate to LinkedIn",
  "마카테모달.접근.설명": "If you select <strong>categories</strong> you're interested in, you can gather only the courses you want!",
  "마카테모달.접근.제목": "Create your own category!",
  "마카테모달.최초접근.설명": "Let us know what <strong>topics</strong> you're interested in,<br/>and we'll help you find the perfect courses quickly!",
  "마카테모달.최초접근.제목": "Welcome to Inflearn, {{userName}}!",
  "모달 닫기": "Close modal",
  "문제가 발생했습니다. 잠시 후 다시 시도해 주세요.": "An error occurred. Please try again later.",
  보러가기: "View",
  사업자: "Business",
  "사업자 상태 인증에 실패했습니다. 고객센터에 문의해주세요.": "Failed to verify business status. Please contact customer support.",
  사업자등록번호: "Business Registration Number",
  "사업자를 찾을 수 없습니다.": "Business not found.",
  사업체명: "Business Name",
  "사운드 문제": "Sound Issue",
  "사운드에 문제가 있어요.": "There is a problem with the sound.",
  "새 강의 폴더를 만들어보세요": "Try creating a new lecture folder.",
  "새 폴더": "New folder",
  "새 폴더 만들기": "Create new folder",
  "새 폴더 이름 입력": "Enter new folder name",
  "새 폴더 입력창 닫기": "Close new folder input window",
  "새 폴더 제출": "Submit new folder",
  "새 폴더를 만들었어요.": "New folder created.",
  "서비스 언어를 선택하세요.": "Select the service language.",
  "선택 완료": "Selection completed",
  "선택한 카테고리": "Selected Category",
  "선택한 카테고리는 강의 검색 페이지 MY 카테고리에 등록됩니다. 😉": "The category you selected will be added to 'My Category' on the course search page. 😉",
  "세션 만료": "Session expired",
  "수강 확인증": "Certificate of Completion",
  "수강평 수정에 문제가 생겼어요.": "There was an issue with editing the review.",
  "수강평 작성에 문제가 생겼어요.": "There was an issue with submitting the review.",
  "수강평을 작성해보세요!": "Write a review!",
  수료일: "Completion Date",
  수료증: "Certificate",
  "수료증 pdf 다운로드": "Download certificate PDF",
  "수료증 링크 복사": "Copy certificate link",
  "수료증 정보를 가져오는데 실패했습니다.": "Failed to retrieve certificate information.",
  수정하기: "Edit",
  "숫자만 입력 가능합니다.": "Only numbers are allowed.",
  시작일: "Start Date",
  "실명 인증 모달 닫기": "Close real name verification modal",
  "실명 입력": "Enter full name",
  "실명 입력 실패": "Failed to enter real name",
  "실명 입력 완료": "Real name input completed",
  "실명:": "Real name:",
  "실사용자 검증을 위해 휴대폰 인증을 진행해 주세요.": "Please verify your phone number for real user validation.",
  "아쉬웠던 점을 1개 이상 선택해 주시면,": "Please select at least one area for improvement,",
  "알 수 없는 오류가 발생했습니다.": "An unknown error occurred.",
  "언어 설정": "Language Settings",
  "예금주명이 일치하지 않습니다.": "Account holder name does not match.",
  "올바른 정산 유형을 선택해주세요.": "Please select a valid settlement type.",
  "외화 계좌는 입력이 불가합니다.": "Foreign currency accounts cannot be used.",
  "위의 교육과정을 성공적으로 수료하였음을 인정하여 이 인증서를 수여합니다.": "This certifies the successful completion of the above course.",
  유형: "Type",
  "유효한 사업자등록번호를 입력해야합니다.": "You must enter a valid business registration number.",
  "유효한 주민등록번호를 입력해야합니다.": "You must enter a valid resident registration number.",
  은행: "Bank",
  "은행을 선택해 주세요.": "Please select a bank.",
  "의견을 반영해 더 좋은 강의를 만들게요.": "and we will use your feedback to create better courses.",
  이름: "Name",
  "이름 (실명)": "Name (Real name)",
  "이름을 입력해 주세요.": "Enter your full name.",
  "이미 인증된 요청입니다.": "This request has already beenauthenticated.",
  "이미 저장된 실명이 있거나 오류가 발생했습니다.": "A real name is already saved or an error has occurred.",
  인증: "Verify",
  "인증 요청": "Send code",
  인증번호: "Verification code",
  "인증번호 요청 중 오류가 발생했습니다.": "An error occurredduring verification code request.",
  "인증번호 유효시간이 초과되었습니다.": "The verificationcode has expired.",
  "인증번호가 일치하지 않습니다.": "The verification codedoes not match.",
  "인증번호가 카카오톡 또는 문자로 전송되었습니다.": "Theverification code has been sent via KakaoTalk or textmessage.",
  "인증번호를 못 받으셨나요? 스팸차단 확인 방법": "Didn'treceive the verification code? Check spam filters.",
  인프랩: "InfLab",
  "인프런 [문의하기]를 이용해 주세요.": "Please use Inflearn's [Contact Us].",
  "인프런 대표": "Inflearn CEO",
  "일일 인증 횟수를 초과했습니다. 고객센터 문의 부탁드립니다.": "You have exceeded the daily authenticationlimit. Please contact customer support.",
  "입력 정보가 유효하지 않습니다.": "The entered information is invalid.",
  "입력된 실명은 수정이 불가하니 한번 더 확인해 주세요!": "The entered real name cannot be modified, so please double-check!",
  "자동 로그아웃 되었습니다. 다시 로그인해주세요.": "You have been automatically signed out. Please sign in again.",
  "자료 부족": "Lack of Materials",
  "자료가 부족해요!": "There aren't enough materials!",
  "잠시 후 다시 시도해주세요.": "Please try again later.",
  재전송: "Resend",
  "재전송은 최대 10회입니다. 10분 후 재시도해 주세요.": "The retransmission is up to 10 times. Please try again in 10minutes.",
  저장하기: "Save",
  전체: "All",
  "정산 정보 수정 완료": "Settlement Info Updated",
  "정산 확정 시 수정된 정보는 익월에 반영됩니다.": "Changes will take effect the following month after settlement confirmation.",
  "정산받으실 분의 성명 또는 사업체명을 입력": "Enter the name or business name of the recipient",
  "정산자 유형": "Settlement Type",
  정산자명: "Payee Name",
  "정산자명 (예금주명)": "Payee Name (Account Holder)",
  "정산정보 등록": "Register Settlement Info",
  "정산정보 수정": "Edit Settlement Info",
  "정산정보는 모든 강의에 동일하게 적용되며, 정산은 익월 10 영업일에 확정됩니다.": "Settlement info applies to all courses and will be finalized within 10 business days of the following month.",
  "정지된 계좌입니다.": "This account is suspended.",
  제출: "Submit",
  제출완료: "Confirm",
  "존재하지 않는 계좌입니다.": "This account does not exist.",
  주민등록번호: "Resident Registration Number",
  지식공유자: "Instructor",
  지출증빙유형: "Expense Proof Type",
  "질문 답변 소통": "Q&A Communication",
  "질문 답변 소통이 원활하지 않아요.": "The Q&A communication is not smooth.",
  "처리 중 오류가 발생했습니다. 잠시 후 다시 시도해 주세요.": "An error occurred during processing. Please try again later.",
  "처리중 오류가 발생했습니다. 잠시후 다시 시도해 주세요.": "An error occurred during processing. Please try again later.",
  "추후 수정이 불가하니 실수없이 입력해 주세요.": "Cannot be modified later, so please enter carefully.",
  취소: "Cancel",
  "폐업 상태인 사업자입니다.": "This business is closed.",
  "폴더명 입력": "Enter folder name",
  "해외 거주자": "Overseas Resident",
  "화질 문제": "Video Quality Issue",
  "화질이 안 좋아요.": "The video quality is poor.",
  확인: "OK",
  "휴대폰 번호": "Mobile",
  "휴대폰 번호 인증": "Phone number verification",
  "휴대폰 번호 입력": "Enter phone number",
  "휴대폰 번호 형식이 올바르지 않습니다.": "Invalid mobilephone number format.",
  "휴대폰 번호를 입력해 주세요.": "Please enter your phonenumber.",
  "휴대폰인증모달.인증안내": "<Span>Verification isperformed</Span> <Green>once.</Green>",
  "휴업 상태인 사업자입니다.": "This business is temporarily closed.",
  "힘이 되는 수강평을 남겨주세요!": "Leave an encouraging review!"
}, Nu = "Paypal", pu = {
  "010부터 다시 입력해 주세요.": "010から再入力してください。",
  "2자 이상 입력": "2文字以上入力",
  "2자 이상 입력해 주세요.": "2文字以上入力してください。",
  Paypal: Nu,
  "Paypal 링크": "Paypalリンク",
  "YYYY년 MM월 DD일": "YYYY年MM月DD日",
  "{{label}} 입력": "{{label}} を入力",
  "{{runningHour}}시간": "{{runningHour}}時間",
  "{{runningHour}}시간_one": "{{runningHour}}時間",
  "{{runningHour}}시간_other": "{{runningHour}}時間",
  "{{runningMinute}}분": "{{runningMinute}}分",
  "{{runningMinute}}분_one": "{{runningMinute}}分",
  "{{runningMinute}}분_other": "{{runningMinute}}分",
  "{{titleType}} 실명 확인": "{{titleType}} 実名確認",
  "{{titleType}}에는 실명이 꼭 필요해요!": "{{titleType}}には実名が必要です！",
  "감사합니다. 이제 {{realname}}님의 실명이 적힌 수료증을 확인할 수 있습니다.": "ありがとうございます。これで{{realname}}様の実名が記載された修了証を確認できます。",
  "강의 난이도": "講義の難易度",
  "강의 난이도가 아쉬워요!": "講義の難易度が物足りないです！",
  "강의 퀄리티": "講義のクオリティ",
  "강의 퀄리티가 만족스럽지 않아요.": "講義のクオリティが満足できません。",
  "강의 폴더": "講義フォルダ",
  "강의 폴더가 없어요": "講義フォルダがありません",
  "강의 폴더에 추가했어요.": "講義フォルダに追加しました。",
  "강의 폴더에서 제거했어요.": "講義フォルダから削除しました。",
  "같은 문제가 계속 발생한다면 서비스에 문의해주세요.": "同じ問題が続けて発生する場合は、サービスにお問い合わせください。",
  개인: "個人",
  "견적서(국내송금)": "見積書（国内送金）",
  "견적서(해외송금)": "見積書（海外送金）",
  계약자명: "契約者名",
  "계좌 인증에 실패했습니다. 고객센터에 문의해주세요.": "口座の認証に失敗しました。カスタマーサポートにお問い合わせください。",
  계좌번호: "口座番号",
  "계좌번호를 다시 확인해주세요. 오류가 지속되면 고객센터로 문의해주세요.": "口座番号を再確認してください。エラーが続く場合は、サポートまでご連絡ください。",
  "고유번호가 부여된 단체는 입력이 불가합니다.": "固有番号が付与された団体は入力できません。",
  교육시간: "教育時間",
  "나만의 카테고리를 구성해보세요!": "自分だけのカテゴリを構成してみてください！",
  "내 강의 폴더로 이동": "自分の講義フォルダに移動",
  "내 정산정보": "自分の精算情報",
  "내용을 입력해 주세요.": "内容を入力してください。",
  다시입력: "再入力",
  "다운 가능한 이미지가 없습니다. 반복될 경우 고객센터에 문의해주세요.": "ダウンロード可能な画像がありません。繰り返し発生する場合はカスタマーセンターにお問い合わせください。",
  "다음에 할게요": "次にします",
  다음으로: "次へ",
  "더 나은 강의를 위해 개선해야할 점을 작성해 주세요!": "より良い講義のために改善すべき点を書いてください！",
  "더 이상 선택할 수 없어요.": "これ以上選択できません。",
  등록하기: "登録する",
  "로그인 하기": "ログインする",
  "링크 복사에 실패했습니다. 반복될 경우 고객센터에 문의해주세요.": "リンクのコピーに失敗しました。繰り返し発生する場合はカスタマーセンターにお問い合わせください。",
  "링크가 복사되었습니다": "リンクがコピーされました",
  "링크드인 수료증 추가": "LinkedIn修了証を追加",
  "마카테모달.접근.설명": "<strong>興味のあるカテゴリ</strong>を選択すると、自分が欲しい講義だけをまとめて見ることができます！",
  "마카테모달.접근.제목": "自分だけのカテゴリを作りましょう！",
  "마카테모달.최초접근.설명": "<strong>興味のあるテーマ</strong>を教えていただければ、</br>あなたにぴったりの講義をすぐに見つけることができます！",
  "마카테모달.최초접근.제목": "{{userName}}さん、<br/>インフランへようこそ！",
  "모달 닫기": "モーダルを閉じる",
  "문제가 발생했습니다. 잠시 후 다시 시도해 주세요.": "問題が発生しました。しばらくしてからもう一度お試しください。",
  보러가기: "見に行く",
  사업자: "事業者",
  "사업자 상태 인증에 실패했습니다. 고객센터에 문의해주세요.": "事業者の状態認証に失敗しました。カスタマーサポートにお問い合わせください。",
  사업자등록번호: "事業者登録番号",
  "사업자를 찾을 수 없습니다.": "事業者が見つかりません。",
  사업체명: "事業所名",
  "사운드 문제": "サウンド問題",
  "사운드에 문제가 있어요.": "サウンドに問題があります。",
  "새 강의 폴더를 만들어보세요": "新しい講義フォルダを作ってみてください",
  "새 폴더": "新しいフォルダ",
  "새 폴더 만들기": "新しいフォルダを作る",
  "새 폴더 이름 입력": "新しいフォルダ名を入力",
  "새 폴더 입력창 닫기": "新しいフォルダ入力欄を閉じる",
  "새 폴더 제출": "新しいフォルダの提出",
  "새 폴더를 만들었어요.": "新しいフォルダを作りました。",
  "서비스 언어를 선택하세요.": "サービス言語を選択してください。",
  "선택 완료": "選択完了",
  "선택한 카테고리": "選択したカテゴリ",
  "선택한 카테고리는 강의 검색 페이지 MY 카테고리에 등록됩니다. 😉": "選択したカテゴリは講義検索ページの私のカテゴリに登録されます。😉",
  "세션 만료": "セッションが期限切れです",
  "수강 확인증": "受講確認証",
  "수강평 수정에 문제가 생겼어요.": "受講評価の修正に問題が発生しました。",
  "수강평 작성에 문제가 생겼어요.": "受講評価の作成に問題が発生しました。",
  "수강평을 작성해보세요!": "受講評価を書いてみてください！",
  수료일: "修了日",
  수료증: "修了証",
  "수료증 pdf 다운로드": "修了証PDFダウンロード",
  "수료증 링크 복사": "修了証リンクをコピー",
  "수료증 정보를 가져오는데 실패했습니다.": "修了証の情報を取得できませんでした。",
  수정하기: "修正する",
  "숫자만 입력 가능합니다.": "数字のみ入力可能です。",
  시작일: "開始日",
  "실명 인증 모달 닫기": "実名認証モーダルを閉じる",
  "실명 입력": "実名入力",
  "실명 입력 실패": "実名入力失敗",
  "실명 입력 완료": "実名入力完了",
  "실명:": "実名:",
  "실사용자 검증을 위해 휴대폰 인증을 진행해 주세요.": "実際の利用者確認のため、携帯電話認証を行ってください。",
  "아쉬웠던 점을 1개 이상 선택해 주시면,": "残念だった点を1つ以上選択してください、",
  "알 수 없는 오류가 발생했습니다.": "不明なエラーが発生しました。",
  "언어 설정": "言語設定",
  "예금주명이 일치하지 않습니다.": "口座名義が一致しません。",
  "올바른 정산 유형을 선택해주세요.": "正しい精算タイプを選択してください。",
  "외화 계좌는 입력이 불가합니다.": "外貨口座は使用できません。",
  "위의 교육과정을 성공적으로 수료하였음을 인정하여 이 인증서를 수여합니다.": "この者は上記の課程を修了したことを認め、ここに証明いたします。",
  유형: "タイプ",
  "유효한 사업자등록번호를 입력해야합니다.": "有効な事業者登録番号を入力してください。",
  "유효한 주민등록번호를 입력해야합니다.": "有効な住民登録番号を入力してください。",
  은행: "銀行",
  "은행을 선택해 주세요.": "銀行を選択してください。",
  "의견을 반영해 더 좋은 강의를 만들게요.": "ご意見を反映してより良い講義を提供します。",
  이름: "名前",
  "이름 (실명)": "名前（実名）",
  "이름을 입력해 주세요.": "お名前を入力してください。",
  "이미 인증된 요청입니다.": "すでに認証されたリクエストです。",
  "이미 저장된 실명이 있거나 오류가 발생했습니다.": "すでに保存された実名があるかエラーが発生しました。",
  인증: "認証",
  "인증 요청": "認証リクエスト",
  인증번호: "認証番号",
  "인증번호 요청 중 오류가 발생했습니다.": "認証番号のリクエスト中にエラーが発生しました。",
  "인증번호 유효시간이 초과되었습니다.": "認証番号の有効時間が切れました。",
  "인증번호가 일치하지 않습니다.": "認証番号が一致しません。",
  "인증번호가 카카오톡 또는 문자로 전송되었습니다.": "認証番号がカカオトークまたはSMSで送信されました。",
  "인증번호를 못 받으셨나요? 스팸차단 확인 방법": "認証番号を受け取れませんか？ スパム防止設定の確認方法",
  인프랩: "インフラップ",
  "인프런 [문의하기]를 이용해 주세요.": "インフラン [お問い合わせ]をご利用ください。",
  "인프런 대표": "インフラン代表",
  "일일 인증 횟수를 초과했습니다. 고객센터 문의 부탁드립니다.": "1日の認証回数を超えました。カスタマーサポートにお問い合わせください。",
  "입력 정보가 유효하지 않습니다.": "入力された情報が無効です。",
  "입력된 실명은 수정이 불가하니 한번 더 확인해 주세요!": "入力された実名は修正できませんので、もう一度確認してください！",
  "자동 로그아웃 되었습니다. 다시 로그인해주세요.": "自動ログアウトされました。再度ログインしてください。",
  "자료 부족": "資料不足",
  "자료가 부족해요!": "資料が不足しています！",
  "잠시 후 다시 시도해주세요.": "しばらくしてからもう一度お試しください。",
  재전송: "再送",
  "재전송은 최대 10회입니다. 10분 후 재시도해 주세요.": "再送は最大10回です。10分後に再度お試しください。",
  저장하기: "保存する",
  전체: "全体",
  "정산 정보 수정 완료": "精算情報の修正が完了しました",
  "정산 확정 시 수정된 정보는 익월에 반영됩니다.": "精算確定後、修正された情報は翌月に反映されます。",
  "정산받으실 분의 성명 또는 사업체명을 입력": "精算を受け取る方の氏名または事業所名を入力してください",
  "정산자 유형": "精算者タイプ",
  정산자명: "精算者名",
  "정산자명 (예금주명)": "精算者名（口座名義）",
  "정산정보 등록": "精算情報を登録",
  "정산정보 수정": "精算情報を修正",
  "정산정보는 모든 강의에 동일하게 적용되며, 정산은 익월 10 영업일에 확정됩니다.": "精算情報はすべての講座に共通で適用され、精算は翌月10営業日以内に確定されます。",
  "정지된 계좌입니다.": "停止された口座です。",
  제출: "提出",
  제출완료: "提出完了",
  "존재하지 않는 계좌입니다.": "存在しない口座です。",
  주민등록번호: "住民登録番号",
  지식공유자: "知識共有者",
  지출증빙유형: "支出証憑の種類",
  "질문 답변 소통": "質問応答コミュニケーション",
  "질문 답변 소통이 원활하지 않아요.": "質問応答のコミュニケーションが円滑ではありません。",
  "처리 중 오류가 발생했습니다. 잠시 후 다시 시도해 주세요.": "処理中にエラーが発生しました。しばらくしてから再試行してください。",
  "처리중 오류가 발생했습니다. 잠시후 다시 시도해 주세요.": "処理中にエラーが発生しました。少し時間をおいてから再試行してください。",
  "추후 수정이 불가하니 실수없이 입력해 주세요.": "後で修正できませんので、ミスなく入力してください。",
  취소: "キャンセル",
  "폐업 상태인 사업자입니다.": "廃業状態の事業者です。",
  "폴더명 입력": "フォルダ名入力",
  "해외 거주자": "海外居住者",
  "화질 문제": "画質問題",
  "화질이 안 좋아요.": "画質が良くありません。",
  확인: "確認",
  "휴대폰 번호": "携帯電話番号",
  "휴대폰 번호 인증": "携帯電話番号認証",
  "휴대폰 번호 입력": "携帯電話番号入力",
  "휴대폰 번호 형식이 올바르지 않습니다.": "携帯電話番号の形式が正しくありません。",
  "휴대폰 번호를 입력해 주세요.": "携帯電話番号を入力してください。",
  "휴대폰인증모달.인증안내": "<Span>認証は</Span> <Green>最初の1回</Green><Span>だけ実施されます。</Span>",
  "휴업 상태인 사업자입니다.": "休業状態の事業者です。",
  "힘이 되는 수강평을 남겨주세요!": "励みになる受講評価を残してください！"
}, Fu = "Paypal", Yu = {
  "010부터 다시 입력해 주세요.": "010부터 다시 입력해주세요.",
  "2자 이상 입력": "2자 이상 입력",
  "2자 이상 입력해 주세요.": "2자 이상 입력해 주세요.",
  Paypal: Fu,
  "Paypal 링크": "Paypal 링크",
  "YYYY년 MM월 DD일": "YYYY년 MM월 DD일",
  "{{label}} 입력": "{{label}} 입력",
  "{{runningHour}}시간": "{{runningHour}}시간",
  "{{runningHour}}시간_one": "{{runningHour}}시간",
  "{{runningHour}}시간_other": "{{runningHour}}시간",
  "{{runningMinute}}분": "{{runningMinute}}분",
  "{{runningMinute}}분_one": "{{runningMinute}}분",
  "{{runningMinute}}분_other": "{{runningMinute}}분",
  "{{titleType}} 실명 확인": "{{titleType}} 실명 확인",
  "{{titleType}}에는 실명이 꼭 필요해요!": "{{titleType}}에는 실명이 꼭 필요해요!",
  "감사합니다. 이제 {{realname}}님의 실명이 적힌 수료증을 확인할 수 있습니다.": "감사합니다. 이제 {{realname}}님의 실명이 적힌 수료증을 확인할 수 있습니다.",
  "강의 난이도": "강의 난이도",
  "강의 난이도가 아쉬워요!": "강의 난이도가 아쉬워요!",
  "강의 퀄리티": "강의 퀄리티",
  "강의 퀄리티가 만족스럽지 않아요.": "강의 퀄리티가 만족스럽지 않아요.",
  "강의 폴더": "강의 폴더",
  "강의 폴더가 없어요": "강의 폴더가 없어요",
  "강의 폴더에 추가했어요.": "강의 폴더에 추가했어요.",
  "강의 폴더에서 제거했어요.": "강의 폴더에서 제거했어요.",
  "같은 문제가 계속 발생한다면 서비스에 문의해주세요.": "같은 문제가 계속 발생한다면 서비스에 문의해주세요.",
  개인: "개인",
  "견적서(국내송금)": "견적서(국내송금)",
  "견적서(해외송금)": "견적서(해외송금)",
  계약자명: "계약자명",
  "계좌 인증에 실패했습니다. 고객센터에 문의해주세요.": "계좌 인증에 실패했습니다. 고객센터에 문의해주세요.",
  계좌번호: "계좌번호",
  "계좌번호를 다시 확인해주세요. 오류가 지속되면 고객센터로 문의해주세요.": "계좌번호를 다시 확인해주세요. 오류가 지속되면 고객센터로 문의해주세요.",
  "고유번호가 부여된 단체는 입력이 불가합니다.": "고유번호가 부여된 단체는 입력이 불가합니다.",
  교육시간: "교육시간",
  "나만의 카테고리를 구성해보세요!": "나만의 카테고리를 구성해보세요!",
  "내 강의 폴더로 이동": "내 강의 폴더로 이동",
  "내 정산정보": "내 정산정보",
  "내용을 입력해 주세요.": "내용을 입력해 주세요.",
  다시입력: "다시입력",
  "다운 가능한 이미지가 없습니다. 반복될 경우 고객센터에 문의해주세요.": "다운 가능한 이미지가 없습니다. 반복될 경우 고객센터에 문의해주세요.",
  "다음에 할게요": "다음에 할게요",
  다음으로: "다음으로",
  "더 나은 강의를 위해 개선해야할 점을 작성해 주세요!": "더 나은 강의를 위해 개선해야할 점을 작성해 주세요!",
  "더 이상 선택할 수 없어요.": "더 이상 선택할 수 없어요.",
  등록하기: "등록하기",
  "로그인 하기": "로그인 하기",
  "링크 복사에 실패했습니다. 반복될 경우 고객센터에 문의해주세요.": "링크 복사에 실패했습니다. 반복될 경우 고객센터에 문의해주세요.",
  "링크가 복사되었습니다": "링크가 복사되었습니다",
  "링크드인 수료증 추가": "링크드인 수료증 추가",
  "마카테모달.접근.설명": "<strong>관심있는 카테고리</strong>를 선택하면, 내가 원하는 강의만 따로 모아 볼 수 있어요!",
  "마카테모달.접근.제목": "나만의 카테고리를 만들어보세요!",
  "마카테모달.최초접근.설명": "<strong>관심있는 주제</strong>에 대해 알려주시면,</br>나에게 딱 맞는 강의를 빠르게 찾을 수 있어요!",
  "마카테모달.최초접근.제목": "{{userName}} 님, <br/> 인프런에 오신 것을 환영해요!",
  "모달 닫기": "모달 닫기",
  "문제가 발생했습니다. 잠시 후 다시 시도해 주세요.": "문제가 발생했습니다. 잠시 후 다시 시도해 주세요.",
  보러가기: "보러가기",
  사업자: "사업자",
  "사업자 상태 인증에 실패했습니다. 고객센터에 문의해주세요.": "사업자 상태 인증에 실패했습니다. 고객센터에 문의해주세요.",
  사업자등록번호: "사업자등록번호",
  "사업자를 찾을 수 없습니다.": "사업자를 찾을 수 없습니다.",
  사업체명: "사업체명",
  "사운드 문제": "사운드 문제",
  "사운드에 문제가 있어요.": "사운드에 문제가 있어요.",
  "새 강의 폴더를 만들어보세요": "새 강의 폴더를 만들어보세요",
  "새 폴더": "새 폴더",
  "새 폴더 만들기": "새 폴더 만들기",
  "새 폴더 이름 입력": "새 폴더 이름 입력",
  "새 폴더 입력창 닫기": "새 폴더 입력창 닫기",
  "새 폴더 제출": "새 폴더 제출",
  "새 폴더를 만들었어요.": "새 폴더를 만들었어요.",
  "서비스 언어를 선택하세요.": "서비스 언어를 선택하세요.",
  "선택 완료": "선택 완료",
  "선택한 카테고리": "선택한 카테고리",
  "선택한 카테고리는 강의 검색 페이지 MY 카테고리에 등록됩니다. 😉": "선택한 카테고리는 강의 검색 페이지 MY 카테고리에 등록됩니다. 😉",
  "세션 만료": "세션 만료",
  "수강 확인증": "수강 확인증",
  "수강평 수정에 문제가 생겼어요.": "수강평 수정에 문제가 생겼어요.",
  "수강평 작성에 문제가 생겼어요.": "수강평 작성에 문제가 생겼어요.",
  "수강평을 작성해보세요!": "수강평을 작성해보세요!",
  수료일: "수료일",
  수료증: "수료증",
  "수료증 pdf 다운로드": "수료증 pdf 다운로드",
  "수료증 링크 복사": "수료증 링크 복사",
  "수료증 정보를 가져오는데 실패했습니다.": "수료증 정보를 가져오는데 실패했습니다.",
  수정하기: "수정하기",
  "숫자만 입력 가능합니다.": "숫자만 입력 가능합니다.",
  시작일: "시작일",
  "실명 인증 모달 닫기": "실명 인증 모달 닫기",
  "실명 입력": "실명 입력",
  "실명 입력 실패": "실명 입력 실패",
  "실명 입력 완료": "실명 입력 완료",
  "실명:": "실명:",
  "실사용자 검증을 위해 휴대폰 인증을 진행해 주세요.": "실사용자 검증을 위해 휴대폰 인증을 진행해 주세요.",
  "아쉬웠던 점을 1개 이상 선택해 주시면,": "아쉬웠던 점을 1개 이상 선택해 주시면,",
  "알 수 없는 오류가 발생했습니다.": "알 수 없는 오류가 발생했습니다.",
  "언어 설정": "언어 설정",
  "예금주명이 일치하지 않습니다.": "예금주명이 일치하지 않습니다.",
  "올바른 정산 유형을 선택해주세요.": "올바른 정산 유형을 선택해주세요.",
  "외화 계좌는 입력이 불가합니다.": "외화 계좌는 입력이 불가합니다.",
  "위의 교육과정을 성공적으로 수료하였음을 인정하여 이 인증서를 수여합니다.": "위의 교육과정을 성공적으로 수료하였음을 인정하여 이 인증서를 수여합니다.",
  유형: "유형",
  "유효한 사업자등록번호를 입력해야합니다.": "유효한 사업자등록번호를 입력해야합니다.",
  "유효한 주민등록번호를 입력해야합니다.": "유효한 주민등록번호를 입력해야합니다.",
  은행: "은행",
  "은행을 선택해 주세요.": "은행을 선택해 주세요.",
  "의견을 반영해 더 좋은 강의를 만들게요.": "의견을 반영해 더 좋은 강의를 만들게요.",
  이름: "이름",
  "이름 (실명)": "이름 (실명)",
  "이름을 입력해 주세요.": "이름을 입력해 주세요.",
  "이미 인증된 요청입니다.": "이미 인증된 요청입니다.",
  "이미 저장된 실명이 있거나 오류가 발생했습니다.": "이미 저장된 실명이 있거나 오류가 발생했습니다.",
  인증: "인증",
  "인증 요청": "인증 요청",
  인증번호: "인증번호",
  "인증번호 요청 중 오류가 발생했습니다.": "인증번호 요청 중 오류가 발생했습니다.",
  "인증번호 유효시간이 초과되었습니다.": "인증번호 유효시간이 초과되었습니다.",
  "인증번호가 일치하지 않습니다.": "인증번호가 일치하지않습니다.",
  "인증번호가 카카오톡 또는 문자로 전송되었습니다.": "인증번호가 카카오톡 또는 문자로 전송되었습니다.",
  "인증번호를 못 받으셨나요? 스팸차단 확인 방법": "인증번호를 못 받으셨나요? 스팸차단 확인 방법",
  인프랩: "인프랩",
  "인프런 [문의하기]를 이용해 주세요.": "인프런 [문의하기]를 이용해 주세요.",
  "인프런 대표": "인프런 대표",
  "일일 인증 횟수를 초과했습니다. 고객센터 문의 부탁드립니다.": "일일 인증 횟수를 초과했습니다. 고객센터 문의부탁드립니다.",
  "입력 정보가 유효하지 않습니다.": "입력 정보가 유효하지 않습니다.",
  "입력된 실명은 수정이 불가하니 한번 더 확인해 주세요!": "입력된 실명은 수정이 불가하니 한번 더 확인해 주세요!",
  "자동 로그아웃 되었습니다. 다시 로그인해주세요.": "자동 로그아웃 되었습니다. 다시 로그인해주세요.",
  "자료 부족": "자료 부족",
  "자료가 부족해요!": "자료가 부족해요!",
  "잠시 후 다시 시도해주세요.": "잠시 후 다시 시도해주세요.",
  재전송: "재전송",
  "재전송은 최대 10회입니다. 10분 후 재시도해 주세요.": "재전송은 최대 10회입니다. 10분 후 재시도해 주세요.",
  저장하기: "저장하기",
  전체: "전체",
  "정산 정보 수정 완료": "정산 정보 수정 완료",
  "정산 확정 시 수정된 정보는 익월에 반영됩니다.": "정산 확정 시 수정된 정보는 익월에 반영됩니다.",
  "정산받으실 분의 성명 또는 사업체명을 입력": "정산받으실 분의 성명 또는 사업체명을 입력",
  "정산자 유형": "정산자 유형",
  정산자명: "정산자명",
  "정산자명 (예금주명)": "정산자명 (예금주명)",
  "정산정보 등록": "정산정보 등록",
  "정산정보 수정": "정산정보 수정",
  "정산정보는 모든 강의에 동일하게 적용되며, 정산은 익월 10 영업일에 확정됩니다.": "정산정보는 모든 강의에 동일하게 적용되며, 정산은 익월 10 영업일에 확정됩니다.",
  "정지된 계좌입니다.": "정지된 계좌입니다.",
  제출: "제출",
  제출완료: "제출완료",
  "존재하지 않는 계좌입니다.": "존재하지 않는 계좌입니다.",
  주민등록번호: "주민등록번호",
  지식공유자: "지식공유자",
  지출증빙유형: "지출증빙유형",
  "질문 답변 소통": "질문 답변 소통",
  "질문 답변 소통이 원활하지 않아요.": "질문 답변 소통이 원활하지 않아요.",
  "처리 중 오류가 발생했습니다. 잠시 후 다시 시도해 주세요.": "처리 중 오류가 발생했습니다. 잠시 후 다시 시도해 주세요.",
  "처리중 오류가 발생했습니다. 잠시후 다시 시도해 주세요.": "처리중 오류가 발생했습니다. 잠시후 다시 시도해 주세요.",
  "추후 수정이 불가하니 실수없이 입력해 주세요.": "추후 수정이 불가하니 실수없이 입력해 주세요.",
  취소: "취소",
  "폐업 상태인 사업자입니다.": "폐업 상태인 사업자입니다.",
  "폴더명 입력": "폴더명 입력",
  "해외 거주자": "해외 거주자",
  "화질 문제": "화질 문제",
  "화질이 안 좋아요.": "화질이 안 좋아요.",
  확인: "확인",
  "휴대폰 번호": "휴대폰 번호",
  "휴대폰 번호 인증": "휴대폰 번호 인증",
  "휴대폰 번호 입력": "휴대폰 번호 입력",
  "휴대폰 번호 형식이 올바르지 않습니다.": "휴대폰 번호 형식이 올바르지 않습니다.",
  "휴대폰 번호를 입력해 주세요.": "휴대폰 번호를 입력해주세요.",
  "휴대폰인증모달.인증안내": "<Span>인증은</Span> <Green>최초1회</Green><Span>만 진행 됩니다.</Span>",
  "휴업 상태인 사업자입니다.": "휴업 상태인 사업자입니다.",
  "힘이 되는 수강평을 남겨주세요!": "힘이 되는 수강평을 남겨주세요!"
}, Hu = "Paypal", zu = {
  "010부터 다시 입력해 주세요.": "Vui lòng nhập lại bắt đầu với 010.",
  "2자 이상 입력": "Nhập ít nhất 2 ký tự",
  "2자 이상 입력해 주세요.": "Vui lòng nhập ít nhất 2 ký tự.",
  Paypal: Hu,
  "Paypal 링크": "Liên kết Paypal",
  "YYYY년 MM월 DD일": "YYYY-MM-DD",
  "{{label}} 입력": "Nhập {{label}}",
  "{{runningHour}}시간_one": "{{runningHour}} giờ",
  "{{runningHour}}시간_other": "{{runningHour}} giờ",
  "{{runningMinute}}분_one": "{{runningMinute}} phút",
  "{{runningMinute}}분_other": "{{runningMinute}} phút",
  "{{titleType}} 실명 확인": "Xác minh tên thật {{titleType}}",
  "{{titleType}}에는 실명이 꼭 필요해요!": "{{titleType}} yêu cầu phải có tên thật!",
  "감사합니다. 이제 {{realname}}님의 실명이 적힌 수료증을 확인할 수 있습니다.": "Cảm ơn bạn. Bây giờ bạn có thể xem chứng chỉ với tên thật của {{realname}}.",
  "강의 난이도": "Độ khó của khóa học",
  "강의 난이도가 아쉬워요!": "Độ khó của khóa học không như mong đợi!",
  "강의 퀄리티": "Chất lượng khóa học",
  "강의 퀄리티가 만족스럽지 않아요.": "Chất lượng khóa học không đạt yêu cầu.",
  "강의 폴더": "Thư mục bài giảng",
  "강의 폴더가 없어요": "Không có thư mục bài giảng.",
  "강의 폴더에 추가했어요.": "Đã thêm vào thư mục bài giảng.",
  "강의 폴더에서 제거했어요.": "Đã xóa khỏi thư mục bài giảng.",
  "같은 문제가 계속 발생한다면 서비스에 문의해주세요.": "Nếu vấn đề tiếp tục xảy ra, vui lòng liên hệ dịch vụ hỗ trợ.",
  개인: "Cá nhân",
  "견적서(국내송금)": "Báo giá (Chuyển khoản nội địa)",
  "견적서(해외송금)": "Báo giá (Chuyển khoản quốc tế)",
  계약자명: "Tên người ký hợp đồng",
  "계좌 인증에 실패했습니다. 고객센터에 문의해주세요.": "Xác minh tài khoản thất bại. Vui lòng liên hệ bộ phận chăm sóc khách hàng.",
  계좌번호: "Số tài khoản",
  "계좌번호를 다시 확인해주세요. 오류가 지속되면 고객센터로 문의해주세요.": "Vui lòng kiểm tra lại số tài khoản. Nếu lỗi tiếp tục xảy ra, hãy liên hệ với bộ phận chăm sóc khách hàng.",
  "고유번호가 부여된 단체는 입력이 불가합니다.": "Không thể nhập tổ chức có mã số định danh.",
  교육시간: "Thời lượng",
  "나만의 카테고리를 구성해보세요!": "Hãy tạo danh mục riêng của bạn!",
  "내 강의 폴더로 이동": "Đi đến thư mục bài giảng của tôi",
  "내 정산정보": "Thông tin thanh toán của tôi",
  "내용을 입력해 주세요.": "Vui lòng nhập nội dung.",
  다시입력: "Nhập lại",
  "다운 가능한 이미지가 없습니다. 반복될 경우 고객센터에 문의해주세요.": "Không có hình ảnh nào để tải xuống. Nếu vấn đề tiếp diễn, vui lòng liên hệ với trung tâm dịch vụ khách hàng.",
  "다음에 할게요": "Tôi sẽ làm sau.",
  다음으로: "Tiếp theo",
  "더 나은 강의를 위해 개선해야할 점을 작성해 주세요!": "Vui lòng viết những điểm cần cải thiện để khóa học tốt hơn!",
  "더 이상 선택할 수 없어요.": "Bạn không thể chọn thêm nữa.",
  등록하기: "Đăng ký",
  "로그인 하기": "Đăng nhập",
  "링크 복사에 실패했습니다. 반복될 경우 고객센터에 문의해주세요.": "Không thể sao chép liên kết. Nếu vấn đề tiếp diễn, vui lòng liên hệ với trung tâm dịch vụ khách hàng.",
  "링크가 복사되었습니다": "Liên kết đã được sao chép.",
  "링크드인 수료증 추가": "Thêm chứng chỉ vào LinkedIn",
  "마카테모달.접근.설명": "Nếu bạn chọn <strong>các danh mục</strong> bạn quan tâm, bạn có thể tập hợp các khóa học bạn muốn!",
  "마카테모달.접근.제목": "Tạo danh mục riêng của bạn!",
  "마카테모달.최초접근.설명": "Hãy cho chúng tôi biết <strong>chủ đề</strong> bạn quan tâm,<br/>và chúng tôi sẽ giúp bạn tìm các khóa học phù hợp nhanh chóng!",
  "마카테모달.최초접근.제목": "Chào mừng đến với Inflearn, {{userName}}!",
  "모달 닫기": "Đóng cửa sổ",
  "문제가 발생했습니다. 잠시 후 다시 시도해 주세요.": "Có lỗi xảy ra. Vui lòng thử lại sau.",
  보러가기: "Xem",
  사업자: "Doanh nghiệp",
  "사업자 상태 인증에 실패했습니다. 고객센터에 문의해주세요.": "Xác minh trạng thái doanh nghiệp thất bại. Vui lòng liên hệ bộ phận chăm sóc khách hàng.",
  사업자등록번호: "Số đăng ký doanh nghiệp",
  "사업자를 찾을 수 없습니다.": "Không tìm thấy doanh nghiệp.",
  사업체명: "Tên doanh nghiệp",
  "사운드 문제": "Vấn đề âm thanh",
  "사운드에 문제가 있어요.": "Có vấn đề với âm thanh.",
  "새 강의 폴더를 만들어보세요": "Hãy thử tạo thư mục bài giảng mới.",
  "새 폴더": "Thư mục mới",
  "새 폴더 만들기": "Tạo thư mục mới",
  "새 폴더 이름 입력": "Nhập tên thư mục mới",
  "새 폴더 입력창 닫기": "Đóng cửa sổ nhập thư mục mới",
  "새 폴더 제출": "Gửi thư mục mới",
  "새 폴더를 만들었어요.": "Đã tạo thư mục mới.",
  "서비스 언어를 선택하세요.": "Vui lòng chọn ngôn ngữ dịch vụ.",
  "선택 완료": "Hoàn tất lựa chọn",
  "선택한 카테고리": "Danh mục đã chọn",
  "선택한 카테고리는 강의 검색 페이지 MY 카테고리에 등록됩니다. 😉": "Danh mục bạn đã chọn sẽ được thêm vào 'Danh mục của tôi' trên trang tìm kiếm khóa học. 😉",
  "세션 만료": "Phiên đã hết hạn",
  "수강 확인증": "Chứng nhận hoàn thành khóa học",
  "수강평 수정에 문제가 생겼어요.": "Đã xảy ra lỗi khi chỉnh sửa đánh giá.",
  "수강평 작성에 문제가 생겼어요.": "Đã xảy ra lỗi khi gửi đánh giá.",
  "수강평을 작성해보세요!": "Hãy viết đánh giá!",
  수료일: "Ngày hoàn thành",
  수료증: "Chứng chỉ",
  "수료증 pdf 다운로드": "Tải xuống PDF chứng chỉ",
  "수료증 링크 복사": "Sao chép liên kết chứng chỉ",
  "수료증 정보를 가져오는데 실패했습니다.": "Không thể lấy thông tin chứng chỉ.",
  수정하기: "Chỉnh sửa",
  "숫자만 입력 가능합니다.": "Chỉ có thể nhập số.",
  시작일: "Ngày bắt đầu",
  "실명 인증 모달 닫기": "Đóng cửa sổ xác minh tên thật",
  "실명 입력": "Nhập tên đầy đủ",
  "실명 입력 실패": "Nhập tên thật thất bại",
  "실명 입력 완료": "Hoàn tất nhập tên thật",
  "실명:": "Tên thật:",
  "실사용자 검증을 위해 휴대폰 인증을 진행해 주세요.": "Vui lòng xác minh số điện thoại của bạn cho việc xác thực người dùng thực.",
  "아쉬웠던 점을 1개 이상 선택해 주시면,": "Vui lòng chọn ít nhất 1 điểm cần cải thiện,",
  "알 수 없는 오류가 발생했습니다.": "Đã xảy ra lỗi không xác định.",
  "언어 설정": "Cài đặt ngôn ngữ",
  "예금주명이 일치하지 않습니다.": "Tên chủ tài khoản không khớp.",
  "올바른 정산 유형을 선택해주세요.": "Vui lòng chọn loại thanh toán hợp lệ.",
  "외화 계좌는 입력이 불가합니다.": "Không thể nhập tài khoản ngoại tệ.",
  "위의 교육과정을 성공적으로 수료하였음을 인정하여 이 인증서를 수여합니다.": "Chúng tôi trao chứng chỉ này để công nhận bạn đã hoàn thành xuất sắc khóa học trên.",
  유형: "Loại",
  "유효한 사업자등록번호를 입력해야합니다.": "Bạn phải nhập số đăng ký doanh nghiệp hợp lệ.",
  "유효한 주민등록번호를 입력해야합니다.": "Bạn phải nhập số chứng minh nhân dân hợp lệ.",
  은행: "Ngân hàng",
  "은행을 선택해 주세요.": "Vui lòng chọn ngân hàng.",
  "의견을 반영해 더 좋은 강의를 만들게요.": "Chúng tôi sẽ sử dụng ý kiến của bạn để tạo ra các khóa học tốt hơn.",
  이름: "Tên",
  "이름 (실명)": "Tên (Tên thật)",
  "이름을 입력해 주세요.": "Nhập tên đầy đủ của bạn.",
  "이미 인증된 요청입니다.": "Yêu cầu này đã được xác thực.",
  "이미 저장된 실명이 있거나 오류가 발생했습니다.": "Tên thật đã được lưu hoặc đã xảy ra lỗi.",
  인증: "Xác minh",
  "인증 요청": "Gửi mã",
  인증번호: "Mã xác minh",
  "인증번호 요청 중 오류가 발생했습니다.": "Có lỗi xảy ra khi yêu cầu mã xác minh.",
  "인증번호 유효시간이 초과되었습니다.": "Mã xác minh đã hết hạn.",
  "인증번호가 일치하지 않습니다.": "Mã xác minh không khớp.",
  "인증번호가 카카오톡 또는 문자로 전송되었습니다.": "Mã xác minh đã được gửi qua KakaoTalk hoặc tin nhắn.",
  "인증번호를 못 받으셨나요? 스팸차단 확인 방법": "Bạn không nhận được mã xác minh? Kiểm tra bộ lọc thư rác.",
  인프랩: "InfLab",
  "인프런 [문의하기]를 이용해 주세요.": "Vui lòng sử dụng [Liên hệ] của Inflearn.",
  "인프런 대표": "CEO Inflearn",
  "일일 인증 횟수를 초과했습니다. 고객센터 문의 부탁드립니다.": "Bạn đã vượt quá số lần xác thực hàng ngày. Vui lòng liên hệ bộ phận hỗ trợ.",
  "입력 정보가 유효하지 않습니다.": "Thông tin nhập vào không hợp lệ.",
  "입력된 실명은 수정이 불가하니 한번 더 확인해 주세요!": "Tên thật đã nhập không thể chỉnh sửa, vui lòng kiểm tra kỹ!",
  "자동 로그아웃 되었습니다. 다시 로그인해주세요.": "Bạn đã tự động đăng xuất. Vui lòng đăng nhập lại.",
  "자료 부족": "Thiếu tài liệu",
  "자료가 부족해요!": "Không đủ tài liệu!",
  "잠시 후 다시 시도해주세요.": "Vui lòng thử lại sau.",
  재전송: "Gửi lại",
  "재전송은 최대 10회입니다. 10분 후 재시도해 주세요.": "Việc gửi lại tối đa 10 lần. Vui lòng thử lại sau 10 phút.",
  저장하기: "Lưu",
  전체: "Tất cả",
  "정산 정보 수정 완료": "Đã cập nhật thông tin thanh toán",
  "정산 확정 시 수정된 정보는 익월에 반영됩니다.": "Khi thanh toán được chốt, thông tin đã chỉnh sửa sẽ được áp dụng vào tháng sau.",
  "정산받으실 분의 성명 또는 사업체명을 입력": "Nhập tên người nhận thanh toán hoặc tên doanh nghiệp",
  "정산자 유형": "Loại người nhận thanh toán",
  정산자명: "Tên người thanh toán",
  "정산자명 (예금주명)": "Tên người thanh toán (Chủ tài khoản)",
  "정산정보 등록": "Đăng ký thông tin thanh toán",
  "정산정보 수정": "Chỉnh sửa thông tin thanh toán",
  "정산정보는 모든 강의에 동일하게 적용되며, 정산은 익월 10 영업일에 확정됩니다.": "Thông tin thanh toán được áp dụng giống nhau cho tất cả các khóa học và sẽ được chốt vào ngày làm việc thứ 10 của tháng sau.",
  "정지된 계좌입니다.": "Tài khoản đã bị khóa.",
  제출: "Gửi",
  제출완료: "Xác nhận",
  "존재하지 않는 계좌입니다.": "Tài khoản không tồn tại.",
  주민등록번호: "Số chứng minh nhân dân",
  지식공유자: "Giảng viên",
  지출증빙유형: "Loại chứng từ chi tiêu",
  "질문 답변 소통": "Giao tiếp Hỏi & Đáp",
  "질문 답변 소통이 원활하지 않아요.": "Giao tiếp Hỏi & Đáp không suôn sẻ.",
  "처리 중 오류가 발생했습니다. 잠시 후 다시 시도해 주세요.": "Đã xảy ra lỗi trong quá trình xử lý. Vui lòng thử lại sau.",
  "처리중 오류가 발생했습니다. 잠시후 다시 시도해 주세요.": "Đã xảy ra lỗi trong quá trình xử lý. Vui lòng thử lại sau.",
  "추후 수정이 불가하니 실수없이 입력해 주세요.": "Không thể chỉnh sửa sau này, vui lòng nhập cẩn thận.",
  취소: "Hủy",
  "폐업 상태인 사업자입니다.": "Doanh nghiệp đã ngừng hoạt động.",
  "폴더명 입력": "Nhập tên thư mục",
  "해외 거주자": "Người cư trú ở nước ngoài",
  "화질 문제": "Vấn đề chất lượng video",
  "화질이 안 좋아요.": "Chất lượng video kém.",
  확인: "OK",
  "휴대폰 번호": "Điện thoại",
  "휴대폰 번호 인증": "Xác minh số điện thoại",
  "휴대폰 번호 입력": "Nhập số điện thoại",
  "휴대폰 번호 형식이 올바르지 않습니다.": "Định dạng số điện thoại không đúng",
  "휴대폰 번호를 입력해 주세요.": "Nhập số điện thoại di động của bạn.",
  "휴대폰인증모달.인증안내": "<Span>Xác minh được thực hiện</Span> <Green>một lần.</Green>",
  "휴업 상태인 사업자입니다.": "Doanh nghiệp đang tạm ngừng hoạt động.",
  "힘이 되는 수강평을 남겨주세요!": "Hãy để lại đánh giá khích lệ!"
}, Uu = {
  ko: {
    modals: Yu
  },
  en: {
    modals: vu
  },
  vi: {
    modals: zu
  },
  ja: {
    modals: pu
  }
}, Lu = (I) => !!kA.find((g) => I === g), Og = xi.createInstance();
Og.use(Bi).init({
  defaultNS: "modals",
  lng: ig,
  supportedLngs: kA,
  fallbackLng: ig,
  debug: !1,
  interpolation: {
    escapeValue: !1
  },
  resources: Uu
});
function Al(I) {
  return BA("modals", I);
}
var YC = { exports: {} };
YC.exports;
(function(I, g) {
  (function(C, A) {
    I.exports = A();
  })(NI, function() {
    var C, A, c = 1e3, b = 6e4, l = 36e5, i = 864e5, u = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, n = 31536e6, t = 2628e6, X = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/, y = { years: n, months: t, days: i, hours: l, minutes: b, seconds: c, milliseconds: 1, weeks: 6048e5 }, s = function(r) {
      return r instanceof d;
    }, B = function(r, h, o) {
      return new d(r, o, h.$l);
    }, m = function(r) {
      return A.p(r) + "s";
    }, x = function(r) {
      return r < 0;
    }, v = function(r) {
      return x(r) ? Math.ceil(r) : Math.floor(r);
    }, G = function(r) {
      return Math.abs(r);
    }, V = function(r, h) {
      return r ? x(r) ? { negative: !0, format: "" + G(r) + h } : { negative: !1, format: "" + r + h } : { negative: !1, format: "" };
    }, d = function() {
      function r(o, F, R) {
        var z = this;
        if (this.$d = {}, this.$l = R, o === void 0 && (this.$ms = 0, this.parseFromMilliseconds()), F)
          return B(o * y[m(F)], this);
        if (typeof o == "number")
          return this.$ms = o, this.parseFromMilliseconds(), this;
        if (typeof o == "object")
          return Object.keys(o).forEach(function(H) {
            z.$d[m(H)] = o[H];
          }), this.calMilliseconds(), this;
        if (typeof o == "string") {
          var D = o.match(X);
          if (D) {
            var _ = D.slice(2).map(function(H) {
              return H != null ? Number(H) : 0;
            });
            return this.$d.years = _[0], this.$d.months = _[1], this.$d.weeks = _[2], this.$d.days = _[3], this.$d.hours = _[4], this.$d.minutes = _[5], this.$d.seconds = _[6], this.calMilliseconds(), this;
          }
        }
        return this;
      }
      var h = r.prototype;
      return h.calMilliseconds = function() {
        var o = this;
        this.$ms = Object.keys(this.$d).reduce(function(F, R) {
          return F + (o.$d[R] || 0) * y[R];
        }, 0);
      }, h.parseFromMilliseconds = function() {
        var o = this.$ms;
        this.$d.years = v(o / n), o %= n, this.$d.months = v(o / t), o %= t, this.$d.days = v(o / i), o %= i, this.$d.hours = v(o / l), o %= l, this.$d.minutes = v(o / b), o %= b, this.$d.seconds = v(o / c), o %= c, this.$d.milliseconds = o;
      }, h.toISOString = function() {
        var o = V(this.$d.years, "Y"), F = V(this.$d.months, "M"), R = +this.$d.days || 0;
        this.$d.weeks && (R += 7 * this.$d.weeks);
        var z = V(R, "D"), D = V(this.$d.hours, "H"), _ = V(this.$d.minutes, "M"), H = this.$d.seconds || 0;
        this.$d.milliseconds && (H += this.$d.milliseconds / 1e3, H = Math.round(1e3 * H) / 1e3);
        var J = V(H, "S"), N = o.negative || F.negative || z.negative || D.negative || _.negative || J.negative, U = D.format || _.format || J.format ? "T" : "", Y = (N ? "-" : "") + "P" + o.format + F.format + z.format + U + D.format + _.format + J.format;
        return Y === "P" || Y === "-P" ? "P0D" : Y;
      }, h.toJSON = function() {
        return this.toISOString();
      }, h.format = function(o) {
        var F = o || "YYYY-MM-DDTHH:mm:ss", R = { Y: this.$d.years, YY: A.s(this.$d.years, 2, "0"), YYYY: A.s(this.$d.years, 4, "0"), M: this.$d.months, MM: A.s(this.$d.months, 2, "0"), D: this.$d.days, DD: A.s(this.$d.days, 2, "0"), H: this.$d.hours, HH: A.s(this.$d.hours, 2, "0"), m: this.$d.minutes, mm: A.s(this.$d.minutes, 2, "0"), s: this.$d.seconds, ss: A.s(this.$d.seconds, 2, "0"), SSS: A.s(this.$d.milliseconds, 3, "0") };
        return F.replace(u, function(z, D) {
          return D || String(R[z]);
        });
      }, h.as = function(o) {
        return this.$ms / y[m(o)];
      }, h.get = function(o) {
        var F = this.$ms, R = m(o);
        return R === "milliseconds" ? F %= 1e3 : F = R === "weeks" ? v(F / y[R]) : this.$d[R], F || 0;
      }, h.add = function(o, F, R) {
        var z;
        return z = F ? o * y[m(F)] : s(o) ? o.$ms : B(o, this).$ms, B(this.$ms + z * (R ? -1 : 1), this);
      }, h.subtract = function(o, F) {
        return this.add(o, F, !0);
      }, h.locale = function(o) {
        var F = this.clone();
        return F.$l = o, F;
      }, h.clone = function() {
        return B(this.$ms, this);
      }, h.humanize = function(o) {
        return C().add(this.$ms, "ms").locale(this.$l).fromNow(!o);
      }, h.valueOf = function() {
        return this.asMilliseconds();
      }, h.milliseconds = function() {
        return this.get("milliseconds");
      }, h.asMilliseconds = function() {
        return this.as("milliseconds");
      }, h.seconds = function() {
        return this.get("seconds");
      }, h.asSeconds = function() {
        return this.as("seconds");
      }, h.minutes = function() {
        return this.get("minutes");
      }, h.asMinutes = function() {
        return this.as("minutes");
      }, h.hours = function() {
        return this.get("hours");
      }, h.asHours = function() {
        return this.as("hours");
      }, h.days = function() {
        return this.get("days");
      }, h.asDays = function() {
        return this.as("days");
      }, h.weeks = function() {
        return this.get("weeks");
      }, h.asWeeks = function() {
        return this.as("weeks");
      }, h.months = function() {
        return this.get("months");
      }, h.asMonths = function() {
        return this.as("months");
      }, h.years = function() {
        return this.get("years");
      }, h.asYears = function() {
        return this.as("years");
      }, r;
    }(), Z = function(r, h, o) {
      return r.add(h.years() * o, "y").add(h.months() * o, "M").add(h.days() * o, "d").add(h.hours() * o, "h").add(h.minutes() * o, "m").add(h.seconds() * o, "s").add(h.milliseconds() * o, "ms");
    };
    return function(r, h, o) {
      C = o, A = o().$utils(), o.duration = function(z, D) {
        var _ = o.locale();
        return B(z, { $l: _ }, D);
      }, o.isDuration = s;
      var F = h.prototype.add, R = h.prototype.subtract;
      h.prototype.add = function(z, D) {
        return s(z) ? Z(this, z, 1) : F.bind(this)(z, D);
      }, h.prototype.subtract = function(z, D) {
        return s(z) ? Z(this, z, -1) : R.bind(this)(z, D);
      };
    };
  });
})(YC, YC.exports);
var Su = YC.exports;
const fu = /* @__PURE__ */ KI(Su);
LI.extend(fu);
LI.locale(ig);
function Tu({
  lang: I,
  isOpened: g
}) {
  const [C, A] = UI(!1), c = async (b) => {
    Og.language !== b && (await Og.changeLanguage(b), LI.locale(b));
  };
  return II(function() {
    if (!g)
      return;
    const b = Lu(I) ? I : ig;
    c(b).then(() => {
      A.open();
    });
  }, [I, g]), II(function() {
    g || A.close();
  }, [g]), {
    isReady: C,
    i18nInstance: Og
  };
}
var ku = {}, wu = (I) => encodeURIComponent(I).replace(/[!'()*]/g, (g) => `%${g.charCodeAt(0).toString(16).toUpperCase()}`), cl = "%[a-f0-9]{2}", zc = new RegExp("(" + cl + ")|([^%]+?)", "gi"), Uc = new RegExp("(" + cl + ")+", "gi");
function aA(I, g) {
  try {
    return [decodeURIComponent(I.join(""))];
  } catch {
  }
  if (I.length === 1)
    return I;
  g = g || 1;
  var C = I.slice(0, g), A = I.slice(g);
  return Array.prototype.concat.call([], aA(C), aA(A));
}
function Qu(I) {
  try {
    return decodeURIComponent(I);
  } catch {
    for (var g = I.match(zc) || [], C = 1; C < g.length; C++)
      I = aA(g, C).join(""), g = I.match(zc) || [];
    return I;
  }
}
function Ou(I) {
  for (var g = {
    "%FE%FF": "��",
    "%FF%FE": "��"
  }, C = Uc.exec(I); C; ) {
    try {
      g[C[0]] = decodeURIComponent(C[0]);
    } catch {
      var A = Qu(C[0]);
      A !== C[0] && (g[C[0]] = A);
    }
    C = Uc.exec(I);
  }
  g["%C2"] = "�";
  for (var c = Object.keys(g), b = 0; b < c.length; b++) {
    var l = c[b];
    I = I.replace(new RegExp(l, "g"), g[l]);
  }
  return I;
}
var Du = function(I) {
  if (typeof I != "string")
    throw new TypeError("Expected `encodedURI` to be of type `string`, got `" + typeof I + "`");
  try {
    return I = I.replace(/\+/g, " "), decodeURIComponent(I);
  } catch {
    return Ou(I);
  }
}, Eu = (I, g) => {
  if (!(typeof I == "string" && typeof g == "string"))
    throw new TypeError("Expected the arguments to be of type `string`");
  if (g === "")
    return [I];
  const C = I.indexOf(g);
  return C === -1 ? [I] : [
    I.slice(0, C),
    I.slice(C + g.length)
  ];
}, Pu = function(I, g) {
  for (var C = {}, A = Object.keys(I), c = Array.isArray(g), b = 0; b < A.length; b++) {
    var l = A[b], i = I[l];
    (c ? g.indexOf(l) !== -1 : g(l, i, I)) && (C[l] = i);
  }
  return C;
};
(function(I) {
  const g = wu, C = Du, A = Eu, c = Pu, b = (G) => G == null, l = Symbol("encodeFragmentIdentifier");
  function i(G) {
    switch (G.arrayFormat) {
      case "index":
        return (V) => (d, Z) => {
          const r = d.length;
          return Z === void 0 || G.skipNull && Z === null || G.skipEmptyString && Z === "" ? d : Z === null ? [...d, [t(V, G), "[", r, "]"].join("")] : [
            ...d,
            [t(V, G), "[", t(r, G), "]=", t(Z, G)].join("")
          ];
        };
      case "bracket":
        return (V) => (d, Z) => Z === void 0 || G.skipNull && Z === null || G.skipEmptyString && Z === "" ? d : Z === null ? [...d, [t(V, G), "[]"].join("")] : [...d, [t(V, G), "[]=", t(Z, G)].join("")];
      case "colon-list-separator":
        return (V) => (d, Z) => Z === void 0 || G.skipNull && Z === null || G.skipEmptyString && Z === "" ? d : Z === null ? [...d, [t(V, G), ":list="].join("")] : [...d, [t(V, G), ":list=", t(Z, G)].join("")];
      case "comma":
      case "separator":
      case "bracket-separator": {
        const V = G.arrayFormat === "bracket-separator" ? "[]=" : "=";
        return (d) => (Z, r) => r === void 0 || G.skipNull && r === null || G.skipEmptyString && r === "" ? Z : (r = r === null ? "" : r, Z.length === 0 ? [[t(d, G), V, t(r, G)].join("")] : [[Z, t(r, G)].join(G.arrayFormatSeparator)]);
      }
      default:
        return (V) => (d, Z) => Z === void 0 || G.skipNull && Z === null || G.skipEmptyString && Z === "" ? d : Z === null ? [...d, t(V, G)] : [...d, [t(V, G), "=", t(Z, G)].join("")];
    }
  }
  function u(G) {
    let V;
    switch (G.arrayFormat) {
      case "index":
        return (d, Z, r) => {
          if (V = /\[(\d*)\]$/.exec(d), d = d.replace(/\[\d*\]$/, ""), !V) {
            r[d] = Z;
            return;
          }
          r[d] === void 0 && (r[d] = {}), r[d][V[1]] = Z;
        };
      case "bracket":
        return (d, Z, r) => {
          if (V = /(\[\])$/.exec(d), d = d.replace(/\[\]$/, ""), !V) {
            r[d] = Z;
            return;
          }
          if (r[d] === void 0) {
            r[d] = [Z];
            return;
          }
          r[d] = [].concat(r[d], Z);
        };
      case "colon-list-separator":
        return (d, Z, r) => {
          if (V = /(:list)$/.exec(d), d = d.replace(/:list$/, ""), !V) {
            r[d] = Z;
            return;
          }
          if (r[d] === void 0) {
            r[d] = [Z];
            return;
          }
          r[d] = [].concat(r[d], Z);
        };
      case "comma":
      case "separator":
        return (d, Z, r) => {
          const h = typeof Z == "string" && Z.includes(G.arrayFormatSeparator), o = typeof Z == "string" && !h && X(Z, G).includes(G.arrayFormatSeparator);
          Z = o ? X(Z, G) : Z;
          const F = h || o ? Z.split(G.arrayFormatSeparator).map((R) => X(R, G)) : Z === null ? Z : X(Z, G);
          r[d] = F;
        };
      case "bracket-separator":
        return (d, Z, r) => {
          const h = /(\[\])$/.test(d);
          if (d = d.replace(/\[\]$/, ""), !h) {
            r[d] = Z && X(Z, G);
            return;
          }
          const o = Z === null ? [] : Z.split(G.arrayFormatSeparator).map((F) => X(F, G));
          if (r[d] === void 0) {
            r[d] = o;
            return;
          }
          r[d] = [].concat(r[d], o);
        };
      default:
        return (d, Z, r) => {
          if (r[d] === void 0) {
            r[d] = Z;
            return;
          }
          r[d] = [].concat(r[d], Z);
        };
    }
  }
  function n(G) {
    if (typeof G != "string" || G.length !== 1)
      throw new TypeError("arrayFormatSeparator must be single character string");
  }
  function t(G, V) {
    return V.encode ? V.strict ? g(G) : encodeURIComponent(G) : G;
  }
  function X(G, V) {
    return V.decode ? C(G) : G;
  }
  function y(G) {
    return Array.isArray(G) ? G.sort() : typeof G == "object" ? y(Object.keys(G)).sort((V, d) => Number(V) - Number(d)).map((V) => G[V]) : G;
  }
  function s(G) {
    const V = G.indexOf("#");
    return V !== -1 && (G = G.slice(0, V)), G;
  }
  function B(G) {
    let V = "";
    const d = G.indexOf("#");
    return d !== -1 && (V = G.slice(d)), V;
  }
  function m(G) {
    G = s(G);
    const V = G.indexOf("?");
    return V === -1 ? "" : G.slice(V + 1);
  }
  function x(G, V) {
    return V.parseNumbers && !Number.isNaN(Number(G)) && typeof G == "string" && G.trim() !== "" ? G = Number(G) : V.parseBooleans && G !== null && (G.toLowerCase() === "true" || G.toLowerCase() === "false") && (G = G.toLowerCase() === "true"), G;
  }
  function v(G, V) {
    V = Object.assign({
      decode: !0,
      sort: !0,
      arrayFormat: "none",
      arrayFormatSeparator: ",",
      parseNumbers: !1,
      parseBooleans: !1
    }, V), n(V.arrayFormatSeparator);
    const d = u(V), Z = /* @__PURE__ */ Object.create(null);
    if (typeof G != "string" || (G = G.trim().replace(/^[?#&]/, ""), !G))
      return Z;
    for (const r of G.split("&")) {
      if (r === "")
        continue;
      let [h, o] = A(V.decode ? r.replace(/\+/g, " ") : r, "=");
      o = o === void 0 ? null : ["comma", "separator", "bracket-separator"].includes(V.arrayFormat) ? o : X(o, V), d(X(h, V), o, Z);
    }
    for (const r of Object.keys(Z)) {
      const h = Z[r];
      if (typeof h == "object" && h !== null)
        for (const o of Object.keys(h))
          h[o] = x(h[o], V);
      else
        Z[r] = x(h, V);
    }
    return V.sort === !1 ? Z : (V.sort === !0 ? Object.keys(Z).sort() : Object.keys(Z).sort(V.sort)).reduce((r, h) => {
      const o = Z[h];
      return o && typeof o == "object" && !Array.isArray(o) ? r[h] = y(o) : r[h] = o, r;
    }, /* @__PURE__ */ Object.create(null));
  }
  I.extract = m, I.parse = v, I.stringify = (G, V) => {
    if (!G)
      return "";
    V = Object.assign({
      encode: !0,
      strict: !0,
      arrayFormat: "none",
      arrayFormatSeparator: ","
    }, V), n(V.arrayFormatSeparator);
    const d = (o) => V.skipNull && b(G[o]) || V.skipEmptyString && G[o] === "", Z = i(V), r = {};
    for (const o of Object.keys(G))
      d(o) || (r[o] = G[o]);
    const h = Object.keys(r);
    return V.sort !== !1 && h.sort(V.sort), h.map((o) => {
      const F = G[o];
      return F === void 0 ? "" : F === null ? t(o, V) : Array.isArray(F) ? F.length === 0 && V.arrayFormat === "bracket-separator" ? t(o, V) + "[]" : F.reduce(Z(o), []).join("&") : t(o, V) + "=" + t(F, V);
    }).filter((o) => o.length > 0).join("&");
  }, I.parseUrl = (G, V) => {
    V = Object.assign({
      decode: !0
    }, V);
    const [d, Z] = A(G, "#");
    return Object.assign(
      {
        url: d.split("?")[0] || "",
        query: v(m(G), V)
      },
      V && V.parseFragmentIdentifier && Z ? { fragmentIdentifier: X(Z, V) } : {}
    );
  }, I.stringifyUrl = (G, V) => {
    V = Object.assign({
      encode: !0,
      strict: !0,
      [l]: !0
    }, V);
    const d = s(G.url).split("?")[0] || "", Z = I.extract(G.url), r = I.parse(Z, { sort: !1 }), h = Object.assign(r, G.query);
    let o = I.stringify(h, V);
    o && (o = `?${o}`);
    let F = B(G.url);
    return G.fragmentIdentifier && (F = `#${V[l] ? t(G.fragmentIdentifier, V) : G.fragmentIdentifier}`), `${d}${o}${F}`;
  }, I.pick = (G, V, d) => {
    d = Object.assign({
      parseFragmentIdentifier: !0,
      [l]: !1
    }, d);
    const { url: Z, query: r, fragmentIdentifier: h } = I.parseUrl(G, d);
    return I.stringifyUrl({
      url: Z,
      query: c(r, V),
      fragmentIdentifier: h
    }, d);
  }, I.exclude = (G, V, d) => {
    const Z = Array.isArray(V) ? (r) => !V.includes(r) : (r, h) => !V(r, h);
    return I.pick(G, Z, d);
  };
})(ku);
var ju = Object.defineProperty, Mu = (I, g, C) => g in I ? ju(I, g, { enumerable: !0, configurable: !0, writable: !0, value: C }) : I[g] = C, aI = (I, g, C) => (Mu(I, typeof g != "symbol" ? g + "" : g, C), C);
function bl() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
process.env.NODE_ENV;
process.env.NODE_ENV;
_g(null);
function Ku() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
process.env.NODE_ENV;
function wA() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
const _I = Xu, dX = {
  CLIENT_V1_COURSE_CATEGORY: "/client/api/v1/course-category",
  CLIENT_V1_REACTIONS_COMMENTS_ID: (I) => `/client/api/v1/reactions/comments/${I}`,
  CLIENT_V1_FILES_POST_IMAGE: "/client/api/v1/files/post-image",
  CLIENT_V1_REVIEWS_ID: (I) => `/client/api/v1/reviews/${I}`,
  CLIENT_V2_REVIEWS: "/client/api/v2/reviews",
  CLIENT_V1_MY_CATEGORY: "/client/api/v1/my-category",
  CLIENT_V1_SUBMISSIONS_ID: (I) => `/client/api/v1/submissions/${I}`,
  CLIENT_V1_SUBMISSIONS_ID_REACTIONS: (I) => `/client/api/v1/submissions/${I}/reactions`,
  CLIENT_V1_SUBMISSIONS_ID_COMMENTS: (I) => `/client/api/v1/submissions/${I}/comments`,
  CLIENT_V1_SUBMISSIONS_ID_CLAPS: (I) => `/client/api/v1/submissions/${I}/claps`,
  CLIENT_V1_SUBMISSIONS_COMMENTS: "/client/api/v1/submissions/comments",
  CLIENT_V1_SUBMISSIONS_COMMENTS_COMMENTID: (I) => `/client/api/v1/submissions/comments/${I}`,
  CLIENT_V1_SUBMISSIONS_ID_NAVIGATION: (I) => `/client/api/v1/submissions/${I}/navigation`,
  CLIENT_V1_SUBMISSIONS_ID_PUBLIC: (I) => `/client/api/v1/submissions/${I}/public`
};
function aX({
  url: I,
  options: g,
  requestOptions: C
}) {
  var A;
  const c = zg({
    mutationFn: (b) => _I.put(I, b, C),
    ...g
  });
  return {
    ...c,
    data: (A = c.data) == null ? void 0 : A.data
  };
}
function VX({
  url: I,
  options: g,
  requestOptions: C
}) {
  var A;
  const c = zg({
    mutationFn: (b) => _I.post(I, b, C),
    ...g
  });
  return {
    ...c,
    data: (A = c.data) == null ? void 0 : A.data
  };
}
function sX({
  url: I,
  options: g,
  requestOptions: C
}) {
  var A;
  const c = zg({
    mutationFn: (b) => _I.post(I, b, C),
    ...g
  });
  return {
    ...c,
    data: (A = c.data) == null ? void 0 : A.data
  };
}
function mX({
  url: I,
  options: g,
  requestOptions: C
}) {
  var A;
  const c = zg({
    mutationFn: (b) => _I.put(I, b, C),
    ...g
  });
  return {
    ...c,
    data: (A = c.data) == null ? void 0 : A.data
  };
}
function WX({
  url: I,
  options: g,
  requestOptions: C
}) {
  var A;
  const c = zg({
    mutationFn: (b) => _I.put(I, b, C),
    ...g
  });
  return {
    ...c,
    data: (A = c.data) == null ? void 0 : A.data
  };
}
function oX({
  url: I,
  options: g,
  requestOptions: C
}) {
  var A;
  const c = zg({
    mutationFn: (b) => _I.delete(I, b, C),
    ...g
  });
  return {
    ...c,
    data: (A = c.data) == null ? void 0 : A.data
  };
}
const _u = async (I, g) => _I.get(I, g), qu = ({
  queryKey: I,
  url: g,
  options: C,
  requestOptions: A
}) => ({
  queryKey: I,
  queryFn: () => _u(g, A),
  ...C
});
function rX(I) {
  var g;
  const C = FA(qu(I));
  return {
    ...C,
    data: (g = C.data) == null ? void 0 : g.data
  };
}
const $u = async (I, g) => _I.get(I, g), It = ({
  queryKey: I,
  url: g,
  options: C,
  requestOptions: A
}) => ({
  queryKey: I,
  queryFn: () => $u(g, A),
  ...C
});
function yX(I) {
  var g;
  const C = FA(It(I));
  return {
    ...C,
    data: (g = C.data) == null ? void 0 : g.data
  };
}
const ll = {
  TO: "to"
}, gt = {
  FIRST_HELLO: "first_hello",
  IS_FIRSTREGISTER: "is_firstregister",
  COURSE_LIST: "course_list",
  ACCOUNT: "account"
};
function Ct({
  enabled: I,
  valueKey: g,
  onSuccessPipe: C
}) {
  const [A, c] = nI(!1);
  return II(() => {
    if (!I)
      return;
    const b = new URLSearchParams(window.location.search);
    if (b.get(ll.TO) === g) {
      c(!0);
      const l = (C ? C(b) : b).toString(), i = window.location.pathname + (l ? `?${l}` : "");
      window.history.replaceState({}, "", i);
    }
  }, [I]), A;
}
/*! js-cookie v3.0.5 | MIT */
function uC(I) {
  for (var g = 1; g < arguments.length; g++) {
    var C = arguments[g];
    for (var A in C)
      I[A] = C[A];
  }
  return I;
}
var At = {
  read: function(I) {
    return I[0] === '"' && (I = I.slice(1, -1)), I.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
  },
  write: function(I) {
    return encodeURIComponent(I).replace(
      /%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g,
      decodeURIComponent
    );
  }
};
function VA(I, g) {
  function C(c, b, l) {
    if (!(typeof document > "u")) {
      l = uC({}, g, l), typeof l.expires == "number" && (l.expires = new Date(Date.now() + l.expires * 864e5)), l.expires && (l.expires = l.expires.toUTCString()), c = encodeURIComponent(c).replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent).replace(/[()]/g, escape);
      var i = "";
      for (var u in l)
        l[u] && (i += "; " + u, l[u] !== !0 && (i += "=" + l[u].split(";")[0]));
      return document.cookie = c + "=" + I.write(b, c) + i;
    }
  }
  function A(c) {
    if (!(typeof document > "u" || arguments.length && !c)) {
      for (var b = document.cookie ? document.cookie.split("; ") : [], l = {}, i = 0; i < b.length; i++) {
        var u = b[i].split("="), n = u.slice(1).join("=");
        try {
          var t = decodeURIComponent(u[0]);
          if (l[t] = I.read(n, t), c === t)
            break;
        } catch {
        }
      }
      return c ? l[c] : l;
    }
  }
  return Object.create(
    {
      set: C,
      get: A,
      remove: function(c, b) {
        C(
          c,
          "",
          uC({}, b, {
            expires: -1
          })
        );
      },
      withAttributes: function(c) {
        return VA(this.converter, uC({}, this.attributes, c));
      },
      withConverter: function(c) {
        return VA(uC({}, this.converter, c), this.attributes);
      }
    },
    {
      attributes: { value: Object.freeze(g) },
      converter: { value: Object.freeze(I) }
    }
  );
}
var ct = VA(At, { path: "/" });
const bt = Zu, lt = {
  CLIENT_V2_ACCOUNTS_PROFILE: "/client/api/v2/accounts/profile",
  CLIENT_V1_AUTH_PHONE_VERIFICATION: "/client/api/v1/auth/phone-verification",
  CLIENT_V1_AUTH_CHANGE_PHONE_NUMBER: "/client/api/v1/auth/change/phone-number",
  CLIENT_V1_DASHBOARD_CERTIFICATE_REALNAME: "/client/api/v1/dashboard/certificate-realname",
  CLIENT_V1_BANK_ACCOUNTS_ACCOUNT_HOLDER: "/client/api/v1/bank-accounts/account-holder",
  CLIENT_V1_BUSINESSES_BUSINESSNUMBER_SETTLEMENT_TYPE: (I) => `/client/api/v1/businesses/${I}/settlement-type`
}, it = async (I, g) => bt.get(I, g), nt = ({
  queryKey: I,
  url: g,
  options: C,
  requestOptions: A
}) => ({
  queryKey: I,
  queryFn: () => it(g, A),
  ...C
});
function hX(I) {
  var g;
  const C = FA(nt(I));
  return {
    ...C,
    data: (g = C.data) == null ? void 0 : g.data
  };
}
var mI = /* @__PURE__ */ ((I) => (I.SIMPLE = "SIMPLE", I.ASSIGNED_ID_NUMBER = "ASSIGNED_ID_NUMBER", I.TAX_FREE = "TAX_FREE", I.SIMPLE_TAX_INVOICE_ISSUER = "SIMPLE_TAX_INVOICE_ISSUER", I.NORMAL = "NORMAL", I))(mI || {}), S = /* @__PURE__ */ ((I) => (I.토스뱅크 = "토스뱅크", I.기업 = "기업", I.국민 = "국민", I.우리 = "우리", I.신한 = "신한", I.하나 = "하나", I.농협 = "농협", I.지역농축협 = "지역농축협", I.SC = "SC", I.한국씨티 = "한국씨티", I.우체국 = "우체국", I.경남 = "경남", I.광주 = "광주", I.대구 = "대구", I.도이치 = "도이치", I.부산 = "부산", I.산림조합 = "산림조합", I.산업 = "산업", I.저축 = "저축", I.새마을금고 = "새마을금고", I.수협 = "수협", I.신협 = "신협", I.전북 = "전북", I.제주 = "제주", I.BOA = "BOA", I.HSBC = "HSBC", I.JP모간 = "JP모간", I.교보증권 = "교보증권", I.대신증권 = "대신증권", I.미래에셋증권 = "미래에셋증권", I.DB금융투자 = "DB금융투자", I.유안타증권 = "유안타증권", I.메리츠증권 = "메리츠증권", I.부국증권 = "부국증권", I.삼성증권 = "삼성증권", I.신영증권 = "신영증권", I.신한금융투자 = "신한금융투자", I.NH투자증권 = "NH투자증권", I.유진투자증권 = "유진투자증권", I.이베스트증권 = "이베스트증권", I.키움증권 = "키움증권", I.하나금융투자 = "하나금융투자", I.하이투자 = "하이투자", I.한국투자 = "한국투자", I.한화증권 = "한화증권", I.KB증권 = "KB증권", I.현대차증권 = "현대차증권", I.케이프투자증권 = "케이프투자증권", I.SK증권 = "SK증권", I.중국공상 = "중국공상", I.카카오페이증권 = "카카오페이증권", I.비엔피파리바 = "비엔피파리바", I.중국건설 = "중국건설", I.중국서울지점 = "중국서울지점", I.카카오뱅크 = "카카오뱅크", I.케이뱅크 = "케이뱅크", I.토스증권 = "토스증권", I.한국포스증권 = "한국포스증권", I))(S || {});
function et() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
process.env.NODE_ENV;
function ut() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
process.env.NODE_ENV;
function tt() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
process.env.NODE_ENV;
const Lc = {
  VIEW_MYCATEGORY: "view_mycategory",
  CLICK_SAVE_MYCATEGORY: "click_save_mycategory",
  COMPLETE_LANGUAGE_CHANGE: "complete_language_change",
  VIEW_LANGUAGE_SETTING: "view_language_setting",
  COMPLETE_PHONE_AUTH: "complete_phone_auth",
  CLICK_PHONE_AUTH_REQ_DIGIT: "click_phone_auth_req_digit",
  VIEW_PHONE_AUTH_MODAL: "view_phone_auth_modal",
  CLICK_PHONE_AUTH_SUBMIT: "click_phone_auth_submit"
}, Gt = {
  error: 3,
  warn: 4,
  info: 6,
  debug: 7
};
class Zt {
  constructor() {
    aI(this, "logger"), aI(this, "defaultLogLevelMap"), this.defaultLogLevelMap = Gt, this.logger = gl(), this.logger.levels = {
      labels: xA(this.defaultLogLevelMap),
      values: this.defaultLogLevelMap
    };
  }
  debug(g) {
    this.log("debug", g);
  }
  info(g) {
    this.log("info", g);
  }
  warn(g) {
    this.log("warn", g);
  }
  error(g) {
    this.log("error", g);
  }
  log(g, C) {
    if (this.isLogLevelKey(g)) {
      this.logger[g](C);
      return;
    }
    const A = this.findLoggerTypeForSyslogLevel(g);
    A && this.logger[A](C);
  }
  isLogLevelKey(g) {
    return typeof g == "string" && LC(Object.keys(this.defaultLogLevelMap), g);
  }
  findLoggerTypeForSyslogLevel(g) {
    const C = this.logger.levels.labels[g];
    return this.isLogLevelKey(C) ? C : null;
  }
}
new Zt();
function Xt() {
  const I = gn(), g = HI(/* @__PURE__ */ new Set()), C = () => {
    const c = I.getQueryData([lt.CLIENT_V2_ACCOUNTS_PROFILE]);
    if (!(c != null && c.data))
      return {
        user_id: null,
        user_name: null,
        user_email: null,
        role_b2b: !1,
        role_b2c: !1,
        role_admin: !1,
        role_instructor: !1
      };
    const {
      id: b,
      name: l,
      email: i,
      isAdmin: u,
      isInstructor: n,
      group: t
    } = c.data, X = !!t;
    return {
      user_id: b,
      user_name: l,
      user_email: i,
      role_b2b: X,
      role_b2c: !X,
      role_admin: u,
      role_instructor: n
    };
  };
  function A(c, b) {
    const {
      props: l,
      once: i = !1
    } = b || {};
    if (!window.dataLayer) {
      console.log("[LOG] dataLayer is not defined");
      return;
    }
    if (i) {
      if (g.current.has(c)) {
        console.log(`[LOG] Event "${c}" already tracked, skipping...`);
        return;
      }
      g.current.add(c);
    }
    return window.dataLayer.push({
      event: c,
      mixpanelToken: iu,
      userId: C().user_id,
      mxp___user: C(),
      ...l
    });
  }
  return {
    trackEvent: A
  };
}
function dt() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
process.env.NODE_ENV;
rb`
    0% {
        transform: translateY(0px);
    }
    100% {
        transform: translateY(calc(100vh + 16px));
    }`;
rb`
    0% {
        transform: translateX(0px) rotate(-30deg);
    }
    50% {
        transform: translateX(80px) rotate(30deg);
    }
    100% {
        transform: translateX(0px) rotate(-30deg);
    }
`;
const lA = "realName", Sc = {
  get: () => sessionStorage.getItem(lA),
  set: (I) => sessionStorage.setItem(lA, I),
  remove: () => sessionStorage.removeItem(lA)
}, at = 100, Vt = Ab(({
  nextStep: I
}, g) => {
  const {
    t: C
  } = Al(), [A, c] = nI(!1), [b, l] = nI(Sc.get() ?? "");
  ti(g, () => ({
    getRealName: () => b
  }));
  const i = (t) => {
    const X = t.target.value;
    /[\d`~!@#$%^&*()_+=[\]{}\\|;:"<>,.?/]/.test(X) || X.length < at && l(X);
  }, u = (t) => {
    t.preventDefault(), Sc.set(b), I();
  }, n = b.trim().length < 2;
  return /* @__PURE__ */ O("form", { onSubmit: u, children: [
    /* @__PURE__ */ e(qi, { size: "md", label: C("이름 (실명)"), placeholder: C("2자 이상 입력"), description: C("추후 수정이 불가하니 실수없이 입력해 주세요."), error: A && n ? C("2자 이상 입력해 주세요.") : null, inputWrapperOrder: ["label", "description", "input", "error"], value: b, onChange: i, onFocus: () => {
      c(!0);
    }, mb: 16 }),
    /* @__PURE__ */ e(mC, { disabled: n, type: "submit", size: "md", radius: "md", fullWidth: !0, children: C("제출") })
  ] });
});
Vt.displayName = "RealNameAuthenticateModal";
_g(null);
const st = () => typeof window < "u", mt = ct.withAttributes({
  path: "/",
  domain: tu
}).withConverter({
  write: function(I) {
    return encodeURIComponent(I);
  }
});
function il() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const Wt = {
  ko: "한국어",
  en: "English",
  vi: "Tiếng Việt",
  ja: "日本語"
};
function fc(I) {
  const g = I.split("/");
  return kA.some((C) => g.includes(C));
}
function Tc(I) {
  return I.replace(/^\/[a-z]{2}/, "");
}
function kc() {
  const {
    pathname: I,
    search: g
  } = window.location, C = I.startsWith("/courses/lecture");
  return C && g.includes("roadmapId") ? "roadmap-lecture" : C ? "lecture" : "header";
}
var ot = process.env.NODE_ENV === "production" ? {
  name: "1yydxi7",
  styles: "display:flex;align-items:center;gap:8px"
} : {
  name: "1yydxi7",
  styles: "display:flex;align-items:center;gap:8px",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: il
}, rt = process.env.NODE_ENV === "production" ? {
  name: "1tk8yx0",
  styles: "padding:8px"
} : {
  name: "1tk8yx0",
  styles: "padding:8px",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: il
};
function yt({
  onClose: I,
  opened: g
}) {
  const {
    lang: C
  } = Bu(), {
    t: A
  } = Al(), {
    trackEvent: c
  } = Xt(), b = Wt;
  function l(i) {
    if (!st())
      return;
    let u;
    const n = window.location.pathname;
    i === "ko" ? u = fc(n) ? Tc(n) : n : u = `/${i}${fc(n) ? Tc(n) : n}`, VC(u) && (u = "/"), mt.set("lang", i, {
      secure: !0,
      expires: 365
    }), c(Lc.COMPLETE_LANGUAGE_CHANGE, {
      props: {
        current_language: C,
        selected_language: i,
        spot: kc()
      },
      once: !0
    }), window.location.href = u + window.location.search + window.location.hash;
  }
  return II(function() {
    c(Lc.VIEW_LANGUAGE_SETTING, {
      props: {
        current_language: C,
        spot: kc()
      },
      once: !0
    });
  }, []), /* @__PURE__ */ O(qI.Root, { size: "xs", onClose: I, opened: g, children: [
    /* @__PURE__ */ e(qI.Overlay, {}),
    /* @__PURE__ */ O(qI.Content, { children: [
      /* @__PURE__ */ O(qI.Header, { children: [
        /* @__PURE__ */ O(qI.Title, { css: ot, children: [
          /* @__PURE__ */ e(K, { icon: Re, size: "lg" }),
          " ",
          A("언어 설정")
        ] }),
        /* @__PURE__ */ e(qI.CloseButton, { onClick: I })
      ] }),
      /* @__PURE__ */ e(qI.Body, { children: /* @__PURE__ */ e(PI, { spacing: "md", children: /* @__PURE__ */ e(qC.Group, { withRadioCard: !0, name: "language", value: C, onChange: l, children: /* @__PURE__ */ e(PI, { spacing: 8, children: Object.entries(b).map(([i, u]) => /* @__PURE__ */ e(qC.Card, { name: "language", value: i, css: rt, children: /* @__PURE__ */ O(BI, { spacing: "xs", children: [
        /* @__PURE__ */ e(qC.Indicator, {}),
        /* @__PURE__ */ e(NA, { wrap: "wrap", children: /* @__PURE__ */ e(cI, { color: "gray.9", weight: 500, children: u }) })
      ] }) }, i)) }) }) }) })
    ] })
  ] });
}
function nl({
  lang: I,
  opened: g,
  ...C
}) {
  const {
    i18nInstance: A,
    isReady: c
  } = Tu({
    lang: I,
    isOpened: g
  });
  return c ? /* @__PURE__ */ e(di, { i18n: A, children: /* @__PURE__ */ e(yt, { opened: c, ...C }) }) : null;
}
var QI = /* @__PURE__ */ ((I) => (I.INSTRUCTOR = "INSTRUCTOR", I.MARKETING_PARTNER = "MARKETING_PARTNER", I))(QI || {}), GI = /* @__PURE__ */ ((I) => (I.WITHHOLDING_TAX = "WITHHOLDING_TAX", I.BUSINESS = "BUSINESS", I.NON_WITHHOLDING_TAX = "NON_WITHHOLDING_TAX", I))(GI || {}), kI = /* @__PURE__ */ ((I) => (I.DOMESTIC_QUOTATION = "DOMESTIC_QUOTATION", I.OVERSEAS_QUOTATION = "OVERSEAS_QUOTATION", I.PAYPAL = "PAYPAL", I))(kI || {});
function xg(I, g) {
  return () => Og.t(I, g) ?? "";
}
const el = {
  [GI.BUSINESS]: GI.BUSINESS,
  [GI.NON_WITHHOLDING_TAX]: GI.NON_WITHHOLDING_TAX,
  [GI.WITHHOLDING_TAX]: GI.WITHHOLDING_TAX
};
GI.WITHHOLDING_TAX + "", xg("개인"), GI.BUSINESS + "", xg("사업자"), GI.NON_WITHHOLDING_TAX + "", xg("해외 거주자");
const RI = {
  [kI.DOMESTIC_QUOTATION]: kI.DOMESTIC_QUOTATION,
  [kI.OVERSEAS_QUOTATION]: kI.OVERSEAS_QUOTATION,
  [kI.PAYPAL]: kI.PAYPAL
};
RI.DOMESTIC_QUOTATION + "", xg("견적서(국내송금)")(), RI.OVERSEAS_QUOTATION + "", xg("견적서(해외송금)")(), RI.PAYPAL + "", xg("Paypal")();
const dC = (I) => I === GI.BUSINESS, OI = (I) => I === GI.NON_WITHHOLDING_TAX, ht = (I) => I === GI.WITHHOLDING_TAX, Jt = (I) => typeof I == "string" && Object.values(el).includes(I), sA = (I, g) => OI(I) && g === kI.PAYPAL, xt = (I) => I === QI.MARKETING_PARTNER, Bt = (I) => I === QI.INSTRUCTOR;
function Xg(I) {
  return typeof I == "function" ? I() : I;
}
const FI = class {
  /**
   * 정산 유형에 따라 함수 실행
   * @param subjectType 정산 유형
   * @param fn 함수
   * @returns 함수 실행 결과
   */
  static whenSubjectType(I, {
    BUSINESS: g,
    NON_WITHHOLDING_TAX: C,
    WITHHOLDING_TAX: A
  }) {
    return FI.isBusinessSubjectType(I) ? Xg(g) : FI.isInternationalSubjectType(I) ? Xg(C) : Xg(A);
  }
  /**
   * 지출증빙유형에 따라 함수 실행
   * @param nonWithholdingTaxType 지출증빙유형
   * @param fn 함수
   * @returns 함수 실행 결과
   */
  static whenNonWithholdingTaxType(I, {
    DOMESTIC_QUOTATION: g,
    OVERSEAS_QUOTATION: C,
    PAYPAL: A
  }) {
    return I === RI.DOMESTIC_QUOTATION ? Xg(g) : I === RI.OVERSEAS_QUOTATION ? Xg(C) : Xg(A);
  }
};
let JI = FI;
aI(JI, "isInstructorUserType", (I) => Bt(String(I))), /** 마케팅 파트너 정산 정보인지 확인 */
aI(JI, "isMarketingPartnerUserType", (I) => xt(String(I))), /** 정산 유형인지 확인 */
aI(JI, "isSubjectType", (I) => FI.isBusinessSubjectType(I) || FI.isInternationalSubjectType(I) || FI.isPersonalSubjectType(I)), /** 개인 정산 정보인지 확인 */
aI(JI, "isPersonalSubjectType", (I) => ht(String(I))), /** 사업자 정산 정보인지 확인 */
aI(JI, "isBusinessSubjectType", (I) => dC(String(I))), /** 해외 거주자 정산 정보인지 확인 */
aI(JI, "isInternationalSubjectType", (I) => OI(String(I))), /** 지출증빙 유형인지 확인 */
aI(JI, "isNonWithholdingTaxType", (I, g) => FI.isDomesticQuotationType(I, g) || FI.isOverseasQuotationType(I, g) || FI.isPaypalType(I, g)), /** 지출증빙 유형이 국내 견적인지 확인 */
aI(JI, "isDomesticQuotationType", (I, g) => OI(String(I)) && g === RI.DOMESTIC_QUOTATION), /** 지출증빙 유형이 해외 견적인지 확인 */
aI(JI, "isOverseasQuotationType", (I, g) => OI(String(I)) && g === RI.OVERSEAS_QUOTATION), /** 지출증빙유형이 Paypal인지 확인 */
aI(JI, "isPaypalType", (I, g) => sA(I, g));
const Rt = {
  [mI.SIMPLE]: mI.SIMPLE,
  [mI.ASSIGNED_ID_NUMBER]: mI.ASSIGNED_ID_NUMBER,
  [mI.TAX_FREE]: mI.TAX_FREE,
  [mI.SIMPLE_TAX_INVOICE_ISSUER]: mI.SIMPLE_TAX_INVOICE_ISSUER,
  [mI.NORMAL]: mI.NORMAL
};
QI.INSTRUCTOR + "", QI.INSTRUCTOR, QI.MARKETING_PARTNER + "", QI.MARKETING_PARTNER;
function ul() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
process.env.NODE_ENV;
process.env.NODE_ENV;
P.red[6], process.env.NODE_ENV, process.env.NODE_ENV;
function vt() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
process.env.NODE_ENV;
const tl = {
  [S.토스뱅크]: !0,
  [S.기업]: !0,
  [S.국민]: !0,
  [S.우리]: !0,
  [S.신한]: !0,
  [S.하나]: !0,
  [S.농협]: !0,
  [S.지역농축협]: !0,
  [S.SC]: !0,
  [S.한국씨티]: !0,
  [S.우체국]: !0,
  [S.경남]: !0,
  [S.광주]: !0,
  [S.대구]: !0,
  [S.도이치]: !0,
  [S.부산]: !0,
  [S.산림조합]: !0,
  [S.산업]: !0,
  [S.저축]: !0,
  [S.새마을금고]: !0,
  [S.수협]: !0,
  [S.신협]: !0,
  [S.전북]: !0,
  [S.제주]: !0,
  [S.BOA]: !0,
  [S.HSBC]: !0,
  [S.JP모간]: !0,
  [S.교보증권]: !0,
  [S.대신증권]: !0,
  [S.미래에셋증권]: !0,
  [S.DB금융투자]: !0,
  [S.유안타증권]: !0,
  [S.메리츠증권]: !0,
  [S.부국증권]: !0,
  [S.삼성증권]: !0,
  [S.신영증권]: !0,
  [S.신한금융투자]: !0,
  [S.NH투자증권]: !0,
  [S.유진투자증권]: !0,
  [S.이베스트증권]: !0,
  [S.키움증권]: !0,
  [S.하나금융투자]: !0,
  [S.하이투자]: !0,
  [S.한국투자]: !0,
  [S.한화증권]: !0,
  [S.KB증권]: !0,
  [S.현대차증권]: !0,
  [S.케이프투자증권]: !0,
  [S.SK증권]: !0,
  [S.중국공상]: !0,
  [S.카카오페이증권]: !0,
  [S.비엔피파리바]: !0,
  [S.중국건설]: !0,
  [S.중국서울지점]: !0,
  [S.카카오뱅크]: !0,
  [S.케이뱅크]: !0,
  [S.토스증권]: !0,
  [S.한국포스증권]: !0
}, Nt = (I) => tl[I] !== void 0, pt = Object.keys(tl).filter(Nt).map((I, g) => ({
  label: I,
  value: I,
  index: g
})), wc = pt.flatMap(({
  value: I
}) => I);
function Gl() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
process.env.NODE_ENV;
var Ft = process.env.NODE_ENV === "production" ? {
  name: "ddhrvl",
  styles: "width:24px;height:24px;margin-right:8px;display:block"
} : {
  name: "dwu4ue-BankSelectItem",
  styles: "width:24px;height:24px;margin-right:8px;display:block;label:BankSelectItem;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: Gl
};
const Yt = Ab(({
  label: I,
  code: g,
  ...C
}, A) => /* @__PURE__ */ O(NA, { ref: A, align: "center", ...C, children: [
  /* @__PURE__ */ e($i, { w: 48, src: `${lu}/assets/images/banks/${g}.png`, alt: I, css: Ft }),
  /* @__PURE__ */ e(cI, { size: "sm", children: I })
] }));
Yt.displayName = "BankSelectItem";
function tg(I) {
  this._maxSize = I, this.clear();
}
tg.prototype.clear = function() {
  this._size = 0, this._values = /* @__PURE__ */ Object.create(null);
};
tg.prototype.get = function(I) {
  return this._values[I];
};
tg.prototype.set = function(I, g) {
  return this._size >= this._maxSize && this.clear(), I in this._values || this._size++, this._values[I] = g;
};
var Ht = /[^.^\]^[]+|(?=\[\]|\.\.)/g, Zl = /^\d+$/, zt = /^\d/, Ut = /[~`!#$%\^&*+=\-\[\]\\';,/{}|\\":<>\?]/g, Lt = /^\s*(['"]?)(.*?)(\1)\s*$/, QA = 512, Qc = new tg(QA), Oc = new tg(QA), Dc = new tg(QA), Ag = {
  Cache: tg,
  split: mA,
  normalizePath: iA,
  setter: function(I) {
    var g = iA(I);
    return Oc.get(I) || Oc.set(I, function(C, A) {
      for (var c = 0, b = g.length, l = C; c < b - 1; ) {
        var i = g[c];
        if (i === "__proto__" || i === "constructor" || i === "prototype")
          return C;
        l = l[g[c++]];
      }
      l[g[c]] = A;
    });
  },
  getter: function(I, g) {
    var C = iA(I);
    return Dc.get(I) || Dc.set(I, function(A) {
      for (var c = 0, b = C.length; c < b; )
        if (A != null || !g)
          A = A[C[c++]];
        else
          return;
      return A;
    });
  },
  join: function(I) {
    return I.reduce(function(g, C) {
      return g + (OA(C) || Zl.test(C) ? "[" + C + "]" : (g ? "." : "") + C);
    }, "");
  },
  forEach: function(I, g, C) {
    St(Array.isArray(I) ? I : mA(I), g, C);
  }
};
function iA(I) {
  return Qc.get(I) || Qc.set(
    I,
    mA(I).map(function(g) {
      return g.replace(Lt, "$2");
    })
  );
}
function mA(I) {
  return I.match(Ht) || [""];
}
function St(I, g, C) {
  var A = I.length, c, b, l, i;
  for (b = 0; b < A; b++)
    c = I[b], c && (kt(c) && (c = '"' + c + '"'), i = OA(c), l = !i && /^\d+$/.test(c), g.call(C, c, i, l, b, I));
}
function OA(I) {
  return typeof I == "string" && I && ["'", '"'].indexOf(I.charAt(0)) !== -1;
}
function ft(I) {
  return I.match(zt) && !I.match(Zl);
}
function Tt(I) {
  return Ut.test(I);
}
function kt(I) {
  return !OA(I) && (ft(I) || Tt(I));
}
const wt = /[A-Z\xc0-\xd6\xd8-\xde]?[a-z\xdf-\xf6\xf8-\xff]+(?:['’](?:d|ll|m|re|s|t|ve))?(?=[\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000]|[A-Z\xc0-\xd6\xd8-\xde]|$)|(?:[A-Z\xc0-\xd6\xd8-\xde]|[^\ud800-\udfff\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\d+\u2700-\u27bfa-z\xdf-\xf6\xf8-\xffA-Z\xc0-\xd6\xd8-\xde])+(?:['’](?:D|LL|M|RE|S|T|VE))?(?=[\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000]|[A-Z\xc0-\xd6\xd8-\xde](?:[a-z\xdf-\xf6\xf8-\xff]|[^\ud800-\udfff\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\d+\u2700-\u27bfa-z\xdf-\xf6\xf8-\xffA-Z\xc0-\xd6\xd8-\xde])|$)|[A-Z\xc0-\xd6\xd8-\xde]?(?:[a-z\xdf-\xf6\xf8-\xff]|[^\ud800-\udfff\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\d+\u2700-\u27bfa-z\xdf-\xf6\xf8-\xffA-Z\xc0-\xd6\xd8-\xde])+(?:['’](?:d|ll|m|re|s|t|ve))?|[A-Z\xc0-\xd6\xd8-\xde]+(?:['’](?:D|LL|M|RE|S|T|VE))?|\d*(?:1ST|2ND|3RD|(?![123])\dTH)(?=\b|[a-z_])|\d*(?:1st|2nd|3rd|(?![123])\dth)(?=\b|[A-Z_])|\d+|(?:[\u2700-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff])[\ufe0e\ufe0f]?(?:[\u0300-\u036f\ufe20-\ufe2f\u20d0-\u20ff]|\ud83c[\udffb-\udfff])?(?:\u200d(?:[^\ud800-\udfff]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff])[\ufe0e\ufe0f]?(?:[\u0300-\u036f\ufe20-\ufe2f\u20d0-\u20ff]|\ud83c[\udffb-\udfff])?)*/g, jC = (I) => I.match(wt) || [], MC = (I) => I[0].toUpperCase() + I.slice(1), DA = (I, g) => jC(I).join(g).toLowerCase(), Xl = (I) => jC(I).reduce(
  (g, C) => `${g}${g ? C[0].toUpperCase() + C.slice(1).toLowerCase() : C.toLowerCase()}`,
  ""
), Qt = (I) => MC(Xl(I)), Ot = (I) => DA(I, "_"), Dt = (I) => DA(I, "-"), Et = (I) => MC(DA(I, " ")), Pt = (I) => jC(I).map(MC).join(" ");
var nA = {
  words: jC,
  upperFirst: MC,
  camelCase: Xl,
  pascalCase: Qt,
  snakeCase: Ot,
  kebabCase: Dt,
  sentenceCase: Et,
  titleCase: Pt
}, EA = { exports: {} };
EA.exports = function(I) {
  return dl(jt(I), I);
};
EA.exports.array = dl;
function dl(I, g) {
  var C = I.length, A = new Array(C), c = {}, b = C, l = Mt(g), i = Kt(I);
  for (g.forEach(function(n) {
    if (!i.has(n[0]) || !i.has(n[1]))
      throw new Error("Unknown node. There is an unknown node in the supplied edges.");
  }); b--; )
    c[b] || u(I[b], b, /* @__PURE__ */ new Set());
  return A;
  function u(n, t, X) {
    if (X.has(n)) {
      var y;
      try {
        y = ", node was:" + JSON.stringify(n);
      } catch {
        y = "";
      }
      throw new Error("Cyclic dependency" + y);
    }
    if (!i.has(n))
      throw new Error("Found unknown node. Make sure to provided all involved nodes. Unknown node: " + JSON.stringify(n));
    if (!c[t]) {
      c[t] = !0;
      var s = l.get(n) || /* @__PURE__ */ new Set();
      if (s = Array.from(s), t = s.length) {
        X.add(n);
        do {
          var B = s[--t];
          u(B, i.get(B), X);
        } while (t);
        X.delete(n);
      }
      A[--C] = n;
    }
  }
}
function jt(I) {
  for (var g = /* @__PURE__ */ new Set(), C = 0, A = I.length; C < A; C++) {
    var c = I[C];
    g.add(c[0]), g.add(c[1]);
  }
  return Array.from(g);
}
function Mt(I) {
  for (var g = /* @__PURE__ */ new Map(), C = 0, A = I.length; C < A; C++) {
    var c = I[C];
    g.has(c[0]) || g.set(c[0], /* @__PURE__ */ new Set()), g.has(c[1]) || g.set(c[1], /* @__PURE__ */ new Set()), g.get(c[0]).add(c[1]);
  }
  return g;
}
function Kt(I) {
  for (var g = /* @__PURE__ */ new Map(), C = 0, A = I.length; C < A; C++)
    g.set(I[C], C);
  return g;
}
var _t = EA.exports;
const qt = /* @__PURE__ */ KI(_t), $t = Object.prototype.toString, IG = Error.prototype.toString, gG = RegExp.prototype.toString, CG = typeof Symbol < "u" ? Symbol.prototype.toString : () => "", AG = /^Symbol\((.*)\)(.*)$/;
function cG(I) {
  return I != +I ? "NaN" : I === 0 && 1 / I < 0 ? "-0" : "" + I;
}
function Ec(I, g = !1) {
  if (I == null || I === !0 || I === !1)
    return "" + I;
  const C = typeof I;
  if (C === "number")
    return cG(I);
  if (C === "string")
    return g ? `"${I}"` : I;
  if (C === "function")
    return "[Function " + (I.name || "anonymous") + "]";
  if (C === "symbol")
    return CG.call(I).replace(AG, "Symbol($1)");
  const A = $t.call(I).slice(8, -1);
  return A === "Date" ? isNaN(I.getTime()) ? "" + I : I.toISOString(I) : A === "Error" || I instanceof Error ? "[" + IG.call(I) + "]" : A === "RegExp" ? gG.call(I) : null;
}
function Bg(I, g) {
  let C = Ec(I, g);
  return C !== null ? C : JSON.stringify(I, function(A, c) {
    let b = Ec(this[A], g);
    return b !== null ? b : c;
  }, 2);
}
function al(I) {
  return I == null ? [] : [].concat(I);
}
let bG = /\$\{\s*(\w+)\s*\}/g;
class dI extends Error {
  static formatError(g, C) {
    const A = C.label || C.path || "this";
    return A !== C.path && (C = Object.assign({}, C, {
      path: A
    })), typeof g == "string" ? g.replace(bG, (c, b) => Bg(C[b])) : typeof g == "function" ? g(C) : g;
  }
  static isError(g) {
    return g && g.name === "ValidationError";
  }
  constructor(g, C, A, c) {
    super(), this.value = void 0, this.path = void 0, this.type = void 0, this.errors = void 0, this.params = void 0, this.inner = void 0, this.name = "ValidationError", this.value = C, this.path = A, this.type = c, this.errors = [], this.inner = [], al(g).forEach((b) => {
      dI.isError(b) ? (this.errors.push(...b.errors), this.inner = this.inner.concat(b.inner.length ? b.inner : b)) : this.errors.push(b);
    }), this.message = this.errors.length > 1 ? `${this.errors.length} errors occurred` : this.errors[0], Error.captureStackTrace && Error.captureStackTrace(this, dI);
  }
}
let pI = {
  default: "${path} is invalid",
  required: "${path} is a required field",
  defined: "${path} must be defined",
  notNull: "${path} cannot be null",
  oneOf: "${path} must be one of the following values: ${values}",
  notOneOf: "${path} must not be one of the following values: ${values}",
  notType: ({
    path: I,
    type: g,
    value: C,
    originalValue: A
  }) => {
    const c = A != null && A !== C ? ` (cast from the value \`${Bg(A, !0)}\`).` : ".";
    return g !== "mixed" ? `${I} must be a \`${g}\` type, but the final value was: \`${Bg(C, !0)}\`` + c : `${I} must match the configured type. The validated value was: \`${Bg(C, !0)}\`` + c;
  }
}, WI = {
  length: "${path} must be exactly ${length} characters",
  min: "${path} must be at least ${min} characters",
  max: "${path} must be at most ${max} characters",
  matches: '${path} must match the following: "${regex}"',
  email: "${path} must be a valid email",
  url: "${path} must be a valid URL",
  uuid: "${path} must be a valid UUID",
  trim: "${path} must be a trimmed string",
  lowercase: "${path} must be a lowercase string",
  uppercase: "${path} must be a upper case string"
}, lG = {
  min: "${path} must be greater than or equal to ${min}",
  max: "${path} must be less than or equal to ${max}",
  lessThan: "${path} must be less than ${less}",
  moreThan: "${path} must be greater than ${more}",
  positive: "${path} must be a positive number",
  negative: "${path} must be a negative number",
  integer: "${path} must be an integer"
}, WA = {
  min: "${path} field must be later than ${min}",
  max: "${path} field must be at earlier than ${max}"
}, iG = {
  isValue: "${path} field must be ${value}"
}, oA = {
  noUnknown: "${path} field has unspecified keys: ${unknown}"
}, nG = {
  min: "${path} field must have at least ${min} items",
  max: "${path} field must have less than or equal to ${max} items",
  length: "${path} must have ${length} items"
};
Object.assign(/* @__PURE__ */ Object.create(null), {
  mixed: pI,
  string: WI,
  number: lG,
  date: WA,
  object: oA,
  array: nG,
  boolean: iG
});
const PA = (I) => I && I.__isYupSchema__;
class HC {
  static fromOptions(g, C) {
    if (!C.then && !C.otherwise)
      throw new TypeError("either `then:` or `otherwise:` is required for `when()` conditions");
    let {
      is: A,
      then: c,
      otherwise: b
    } = C, l = typeof A == "function" ? A : (...i) => i.every((u) => u === A);
    return new HC(g, (i, u) => {
      var n;
      let t = l(...i) ? c : b;
      return (n = t == null ? void 0 : t(u)) != null ? n : u;
    });
  }
  constructor(g, C) {
    this.fn = void 0, this.refs = g, this.refs = g, this.fn = C;
  }
  resolve(g, C) {
    let A = this.refs.map((b) => (
      // TODO: ? operator here?
      b.getValue(C == null ? void 0 : C.value, C == null ? void 0 : C.parent, C == null ? void 0 : C.context)
    )), c = this.fn(A, g, C);
    if (c === void 0 || // @ts-ignore this can be base
    c === g)
      return g;
    if (!PA(c))
      throw new TypeError("conditions must return a schema object");
    return c.resolve(C);
  }
}
const tC = {
  context: "$",
  value: "."
};
class Gg {
  constructor(g, C = {}) {
    if (this.key = void 0, this.isContext = void 0, this.isValue = void 0, this.isSibling = void 0, this.path = void 0, this.getter = void 0, this.map = void 0, typeof g != "string")
      throw new TypeError("ref must be a string, got: " + g);
    if (this.key = g.trim(), g === "")
      throw new TypeError("ref must be a non-empty string");
    this.isContext = this.key[0] === tC.context, this.isValue = this.key[0] === tC.value, this.isSibling = !this.isContext && !this.isValue;
    let A = this.isContext ? tC.context : this.isValue ? tC.value : "";
    this.path = this.key.slice(A.length), this.getter = this.path && Ag.getter(this.path, !0), this.map = C.map;
  }
  getValue(g, C, A) {
    let c = this.isContext ? A : this.isValue ? g : C;
    return this.getter && (c = this.getter(c || {})), this.map && (c = this.map(c)), c;
  }
  /**
   *
   * @param {*} value
   * @param {Object} options
   * @param {Object=} options.context
   * @param {Object=} options.parent
   */
  cast(g, C) {
    return this.getValue(g, C == null ? void 0 : C.parent, C == null ? void 0 : C.context);
  }
  resolve() {
    return this;
  }
  describe() {
    return {
      type: "ref",
      key: this.key
    };
  }
  toString() {
    return `Ref(${this.key})`;
  }
  static isRef(g) {
    return g && g.__isYupRef;
  }
}
Gg.prototype.__isYupRef = !0;
const DI = (I) => I == null;
function dg(I) {
  function g({
    value: C,
    path: A = "",
    options: c,
    originalValue: b,
    schema: l
  }, i, u) {
    const {
      name: n,
      test: t,
      params: X,
      message: y,
      skipAbsent: s
    } = I;
    let {
      parent: B,
      context: m,
      abortEarly: x = l.spec.abortEarly
    } = c;
    function v(R) {
      return Gg.isRef(R) ? R.getValue(C, B, m) : R;
    }
    function G(R = {}) {
      const z = Object.assign({
        value: C,
        originalValue: b,
        label: l.spec.label,
        path: R.path || A,
        spec: l.spec
      }, X, R.params);
      for (const _ of Object.keys(z))
        z[_] = v(z[_]);
      const D = new dI(dI.formatError(R.message || y, z), C, z.path, R.type || n);
      return D.params = z, D;
    }
    const V = x ? i : u;
    let d = {
      path: A,
      parent: B,
      type: n,
      from: c.from,
      createError: G,
      resolve: v,
      options: c,
      originalValue: b,
      schema: l
    };
    const Z = (R) => {
      dI.isError(R) ? V(R) : R ? u(null) : V(G());
    }, r = (R) => {
      dI.isError(R) ? V(R) : i(R);
    }, h = s && DI(C);
    if (!c.sync) {
      try {
        Promise.resolve(h ? !0 : t.call(d, C, d)).then(Z, r);
      } catch (R) {
        r(R);
      }
      return;
    }
    let o;
    try {
      var F;
      if (o = h ? !0 : t.call(d, C, d), typeof ((F = o) == null ? void 0 : F.then) == "function")
        throw new Error(`Validation test of type: "${d.type}" returned a Promise during a synchronous validate. This test will finish after the validate call has returned`);
    } catch (R) {
      r(R);
      return;
    }
    Z(o);
  }
  return g.OPTIONS = I, g;
}
function eG(I, g, C, A = C) {
  let c, b, l;
  return g ? (Ag.forEach(g, (i, u, n) => {
    let t = u ? i.slice(1, i.length - 1) : i;
    I = I.resolve({
      context: A,
      parent: c,
      value: C
    });
    let X = I.type === "tuple", y = n ? parseInt(t, 10) : 0;
    if (I.innerType || X) {
      if (X && !n)
        throw new Error(`Yup.reach cannot implicitly index into a tuple type. the path part "${l}" must contain an index to the tuple element, e.g. "${l}[0]"`);
      if (C && y >= C.length)
        throw new Error(`Yup.reach cannot resolve an array item at index: ${i}, in the path: ${g}. because there is no value at that index. `);
      c = C, C = C && C[y], I = X ? I.spec.types[y] : I.innerType;
    }
    if (!n) {
      if (!I.fields || !I.fields[t])
        throw new Error(`The schema does not contain the path: ${g}. (failed at: ${l} which is a type: "${I.type}")`);
      c = C, C = C && C[t], I = I.fields[t];
    }
    b = t, l = u ? "[" + i + "]" : "." + i;
  }), {
    schema: I,
    parent: c,
    parentPath: b
  }) : {
    parent: c,
    parentPath: g,
    schema: I
  };
}
class zC extends Set {
  describe() {
    const g = [];
    for (const C of this.values())
      g.push(Gg.isRef(C) ? C.describe() : C);
    return g;
  }
  resolveAll(g) {
    let C = [];
    for (const A of this.values())
      C.push(g(A));
    return C;
  }
  clone() {
    return new zC(this.values());
  }
  merge(g, C) {
    const A = this.clone();
    return g.forEach((c) => A.add(c)), C.forEach((c) => A.delete(c)), A;
  }
}
function Wg(I, g = /* @__PURE__ */ new Map()) {
  if (PA(I) || !I || typeof I != "object")
    return I;
  if (g.has(I))
    return g.get(I);
  let C;
  if (I instanceof Date)
    C = new Date(I.getTime()), g.set(I, C);
  else if (I instanceof RegExp)
    C = new RegExp(I), g.set(I, C);
  else if (Array.isArray(I)) {
    C = new Array(I.length), g.set(I, C);
    for (let A = 0; A < I.length; A++)
      C[A] = Wg(I[A], g);
  } else if (I instanceof Map) {
    C = /* @__PURE__ */ new Map(), g.set(I, C);
    for (const [A, c] of I.entries())
      C.set(A, Wg(c, g));
  } else if (I instanceof Set) {
    C = /* @__PURE__ */ new Set(), g.set(I, C);
    for (const A of I)
      C.add(Wg(A, g));
  } else if (I instanceof Object) {
    C = {}, g.set(I, C);
    for (const [A, c] of Object.entries(I))
      C[A] = Wg(c, g);
  } else
    throw Error(`Unable to clone ${I}`);
  return C;
}
class rI {
  constructor(g) {
    this.type = void 0, this.deps = [], this.tests = void 0, this.transforms = void 0, this.conditions = [], this._mutate = void 0, this.internalTests = {}, this._whitelist = new zC(), this._blacklist = new zC(), this.exclusiveTests = /* @__PURE__ */ Object.create(null), this._typeCheck = void 0, this.spec = void 0, this.tests = [], this.transforms = [], this.withMutation(() => {
      this.typeError(pI.notType);
    }), this.type = g.type, this._typeCheck = g.check, this.spec = Object.assign({
      strip: !1,
      strict: !1,
      abortEarly: !0,
      recursive: !0,
      nullable: !1,
      optional: !0,
      coerce: !0
    }, g == null ? void 0 : g.spec), this.withMutation((C) => {
      C.nonNullable();
    });
  }
  // TODO: remove
  get _type() {
    return this.type;
  }
  clone(g) {
    if (this._mutate)
      return g && Object.assign(this.spec, g), this;
    const C = Object.create(Object.getPrototypeOf(this));
    return C.type = this.type, C._typeCheck = this._typeCheck, C._whitelist = this._whitelist.clone(), C._blacklist = this._blacklist.clone(), C.internalTests = Object.assign({}, this.internalTests), C.exclusiveTests = Object.assign({}, this.exclusiveTests), C.deps = [...this.deps], C.conditions = [...this.conditions], C.tests = [...this.tests], C.transforms = [...this.transforms], C.spec = Wg(Object.assign({}, this.spec, g)), C;
  }
  label(g) {
    let C = this.clone();
    return C.spec.label = g, C;
  }
  meta(...g) {
    if (g.length === 0)
      return this.spec.meta;
    let C = this.clone();
    return C.spec.meta = Object.assign(C.spec.meta || {}, g[0]), C;
  }
  withMutation(g) {
    let C = this._mutate;
    this._mutate = !0;
    let A = g(this);
    return this._mutate = C, A;
  }
  concat(g) {
    if (!g || g === this)
      return this;
    if (g.type !== this.type && this.type !== "mixed")
      throw new TypeError(`You cannot \`concat()\` schema's of different types: ${this.type} and ${g.type}`);
    let C = this, A = g.clone();
    const c = Object.assign({}, C.spec, A.spec);
    return A.spec = c, A.internalTests = Object.assign({}, C.internalTests, A.internalTests), A._whitelist = C._whitelist.merge(g._whitelist, g._blacklist), A._blacklist = C._blacklist.merge(g._blacklist, g._whitelist), A.tests = C.tests, A.exclusiveTests = C.exclusiveTests, A.withMutation((b) => {
      g.tests.forEach((l) => {
        b.test(l.OPTIONS);
      });
    }), A.transforms = [...C.transforms, ...A.transforms], A;
  }
  isType(g) {
    return g == null ? !!(this.spec.nullable && g === null || this.spec.optional && g === void 0) : this._typeCheck(g);
  }
  resolve(g) {
    let C = this;
    if (C.conditions.length) {
      let A = C.conditions;
      C = C.clone(), C.conditions = [], C = A.reduce((c, b) => b.resolve(c, g), C), C = C.resolve(g);
    }
    return C;
  }
  resolveOptions(g) {
    var C, A, c;
    return Object.assign({}, g, {
      from: g.from || [],
      strict: (C = g.strict) != null ? C : this.spec.strict,
      abortEarly: (A = g.abortEarly) != null ? A : this.spec.abortEarly,
      recursive: (c = g.recursive) != null ? c : this.spec.recursive
    });
  }
  /**
   * Run the configured transform pipeline over an input value.
   */
  cast(g, C = {}) {
    let A = this.resolve(Object.assign({
      value: g
    }, C)), c = C.assert === "ignore-optionality", b = A._cast(g, C);
    if (C.assert !== !1 && !A.isType(b)) {
      if (c && DI(b))
        return b;
      let l = Bg(g), i = Bg(b);
      throw new TypeError(`The value of ${C.path || "field"} could not be cast to a value that satisfies the schema type: "${A.type}". 

attempted value: ${l} 
` + (i !== l ? `result of cast: ${i}` : ""));
    }
    return b;
  }
  _cast(g, C) {
    let A = g === void 0 ? g : this.transforms.reduce((c, b) => b.call(this, c, g, this), g);
    return A === void 0 && (A = this.getDefault()), A;
  }
  _validate(g, C = {}, A, c) {
    let {
      path: b,
      originalValue: l = g,
      strict: i = this.spec.strict
    } = C, u = g;
    i || (u = this._cast(u, Object.assign({
      assert: !1
    }, C)));
    let n = [];
    for (let t of Object.values(this.internalTests))
      t && n.push(t);
    this.runTests({
      path: b,
      value: u,
      originalValue: l,
      options: C,
      tests: n
    }, A, (t) => {
      if (t.length)
        return c(t, u);
      this.runTests({
        path: b,
        value: u,
        originalValue: l,
        options: C,
        tests: this.tests
      }, A, c);
    });
  }
  /**
   * Executes a set of validations, either schema, produced Tests or a nested
   * schema validate result.
   */
  runTests(g, C, A) {
    let c = !1, {
      tests: b,
      value: l,
      originalValue: i,
      path: u,
      options: n
    } = g, t = (m) => {
      c || (c = !0, C(m, l));
    }, X = (m) => {
      c || (c = !0, A(m, l));
    }, y = b.length, s = [];
    if (!y)
      return X([]);
    let B = {
      value: l,
      originalValue: i,
      path: u,
      options: n,
      schema: this
    };
    for (let m = 0; m < b.length; m++) {
      const x = b[m];
      x(B, t, function(v) {
        v && (s = s.concat(v)), --y <= 0 && X(s);
      });
    }
  }
  asNestedTest({
    key: g,
    index: C,
    parent: A,
    parentPath: c,
    originalParent: b,
    options: l
  }) {
    const i = g ?? C;
    if (i == null)
      throw TypeError("Must include `key` or `index` for nested validations");
    const u = typeof i == "number";
    let n = A[i];
    const t = Object.assign({}, l, {
      // Nested validations fields are always strict:
      //    1. parent isn't strict so the casting will also have cast inner values
      //    2. parent is strict in which case the nested values weren't cast either
      strict: !0,
      parent: A,
      value: n,
      originalValue: b[i],
      // FIXME: tests depend on `index` being passed around deeply,
      //   we should not let the options.key/index bleed through
      key: void 0,
      // index: undefined,
      [u ? "index" : "key"]: i,
      path: u || i.includes(".") ? `${c || ""}[${n ? i : `"${i}"`}]` : (c ? `${c}.` : "") + g
    });
    return (X, y, s) => this.resolve(t)._validate(n, t, y, s);
  }
  validate(g, C) {
    let A = this.resolve(Object.assign({}, C, {
      value: g
    }));
    return new Promise((c, b) => A._validate(g, C, (l, i) => {
      dI.isError(l) && (l.value = i), b(l);
    }, (l, i) => {
      l.length ? b(new dI(l, i)) : c(i);
    }));
  }
  validateSync(g, C) {
    let A = this.resolve(Object.assign({}, C, {
      value: g
    })), c;
    return A._validate(g, Object.assign({}, C, {
      sync: !0
    }), (b, l) => {
      throw dI.isError(b) && (b.value = l), b;
    }, (b, l) => {
      if (b.length)
        throw new dI(b, g);
      c = l;
    }), c;
  }
  isValid(g, C) {
    return this.validate(g, C).then(() => !0, (A) => {
      if (dI.isError(A))
        return !1;
      throw A;
    });
  }
  isValidSync(g, C) {
    try {
      return this.validateSync(g, C), !0;
    } catch (A) {
      if (dI.isError(A))
        return !1;
      throw A;
    }
  }
  _getDefault() {
    let g = this.spec.default;
    return g == null ? g : typeof g == "function" ? g.call(this) : Wg(g);
  }
  getDefault(g) {
    return this.resolve(g || {})._getDefault();
  }
  default(g) {
    return arguments.length === 0 ? this._getDefault() : this.clone({
      default: g
    });
  }
  strict(g = !0) {
    return this.clone({
      strict: g
    });
  }
  nullability(g, C) {
    const A = this.clone({
      nullable: g
    });
    return A.internalTests.nullable = dg({
      message: C,
      name: "nullable",
      test(c) {
        return c === null ? this.schema.spec.nullable : !0;
      }
    }), A;
  }
  optionality(g, C) {
    const A = this.clone({
      optional: g
    });
    return A.internalTests.optionality = dg({
      message: C,
      name: "optionality",
      test(c) {
        return c === void 0 ? this.schema.spec.optional : !0;
      }
    }), A;
  }
  optional() {
    return this.optionality(!0);
  }
  defined(g = pI.defined) {
    return this.optionality(!1, g);
  }
  nullable() {
    return this.nullability(!0);
  }
  nonNullable(g = pI.notNull) {
    return this.nullability(!1, g);
  }
  required(g = pI.required) {
    return this.clone().withMutation((C) => C.nonNullable(g).defined(g));
  }
  notRequired() {
    return this.clone().withMutation((g) => g.nullable().optional());
  }
  transform(g) {
    let C = this.clone();
    return C.transforms.push(g), C;
  }
  /**
   * Adds a test function to the schema's queue of tests.
   * tests can be exclusive or non-exclusive.
   *
   * - exclusive tests, will replace any existing tests of the same name.
   * - non-exclusive: can be stacked
   *
   * If a non-exclusive test is added to a schema with an exclusive test of the same name
   * the exclusive test is removed and further tests of the same name will be stacked.
   *
   * If an exclusive test is added to a schema with non-exclusive tests of the same name
   * the previous tests are removed and further tests of the same name will replace each other.
   */
  test(...g) {
    let C;
    if (g.length === 1 ? typeof g[0] == "function" ? C = {
      test: g[0]
    } : C = g[0] : g.length === 2 ? C = {
      name: g[0],
      test: g[1]
    } : C = {
      name: g[0],
      message: g[1],
      test: g[2]
    }, C.message === void 0 && (C.message = pI.default), typeof C.test != "function")
      throw new TypeError("`test` is a required parameters");
    let A = this.clone(), c = dg(C), b = C.exclusive || C.name && A.exclusiveTests[C.name] === !0;
    if (C.exclusive && !C.name)
      throw new TypeError("Exclusive tests must provide a unique `name` identifying the test");
    return C.name && (A.exclusiveTests[C.name] = !!C.exclusive), A.tests = A.tests.filter((l) => !(l.OPTIONS.name === C.name && (b || l.OPTIONS.test === c.OPTIONS.test))), A.tests.push(c), A;
  }
  when(g, C) {
    !Array.isArray(g) && typeof g != "string" && (C = g, g = ".");
    let A = this.clone(), c = al(g).map((b) => new Gg(b));
    return c.forEach((b) => {
      b.isSibling && A.deps.push(b.key);
    }), A.conditions.push(typeof C == "function" ? new HC(c, C) : HC.fromOptions(c, C)), A;
  }
  typeError(g) {
    let C = this.clone();
    return C.internalTests.typeError = dg({
      message: g,
      name: "typeError",
      test(A) {
        return !DI(A) && !this.schema._typeCheck(A) ? this.createError({
          params: {
            type: this.schema.type
          }
        }) : !0;
      }
    }), C;
  }
  oneOf(g, C = pI.oneOf) {
    let A = this.clone();
    return g.forEach((c) => {
      A._whitelist.add(c), A._blacklist.delete(c);
    }), A.internalTests.whiteList = dg({
      message: C,
      name: "oneOf",
      skipAbsent: !0,
      test(c) {
        let b = this.schema._whitelist, l = b.resolveAll(this.resolve);
        return l.includes(c) ? !0 : this.createError({
          params: {
            values: Array.from(b).join(", "),
            resolved: l
          }
        });
      }
    }), A;
  }
  notOneOf(g, C = pI.notOneOf) {
    let A = this.clone();
    return g.forEach((c) => {
      A._blacklist.add(c), A._whitelist.delete(c);
    }), A.internalTests.blacklist = dg({
      message: C,
      name: "notOneOf",
      test(c) {
        let b = this.schema._blacklist, l = b.resolveAll(this.resolve);
        return l.includes(c) ? this.createError({
          params: {
            values: Array.from(b).join(", "),
            resolved: l
          }
        }) : !0;
      }
    }), A;
  }
  strip(g = !0) {
    let C = this.clone();
    return C.spec.strip = g, C;
  }
  /**
   * Return a serialized description of the schema including validations, flags, types etc.
   *
   * @param options Provide any needed context for resolving runtime schema alterations (lazy, when conditions, etc).
   */
  describe(g) {
    const C = (g ? this.resolve(g) : this).clone(), {
      label: A,
      meta: c,
      optional: b,
      nullable: l
    } = C.spec;
    return {
      meta: c,
      label: A,
      optional: b,
      nullable: l,
      default: C.getDefault(g),
      type: C.type,
      oneOf: C._whitelist.describe(),
      notOneOf: C._blacklist.describe(),
      tests: C.tests.map((i) => ({
        name: i.OPTIONS.name,
        params: i.OPTIONS.params
      })).filter((i, u, n) => n.findIndex((t) => t.name === i.name) === u)
    };
  }
}
rI.prototype.__isYupSchema__ = !0;
for (const I of ["validate", "validateSync"])
  rI.prototype[`${I}At`] = function(g, C, A = {}) {
    const {
      parent: c,
      parentPath: b,
      schema: l
    } = eG(this, g, C, A.context);
    return l[I](c && c[b], Object.assign({}, A, {
      parent: c,
      path: g
    }));
  };
for (const I of ["equals", "is"])
  rI.prototype[I] = rI.prototype.oneOf;
for (const I of ["not", "nope"])
  rI.prototype[I] = rI.prototype.notOneOf;
const uG = () => !0;
function uI(I) {
  return new Vl(I);
}
class Vl extends rI {
  constructor(g) {
    super(typeof g == "function" ? {
      type: "mixed",
      check: g
    } : Object.assign({
      type: "mixed",
      check: uG
    }, g));
  }
}
uI.prototype = Vl.prototype;
let tG = (
  // eslint-disable-next-line
  /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/
), GG = (
  // eslint-disable-next-line
  /^((https?|ftp):)?\/\/(((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:)*@)?(((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?)(:\d*)?)(\/((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*)?)?(\?((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|[\uE000-\uF8FF]|\/|\?)*)?(\#((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|\/|\?)*)?$/i
), ZG = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i, XG = (I) => DI(I) || I === I.trim(), dG = {}.toString();
function iI() {
  return new sl();
}
class sl extends rI {
  constructor() {
    super({
      type: "string",
      check(g) {
        return g instanceof String && (g = g.valueOf()), typeof g == "string";
      }
    }), this.withMutation(() => {
      this.transform((g, C, A) => {
        if (!A.spec.coerce || A.isType(g) || Array.isArray(g))
          return g;
        const c = g != null && g.toString ? g.toString() : g;
        return c === dG ? g : c;
      });
    });
  }
  required(g) {
    return super.required(g).withMutation((C) => C.test({
      message: g || pI.required,
      name: "required",
      skipAbsent: !0,
      test: (A) => !!A.length
    }));
  }
  notRequired() {
    return super.notRequired().withMutation((g) => (g.tests = g.tests.filter((C) => C.OPTIONS.name !== "required"), g));
  }
  length(g, C = WI.length) {
    return this.test({
      message: C,
      name: "length",
      exclusive: !0,
      params: {
        length: g
      },
      skipAbsent: !0,
      test(A) {
        return A.length === this.resolve(g);
      }
    });
  }
  min(g, C = WI.min) {
    return this.test({
      message: C,
      name: "min",
      exclusive: !0,
      params: {
        min: g
      },
      skipAbsent: !0,
      test(A) {
        return A.length >= this.resolve(g);
      }
    });
  }
  max(g, C = WI.max) {
    return this.test({
      name: "max",
      exclusive: !0,
      message: C,
      params: {
        max: g
      },
      skipAbsent: !0,
      test(A) {
        return A.length <= this.resolve(g);
      }
    });
  }
  matches(g, C) {
    let A = !1, c, b;
    return C && (typeof C == "object" ? {
      excludeEmptyString: A = !1,
      message: c,
      name: b
    } = C : c = C), this.test({
      name: b || "matches",
      message: c || WI.matches,
      params: {
        regex: g
      },
      skipAbsent: !0,
      test: (l) => l === "" && A || l.search(g) !== -1
    });
  }
  email(g = WI.email) {
    return this.matches(tG, {
      name: "email",
      message: g,
      excludeEmptyString: !0
    });
  }
  url(g = WI.url) {
    return this.matches(GG, {
      name: "url",
      message: g,
      excludeEmptyString: !0
    });
  }
  uuid(g = WI.uuid) {
    return this.matches(ZG, {
      name: "uuid",
      message: g,
      excludeEmptyString: !1
    });
  }
  //-- transforms --
  ensure() {
    return this.default("").transform((g) => g === null ? "" : g);
  }
  trim(g = WI.trim) {
    return this.transform((C) => C != null ? C.trim() : C).test({
      message: g,
      name: "trim",
      test: XG
    });
  }
  lowercase(g = WI.lowercase) {
    return this.transform((C) => DI(C) ? C : C.toLowerCase()).test({
      message: g,
      name: "string_case",
      exclusive: !0,
      skipAbsent: !0,
      test: (C) => DI(C) || C === C.toLowerCase()
    });
  }
  uppercase(g = WI.uppercase) {
    return this.transform((C) => DI(C) ? C : C.toUpperCase()).test({
      message: g,
      name: "string_case",
      exclusive: !0,
      skipAbsent: !0,
      test: (C) => DI(C) || C === C.toUpperCase()
    });
  }
}
iI.prototype = sl.prototype;
var aG = /^(\d{4}|[+\-]\d{6})(?:-?(\d{2})(?:-?(\d{2}))?)?(?:[ T]?(\d{2}):?(\d{2})(?::?(\d{2})(?:[,\.](\d{1,}))?)?(?:(Z)|([+\-])(\d{2})(?::?(\d{2}))?)?)?$/;
function VG(I) {
  var g = [1, 4, 5, 6, 7, 10, 11], C = 0, A, c;
  if (c = aG.exec(I)) {
    for (var b = 0, l; l = g[b]; ++b)
      c[l] = +c[l] || 0;
    c[2] = (+c[2] || 1) - 1, c[3] = +c[3] || 1, c[7] = c[7] ? String(c[7]).substr(0, 3) : 0, (c[8] === void 0 || c[8] === "") && (c[9] === void 0 || c[9] === "") ? A = +new Date(c[1], c[2], c[3], c[4], c[5], c[6], c[7]) : (c[8] !== "Z" && c[9] !== void 0 && (C = c[10] * 60 + c[11], c[9] === "+" && (C = 0 - C)), A = Date.UTC(c[1], c[2], c[3], c[4], c[5] + C, c[6], c[7]));
  } else
    A = Date.parse ? Date.parse(I) : NaN;
  return A;
}
let sG = /* @__PURE__ */ new Date(""), mG = (I) => Object.prototype.toString.call(I) === "[object Date]";
class KC extends rI {
  constructor() {
    super({
      type: "date",
      check(g) {
        return mG(g) && !isNaN(g.getTime());
      }
    }), this.withMutation(() => {
      this.transform((g, C, A) => !A.spec.coerce || A.isType(g) ? g : (g = VG(g), isNaN(g) ? KC.INVALID_DATE : new Date(g)));
    });
  }
  prepareParam(g, C) {
    let A;
    if (Gg.isRef(g))
      A = g;
    else {
      let c = this.cast(g);
      if (!this._typeCheck(c))
        throw new TypeError(`\`${C}\` must be a Date or a value that can be \`cast()\` to a Date`);
      A = c;
    }
    return A;
  }
  min(g, C = WA.min) {
    let A = this.prepareParam(g, "min");
    return this.test({
      message: C,
      name: "min",
      exclusive: !0,
      params: {
        min: g
      },
      skipAbsent: !0,
      test(c) {
        return c >= this.resolve(A);
      }
    });
  }
  max(g, C = WA.max) {
    let A = this.prepareParam(g, "max");
    return this.test({
      message: C,
      name: "max",
      exclusive: !0,
      params: {
        max: g
      },
      skipAbsent: !0,
      test(c) {
        return c <= this.resolve(A);
      }
    });
  }
}
KC.INVALID_DATE = sG;
KC.prototype;
function WG(I, g = []) {
  let C = [], A = /* @__PURE__ */ new Set(), c = new Set(g.map(([l, i]) => `${l}-${i}`));
  function b(l, i) {
    let u = Ag.split(l)[0];
    A.add(u), c.has(`${i}-${u}`) || C.push([i, u]);
  }
  for (const l of Object.keys(I)) {
    let i = I[l];
    A.add(l), Gg.isRef(i) && i.isSibling ? b(i.path, l) : PA(i) && "deps" in i && i.deps.forEach((u) => b(u, l));
  }
  return qt.array(Array.from(A), C).reverse();
}
function Pc(I, g) {
  let C = 1 / 0;
  return I.some((A, c) => {
    var b;
    if ((b = g.path) != null && b.includes(A))
      return C = c, !0;
  }), C;
}
function ml(I) {
  return (g, C) => Pc(I, g) - Pc(I, C);
}
const oG = (I, g, C) => {
  if (typeof I != "string")
    return I;
  let A = I;
  try {
    A = JSON.parse(I);
  } catch {
  }
  return C.isType(A) ? A : I;
};
function aC(I) {
  if ("fields" in I) {
    const g = {};
    for (const [C, A] of Object.entries(I.fields))
      g[C] = aC(A);
    return I.setFields(g);
  }
  if (I.type === "array") {
    const g = I.optional();
    return g.innerType && (g.innerType = aC(g.innerType)), g;
  }
  return I.type === "tuple" ? I.optional().clone({
    types: I.spec.types.map(aC)
  }) : "optional" in I ? I.optional() : I;
}
const rG = (I, g) => {
  const C = [...Ag.normalizePath(g)];
  if (C.length === 1)
    return C[0] in I;
  let A = C.pop(), c = Ag.getter(Ag.join(C), !0)(I);
  return !!(c && A in c);
};
let jc = (I) => Object.prototype.toString.call(I) === "[object Object]";
function yG(I, g) {
  let C = Object.keys(I.fields);
  return Object.keys(g).filter((A) => C.indexOf(A) === -1);
}
const hG = ml([]);
function jA(I) {
  return new Wl(I);
}
class Wl extends rI {
  constructor(g) {
    super({
      type: "object",
      check(C) {
        return jc(C) || typeof C == "function";
      }
    }), this.fields = /* @__PURE__ */ Object.create(null), this._sortErrors = hG, this._nodes = [], this._excludedEdges = [], this.withMutation(() => {
      g && this.shape(g);
    });
  }
  _cast(g, C = {}) {
    var A;
    let c = super._cast(g, C);
    if (c === void 0)
      return this.getDefault();
    if (!this._typeCheck(c))
      return c;
    let b = this.fields, l = (A = C.stripUnknown) != null ? A : this.spec.noUnknown, i = [].concat(this._nodes, Object.keys(c).filter((X) => !this._nodes.includes(X))), u = {}, n = Object.assign({}, C, {
      parent: u,
      __validating: C.__validating || !1
    }), t = !1;
    for (const X of i) {
      let y = b[X], s = X in c;
      if (y) {
        let B, m = c[X];
        n.path = (C.path ? `${C.path}.` : "") + X, y = y.resolve({
          value: m,
          context: C.context,
          parent: u
        });
        let x = y instanceof rI ? y.spec : void 0, v = x == null ? void 0 : x.strict;
        if (x != null && x.strip) {
          t = t || X in c;
          continue;
        }
        B = !C.__validating || !v ? (
          // TODO: use _cast, this is double resolving
          y.cast(c[X], n)
        ) : c[X], B !== void 0 && (u[X] = B);
      } else
        s && !l && (u[X] = c[X]);
      (s !== X in u || u[X] !== c[X]) && (t = !0);
    }
    return t ? u : c;
  }
  _validate(g, C = {}, A, c) {
    let {
      from: b = [],
      originalValue: l = g,
      recursive: i = this.spec.recursive
    } = C;
    C.from = [{
      schema: this,
      value: l
    }, ...b], C.__validating = !0, C.originalValue = l, super._validate(g, C, A, (u, n) => {
      if (!i || !jc(n)) {
        c(u, n);
        return;
      }
      l = l || n;
      let t = [];
      for (let X of this._nodes) {
        let y = this.fields[X];
        !y || Gg.isRef(y) || t.push(y.asNestedTest({
          options: C,
          key: X,
          parent: n,
          parentPath: C.path,
          originalParent: l
        }));
      }
      this.runTests({
        tests: t,
        value: n,
        originalValue: l,
        options: C
      }, A, (X) => {
        c(X.sort(this._sortErrors).concat(u), n);
      });
    });
  }
  clone(g) {
    const C = super.clone(g);
    return C.fields = Object.assign({}, this.fields), C._nodes = this._nodes, C._excludedEdges = this._excludedEdges, C._sortErrors = this._sortErrors, C;
  }
  concat(g) {
    let C = super.concat(g), A = C.fields;
    for (let [c, b] of Object.entries(this.fields)) {
      const l = A[c];
      A[c] = l === void 0 ? b : l;
    }
    return C.withMutation((c) => c.setFields(A, this._excludedEdges));
  }
  _getDefault() {
    if ("default" in this.spec)
      return super._getDefault();
    if (!this._nodes.length)
      return;
    let g = {};
    return this._nodes.forEach((C) => {
      const A = this.fields[C];
      g[C] = A && "getDefault" in A ? A.getDefault() : void 0;
    }), g;
  }
  setFields(g, C) {
    let A = this.clone();
    return A.fields = g, A._nodes = WG(g, C), A._sortErrors = ml(Object.keys(g)), C && (A._excludedEdges = C), A;
  }
  shape(g, C = []) {
    return this.clone().withMutation((A) => {
      let c = A._excludedEdges;
      return C.length && (Array.isArray(C[0]) || (C = [C]), c = [...A._excludedEdges, ...C]), A.setFields(Object.assign(A.fields, g), c);
    });
  }
  partial() {
    const g = {};
    for (const [C, A] of Object.entries(this.fields))
      g[C] = "optional" in A && A.optional instanceof Function ? A.optional() : A;
    return this.setFields(g);
  }
  deepPartial() {
    return aC(this);
  }
  pick(g) {
    const C = {};
    for (const A of g)
      this.fields[A] && (C[A] = this.fields[A]);
    return this.setFields(C);
  }
  omit(g) {
    const C = Object.assign({}, this.fields);
    for (const A of g)
      delete C[A];
    return this.setFields(C);
  }
  from(g, C, A) {
    let c = Ag.getter(g, !0);
    return this.transform((b) => {
      if (!b)
        return b;
      let l = b;
      return rG(b, g) && (l = Object.assign({}, b), A || delete l[g], l[C] = c(b)), l;
    });
  }
  /** Parse an input JSON string to an object */
  json() {
    return this.transform(oG);
  }
  noUnknown(g = !0, C = oA.noUnknown) {
    typeof g != "boolean" && (C = g, g = !0);
    let A = this.test({
      name: "noUnknown",
      exclusive: !0,
      message: C,
      test(c) {
        if (c == null)
          return !0;
        const b = yG(this.schema, c);
        return !g || b.length === 0 || this.createError({
          params: {
            unknown: b.join(", ")
          }
        });
      }
    });
    return A.spec.noUnknown = g, A;
  }
  unknown(g = !0, C = oA.noUnknown) {
    return this.noUnknown(!g, C);
  }
  transformKeys(g) {
    return this.transform((C) => {
      if (!C)
        return C;
      const A = {};
      for (const c of Object.keys(C))
        A[g(c)] = C[c];
      return A;
    });
  }
  camelCase() {
    return this.transformKeys(nA.camelCase);
  }
  snakeCase() {
    return this.transformKeys(nA.snakeCase);
  }
  constantCase() {
    return this.transformKeys((g) => nA.snakeCase(g).toUpperCase());
  }
  describe(g) {
    let C = super.describe(g);
    C.fields = {};
    for (const [c, b] of Object.entries(this.fields)) {
      var A;
      let l = g;
      (A = l) != null && A.value && (l = Object.assign({}, l, {
        parent: l.value,
        value: l.value[c]
      })), C.fields[c] = b.describe(l);
    }
    return C;
  }
}
jA.prototype = Wl.prototype;
const ag = "내용을 입력해 주세요.";
jA().shape({
  subjectType: uI().when([], () => uI().oneOf(Object.values(el), "올바른 정산 유형을 선택해주세요.").required(ag).default(GI.WITHHOLDING_TAX)),
  name: iI(),
  settlementName: iI().when([], () => iI().required(ag).defined()),
  rrn: iI().when(["subjectType", "nonWithholdingTaxType"], ([I, g]) => {
    if (!Jt(I))
      throw new Error("rrn: subjectType is not a SettlementType");
    return dC(I) || sA(I, g) || OI(I) ? iI().nullable() : iI().required(ag).test({
      name: "rrn",
      test: (C, {
        createError: A,
        path: c
      }) => /^[0-9]{6}-[1-4][0-9]{6}$/.test(C.trim()) ? !0 : A({
        path: c,
        message: "유효한 주민등록번호를 입력해야합니다."
      })
    });
  }),
  brn: iI().when(["subjectType"], ([I]) => dC(I) ? iI().required(ag).defined() : iI().nullable()),
  taxationType: uI().when(["subjectType"], ([I]) => dC(I) ? uI().oneOf(Object.values(Rt)).required().defined() : uI().nullable()),
  bank: uI().when(["settlementName", "subjectType", "nonWithholdingTaxType"], ([I, g, C]) => {
    const A = uI().oneOf([...wc], "은행을 선택해 주세요.").nullable().defined();
    return OI(g) && C !== RI.DOMESTIC_QUOTATION ? uI().nullable() : I ? uI().required("은행을 선택해 주세요.").oneOf([...wc], "은행을 선택해 주세요.") : A;
  }),
  bankAccountNumber: iI().when(["subjectType", "nonWithholdingTaxType"], ([I, g]) => OI(I) && g !== RI.DOMESTIC_QUOTATION ? iI().nullable() : iI().required(ag).test({
    name: "bankAccountNumber",
    test: (C, {
      createError: A,
      path: c
    }) => isNaN(Number(C)) ? A({
      path: c,
      message: "숫자만 입력 가능합니다."
    }) : !0
  })),
  nonWithholdingTaxType: uI().when(["subjectType"], ([I]) => OI(I) ? uI().oneOf(Object.values(RI)).required().defined() : uI().nullable()),
  bankAccountHolder: iI().nullable(),
  userType: uI().required().defined(),
  paypalLink: iI().when(["subjectType", "nonWithholdingTaxType"], ([I, g]) => sA(I, g) ? iI().required(ag).defined() : iI().nullable())
});
function MA() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
function JG() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
process.env.NODE_ENV;
function ol() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
process.env.NODE_ENV;
process.env.NODE_ENV;
function xG() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
process.env.NODE_ENV;
function BG() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
process.env.NODE_ENV;
jA().shape({
  isClickedNextOnInfo: uI().oneOf(["true", "false"])
});
function RG() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
process.env.NODE_ENV;
function rl() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
`${P.gray[2]}`, process.env.NODE_ENV, process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
_g({
  userType: QI.INSTRUCTOR,
  lang: ig,
  Modal: {
    isOpen: !1,
    open: () => {
    },
    close: () => {
    }
  },
  submit: () => {
  },
  updateCompleteCallback: () => {
  }
});
function Zg() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
cb(() => import("./MissionSubmissionModal-31f13bf5-3375c82a.mjs").then((I) => ({
  default: I.MissionSubmissionModal
})));
function JX() {
  const {
    trackEvent: I
  } = sI(), g = Ct({
    enabled: !0,
    valueKey: gt.FIRST_HELLO,
    onSuccessPipe: (C) => (C.delete(ll.TO), C)
  });
  return II(() => {
    g && (I(bI.COMPLETE_SIGNUP), I(bI.COMPLETE_REGISTRATION));
  }, [g, I]), {};
}
function xX() {
  const [I, g] = nI(!1);
  return II(() => {
    g(!0);
  }, []), I;
}
function vG(I) {
  return vi({
    url: uA.CLIENT_V1_COURSE_CONTRACT_HISTORIES_INFLEARN_MARKETING_CONFIRM_REQUIRED,
    queryKey: [uA.CLIENT_V1_COURSE_CONTRACT_HISTORIES_INFLEARN_MARKETING_CONFIRM_REQUIRED],
    options: {
      ...I,
      suspense: !1,
      useErrorBoundary: !1
    }
  });
}
const NG = cb(() => import("./InstructorMarketingModal-30e3fb19.mjs").then((I) => ({
  default: I.InstructorMarketingModal
})));
function BX() {
  const {
    data: I
  } = Fb(), [g, C] = nI(!1), A = (I == null ? void 0 : I.isInstructor) ?? !1;
  return vG({
    enabled: A,
    onSuccess: ({
      data: c
    }) => {
      c.items.length > 0 && C(!0);
    }
  }), !A || !g ? null : /* @__PURE__ */ e(vb, { fallback: null, children: /* @__PURE__ */ e(hA, { fallback: null, children: /* @__PURE__ */ e(NG, {}) }) });
}
const pG = {
  MY_CATEGORY: "MY_CATEGORY",
  WELCOME: "WELCOME",
  INSTRUCTOR_MARKETING: "INSTRUCTOR_MARKETING"
}, Mc = {
  MY_CATEGORY: "my-category-modal",
  WELCOME: "welcome-modal",
  INSTRUCTOR_MARKETING: "marketing-agreement-modal"
}, yl = Cb.createContext(null);
function RX({
  children: I
}) {
  const g = HI(null), [C, A] = UI(!1), c = (l) => {
    A.open(), g.current = l;
  }, b = () => {
    A.close(), g.current = null;
  };
  return II(() => {
    const l = () => c(pG.INSTRUCTOR_MARKETING);
    return window.addEventListener(Mc.INSTRUCTOR_MARKETING, l), () => {
      window.removeEventListener(Mc.INSTRUCTOR_MARKETING, l);
    };
  }, []), /* @__PURE__ */ e(yl.Provider, { value: {
    isOpenedModal: C,
    MODAL_ID: g.current,
    openModal: c,
    closeModal: b
  }, children: I });
}
function FG() {
  const I = Cb.useContext(yl);
  if (!I)
    throw Error("useModalsContext must use in ModalsContext");
  return I;
}
const vX = (I) => {
  const g = FG();
  return [g.MODAL_ID === I && g.isOpenedModal, {
    open: () => {
      g.openModal(I);
    },
    close: () => {
      g.closeModal();
    }
  }];
}, hl = _g(null), NX = ({
  children: I
}) => {
  const [g, C] = nI(null);
  return /* @__PURE__ */ e(hl.Provider, { value: {
    openSideSheet: C,
    closeSideSheet: () => C(null),
    isProfileSideSheetOpen: g === "profile",
    isCategorySideSheetOpen: g === "category"
  }, children: I });
}, pX = () => {
  const I = bb(hl);
  if (!I)
    throw Error("useSideSheetContext must use in SideSheetContext");
  return I;
};
function KA(I) {
  return Ni({
    url: vI.V1_MESSAGE,
    queryKey: [vI.V1_MESSAGE],
    options: {
      suspense: !1,
      staleTime: Dg(1),
      useErrorBoundary: !1,
      ...I
    },
    /**
     * @NOTE 해당 API 는 ant-man-account 로 요청을 보내야하기 때문에 baseURL 이 달라진다.
     */
    requestOptions: {
      baseUrl: pi
    }
  });
}
var YG = {};
const eA = {
  GROUP_MANAGER: "기업관리자",
  GROUP_USER: "기업회원",
  ADMIN: "어드민",
  STUDENT: "학생",
  INSTRUCTOR: "지식공유자"
};
var HG = {}, Jl = {};
(function(I) {
  Object.defineProperty(I, "__esModule", { value: !0 });
  var g = "fal", C = "cart-shopping", A = 576, c = 512, b = [128722, "shopping-cart"], l = "f07a", i = "M16 0C7.2 0 0 7.2 0 16s7.2 16 16 16H53.9c7.6 0 14.2 5.3 15.7 12.8l58.9 288c6.1 29.8 32.3 51.2 62.7 51.2H496c8.8 0 16-7.2 16-16s-7.2-16-16-16H191.2c-15.2 0-28.3-10.7-31.4-25.6L152 288H466.5c29.4 0 55-20 62.1-48.5L570.6 71.8c5-20.2-10.2-39.8-31-39.8H99.1C92.5 13 74.4 0 53.9 0H16zm90.1 64H539.5L497.6 231.8C494 246 481.2 256 466.5 256H145.4L106.1 64zM168 456a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm80 0a56 56 0 1 0 -112 0 56 56 0 1 0 112 0zm200-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0 80a56 56 0 1 0 0-112 56 56 0 1 0 0 112z";
  I.definition = {
    prefix: g,
    iconName: C,
    icon: [
      A,
      c,
      b,
      l,
      i
    ]
  }, I.faCartShopping = I.definition, I.prefix = g, I.iconName = C, I.width = A, I.height = c, I.ligatures = b, I.unicode = l, I.svgPathData = i, I.aliases = b;
})(Jl);
function zG({
  options: I
}) {
  return Fi({
    queryKey: UG(),
    url: vI.V1_NOTICE_EXPOSURE,
    options: {
      ...I
    }
  });
}
const UG = () => [vI.V1_NOTICE_EXPOSURE];
function LG({
  options: I
}) {
  return Yi({
    queryKey: SG(),
    url: Gb.CLIENT_V1_NOTICE_USER_DISCOUNT,
    options: {
      ...I
    }
  });
}
const SG = () => [Gb.CLIENT_V1_NOTICE_USER_DISCOUNT], Kg = 16, fG = ({
  opacity: I = 1
}) => /* @__PURE__ */ O(BI, { position: "apart", w: "100%", pos: "absolute", bottom: -Kg, left: 0, style: {
  opacity: I,
  transition: "opacity 0.3s"
}, children: [
  /* @__PURE__ */ e(TG, { fill: P.infgreen[0] }),
  /* @__PURE__ */ e(kG, { fill: P.infgreen[0] })
] }), TG = ({
  fill: I
}) => /* @__PURE__ */ e("svg", { width: Kg, height: Kg, viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ e("path", { d: `
      M0,0
      H16
      V16
      H0
      Z
      M0,16
      A16,16 0 0 1 16,0
      V16
      Z
    `, fill: I, fillRule: "evenodd" }) }), kG = ({
  fill: I
}) => /* @__PURE__ */ e("svg", { width: Kg, height: Kg, viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ e("path", { d: `
    M0,0
    H16
    V16
    A16,16 0 0 0 0,0
    Z
  `, fill: I }) }), wG = ({
  endedAt: I,
  now: g
}) => {
  const [C, A] = nI(IC(I).diff(g)), c = HI();
  II(() => {
    const l = () => {
      const i = IC(I).diff(IC());
      A(i), i <= 0 && clearInterval(c.current);
    };
    return l(), c.current = setInterval(l, 1e3), () => clearInterval(c.current);
  }, [I]);
  const b = IC.duration(C);
  return {
    diff: C,
    formattedDurationDate: {
      hours: b.hours() + b.days() * 24,
      minutes: b.minutes(),
      seconds: b.seconds()
    }
  };
}, GC = (I) => {
  I.forEach(({
    element: g,
    styles: C
  }) => {
    g && C.forEach(({
      key: A,
      value: c
    }) => {
      g.style[A] = c;
    });
  });
}, Kc = ({
  disabledSticky: I,
  isDesktop: g,
  type: C,
  shouldShowSearchBar: A
}) => {
  if (I || !A)
    return 0;
  const [c, b] = [C === "default" ? 0 : fg.DESKTOP.SEARCH_BAR, C === "default" ? fg.MOBILE.DEFAULT : fg.MOBILE.SEARCH_BAR];
  return g ? c : b;
}, QG = (I, g, C, A, c, b) => {
  var x;
  const l = document.getElementById(VI.HEADER_CONTAINER_DESKTOP), i = document.getElementById(VI.HEADER_CONTAINER_MOBILE), u = ((x = document.getElementsByTagName("main")) == null ? void 0 : x[0]) ?? void 0, n = document.getElementById(VI.HEADER_MOBILE_TOP), t = document.getElementById(VI.HEADER_MOBILE_BOTTOM), X = document.getElementById(VI.HEADER_DIVIDER_DESKTOP), y = document.getElementById(VI.HEADER_DIVIDER_MOBILE), s = document.getElementById(VI.FOOTER_CONTAINER), B = Kc({
    disabledSticky: A,
    isDesktop: c,
    type: "default",
    shouldShowSearchBar: C
  }), m = Kc({
    disabledSticky: A,
    isDesktop: c,
    type: "search-bar",
    shouldShowSearchBar: C
  });
  if (GC([{
    element: n,
    styles: [{
      key: "transition",
      value: "all 0.2s ease-out"
    }]
  }, {
    element: u,
    styles: [{
      key: "transition",
      value: b ? "all 0.2s ease-out" : "unset"
    }]
  }, {
    element: t,
    styles: [{
      key: "transition",
      value: "all 0.2s ease-out"
    }]
  }, {
    element: X,
    styles: [{
      key: "transition",
      value: "all 0.2s ease-out"
    }]
  }]), GC([{
    element: n,
    styles: [{
      key: "transform",
      value: "translateY(0px)"
    }, {
      key: "opacity",
      value: "1"
    }]
  }, {
    element: l,
    styles: [{
      key: "backgroundColor",
      value: "white"
    }]
  }, {
    element: i,
    styles: [{
      key: "backgroundColor",
      value: "white"
    }]
  }, {
    element: u,
    styles: [{
      key: "transform",
      value: `translateY(${m}px)`
    }]
  }, {
    element: s,
    styles: [{
      key: "transform",
      value: `translateY(${m}px)`
    }]
  }, {
    element: t,
    styles: [{
      key: "transform",
      value: "translateY(0px)"
    }, {
      key: "opacity",
      value: "1"
    }, {
      key: "visibility",
      value: "visible"
    }]
  }, {
    element: X,
    styles: [{
      key: "transform",
      value: "translateY(0px)"
    }, {
      key: "opacity",
      value: "1"
    }]
  }, {
    element: y,
    styles: [{
      key: "transform",
      value: `translateY(${m}px)`
    }, {
      key: "opacity",
      value: "1"
    }]
  }]), !I && g) {
    GC([{
      element: n,
      styles: [{
        key: "transform",
        value: "translateY(-100%)"
      }, {
        key: "opacity",
        value: "0"
      }]
    }, {
      element: l,
      styles: [{
        key: "backgroundColor",
        value: "white"
      }]
    }, {
      element: i,
      styles: [{
        key: "backgroundColor",
        value: "transparent"
      }]
    }, {
      element: u,
      styles: [{
        key: "transform",
        value: `translateY(-${B}px)`
      }]
    }, {
      element: s,
      styles: [{
        key: "transform",
        value: `translateY(-${B}px)`
      }]
    }, {
      element: t,
      styles: [{
        key: "transform",
        value: "translateY(100%)"
      }, {
        key: "opacity",
        value: "0"
      }, {
        key: "visibility",
        value: "hidden"
      }]
    }, {
      element: y,
      styles: [{
        key: "opacity",
        value: "0"
      }]
    }]);
    return;
  }
  I && GC([{
    element: n,
    styles: [{
      key: "transform",
      value: "translateY(0px)"
    }, {
      key: "opacity",
      value: "1"
    }]
  }, {
    element: u,
    styles: [{
      key: "transform",
      value: `translateY(${m}px)`
    }, {
      key: "opacity",
      value: "1"
    }]
  }, {
    element: s,
    styles: [{
      key: "transform",
      value: `translateY(${m}px)`
    }]
  }, {
    element: X,
    styles: [{
      key: "transform",
      value: `translateY(${m}px)`
    }, {
      key: "opacity",
      value: C ? "0" : "1"
    }]
  }, {
    element: y,
    styles: [{
      key: "transform",
      value: `translateY(max(0px, ${C ? fg.MOBILE.SEARCH_BAR : 0}px))`
    }, {
      key: "opacity",
      value: C ? "0" : "1"
    }]
  }]);
}, xl = _g({
  isTop: !0,
  setIsTop: () => {
  }
}), OG = ({
  notice: I,
  children: g,
  disabledSticky: C
}) => {
  const A = HI(null), [c, b] = nI(!0), [l, i] = nI(0), [u, n] = nI(!1), [t, X] = nI(!1), y = HI(0), [s, B] = nI(!1), m = SC(), x = yA(pA.tablet), v = Gi(() => {
    const d = window.scrollY, Z = d <= l, r = d > y.current;
    y.current = d, (Z !== c || r !== u) && (b(Z), n(r), G({
      isAtTop: Z,
      scrollingDown: r,
      isMounted: !0
    }));
  }, [c, u, l]), G = Rg(() => ({
    isAtTop: d,
    scrollingDown: Z,
    isMounted: r
  } = {
    isAtTop: c,
    scrollingDown: u,
    isMounted: !1
  }) => {
    QG(d, Z, m, C, !x, r);
  }, [m, C, x, c, u]);
  II(() => {
    if (!A.current)
      return;
    const d = new ResizeObserver(() => {
      var r;
      const Z = ((r = A.current) == null ? void 0 : r.clientHeight) ?? 0;
      i(Z), Z > 0 && !t && (X(!0), G());
    });
    return d.observe(A.current), () => d.disconnect();
  }, [t]), II(() => (window.addEventListener("scroll", v, {
    passive: !0
  }), () => window.removeEventListener("scroll", v)), [v]), II(() => {
    v();
  }, [s]), Zi(() => {
    s || G();
  }, [G, s]), Hi(() => {
    G();
  }), II(() => {
    B(!0);
  }, []);
  const V = Rg(() => ({
    isTop: c,
    setIsTop: b
  }), [c, b]);
  return /* @__PURE__ */ O(xl.Provider, { value: V, children: [
    /* @__PURE__ */ e(gI, { ref: A, css: /* @__PURE__ */ CI({
      transition: "all 0.25s ease-out",
      opacity: t ? 1 : 0,
      transform: t ? "translateY(0)" : "translateY(-10px)"
    }, process.env.NODE_ENV === "production" ? "" : ";label:ScrollModeProvider;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), children: I }),
    g
  ] });
}, _C = () => {
  const I = bb(xl);
  if (!I)
    throw new Error("useScrollModeContext must be used within a ScrollModeProvider");
  return I;
}, DG = ({
  title: I,
  body: g,
  id: C,
  cookieExpireDays: A,
  afterClose: c,
  isAntMan: b
}) => {
  const l = HI(null), {
    trackEvent: i
  } = sI(), u = () => {
    vg.set("checked_noti_id", String(C), A, "High"), c();
  };
  return II(() => {
    if (!l.current)
      return;
    const n = (X) => {
      var m;
      const y = X.target, s = (m = y == null ? void 0 : y.closest) == null ? void 0 : m.call(y, "a");
      if (!s)
        return;
      const B = s.textContent || s.innerText || "";
      i(bI.CLICK_HEADER_NOTICE, {
        spot: "link",
        title: B,
        id: C
      });
    }, t = l.current;
    return t.addEventListener("click", n), () => {
      t.removeEventListener("click", n);
    };
  }, [g, i]), /* @__PURE__ */ e(Bl, { title: I, onClose: u, id: C, isAntMan: b, children: /* @__PURE__ */ e(gI, { ref: l, children: /* @__PURE__ */ e(cI, { dangerouslySetInnerHTML: {
    __html: g ?? ""
  }, css: Rl }) }) });
}, EG = ({
  type: I,
  now: g,
  endedAt: C,
  discountPercent: A,
  isAntMan: c
}) => {
  const {
    profile: b
  } = yI(), {
    title: l,
    body: i,
    id: u
  } = Rg(() => ({
    title: zi[I]((b == null ? void 0 : b.name) ?? ""),
    body: Ui[I](A),
    id: Li[I]
  }), [I, b == null ? void 0 : b.name, A]), n = () => {
    const y = vg.get("userDC");
    y && vg.set("userDC", y.replace("true", "false"));
  }, {
    diff: t,
    formattedDurationDate: X
  } = wG({
    endedAt: C,
    now: g
  });
  return /* @__PURE__ */ e(Bl, { title: l, onClose: n, hidden: t <= 0, id: u, isAntMan: c, children: /* @__PURE__ */ O(eI, { children: [
    /* @__PURE__ */ e(cI, { dangerouslySetInnerHTML: {
      __html: i || ""
    }, css: Rl }),
    /* @__PURE__ */ e(PG, { durationDate: X })
  ] }) });
}, PG = ({
  durationDate: I
}) => {
  const {
    t: g
  } = MI();
  return /* @__PURE__ */ O(cI, { children: [
    g("할인 종료까지"),
    /* @__PURE__ */ O(cI, { component: "span", weight: "bold", ml: 3, mr: 3, children: [
      I.hours,
      g("시간"),
      /* @__PURE__ */ e(cI, { component: "span", weight: "bold", ml: 3, children: I.minutes }),
      g("분"),
      /* @__PURE__ */ e(cI, { component: "span", weight: "bold", ml: 3, children: I.seconds }),
      g("초")
    ] }),
    g("남았어요.")
  ] });
}, Bl = ({
  title: I = "",
  children: g,
  onClose: C,
  hidden: A = !1,
  id: c,
  isAntMan: b
}) => {
  const l = HI(null), [i, u] = nI(!1), {
    trackEvent: n
  } = sI(), {
    isTop: t
  } = _C(), X = () => {
    var s;
    l != null && l.current && (l.current.style.marginTop = `-${(s = l.current) == null ? void 0 : s.clientHeight}px`);
  }, y = () => {
    u(!0), X(), n(bI.CLICK_HEADER_NOTICE, {
      spot: "close",
      id: c
    }), C();
  };
  return A ? null : /* @__PURE__ */ O(gI, { w: "100%", ref: l, css: /* @__PURE__ */ CI({
    position: "relative",
    zIndex: RA(b).HEADER_NOTICE
  }, process.env.NODE_ENV === "production" ? "" : ";label:HeaderNoticeRenderer;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), children: [
    /* @__PURE__ */ e(yb, { type: "success", radius: "none", withCloseButton: !0, title: I, onClose: y, styles: {
      title: {
        padding: "0 !important",
        justifyContent: "center",
        fontWeight: 700,
        marginBottom: 3
      },
      body: {
        fontSize: 14,
        textAlign: "center",
        color: `${P.infgreen[7]} !important`
      },
      message: {
        color: `${P.infgreen[7]} !important`
      }
    }, children: g }),
    /* @__PURE__ */ e(fG, { opacity: i || !t ? 0 : 1 })
  ] });
}, Rl = /* @__PURE__ */ CI({
  "sub, sup": {
    fontSize: "smaller"
  },
  p: {
    textAlignLast: "center",
    color: P.infgreen[7]
  },
  a: {
    color: P.infgreen[7],
    "&:hover": {
      color: P.infgreen[6]
    }
  }
}, process.env.NODE_ENV === "production" ? "" : ";label:styleBody;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), jG = ({
  isAntMan: I
}) => {
  const {
    isKo: g
  } = Yg(), [C, A] = nI(null), c = vg.get("checked_noti_id"), b = vg.get("userDC"), l = !!b && b.includes("true"), {
    profile: i
  } = yI(), u = (i == null ? void 0 : i.isB2b) ?? !1, n = !!i, {
    data: t,
    isInitialLoading: X
  } = zG({
    options: {
      suspense: !1,
      staleTime: Ic(1),
      useErrorBoundary: !1,
      enabled: !u
    }
  }), {
    data: y
  } = LG({
    options: {
      suspense: !1,
      useErrorBoundary: !1,
      staleTime: Ic(1),
      enabled: !X && l && n
    }
  }), s = g && c !== String(t == null ? void 0 : t.id) && (t == null ? void 0 : t.hasNotice);
  II(() => {
    if (s) {
      A("ALL");
      return;
    }
    if (!VC(y)) {
      A("USER_DISCOUNT");
      return;
    }
    A(null);
  }, [s, y]);
  const B = () => {
    if (!VC(y)) {
      A("USER_DISCOUNT");
      return;
    }
    A(null);
  };
  return I ? null : C === "ALL" && t ? /* @__PURE__ */ e(DG, { title: t.title, body: t.body, id: t.id, cookieExpireDays: t.cookieExpireDays, afterClose: B, hasNotice: t.hasNotice, isAntMan: I }) : C === "USER_DISCOUNT" && y ? /* @__PURE__ */ e(EG, { type: y.type, now: y.now, endedAt: y.endedAt, discountPercent: y.discountPercent, isAntMan: I }) : null;
};
var vl = {};
(function(I) {
  Object.defineProperty(I, "__esModule", { value: !0 });
  var g = "fas", C = "seedling", A = 512, c = 512, b = [127793, "sprout"], l = "f4d8", i = "M512 32c0 113.6-84.6 207.5-194.2 222c-7.1-53.4-30.6-101.6-65.3-139.3C290.8 46.3 364 0 448 0h32c17.7 0 32 14.3 32 32zM0 96C0 78.3 14.3 64 32 64H64c123.7 0 224 100.3 224 224v32V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V320C100.3 320 0 219.7 0 96z";
  I.definition = {
    prefix: g,
    iconName: C,
    icon: [
      A,
      c,
      b,
      l,
      i
    ]
  }, I.faSeedling = I.definition, I.prefix = g, I.iconName = C, I.width = A, I.height = c, I.ligatures = b, I.unicode = l, I.svgPathData = i, I.aliases = b;
})(vl);
var Nl = {};
(function(I) {
  Object.defineProperty(I, "__esModule", { value: !0 });
  var g = "fad", C = "gift", A = 512, c = 512, b = [127873], l = "f06b", i = ["M73.6 128c14.6 28.5 44.2 48 78.4 48h64 8v80H32c-17.7 0-32-14.3-32-32V160c0-17.7 14.3-32 32-32H73.6zM480 256H288V176h72c34.2 0 63.8-19.5 78.4-48H480c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32zM32 288H224V512H80c-26.5 0-48-21.5-48-48V288zM288 512V288H480V464c0 26.5-21.5 48-48 48H288z", "M190.5 68.8L225.3 128H224h-8H152c-22.1 0-40-17.9-40-40s17.9-40 40-40h2.2c14.9 0 28.8 7.9 36.3 20.8zM256 85.5l-24.1-41C215.7 16.9 186.1 0 154.2 0H152C103.4 0 64 39.4 64 88s39.4 88 88 88h64 8v80h64V176h72c48.6 0 88-39.4 88-88s-39.4-88-88-88h-2.2c-31.9 0-61.5 16.9-77.7 44.4L256 85.5zm65.5-16.7C329.1 55.9 342.9 48 357.8 48H360c22.1 0 40 17.9 40 40s-17.9 40-40 40H286.7l34.8-59.2zM288 512V288H224V512h64z"];
  I.definition = {
    prefix: g,
    iconName: C,
    icon: [
      A,
      c,
      b,
      l,
      i
    ]
  }, I.faGift = I.definition, I.prefix = g, I.iconName = C, I.width = A, I.height = c, I.ligatures = b, I.unicode = l, I.svgPathData = i, I.aliases = b;
})(Nl);
var pl = {};
(function(I) {
  Object.defineProperty(I, "__esModule", { value: !0 });
  var g = "fad", C = "wand-magic-sparkles", A = 576, c = 512, b = ["magic-wand-sparkles"], l = "e2ca", i = ["M234.7 42.7L248.8 5c1.1-3 4-5 7.2-5s6.1 2 7.2 5l14.1 37.7L315 56.8c3 1.1 5 4 5 7.2s-2 6.1-5 7.2L277.3 85.3 263.2 123c-1.1 3-4 5-7.2 5s-6.1-2-7.2-5L234.7 85.3 197 71.2c-3-1.1-5-4-5-7.2s2-6.1 5-7.2l37.7-14.1zm295.2 73.9L419.2 227.2l-39.6-39.6 105-105L461.4 59.3l-105 105-39.6-39.6L427.4 14.1c18.7-18.7 49.1-18.7 67.9 0l34.6 34.6c18.7 18.7 18.7 49.1 0 67.9zM7.5 117.2L64 96 85.2 39.5C86.9 35 91.2 32 96 32s9.1 3 10.8 7.5L128 96l56.5 21.2c4.5 1.7 7.5 6 7.5 10.8s-3 9.1-7.5 10.8L128 160l-21.2 56.5c-1.7 4.5-6 7.5-10.8 7.5s-9.1-3-10.8-7.5L64 160 7.5 138.8C3 137.1 0 132.8 0 128s3-9.1 7.5-10.8zm352 256L416 352l21.2-56.5c1.7-4.5 6-7.5 10.8-7.5s9.1 3 10.8 7.5L480 352l56.5 21.2c4.5 1.7 7.5 6 7.5 10.8s-3 9.1-7.5 10.8L480 416l-21.2 56.5c-1.7 4.5-6 7.5-10.8 7.5s-9.1-3-10.8-7.5L416 416l-56.5-21.2c-4.5-1.7-7.5-6-7.5-10.8s3-9.1 7.5-10.8z", "M419.2 227.2L316.7 124.7 46.1 395.4c-18.7 18.7-18.7 49.1 0 67.9l34.6 34.6c18.7 18.7 49.1 18.7 67.9 0L419.2 227.2z"];
  I.definition = {
    prefix: g,
    iconName: C,
    icon: [
      A,
      c,
      b,
      l,
      i
    ]
  }, I.faWandMagicSparkles = I.definition, I.prefix = g, I.iconName = C, I.width = A, I.height = c, I.ligatures = b, I.unicode = l, I.svgPathData = i, I.aliases = b;
})(pl);
var Fl = {};
(function(I) {
  Object.defineProperty(I, "__esModule", { value: !0 });
  var g = "fad", C = "star", A = 576, c = 512, b = [11088, 61446], l = "f005", i = ["M316.9 18C311.6 7 300.4 0 288.1 0s-23.4 7-28.8 18L195 150.3 51.4 171.5c-12 1.8-22 10.2-25.7 21.7s-.7 24.2 7.9 32.7L137.8 329 113.2 474.7c-2 12 3 24.2 12.9 31.3s23 8 33.8 2.3l128.3-68.5 128.3 68.5c10.8 5.7 23.9 4.9 33.8-2.3s14.9-19.3 12.9-31.3L438.5 329 542.7 225.9c8.6-8.5 11.7-21.2 7.9-32.7s-13.7-19.9-25.7-21.7L381.2 150.3 316.9 18z", ""];
  I.definition = {
    prefix: g,
    iconName: C,
    icon: [
      A,
      c,
      b,
      l,
      i
    ]
  }, I.faStar = I.definition, I.prefix = g, I.iconName = C, I.width = A, I.height = c, I.ligatures = b, I.unicode = l, I.svgPathData = i, I.aliases = b;
})(Fl);
var Yl = {};
(function(I) {
  Object.defineProperty(I, "__esModule", { value: !0 });
  var g = "fad", C = "tree-deciduous", A = 512, c = 512, b = [127795, "tree-alt"], l = "f400", i = ["M351.6 86.8c9.9-4.4 20.9-6.8 32.4-6.8c44.2 0 80 35.8 80 80c0 14.4-3.8 27.9-10.5 39.6C487.9 214.2 512 248.3 512 288c0 53-43 96-96 96H288V160c0-17.7-14.3-32-32-32s-32 14.3-32 32V384H96c-53 0-96-43-96-96c0-39.7 24.1-73.8 58.5-88.4C51.8 187.9 48 174.4 48 160c0-44.2 35.8-80 80-80c11.5 0 22.5 2.4 32.4 6.8C165 38.1 206.1 0 256 0s91 38.1 95.6 86.8z", "M256 128c17.7 0 32 14.3 32 32V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V160c0-17.7 14.3-32 32-32z"];
  I.definition = {
    prefix: g,
    iconName: C,
    icon: [
      A,
      c,
      b,
      l,
      i
    ]
  }, I.faTreeDeciduous = I.definition, I.prefix = g, I.iconName = C, I.width = A, I.height = c, I.ligatures = b, I.unicode = l, I.svgPathData = i, I.aliases = b;
})(Yl);
var Hl = {};
(function(I) {
  Object.defineProperty(I, "__esModule", { value: !0 });
  var g = "fad", C = "building", A = 384, c = 512, b = [127970, 61687], l = "f1ad", i = ["M0 48C0 21.5 21.5 0 48 0H336c26.5 0 48 21.5 48 48V464c0 26.5-21.5 48-48 48H240V432c0-26.5-21.5-48-48-48s-48 21.5-48 48v80H48c-26.5 0-48-21.5-48-48V48zM80 224c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V240c0-8.8-7.2-16-16-16H80zm80 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V240c0-8.8-7.2-16-16-16H176c-8.8 0-16 7.2-16 16zm112-16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V240c0-8.8-7.2-16-16-16H272zM64 112v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V112c0-8.8-7.2-16-16-16H80c-8.8 0-16 7.2-16 16zM176 96c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V112c0-8.8-7.2-16-16-16H176zm80 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V112c0-8.8-7.2-16-16-16H272c-8.8 0-16 7.2-16 16z", "M80 96c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V112c0-8.8-7.2-16-16-16H80zm0 128c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V240c0-8.8-7.2-16-16-16H80zm96 0c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V240c0-8.8-7.2-16-16-16H176zm80 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V240c0-8.8-7.2-16-16-16H272c-8.8 0-16 7.2-16 16zM160 112v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V112c0-8.8-7.2-16-16-16H176c-8.8 0-16 7.2-16 16zM272 96c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V112c0-8.8-7.2-16-16-16H272z"];
  I.definition = {
    prefix: g,
    iconName: C,
    icon: [
      A,
      c,
      b,
      l,
      i
    ]
  }, I.faBuilding = I.definition, I.prefix = g, I.iconName = C, I.width = A, I.height = c, I.ligatures = b, I.unicode = l, I.svgPathData = i, I.aliases = b;
})(Hl);
var zl = {};
(function(I) {
  Object.defineProperty(I, "__esModule", { value: !0 });
  var g = "fad", C = "handshake", A = 640, c = 512, b = [], l = "f2b5", i = ["M512 352V128h-1.5l-71-47.3C423.2 69.8 404.1 64 384.5 64c-20.7 0-40.9 6.5-57.7 18.5l-98.6 70.4c-21.6 15.4-26.6 45.4-11.2 67s45.4 26.6 67 11.2l57.2-40.8L496.4 332.6c6 5.5 10.3 12.2 12.8 19.4H512zm32 0c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V144c0-8.8-7.2-16-16-16H544V352zm48-32a16 16 0 1 1 0 32 16 16 0 1 1 0-32z", "M156.2 352H128V128l72-48c15.6-10.4 34-16 52.8-16c22.7 0 44.7 8.1 61.9 22.9l2.7 2.3-89.3 63.8c-21.6 15.4-26.6 45.4-11.2 67s45.4 26.6 67 11.2l57.2-40.8 13.1 12L496.4 332.6c5.5 5 9.6 11.1 12.1 17.5c6.6 16.6 3.7 36.2-9.2 50.3c-17.9 19.5-48.3 20.9-67.8 2.9l-7.8-7.1c-.9 10.1-5 20.1-12.4 28.2c-17.9 19.5-48.3 20.9-67.8 2.9l-17-15.6c-1.9 7.4-5.6 14.5-11.1 20.6c-17.9 19.6-48.2 21-67.8 3.1L156.2 352zM0 144c0-8.8 7.2-16 16-16H96V352c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32V144zM64 336a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z"];
  I.definition = {
    prefix: g,
    iconName: C,
    icon: [
      A,
      c,
      b,
      l,
      i
    ]
  }, I.faHandshake = I.definition, I.prefix = g, I.iconName = C, I.width = A, I.height = c, I.ligatures = b, I.unicode = l, I.svgPathData = i, I.aliases = b;
})(zl);
var Ul = {};
(function(I) {
  Object.defineProperty(I, "__esModule", { value: !0 });
  var g = "fad", C = "hand-holding-seedling", A = 576, c = 512, b = [], l = "f4bf", i = ["M559.7 392.2c17.8-13.1 21.6-38.1 8.5-55.9s-38.1-21.6-55.9-8.5L392.6 416H272c-8.8 0-16-7.2-16-16s7.2-16 16-16h16 64c17.7 0 32-14.3 32-32s-14.3-32-32-32H288 272 193.7c-29.1 0-57.3 9.9-80 28L68.8 384H32c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32H192 352.5c29 0 57.3-9.3 80.7-26.5l126.6-93.3zm-366.1-8.3a.5 .5 0 1 1 -.9 .2 .5 .5 0 1 1 .9-.2z", "M96 14.5C96 6.5 102.5 0 110.5 0H160c88.4 0 160 71.6 160 160v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V160H241.5C161.1 160 96 94.9 96 14.5zm384 0C480 89 424.1 150.3 352 159c-.2-44.9-15.9-86.2-42-118.8C338.2 15.2 375.3 0 416 0h49.5c8 0 14.5 6.5 14.5 14.5z"];
  I.definition = {
    prefix: g,
    iconName: C,
    icon: [
      A,
      c,
      b,
      l,
      i
    ]
  }, I.faHandHoldingSeedling = I.definition, I.prefix = g, I.iconName = C, I.width = A, I.height = c, I.ligatures = b, I.unicode = l, I.svgPathData = i, I.aliases = b;
})(Ul);
var Ll = {};
(function(I) {
  Object.defineProperty(I, "__esModule", { value: !0 });
  var g = "fad", C = "calendar-star", A = 512, c = 512, b = [], l = "f736", i = ["M480 192H32V464c0 26.5 21.5 48 48 48H432c26.5 0 48-21.5 48-48V192zM265.3 250.9l23.6 47.8 52.7 7.7c8.5 1.2 11.9 11.7 5.8 17.7l-38.2 37.2 9 52.5c1.5 8.5-7.5 15-15.1 11L256 400l-47.2 24.8c-7.6 4-16.5-2.5-15.1-11l9-52.5-38.2-37.2c-6.2-6-2.8-16.5 5.8-17.7l52.7-7.7 23.6-47.8c3.8-7.7 14.8-7.7 18.7 0z", "M160 0c-17.7 0-32 14.3-32 32V64H80c-26.5 0-48 21.5-48 48v80H480V112c0-26.5-21.5-48-48-48H384V32c0-17.7-14.3-32-32-32s-32 14.3-32 32V64H192V32c0-17.7-14.3-32-32-32zM265.3 250.9c-3.8-7.7-14.8-7.7-18.7 0l-23.6 47.8-52.7 7.7c-8.5 1.2-11.9 11.7-5.8 17.7l38.2 37.2-9 52.5c-1.5 8.5 7.5 15 15.1 11L256 400l47.2 24.8c7.6 4 16.5-2.5 15.1-11l-9-52.5 38.2-37.2c6.2-6 2.8-16.5-5.8-17.7l-52.7-7.7-23.6-47.8z"];
  I.definition = {
    prefix: g,
    iconName: C,
    icon: [
      A,
      c,
      b,
      l,
      i
    ]
  }, I.faCalendarStar = I.definition, I.prefix = g, I.iconName = C, I.width = A, I.height = c, I.ligatures = b, I.unicode = l, I.svgPathData = i, I.aliases = b;
})(Ll);
var Sl = {};
(function(I) {
  Object.defineProperty(I, "__esModule", { value: !0 });
  var g = "fad", C = "arrow-progress", A = 512, c = 512, b = [], l = "e5df", i = ["M448 0a64 64 0 1 1 0 128A64 64 0 1 1 448 0zM64 384c23.7 0 44.4 12.9 55.4 32H160V401.9c0-9.9 8-17.9 17.9-17.9c4 0 7.8 1.3 11 3.8l60.8 47.3c4 3.1 6.3 7.9 6.3 12.9s-2.3 9.8-6.3 12.9l-60.8 47.3c-3.1 2.4-7 3.8-11 3.8c-9.9 0-17.9-8-17.9-17.9V480H119.4c-11.1 19.1-31.7 32-55.4 32c-35.3 0-64-28.7-64-64s28.7-64 64-64z", "M256 110.1V96H128c-35.3 0-64 28.7-64 64s28.7 64 64 64H384c70.7 0 128 57.3 128 128c0 62.2-44.4 114.1-103.2 125.6C398.1 498 376.7 512 352 512c-35.3 0-64-28.7-64-64s28.7-64 64-64c22.2 0 41.7 11.3 53.2 28.4c24.9-8.7 42.8-32.5 42.8-60.4c0-35.3-28.7-64-64-64H128C57.3 288 0 230.7 0 160S57.3 32 128 32H256V17.9C256 8 264 0 273.9 0c4 0 7.8 1.3 11 3.8l60.8 47.3c4 3.1 6.3 7.9 6.3 12.9s-2.3 9.8-6.3 12.9l-60.8 47.3c-3.1 2.4-7 3.8-11 3.8c-9.9 0-17.9-8-17.9-17.9z"];
  I.definition = {
    prefix: g,
    iconName: C,
    icon: [
      A,
      c,
      b,
      l,
      i
    ]
  }, I.faArrowProgress = I.definition, I.prefix = g, I.iconName = C, I.width = A, I.height = c, I.ligatures = b, I.unicode = l, I.svgPathData = i, I.aliases = b;
})(Sl);
var fl = {};
(function(I) {
  Object.defineProperty(I, "__esModule", { value: !0 });
  var g = "fad", C = "comments", A = 640, c = 512, b = [128490, 61670], l = "f086", i = ["M231.5 383C348.9 372.9 448 288.3 448 176c0-5.2-.2-10.4-.6-15.5C555.1 167.1 640 243.2 640 336c0 38.6-14.7 74.3-39.6 103.4c3.5 9.4 8.7 17.7 14.2 24.7c4.8 6.2 9.7 11 13.3 14.3c1.8 1.6 3.3 2.9 4.3 3.7c.5 .4 .9 .7 1.1 .8l.2 .2 0 0 0 0c5.6 4.1 7.9 11.3 5.8 17.9c-2.1 6.6-8.3 11.1-15.2 11.1c-21.8 0-43.8-5.6-62.1-12.5c-9.2-3.5-17.8-7.4-25.2-11.4C505.9 503.3 470.2 512 432 512c-95.6 0-176.2-54.6-200.5-129z", "M416 176c0 97.2-93.1 176-208 176c-38.2 0-73.9-8.7-104.7-23.9c-7.5 4-16 7.9-25.3 11.4C59.8 346.4 37.8 352 16 352c-6.9 0-13.1-4.5-15.2-11.1s.2-13.8 5.8-17.9l0 0 0 0 .2-.2c.2-.2 .6-.4 1.1-.8c1-.8 2.5-2 4.3-3.7c3.6-3.3 8.5-8.1 13.3-14.3c5.5-7 10.7-15.4 14.2-24.7C14.7 250.3 0 214.6 0 176C0 78.8 93.1 0 208 0S416 78.8 416 176z"];
  I.definition = {
    prefix: g,
    iconName: C,
    icon: [
      A,
      c,
      b,
      l,
      i
    ]
  }, I.faComments = I.definition, I.prefix = g, I.iconName = C, I.width = A, I.height = c, I.ligatures = b, I.unicode = l, I.svgPathData = i, I.aliases = b;
})(fl);
function Tl({
  children: I,
  condition: g = !0,
  eventName: C,
  eventData: A = {}
}) {
  var i;
  const {
    trackEvent: c
  } = sI();
  if (!lb(I))
    return I;
  const b = (i = I.props) == null ? void 0 : i.onClick;
  return ib(I, {
    onClick: (u) => {
      b == null || b(u), g && c(C, A);
    }
  });
}
function MG({
  children: I,
  events: g
}) {
  var b;
  const {
    trackEvent: C
  } = sI();
  if (!lb(I))
    return I;
  const A = (b = I.props) == null ? void 0 : b.onClick;
  return ib(I, {
    onClick: (l) => {
      A == null || A(l), g.forEach(({
        eventName: i,
        eventData: u = {},
        condition: n = !0
      }) => {
        n && C(i, u);
      });
    }
  });
}
function KG({
  children: I,
  condition: g = !0,
  eventName: C,
  eventData: A = {},
  deps: c = []
}) {
  const {
    trackEvent: b
  } = sI();
  return II(() => {
    g && b(C, A);
  }, [g, C, A, ...c]), /* @__PURE__ */ e(eI, { children: I });
}
const _A = {
  Click: Tl,
  View: KG
}, _G = {
  Click: MG
}, qG = () => {
  const {
    profile: I
  } = yI(), [g, C] = nI(!1), {
    trackEvent: A
  } = sI(), c = HI(!1), b = Rg(
    () => {
      var i;
      return kl({
        isLoggedIn: !!I,
        isAdmin: I == null ? void 0 : I.isAdmin,
        isInstructor: I == null ? void 0 : I.isInstructor,
        isGroupManager: I == null ? void 0 : I.isGroupManager,
        groupId: (i = I == null ? void 0 : I.group) == null ? void 0 : i.id,
        isPartner: I == null ? void 0 : I.isPartner
      }).filter((u) => u.title !== "커뮤니티");
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [I]
  ), l = yA(pA.tablet);
  return II(function() {
    l && g && C(!1);
  }, [l, g]), II(function() {
    if (c.current) {
      if (g) {
        A(bI.CLICK_SERVICE_MENU_AT_HEADER, {
          label: "popover-open"
        });
        return;
      }
      A(bI.CLICK_SERVICE_MENU_AT_HEADER, {
        label: "popover-close"
      });
    }
  }, [g]), /* @__PURE__ */ O($C, { width: "253", withinPortal: !0, radius: "lg", shadow: "sm", opened: g, closeOnClickOutside: !0, closeOnEscape: !0, onChange: (i) => {
    C(i);
  }, children: [
    /* @__PURE__ */ e($C.Target, { children: /* @__PURE__ */ e(Hg, { variant: "light", size: "n-md", color: "gray", radius: "xl", tabIndex: ng.MENU_LIST, "aria-label": "service-menu", onClick: () => {
      c.current = !0, C((i) => !i);
    }, children: /* @__PURE__ */ e(K, { icon: Si.faGrid }) }) }),
    /* @__PURE__ */ e($C.Dropdown, { py: 12, px: 10, children: /* @__PURE__ */ e(gI, { css: /* @__PURE__ */ CI({
      display: "grid",
      gridTemplateColumns: "repeat(3, 1fr)",
      gap: 6,
      [ZI("tablet")]: {
        display: "none"
      }
    }, process.env.NODE_ENV === "production" ? "" : ";label:AppListButton;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), children: b.map((i, u) => /* @__PURE__ */ e(nb, { children: /* @__PURE__ */ e(_A.Click, { eventName: bI.CLICK_SERVICE_MENU_AT_HEADER, eventData: {
      label: i.value
    }, children: /* @__PURE__ */ e($G, { ...i }) }) }, `${i.value}-${u}`)) }) })
  ] });
}, $G = ({
  title: I,
  icon: g,
  href: C,
  onClick: A
}) => /* @__PURE__ */ O(PI, { w: 73, component: "a", href: C, onClick: A, py: 6, align: "center", justify: "start", spacing: 6, css: /* @__PURE__ */ CI({
  "&:hover": {
    textDecoration: "none",
    borderRadius: 8,
    backgroundColor: P.gray[1]
  }
}, process.env.NODE_ENV === "production" ? "" : ";label:AppItem;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), children: [
  /* @__PURE__ */ e(PI, { p: 10, children: g }),
  /* @__PURE__ */ e(cI, { size: 12, color: "gray.7", lh: 1.3, h: 16, children: I })
] }), IZ = () => /* @__PURE__ */ O("svg", { width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
  /* @__PURE__ */ e("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M0 8.8714C0 4.93468 3.16218 1.74268 7.06182 1.74268H11.1949V4.69977H7.06255C4.77964 4.69977 2.92946 6.56813 2.92946 8.8714C2.92946 11.1754 4.77964 13.043 7.06255 13.043C9.34473 13.043 11.1949 11.1754 11.1949 8.8714V4.69977H14.1244V8.8714C14.1244 12.8089 10.9622 16.0001 7.06255 16.0001C3.16218 16.0001 0 12.8089 0 8.8714Z", fill: "#21252A" }),
  /* @__PURE__ */ e("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M14.2039 3.32655C14.6429 3.32424 15.0629 3.14775 15.3718 2.83586C15.6807 2.52398 15.8531 2.10222 15.8512 1.66327C15.8523 1.4459 15.8105 1.23045 15.7283 1.02922C15.6461 0.827985 15.525 0.644919 15.372 0.490469C15.2191 0.33602 15.0372 0.213211 14.8368 0.129056C14.6363 0.0449015 14.4213 0.00104804 14.2039 0C13.765 0.00230906 13.3449 0.178798 13.036 0.490681C12.7271 0.802565 12.5547 1.22432 12.5567 1.66327V3.32655H14.2039Z", fill: "#00CCAA" })
] }), kl = ({
  isLoggedIn: I,
  isAdmin: g,
  isInstructor: C,
  isGroupManager: A,
  groupId: c,
  isPartner: b
}) => [...c ? [] : [{
  title: "커뮤니티",
  icon: /* @__PURE__ */ e(K, { size: "md", icon: fl.faComments, css: hI(P.infgreen[3], P.blue[6]) }),
  href: E.COMMUNITY_QUESTION,
  value: "community",
  links: [{
    title: "질문 & 답변",
    href: E.COMMUNITY_QUESTION,
    value: "question"
  }, {
    title: "고민있어요",
    href: E.COMMUNITY_CHATS,
    value: "chats"
  }, {
    title: "스터디",
    href: E.COMMUNITY_STUDIES,
    value: "studies"
  }, {
    title: "팀프로젝트",
    href: E.COMMUNITY_PROJECTS,
    value: "projects"
  }, {
    title: "블로그",
    href: E.BLOGS,
    value: "blogs"
  }, {
    title: "로드맵",
    href: E.ROADMAPS,
    value: "roadmaps"
  }, {
    title: "수강평",
    href: E.COMMUNITY_REVIEWS,
    value: "reviews"
  }]
}], {
  title: "로드맵",
  icon: /* @__PURE__ */ e(K, { icon: Sl.faArrowProgress, css: hI(P.blue[6], P.infgreen[6]) }),
  href: E.ROADMAPS,
  value: "roadmaps"
}, {
  title: "이벤트",
  value: "event",
  icon: /* @__PURE__ */ e(K, { icon: Ll.faCalendarStar, css: hI(P.pink[6], P.pink[2]) }),
  href: E.EVENTS
}, {
  title: fi("지식공유하기")(),
  value: "instructor",
  icon: /* @__PURE__ */ e(K, { icon: Ul.faHandHoldingSeedling, css: hI(P.infgreen[6], P.red[3]) }),
  href: C ? E.INSTRUCTOR : Zb.OPEN_KNOWLEDGE
}, {
  title: "파트너스",
  value: "partners",
  icon: /* @__PURE__ */ e(K, { icon: zl.faHandshake, css: hI(P.orange[5], P.orange[2]) }),
  href: b ? E.MY_PARTNERS_LINKS : E.PARTNERS
}, ...!I || A && c ? [{
  title: "비즈니스",
  icon: /* @__PURE__ */ e(K, { icon: Hl.faBuilding, css: hI(P.blue[1], P.gray[6]) }),
  href: c ? E.BUSINESS(c) : E.INTRO_GROUP
}] : [], {
  title: "OurStory",
  value: "ourstory",
  icon: /* @__PURE__ */ e(K, { icon: Yl.faTreeDeciduous, css: hI(P.orange[9], P.infgreen[6]) }),
  href: E.INFLEARN
}, {
  title: "수강평",
  value: "review",
  href: E.COMMUNITY_REVIEWS,
  icon: /* @__PURE__ */ e(K, { icon: Fl.faStar, css: hI(P.yellow[6], P.yellow[6]) })
}, ...c ? [] : [{
  title: "커리어",
  value: "rallit",
  icon: /* @__PURE__ */ e(IZ, {}),
  href: Ti.RALLIT_SITE
}], ...I && (g || ki(c)) ? [{
  title: "AI 채팅",
  href: wi.AI_CHAT,
  icon: /* @__PURE__ */ e(K, { icon: pl.faWandMagicSparkles, css: hI(P.cyan[9], P.yellow[6]) })
}] : [], ...I ? [{
  title: "선물함",
  value: "gift",
  href: E.MY_RECEIVED_GIFTS,
  icon: /* @__PURE__ */ e(K, { icon: Nl.faGift, css: hI(P.infgreen[6], P.infgreen[2]) })
}] : [], {
  title: "인프랩 채용중",
  value: "with us",
  icon: /* @__PURE__ */ e(K, { icon: vl.faSeedling, color: P.infgreen[7] }),
  href: E.WITH_US
}], gZ = ({
  children: I
}) => {
  const {
    profile: g
  } = yI();
  return g ? typeof I == "function" ? /* @__PURE__ */ e(eI, { children: I({
    profile: g
  }) }) : /* @__PURE__ */ e(eI, { children: I }) : null;
}, CZ = ({
  children: I
}) => {
  const {
    profile: g
  } = yI();
  return g ? null : /* @__PURE__ */ e(eI, { children: I });
}, jI = {
  Login: gZ,
  NotLogin: CZ
};
var wl = {};
(function(I) {
  Object.defineProperty(I, "__esModule", { value: !0 });
  var g = "fal", C = "angle-up", A = 448, c = 512, b = [8963], l = "f106", i = "M212.7 148.7c6.2-6.2 16.4-6.2 22.6 0l160 160c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L224 182.6 75.3 331.3c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l160-160z";
  I.definition = {
    prefix: g,
    iconName: C,
    icon: [
      A,
      c,
      b,
      l,
      i
    ]
  }, I.faAngleUp = I.definition, I.prefix = g, I.iconName = C, I.width = A, I.height = c, I.ligatures = b, I.unicode = l, I.svgPathData = i, I.aliases = b;
})(wl);
var Ql = {};
(function(I) {
  Object.defineProperty(I, "__esModule", { value: !0 });
  var g = "fal", C = "pen-to-square", A = 512, c = 512, b = ["edit"], l = "f044", i = "M454.6 45.3l12.1 12.1c12.5 12.5 12.5 32.8 0 45.3L440 129.4 382.6 72l26.7-26.7c12.5-12.5 32.8-12.5 45.3 0zM189 265.6l171-171L417.4 152l-171 171c-4.2 4.2-9.6 7.2-15.4 8.6l-65.6 15.1L180.5 281c1.3-5.8 4.3-11.2 8.6-15.4zm197.7-243L166.4 243c-8.5 8.5-14.4 19.2-17.1 30.9l-20.9 90.6c-1.2 5.4 .4 11 4.3 14.9s9.5 5.5 14.9 4.3l90.6-20.9c11.7-2.7 22.4-8.6 30.9-17.1L489.4 125.3c25-25 25-65.5 0-90.5L477.3 22.6c-25-25-65.5-25-90.5 0zM80 64C35.8 64 0 99.8 0 144V432c0 44.2 35.8 80 80 80H368c44.2 0 80-35.8 80-80V304c0-8.8-7.2-16-16-16s-16 7.2-16 16V432c0 26.5-21.5 48-48 48H80c-26.5 0-48-21.5-48-48V144c0-26.5 21.5-48 48-48H208c8.8 0 16-7.2 16-16s-7.2-16-16-16H80z";
  I.definition = {
    prefix: g,
    iconName: C,
    icon: [
      A,
      c,
      b,
      l,
      i
    ]
  }, I.faPenToSquare = I.definition, I.prefix = g, I.iconName = C, I.width = A, I.height = c, I.ligatures = b, I.unicode = l, I.svgPathData = i, I.aliases = b;
})(Ql);
var Ol = {};
(function(I) {
  Object.defineProperty(I, "__esModule", { value: !0 });
  var g = "fal", C = "right-from-bracket", A = 512, c = 512, b = ["sign-out-alt"], l = "f2f5", i = "M479.2 254.2c.5 .5 .8 1.1 .8 1.8s-.3 1.4-.8 1.8L347.3 382.2c-1.2 1.2-2.9 1.8-4.6 1.8c-3.7 0-6.7-3-6.7-6.7l0-57.3c0-8.8-7.2-16-16-16l-120 0c-4.4 0-8-3.6-8-8l0-80c0-4.4 3.6-8 8-8l120 0c8.8 0 16-7.2 16-16l0-57.3c0-3.7 3-6.7 6.7-6.7c1.7 0 3.3 .7 4.6 1.8L479.2 254.2zM512 256c0-9.5-3.9-18.6-10.8-25.1L369.2 106.5C362 99.8 352.5 96 342.7 96c-21.4 0-38.7 17.3-38.7 38.7l0 41.3-104 0c-22.1 0-40 17.9-40 40l0 80c0 22.1 17.9 40 40 40l104 0 0 41.3c0 21.4 17.3 38.7 38.7 38.7c9.9 0 19.4-3.8 26.5-10.5L501.2 281.1c6.9-6.5 10.8-15.6 10.8-25.1zM176 64c8.8 0 16-7.2 16-16s-7.2-16-16-16L80 32C35.8 32 0 67.8 0 112L0 400c0 44.2 35.8 80 80 80l96 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-96 0c-26.5 0-48-21.5-48-48l0-288c0-26.5 21.5-48 48-48l96 0z";
  I.definition = {
    prefix: g,
    iconName: C,
    icon: [
      A,
      c,
      b,
      l,
      i
    ]
  }, I.faRightFromBracket = I.definition, I.prefix = g, I.iconName = C, I.width = A, I.height = c, I.ligatures = b, I.unicode = l, I.svgPathData = i, I.aliases = b;
})(Ol);
var Dl = {};
(function(I) {
  Object.defineProperty(I, "__esModule", { value: !0 });
  var g = "fal", C = "list", A = 512, c = 512, b = ["list-squares"], l = "f03a", i = "M48 112V80H80v32H48zM16 72v48c0 13.3 10.7 24 24 24H88c13.3 0 24-10.7 24-24V72c0-13.3-10.7-24-24-24H40C26.7 48 16 58.7 16 72zm160 8c-8.8 0-16 7.2-16 16s7.2 16 16 16H496c8.8 0 16-7.2 16-16s-7.2-16-16-16H176zm0 160c-8.8 0-16 7.2-16 16s7.2 16 16 16H496c8.8 0 16-7.2 16-16s-7.2-16-16-16H176zm0 160c-8.8 0-16 7.2-16 16s7.2 16 16 16H496c8.8 0 16-7.2 16-16s-7.2-16-16-16H176zM48 240H80v32H48V240zm-8-32c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24H88c13.3 0 24-10.7 24-24V232c0-13.3-10.7-24-24-24H40zm8 224V400H80v32H48zM16 392v48c0 13.3 10.7 24 24 24H88c13.3 0 24-10.7 24-24V392c0-13.3-10.7-24-24-24H40c-13.3 0-24 10.7-24 24z";
  I.definition = {
    prefix: g,
    iconName: C,
    icon: [
      A,
      c,
      b,
      l,
      i
    ]
  }, I.faList = I.definition, I.prefix = g, I.iconName = C, I.width = A, I.height = c, I.ligatures = b, I.unicode = l, I.svgPathData = i, I.aliases = b;
})(Dl);
var rA = {};
(function(I) {
  Object.defineProperty(I, "__esModule", { value: !0 });
  var g = "fal", C = "handshake", A = 640, c = 512, b = [], l = "f2b5", i = "M263.9 64c-33.9 0-66.7 12-92.6 33.7L144 120.7v39.1c2.7-.5 5.3-1.7 7.4-3.5l40.5-34c13.3-11.2 28.9-19 45.5-23.1L272.6 64h-8.7zM112 352.3c8.9 1 17.2 5 23.6 11.4l28.6 28.6 15.4 15.4 .1 .1 24.3 24.3c25.1 25.1 65.4 26.2 91.8 2.6c.8-.7 1.6-1.4 2.3-2.2c26.3 21.3 65.3 18.6 88.4-7.3c6-6.7 10.3-14.4 13-22.5c19.2 4 40-.8 55.7-14.8c11.3-10.1 18.2-23.2 20.6-37H528V368c0 26.5 21.5 48 48 48h16c26.5 0 48-21.5 48-48V160c0-17.7-14.3-32-32-32H560 528v32V318.8H473.1c-3.1-8.7-8.1-17-15.1-24l-85.6-85.6 8.1-7.5c6.5-6 6.9-16.1 .9-22.6s-16.1-6.9-22.6-.9l-76.1 70.2c-13.2 12.2-33.6 12.4-47 .4c-15.4-13.7-15.7-37.5-.8-51.6l79.4-75C332.2 105.4 355.8 96 380.4 96c22.7 0 44.6 8 61.9 22.6l44.8 37.7c2.5 2.1 5.6 3.4 8.8 3.7V121.8L462.9 94.1C439.8 74.6 410.6 64 380.4 64c-32.8 0-64.3 12.5-88.1 35l-79.4 75c-28.6 27-27.9 72.7 1.5 98.8c25.8 22.9 64.7 22.5 90-.8l44.5-41 86.5 86.5c13 13 12.4 34.3-1.4 46.5c-10.9 9.7-26.7 10.6-38.6 3c-5-3.3-11.4-3.4-16.6-.5s-8.3 8.6-8 14.6c.4 8.1-2.3 16.3-8.1 22.9c-12.3 13.9-33.8 14.5-46.9 1.4l-8.1-8.1c-3.6-3.6-8.7-5.3-13.7-4.5s-9.4 3.9-11.8 8.4c-1.9 3.6-4.4 6.9-7.6 9.8c-13.8 12.3-34.8 11.7-47.8-1.3l-39.9-39.8-28.6-28.6c-12.4-12.4-28.9-19.8-46.3-20.9V160 128H80 32c-17.7 0-32 14.3-32 32V368c0 26.5 21.5 48 48 48H64c26.5 0 48-21.5 48-48V352.3zM80 160V368c0 8.8-7.2 16-16 16H48c-8.8 0-16-7.2-16-16V160H80zm528 0V368c0 8.8-7.2 16-16 16H576c-8.8 0-16-7.2-16-16V160h48z";
  I.definition = {
    prefix: g,
    iconName: C,
    icon: [
      A,
      c,
      b,
      l,
      i
    ]
  }, I.faHandshake = I.definition, I.prefix = g, I.iconName = C, I.width = A, I.height = c, I.ligatures = b, I.unicode = l, I.svgPathData = i, I.aliases = b;
})(rA);
var El = {};
(function(I) {
  Object.defineProperty(I, "__esModule", { value: !0 });
  var g = "fal", C = "circle-user", A = 512, c = 512, b = [62142, "user-circle"], l = "f2bd", i = "M412.1 416.6C398.1 361.1 347.9 320 288 320H224c-59.9 0-110.1 41.1-124.1 96.6C58 375.9 32 319 32 256C32 132.3 132.3 32 256 32s224 100.3 224 224c0 63-26 119.9-67.9 160.6zm-28.5 23.4C347.5 465.2 303.5 480 256 480s-91.5-14.8-127.7-39.9c4-49.3 45.3-88.1 95.7-88.1h64c50.4 0 91.6 38.8 95.7 88.1zM256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-256a48 48 0 1 1 0-96 48 48 0 1 1 0 96zm-80-48a80 80 0 1 0 160 0 80 80 0 1 0 -160 0z";
  I.definition = {
    prefix: g,
    iconName: C,
    icon: [
      A,
      c,
      b,
      l,
      i
    ]
  }, I.faCircleUser = I.definition, I.prefix = g, I.iconName = C, I.width = A, I.height = c, I.ligatures = b, I.unicode = l, I.svgPathData = i, I.aliases = b;
})(El);
var Pl = {};
(function(I) {
  Object.defineProperty(I, "__esModule", { value: !0 });
  var g = "fal", C = "folder-heart", A = 512, c = 512, b = [], l = "e189", i = "M32 96c0-17.7 14.3-32 32-32H188.1c8.5 0 16.6 3.4 22.6 9.4l35.9 35.9c12 12 28.3 18.7 45.3 18.7H448c17.7 0 32 14.3 32 32V416c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V96zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H291.9c-8.5 0-16.6-3.4-22.6-9.4L233.4 50.7c-12-12-28.3-18.7-45.3-18.7H64zM176 253.3c0-16.2 13.1-29.3 29.3-29.3c7.8 0 15.2 3.1 20.7 8.6l18.7 18.7c6.2 6.2 16.4 6.2 22.6 0l18.7-18.7c5.5-5.5 12.9-8.6 20.7-8.6c16.2 0 29.3 13.1 29.3 29.3c0 7.8-3.1 15.2-8.6 20.7L256 345.4l-71.4-71.4c-5.5-5.5-8.6-12.9-8.6-20.7zM205.3 192c-33.8 0-61.3 27.4-61.3 61.3c0 16.2 6.5 31.8 17.9 43.3l82.7 82.7c6.2 6.2 16.4 6.2 22.6 0l82.7-82.7c11.5-11.5 17.9-27.1 17.9-43.3c0-33.8-27.4-61.3-61.3-61.3c-16.2 0-31.8 6.5-43.3 17.9l-7.4 7.4-7.4-7.4c-11.5-11.5-27.1-17.9-43.3-17.9z";
  I.definition = {
    prefix: g,
    iconName: C,
    icon: [
      A,
      c,
      b,
      l,
      i
    ]
  }, I.faFolderHeart = I.definition, I.prefix = g, I.iconName = C, I.width = A, I.height = c, I.ligatures = b, I.unicode = l, I.svgPathData = i, I.aliases = b;
})(Pl);
var jl = {};
(function(I) {
  Object.defineProperty(I, "__esModule", { value: !0 });
  var g = "fal", C = "circle-p", A = 512, c = 512, b = [], l = "e11a", i = "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM176 128c-8.8 0-16 7.2-16 16V288v80c0 8.8 7.2 16 16 16s16-7.2 16-16V304h72c48.6 0 88-39.4 88-88s-39.4-88-88-88H176zm88 144H192V160h72c30.9 0 56 25.1 56 56s-25.1 56-56 56z";
  I.definition = {
    prefix: g,
    iconName: C,
    icon: [
      A,
      c,
      b,
      l,
      i
    ]
  }, I.faCircleP = I.definition, I.prefix = g, I.iconName = C, I.width = A, I.height = c, I.ligatures = b, I.unicode = l, I.svgPathData = i, I.aliases = b;
})(jl);
var Ml = {};
(function(I) {
  Object.defineProperty(I, "__esModule", { value: !0 });
  var g = "fal", C = "ticket", A = 576, c = 512, b = [127903], l = "f145", i = "M64 64C28.7 64 0 92.7 0 128v66c0 7.3 4.9 13.7 12 15.5c20.7 5.3 36 24.1 36 46.5s-15.3 41.2-36 46.5C4.9 304.3 0 310.7 0 318v66c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V318c0-7.3-4.9-13.7-12-15.5c-20.7-5.3-36-24.1-36-46.5s15.3-41.2 36-46.5c7.1-1.8 12-8.2 12-15.5V128c0-35.3-28.7-64-64-64H64zM32 128c0-17.7 14.3-32 32-32H512c17.7 0 32 14.3 32 32v54.7c-28.2 12.3-48 40.5-48 73.3s19.8 61 48 73.3V384c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V329.3C60.2 317 80 288.8 80 256s-19.8-61-48-73.3V128zm128 64H416V320H160V192zm-32 0V320c0 17.7 14.3 32 32 32H416c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32H160c-17.7 0-32 14.3-32 32z";
  I.definition = {
    prefix: g,
    iconName: C,
    icon: [
      A,
      c,
      b,
      l,
      i
    ]
  }, I.faTicket = I.definition, I.prefix = g, I.iconName = C, I.width = A, I.height = c, I.ligatures = b, I.unicode = l, I.svgPathData = i, I.aliases = b;
})(Ml);
var Kl = {};
(function(I) {
  Object.defineProperty(I, "__esModule", { value: !0 });
  var g = "fal", C = "globe", A = 512, c = 512, b = [127760], l = "f0ac", i = "M256 480c16.7 0 40.4-14.4 61.9-57.3c9.9-19.8 18.2-43.7 24.1-70.7H170c5.9 27 14.2 50.9 24.1 70.7C215.6 465.6 239.3 480 256 480zM164.3 320H347.7c2.8-20.2 4.3-41.7 4.3-64s-1.5-43.8-4.3-64H164.3c-2.8 20.2-4.3 41.7-4.3 64s1.5 43.8 4.3 64zM170 160H342c-5.9-27-14.2-50.9-24.1-70.7C296.4 46.4 272.7 32 256 32s-40.4 14.4-61.9 57.3C184.2 109.1 175.9 133 170 160zm210 32c2.6 20.5 4 41.9 4 64s-1.4 43.5-4 64h90.8c6-20.3 9.3-41.8 9.3-64s-3.2-43.7-9.3-64H380zm78.5-32c-25.9-54.5-73.1-96.9-130.9-116.3c21 28.3 37.6 68.8 47.2 116.3h83.8zm-321.1 0c9.6-47.6 26.2-88 47.2-116.3C126.7 63.1 79.4 105.5 53.6 160h83.7zm-96 32c-6 20.3-9.3 41.8-9.3 64s3.2 43.7 9.3 64H132c-2.6-20.5-4-41.9-4-64s1.4-43.5 4-64H41.3zM327.5 468.3c57.8-19.5 105-61.8 130.9-116.3H374.7c-9.6 47.6-26.2 88-47.2 116.3zm-143 0c-21-28.3-37.5-68.8-47.2-116.3H53.6c25.9 54.5 73.1 96.9 130.9 116.3zM256 512A256 256 0 1 1 256 0a256 256 0 1 1 0 512z";
  I.definition = {
    prefix: g,
    iconName: C,
    icon: [
      A,
      c,
      b,
      l,
      i
    ]
  }, I.faGlobe = I.definition, I.prefix = g, I.iconName = C, I.width = A, I.height = c, I.ligatures = b, I.unicode = l, I.svgPathData = i, I.aliases = b;
})(Kl);
var _l = {};
(function(I) {
  Object.defineProperty(I, "__esModule", { value: !0 });
  var g = "fal", C = "objects-column", A = 448, c = 512, b = [], l = "e3c1", i = "M48 64c-8.8 0-16 7.2-16 16V240c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16V80c0-8.8-7.2-16-16-16H48zM0 80C0 53.5 21.5 32 48 32h96c26.5 0 48 21.5 48 48V240c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80zM304 256c-8.8 0-16 7.2-16 16V432c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16V272c0-8.8-7.2-16-16-16H304zm-48 16c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48V432c0 26.5-21.5 48-48 48H304c-26.5 0-48-21.5-48-48V272zM144 352H48c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16V368c0-8.8-7.2-16-16-16zM48 320h96c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V368c0-26.5 21.5-48 48-48zM304 64c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16V80c0-8.8-7.2-16-16-16H304zM256 80c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48H304c-26.5 0-48-21.5-48-48V80z";
  I.definition = {
    prefix: g,
    iconName: C,
    icon: [
      A,
      c,
      b,
      l,
      i
    ]
  }, I.faObjectsColumn = I.definition, I.prefix = g, I.iconName = C, I.width = A, I.height = c, I.ligatures = b, I.unicode = l, I.svgPathData = i, I.aliases = b;
})(_l);
var AZ = {
  prefix: "fal",
  iconName: "books",
  icon: [512, 512, [128218], "f5db", "M128 416v48c0 8.8-7.2 16-16 16H48c-8.8 0-16-7.2-16-16V416h96zm-16 96c12.3 0 23.5-4.6 32-12.2c8.5 7.6 19.7 12.2 32 12.2h64c26.5 0 48-21.5 48-48V416 400 384 193.8l51.4 198.1 4 15.5 18 69.2c6.6 25.5 32 40.6 56.7 33.8l59.6-16.5c24.7-6.8 39.3-33 32.7-58.5l-13.9-53.7-4-15.5-63.9-246-4-15.5-18-69.2C400 9.9 374.6-5.2 349.9 1.6L290.3 18.1c-3.5 1-6.8 2.3-9.9 4C271.9 8.8 257 0 240 0H176c-12.3 0-23.5 4.6-32 12.2C135.5 4.6 124.3 0 112 0H48C21.5 0 0 21.5 0 48V96v16 16V384v16 16 48c0 26.5 21.5 48 48 48h64zM288 64.8V63.5c.3-7.2 5.1-13 10.8-14.6l59.6-16.5c6.6-1.8 14.8 2 17.2 11l14.1 54.2-87.3 24.2L288.6 68.6c-.3-1.3-.5-2.6-.6-3.8zm-32-.6c0 0 0 0 0 0V96H160V48c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16V64.2zM176 480c-8.8 0-16-7.2-16-16V416h96v48c0 8.8-7.2 16-16 16H176zM128 128V384H32V128h96zm0-80V96H32V48c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16zM256 384H160V128h96V384zM397.7 128.7l59.8 230.5-87.3 24.2L310.4 152.8l87.3-24.2zm67.9 261.5l13.8 53.2c2.4 9.4-3.2 17.7-10.3 19.6l-59.6 16.5c-6.6 1.8-14.8-2-17.2-11l-14.1-54.2 87.3-24.2z"]
}, _c = {
  prefix: "fal",
  iconName: "receipt",
  icon: [384, 512, [129534], "f543", "M26.5 4C21.8-.2 15.1-1.2 9.4 1.4S0 9.7 0 16V496c0 6.3 3.7 12 9.4 14.6s12.4 1.6 17.1-2.5l52.7-46.1 45.4 45.4c6.2 6.2 16.4 6.2 22.6 0L192 462.6l44.7 44.7c6.2 6.2 16.4 6.2 22.6 0l45.4-45.4L357.5 508c4.7 4.1 11.4 5.1 17.1 2.5s9.4-8.3 9.4-14.6V16c0-6.3-3.7-12-9.4-14.6S362.2-.2 357.5 4L304.7 50.1 259.3 4.7c-6.2-6.2-16.4-6.2-22.6 0L192 49.4 147.3 4.7c-6.2-6.2-16.4-6.2-22.6 0L79.3 50.1 26.5 4zM32 460.7V51.3L69.5 84c6.3 5.5 15.9 5.2 21.8-.7L136 38.6l44.7 44.7c6.2 6.2 16.4 6.2 22.6 0L248 38.6l44.7 44.7c6 6 15.5 6.3 21.8 .7L352 51.3V460.7L314.5 428c-6.3-5.5-15.9-5.2-21.8 .7L248 473.4l-44.7-44.7c-6.2-6.2-16.4-6.2-22.6 0L136 473.4 91.3 428.7c-6-6-15.5-6.3-21.8-.7L32 460.7zM96 144c-8.8 0-16 7.2-16 16s7.2 16 16 16H288c8.8 0 16-7.2 16-16s-7.2-16-16-16H96zM80 352c0 8.8 7.2 16 16 16H288c8.8 0 16-7.2 16-16s-7.2-16-16-16H96c-8.8 0-16 7.2-16 16zM96 240c-8.8 0-16 7.2-16 16s7.2 16 16 16H288c8.8 0 16-7.2 16-16s-7.2-16-16-16H96z"]
};
function cZ({
  isAdmin: I,
  isInstructor: g
}) {
  return I ? eA.ADMIN : g ? eA.INSTRUCTOR : eA.STUDENT;
}
function bZ({
  isMarketingPartners: I,
  isB2B: g,
  lang: C,
  hasAlarm: A
}) {
  const c = vA() ? window.location.href : void 0;
  return C !== "ko" ? [{
    items: [f.Dashboard, f.MyLearning, f.PurchaseHistory, f.Storage, f.CommunityUserPosts]
  }, ...I ? [{
    items: [f.MarketingPartnersGlobal(I)]
  }] : [], {
    items: [f.AccountSettings, f.Logout(c)]
  }] : g ? [{
    items: [f.Alarm(A)]
  }, {
    items: [f.Dashboard, f.MyLearning, f.BusinessCourseHistory, f.PurchaseHistory, f.Storage, f.CommunityUserPosts]
  }, ...I ? [{
    items: [f.MarketingPartners]
  }] : [], {
    items: [f.AccountSettings, f.Logout(c)]
  }] : [{
    items: [f.Alarm(A)]
  }, {
    items: [f.Dashboard, f.MyLearning, f.PurchaseHistory, f.Storage, f.CommunityUserPosts]
  }, ...I ? [{
    items: [f.MarketingPartners]
  }] : [], {
    items: [f.AccountSettings, f.Logout(c)]
  }];
}
function lZ({
  profile: I,
  isMarketingPartners: g,
  isB2B: C,
  lang: A,
  hasAlarm: c,
  showLanguageSectionButton: b,
  isLocalizationFeatureOn: l = !1
}) {
  var X;
  const i = vA() ? window.location.href : void 0, u = !!I, n = kl({
    isLoggedIn: u,
    isAdmin: I == null ? void 0 : I.isAdmin,
    isInstructor: I == null ? void 0 : I.isInstructor,
    isGroupManager: I == null ? void 0 : I.isGroupManager,
    groupId: (X = I == null ? void 0 : I.group) == null ? void 0 : X.id,
    isPartner: !!(I != null && I.marketingPartner)
  }).map(({
    title: y,
    icon: s,
    href: B,
    value: m,
    links: x
  }) => ({
    icon: s,
    label: y,
    href: B,
    value: m,
    type: "service",
    links: (x == null ? void 0 : x.map((v) => ({
      label: v.title,
      href: v.href,
      value: v.value,
      type: "service"
    }))) ?? []
  })), t = () => A === "ko" ? n.filter(({
    label: y
  }) => y !== "로드맵") : n.filter(({
    value: y
  }) => y === "instructor");
  return u ? A !== "ko" ? [{
    menuList: [f.Dashboard, f.MyLearning, f.PurchaseHistory, f.Storage, f.CommunityUserPosts]
  }, ...g ? [{
    menuList: [f.MarketingPartnersGlobal(g)]
  }] : [], {
    menuList: [...b ? [f.Language] : [], f.AccountSettings, f.Logout(i)]
  }, ...l ? [{
    menuList: t()
  }] : []] : C ? [{
    menuList: [f.Alarm(c)]
  }, {
    menuList: [f.Dashboard, f.MyLearning, f.BusinessCourseHistory, f.PurchaseHistory, f.Storage, f.CommunityUserPosts]
  }, ...g ? [{
    menuList: [f.MarketingPartners]
  }] : [], {
    menuList: [...b ? [f.Language] : [], f.AccountSettings, f.Logout(i)]
  }, {
    menuList: t()
  }] : [{
    menuList: [f.Alarm(c)]
  }, {
    menuList: [f.Dashboard, f.MyLearning, f.PurchaseHistory, f.Storage, f.CommunityUserPosts]
  }, ...g ? [{
    menuList: [f.MarketingPartners]
  }] : [], {
    menuList: [...b ? [f.Language] : [], f.AccountSettings, f.Logout(i)]
  }, {
    menuList: t()
  }] : A !== "ko" ? [{
    menuList: [f.Language]
  }] : [{
    menuList: [f.Language]
  }, {
    menuList: t()
  }];
}
const f = {
  Dashboard: {
    icon: /* @__PURE__ */ e(K, { icon: _l.faObjectsColumn, size: "sm", color: "gray.9" }),
    label: "대시보드",
    href: E.ACCOUNT_DASHBOARD,
    value: "dashboard",
    type: "profile"
  },
  MyLearning: {
    icon: /* @__PURE__ */ e(K, { icon: AZ, size: "sm", color: "gray.9" }),
    label: "내 학습",
    href: E.USER_COURSES,
    value: "my-learning",
    type: "profile"
  },
  Language: {
    icon: /* @__PURE__ */ e(K, { icon: Kl.faGlobe, size: "sm", color: "gray.9" }),
    label: "언어 변경",
    href: "#",
    value: "language",
    type: "profile"
  },
  Coupon: (I) => ({
    icon: /* @__PURE__ */ e(K, { icon: Ml.faTicket, size: "sm", color: "gray.9" }),
    label: "쿠폰",
    href: E.USER_COUPONS,
    value: "coupon",
    type: "profile",
    rightSection: I > 0 ? /* @__PURE__ */ O(cI, { size: "xs", weight: "500", lh: "1.3", color: "infgreen.8", children: [
      I,
      " 개"
    ] }) : void 0
  }),
  Point: (I) => ({
    icon: /* @__PURE__ */ e(K, { icon: jl.faCircleP, size: "sm", color: "gray.9" }),
    label: "포인트",
    href: E.USER_POINT,
    value: "point",
    type: "profile",
    rightSection: I > 0 ? /* @__PURE__ */ O(cI, { size: "xs", weight: "500", lh: "1.3", color: "infgreen.8", children: [
      I.toLocaleString(),
      " 잎"
    ] }) : void 0
  }),
  Alarm: (I) => ({
    icon: /* @__PURE__ */ e(K, { icon: HG.faBell, size: "sm", color: "gray.9" }),
    label: "알림",
    href: E.MESSAGE_LIST,
    value: "alarm",
    type: "profile",
    indicator: I ? {
      color: "red",
      radius: "xl",
      size: 6,
      position: "middle-end",
      offset: -10
    } : void 0
  }),
  PurchaseHistoryOld: {
    icon: /* @__PURE__ */ e(K, { icon: _c, size: "sm", color: "gray.9" }),
    label: "구매 내역",
    href: E.ORDERS,
    value: "purchase-history",
    type: "profile"
  },
  PurchaseHistory: {
    icon: /* @__PURE__ */ e(K, { icon: _c, size: "sm", color: "gray.9" }),
    label: "구매 / 혜택",
    href: E.ORDERS,
    value: "purchase-history",
    type: "profile"
  },
  Like: {
    icon: /* @__PURE__ */ e(K, { icon: YG.faHeart, size: "sm", color: "gray.9" }),
    label: "좋아요",
    href: E.USER_LIKES,
    value: "likes",
    type: "profile"
  },
  Storage: {
    icon: /* @__PURE__ */ e(K, { icon: Pl.faFolderHeart, size: "sm", color: "gray.9" }),
    label: "보관함",
    href: E.USER_LIKES,
    value: "likes",
    type: "profile"
  },
  AccountSettings: {
    icon: /* @__PURE__ */ e(K, { icon: El.faCircleUser, size: "sm", color: "gray.9" }),
    label: "계정 설정",
    href: E.USER_SETTINGS_ACCOUNT,
    value: "setting",
    type: "profile"
  },
  MarketingPartners: {
    icon: /* @__PURE__ */ e(K, { icon: rA.faHandshake, size: "sm", color: "gray.9" }),
    label: "파트너스",
    href: E.MY_PARTNERS,
    value: "partners",
    type: "profile"
  },
  MarketingPartnersGlobal: (I) => ({
    icon: /* @__PURE__ */ e(K, { icon: rA.faHandshake, size: "sm", color: "gray.9" }),
    label: "파트너스",
    href: I ? E.MY_PARTNERS_LINKS : E.PARTNERS_NEW,
    value: "partners",
    type: "profile"
  }),
  BusinessCourseHistory: {
    icon: /* @__PURE__ */ e(K, { icon: Dl.faList, size: "sm", color: "gray.9" }),
    label: "비즈니스 수강내역",
    href: E.BUSINESS_ENROLMENTS,
    value: "business-course",
    type: "profile"
  },
  Logout: (I) => ({
    icon: /* @__PURE__ */ e(K, { icon: Ol.faRightFromBracket, size: "sm", color: "gray.9" }),
    label: "로그아웃",
    href: E.LOGOUT({
      redirectTo: I
    }),
    value: "logout",
    type: "profile"
  }),
  CommunityUserPosts: {
    icon: /* @__PURE__ */ e(K, { icon: Ql.faPenToSquare, size: "sm", color: "gray.9" }),
    label: "작성한 게시글",
    href: E.COMMUNITY_USER_POSTS,
    value: "community-user-posts",
    type: "profile"
  }
};
var qA = {};
(function(I) {
  Object.defineProperty(I, "__esModule", { value: !0 });
  var g = "far", C = "chevron-right", A = 320, c = 512, b = [9002], l = "f054", i = "M305 239c9.4 9.4 9.4 24.6 0 33.9L113 465c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l175-175L79 81c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0L305 239z";
  I.definition = {
    prefix: g,
    iconName: C,
    icon: [
      A,
      c,
      b,
      l,
      i
    ]
  }, I.faChevronRight = I.definition, I.prefix = g, I.iconName = C, I.width = A, I.height = c, I.ligatures = b, I.unicode = l, I.svgPathData = i, I.aliases = b;
})(qA);
function ql(I = !1) {
  return UI(I);
}
function iZ() {
  const {
    profile: I
  } = yI(), [g, {
    toggle: C,
    close: A
  }] = UI(!1), c = yA(pA.tablet), {
    trackEvent: b
  } = sI(), {
    data: l
  } = KA({
    enabled: !!I
  }), i = !(l != null && l.hasUncheckedMessage), u = HI(!1);
  return II(function() {
    c && g && A();
  }, [c, g, A]), I ? /* @__PURE__ */ O(ZC, { opened: g, onChange: (n) => {
    if (u.current) {
      u.current = !1;
      return;
    }
    b(bI.CLICK_PROFILE_MENU_AT_HEADER, {
      label: n ? "popover-open" : "popover-close"
    }), C();
  }, withArrow: !1, shadow: "md", withinPortal: !0, position: "top-end", styles: {
    dropdown: {
      width: "210px !important"
    }
  }, offset: 16, children: [
    /* @__PURE__ */ e(ZC.Target, { children: /* @__PURE__ */ e(Hg, { size: 42, radius: "xl", tabIndex: ng.MENU_LIST, "aria-label": "profile", children: /* @__PURE__ */ e(eg, { color: "red", radius: "xl", withBorder: !0, size: 12, offset: 5, disabled: i, children: /* @__PURE__ */ e(fC, { src: `${I.thumbnail}?w=84`, alt: "profile", size: 42, radius: "xl" }) }) }) }),
    /* @__PURE__ */ e(ZC.Dropdown, { children: /* @__PURE__ */ e(nZ, { setIsMenuClicked: (n) => u.current = n }) })
  ] }) : null;
}
function nZ({
  setIsMenuClicked: I
}) {
  const {
    profile: g
  } = yI(), {
    t: C
  } = MI(), {
    lang: A
  } = Yg(), {
    showNotification: c
  } = hb(), {
    data: b,
    isError: l
  } = Xb({
    queryKey: [vI.V1_USER_META],
    url: vI.V1_USER_META,
    options: {
      enabled: !!g,
      suspense: !1,
      useErrorBoundary: !1,
      staleTime: Dg(3),
      cacheTime: Dg(3)
    }
  }), {
    data: i,
    isError: u
  } = KA({
    enabled: !!g
  });
  if (II(function() {
    l && c({
      title: C("메타 정보를 불러오는데 실패했습니다."),
      message: C("잠시 후 다시 시도해주세요.")
    });
  }, [l, u, c, C]), !g)
    return null;
  const n = bZ({
    isMarketingPartners: !!g.marketingPartner,
    isB2B: g.isB2b,
    lang: A,
    point: (b == null ? void 0 : b.point) || 0,
    couponCount: (b == null ? void 0 : b.couponCount) || 0,
    hasAlarm: !!(i != null && i.hasUncheckedMessage)
  });
  return /* @__PURE__ */ O(gI, { css: /* @__PURE__ */ CI({
    [ZI("tablet")]: {
      display: "none"
    }
  }, process.env.NODE_ENV === "production" ? "" : ";label:ProfileDropdownContent;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), children: [
    /* @__PURE__ */ e($l, { onClick: () => {
      I(!0);
    } }),
    n.map(({
      items: t
    }, X) => {
      const y = X !== n.length - 1;
      return /* @__PURE__ */ O(eI, { children: [
        t.map(({
          label: s,
          icon: B,
          href: m,
          rightSection: x,
          indicator: v
        }) => /* @__PURE__ */ e(_A.Click, { eventName: bI.CLICK_PROFILE_MENU_AT_HEADER, eventData: {
          label: s
        }, children: /* @__PURE__ */ e(ZC.Item, { icon: B, rightSection: x, component: "a", href: m, onClick: () => {
          I(!0);
        }, children: v ? /* @__PURE__ */ e(gI, { display: "inline-block", children: /* @__PURE__ */ e(eg, { ...v, children: /* @__PURE__ */ e(cI, { size: 14, fw: 400, lh: "1.15", color: "gray.9", children: C(s) }) }) }) : /* @__PURE__ */ e(cI, { size: 14, fw: 400, lh: "1.15", color: "gray.9", children: C(s) }) }, s) }, s)),
        y && /* @__PURE__ */ e(Jb, { my: 5, color: "gray.2" })
      ] });
    })
  ] });
}
const $l = ({
  onClick: I
}) => {
  const {
    profile: g
  } = yI(), {
    t: C
  } = MI();
  return g ? /* @__PURE__ */ e(Tl, { eventName: bI.CLICK_PROFILE_MENU_AT_HEADER, eventData: {
    label: "profile"
  }, children: /* @__PURE__ */ e(xb, { h: 58, component: "a", styles: {
    root: {
      ":hover": {
        backgroundColor: P.gray[1],
        borderRadius: 8
      }
    }
  }, label: /* @__PURE__ */ e(Bb, { lineClamp: 1, children: /* @__PURE__ */ e(cI, { color: "gray.9", fw: 600, size: 14, children: g.name }) }), onClick: I, description: C(cZ({
    isAdmin: g.isAdmin,
    isInstructor: g.isInstructor
  })), rightSection: /* @__PURE__ */ e(K, { icon: qA.faChevronRight, size: "sm", color: "dark.7" }), icon: /* @__PURE__ */ e(fC, { radius: "xl", alt: "profile", src: g.thumbnail }), variant: "light", href: E.USER_PROFILE(g.id, g.slug) }) }) : null;
}, eZ = () => {
  const {
    t: I
  } = MI(), [g, {
    open: C,
    close: A
  }] = ql(!1);
  return /* @__PURE__ */ e(_G.Click, { events: [{
    eventName: bI.CLICK_PROFILE_MENU_AT_HEADER,
    eventData: {
      label: "profile"
    }
  }, {
    eventName: bI.CLICK_LOGIN_AT_HEADER
  }], children: /* @__PURE__ */ O(eI, { children: [
    /* @__PURE__ */ e(xb, { h: 58, component: "a", styles: {
      root: {
        ":hover": {
          backgroundColor: P.gray[1],
          borderRadius: 8
        }
      }
    }, label: /* @__PURE__ */ e(Bb, { lineClamp: 1, children: /* @__PURE__ */ e(cI, { color: "gray.9", fw: 600, size: 14, children: I("로그인 또는 회원가입") }) }), onClick: (c) => {
      c.preventDefault(), C();
    }, rightSection: /* @__PURE__ */ e(K, { icon: qA.faChevronRight, size: "sm", color: "dark.7" }), icon: /* @__PURE__ */ e(fC, { radius: "xl", alt: "profile" }), variant: "light", href: E.SIGN_IN }),
    /* @__PURE__ */ e(eb, { opened: g, onClose: A })
  ] }) });
};
function uZ({
  children: I,
  shouldCatch: g,
  message: C
}) {
  const {
    showNotification: A
  } = hb(), {
    t: c
  } = MI();
  return II(() => {
    g && A({
      title: c(C.title),
      message: c(C.content)
    });
  }, [g, C, A, c]), /* @__PURE__ */ e(eI, { children: I });
}
const tZ = ({
  opened: I,
  onClose: g,
  showLanguageSectionButton: C,
  hasNotAlarm: A
}) => /* @__PURE__ */ e(In, { size: 288, opened: I, onClose: g, "aria-label": "drawer-menu", position: "right", withCloseButton: !1, zIndex: RA().MOBILE_ASIDE, styles: {
  root: {
    display: "none",
    [ZI("tablet")]: {
      display: "block"
    }
  },
  body: {
    padding: "0px 10px 0px 10px"
  }
}, children: /* @__PURE__ */ O(PI, { pt: 8, pb: 34, w: "100%", children: [
  /* @__PURE__ */ e(jI.Login, { children: /* @__PURE__ */ e($l, {}) }),
  /* @__PURE__ */ e(jI.NotLogin, { children: /* @__PURE__ */ e(eZ, {}) }),
  /* @__PURE__ */ e(GZ, { showLanguageSectionButton: C, hasNotAlarm: A })
] }) });
function GZ({
  showLanguageSectionButton: I,
  hasNotAlarm: g
}) {
  const [C, A] = UI(!1), {
    lang: c
  } = Yg(), b = Nb(db.CREATE_COURSE_LOCALIZATION), {
    profile: l
  } = yI(), {
    data: i,
    isError: u
  } = Xb({
    queryKey: [vI.V1_USER_META],
    url: vI.V1_USER_META,
    options: {
      enabled: !!l,
      suspense: !1,
      useErrorBoundary: !1,
      staleTime: Dg(3),
      cacheTime: Dg(3)
    }
  }), n = lZ({
    profile: l,
    isMarketingPartners: !!(l != null && l.marketingPartner),
    isB2B: (l == null ? void 0 : l.isB2b) || !1,
    lang: c,
    point: (i == null ? void 0 : i.point) || 0,
    couponCount: (i == null ? void 0 : i.couponCount) || 0,
    hasAlarm: g,
    showLanguageSectionButton: I,
    isLocalizationFeatureOn: b
  });
  return /* @__PURE__ */ O(uZ, { shouldCatch: u, message: {
    title: "메타 정보를 불러오는데 실패했습니다.",
    content: "잠시 후 다시 시도해주세요."
  }, children: [
    /* @__PURE__ */ e(PI, { children: n.map(({
      menuList: t
    }, X) => {
      const y = X !== n.length - 1;
      return /* @__PURE__ */ O(gI, { component: "ul", children: [
        t.map((s) => {
          const {
            label: B,
            icon: m,
            href: x,
            rightSection: v,
            indicator: G,
            value: V,
            links: d,
            type: Z
          } = s, r = !!(d != null && d.length);
          return /* @__PURE__ */ e(gI, { component: "li", children: /* @__PURE__ */ e(_A.Click, { condition: !!V, eventName: Z === "service" ? bI.CLICK_SERVICE_MENU_AT_HEADER : bI.CLICK_PROFILE_MENU_AT_HEADER, eventData: {
            label: V
          }, children: r ? /* @__PURE__ */ e(ZZ, { icon: m, indicator: G, label: B, links: d, rightSection: v }) : /* @__PURE__ */ e(XZ, { href: x, icon: m, indicator: G, label: B, rightSection: v, onClick: (h) => {
            V === "language" && (h.preventDefault(), A.open());
          } }) }) }, B);
        }),
        y && /* @__PURE__ */ e(Jb, { my: 5, color: "gray.2" })
      ] }, X);
    }) }),
    C && /* @__PURE__ */ e(nl, { lang: c, opened: C, onClose: A.close })
  ] });
}
function ZZ({
  icon: I,
  indicator: g,
  label: C,
  links: A,
  rightSection: c,
  onClick: b
}) {
  const {
    t: l
  } = MI(), [i, {
    toggle: u
  }] = UI(!1);
  return /* @__PURE__ */ O(eI, { children: [
    /* @__PURE__ */ O(cn, { px: 16, py: 10, css: [Ii, "align-items:center;justify-content:space-between;" + (process.env.NODE_ENV === "production" ? "" : ";label:MenuItemWithLinks;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"], onClick: (n) => {
      u(), b == null || b(n);
    }, w: "100%", children: [
      /* @__PURE__ */ O(NA, { align: "center", gap: 10, children: [
        /* @__PURE__ */ e(gI, { style: {
          width: 16,
          display: "flex",
          alignItems: "center",
          justifyContent: "center"
        }, children: I }),
        g ? /* @__PURE__ */ e(gI, { display: "inline-block", children: /* @__PURE__ */ e(eg, { ...g, children: /* @__PURE__ */ e(cI, { size: 14, fw: 400, lh: "1.15", color: "gray.9", children: l(C) }) }) }) : /* @__PURE__ */ e(cI, { size: 14, fw: 400, lh: "1.15", color: "gray.9", children: l(C) }),
        c
      ] }),
      /* @__PURE__ */ e(K, { icon: wl.faAngleUp, size: "sm", color: "dark.7", css: /* @__PURE__ */ CI({
        transform: i ? "rotate(0deg)" : "rotate(180deg)"
      }, process.env.NODE_ENV === "production" ? "" : ";label:MenuItemWithLinks;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */") })
    ] }),
    /* @__PURE__ */ e(bn, { in: i, transitionDuration: 200, children: /* @__PURE__ */ e(gI, { component: "ul", pl: 24, children: A.map((n) => /* @__PURE__ */ e(gI, { component: "li", pl: 6, css: /* @__PURE__ */ CI({
      borderLeft: `1px solid ${P.gray[3]}`
    }, process.env.NODE_ENV === "production" ? "" : ";label:MenuItemWithLinks;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), children: /* @__PURE__ */ e(Rb, { href: n.href, px: 12, py: 10, w: "100%", css: /* @__PURE__ */ CI({
      "&:hover": {
        textDecoration: "none",
        backgroundColor: P.gray[0],
        borderRadius: 8
      }
    }, process.env.NODE_ENV === "production" ? "" : ";label:MenuItemWithLinks;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), children: /* @__PURE__ */ e(cI, { fw: 400, size: 14, lh: "1.15", color: "gray.9", children: n.label }) }) }, n.value)) }) })
  ] });
}
function XZ({
  href: I,
  icon: g,
  indicator: C,
  label: A,
  rightSection: c,
  onClick: b
}) {
  const {
    t: l
  } = MI();
  return /* @__PURE__ */ O(Rb, { component: "a", href: I, px: 16, py: 10, css: Ii, onClick: b, children: [
    /* @__PURE__ */ e(gI, { style: {
      width: 16,
      display: "flex",
      alignItems: "center",
      justifyContent: "center"
    }, children: g }),
    C ? /* @__PURE__ */ e(gI, { display: "inline-block", children: /* @__PURE__ */ e(eg, { ...C, children: /* @__PURE__ */ e(cI, { size: 14, fw: 400, lh: "1.15", color: "gray.9", children: l(A) }) }) }) : /* @__PURE__ */ e(cI, { size: 14, fw: 400, lh: "1.15", color: "gray.9", children: l(A) }),
    c
  ] });
}
const dZ = ({
  thumbnail: I,
  hasNotAlarm: g,
  onClick: C
}) => /* @__PURE__ */ e(Hg, { size: 36, radius: "xl", tabIndex: ng.MENU_LIST, "aria-label": "menu", onClick: C, children: /* @__PURE__ */ e(eg, { color: "red", radius: "xl", withBorder: !0, size: 12, offset: 5, disabled: g, children: /* @__PURE__ */ e(fC, { src: `${I}?w=72`, alt: "profile", size: 36, radius: "xl" }) }) }), aZ = ({
  opened: I,
  onClick: g
}) => /* @__PURE__ */ e(ln, { size: "xs", opened: I, onClick: g, "aria-label": "menu", styles: {
  root: {
    display: "none",
    alignItems: "center",
    justifyContent: "center",
    width: 36,
    height: 36,
    borderRadius: 50,
    backgroundColor: `${P.gray[0]}`,
    [ZI("tablet")]: {
      display: "flex"
    }
  }
} }), Ii = /* @__PURE__ */ CI({
  display: "flex",
  gap: 10,
  "&:hover": {
    textDecoration: "none",
    backgroundColor: P.gray[1],
    borderRadius: 8
  }
}, process.env.NODE_ENV === "production" ? "" : ";label:styleAnchor;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
function qc({
  children: I
}) {
  const {
    profile: g
  } = yI(), {
    data: C
  } = KA({
    enabled: !!g
  }), A = !(C != null && C.hasUncheckedMessage);
  return typeof I == "function" ? /* @__PURE__ */ e(eI, { children: I({
    hasNotAlarm: A
  }) }) : /* @__PURE__ */ e(eI, { children: I });
}
const $c = ({
  showLanguageSectionButton: I
}) => {
  const [g, {
    open: C,
    close: A
  }] = UI(!1);
  return /* @__PURE__ */ O(eI, { children: [
    /* @__PURE__ */ O(gI, { w: 36, h: 36, children: [
      /* @__PURE__ */ e(jI.Login, { children: ({
        profile: c
      }) => /* @__PURE__ */ e(qc, { children: ({
        hasNotAlarm: b
      }) => /* @__PURE__ */ e(dZ, { thumbnail: c.thumbnail, hasNotAlarm: b, onClick: C }) }) }),
      /* @__PURE__ */ e(jI.NotLogin, { children: /* @__PURE__ */ e(aZ, { opened: g, onClick: C }) })
    ] }),
    /* @__PURE__ */ e(qc, { children: ({
      hasNotAlarm: c
    }) => /* @__PURE__ */ e(tZ, { opened: g, onClose: A, showLanguageSectionButton: I, hasNotAlarm: c }) })
  ] });
};
var gi = {}, Ci = {};
(function(I) {
  Object.defineProperty(I, "__esModule", { value: !0 });
  var g = "far", C = "cart-shopping", A = 576, c = 512, b = [128722, "shopping-cart"], l = "f07a", i = "M24 0C10.7 0 0 10.7 0 24S10.7 48 24 48H69.5c3.8 0 7.1 2.7 7.9 6.5l51.6 271c6.5 34 36.2 58.5 70.7 58.5H488c13.3 0 24-10.7 24-24s-10.7-24-24-24H199.7c-11.5 0-21.4-8.2-23.6-19.5L170.7 288H459.2c32.6 0 61.1-21.8 69.5-53.3l41-152.3C576.6 57 557.4 32 531.1 32h-411C111 12.8 91.6 0 69.5 0H24zM131.1 80H520.7L482.4 222.2c-2.8 10.5-12.3 17.8-23.2 17.8H161.6L131.1 80zM176 512a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm336-48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z";
  I.definition = {
    prefix: g,
    iconName: C,
    icon: [
      A,
      c,
      b,
      l,
      i
    ]
  }, I.faCartShopping = I.definition, I.prefix = g, I.iconName = C, I.width = A, I.height = c, I.ligatures = b, I.unicode = l, I.svgPathData = i, I.aliases = b;
})(Ci);
(function(I) {
  Object.defineProperty(I, "__esModule", { value: !0 });
  var g = Ci;
  I.definition = {
    prefix: g.prefix,
    iconName: g.iconName,
    icon: [
      g.width,
      g.height,
      g.aliases,
      g.unicode,
      g.svgPathData
    ]
  }, I.faShoppingCart = I.definition, I.prefix = g.prefix, I.iconName = g.iconName, I.width = g.width, I.height = g.height, I.ligatures = g.aliases, I.unicode = g.unicode, I.svgPathData = g.svgPathData, I.aliases = g.aliases;
})(gi);
var Ai = {};
(function(I) {
  Object.defineProperty(I, "__esModule", { value: !0 });
  var g = Jl;
  I.definition = {
    prefix: g.prefix,
    iconName: g.iconName,
    icon: [
      g.width,
      g.height,
      g.aliases,
      g.unicode,
      g.svgPathData
    ]
  }, I.faShoppingCart = I.definition, I.prefix = g.prefix, I.iconName = g.iconName, I.width = g.width, I.height = g.height, I.ligatures = g.aliases, I.unicode = g.unicode, I.svgPathData = g.svgPathData, I.aliases = g.aliases;
})(Ai);
const VZ = "/v1/cart";
function ci(I) {
  const {
    getSnapshot: g,
    setSnapshot: C
  } = tb(), {
    lang: A
  } = Yg();
  return Qi({
    // NOTE: 타 페이지에서 해당 url로 invalidate queries를 하는 경우가 있어서 queryKey는 구버전을 유지함.
    queryKey: [VZ],
    url: Oi(uA.CLIENT_V1_CART, A),
    options: {
      suspense: !1,
      useErrorBoundary: !1,
      staleTime: Di(5),
      ...I,
      onSuccess: (c) => {
        var i, u, n, t, X, y, s;
        (i = I == null ? void 0 : I.onSuccess) == null || i.call(I, c);
        const b = ((n = (u = c == null ? void 0 : c.data) == null ? void 0 : u.items) == null ? void 0 : n.length) ?? 0, l = ((X = (t = g()) == null ? void 0 : t.profile) == null ? void 0 : X.cartCount) ?? 0;
        b !== l && C({
          profile: {
            cartCount: (s = (y = c == null ? void 0 : c.data) == null ? void 0 : y.items) == null ? void 0 : s.length
          }
        });
      }
    }
  });
}
const sZ = () => {
  var b, l, i;
  const {
    data: I,
    isLoading: g
  } = ci(), {
    trackEvent: C
  } = sI(), A = (((b = I == null ? void 0 : I.items) == null ? void 0 : b.length) ?? 0) > 9 ? "9+" : (l = I == null ? void 0 : I.items) == null ? void 0 : l.length, c = ((i = I == null ? void 0 : I.items) == null ? void 0 : i.length) ?? 0;
  return /* @__PURE__ */ e(eg, { color: "red", size: 16, offset: 6, disabled: g || c === 0, label: A, children: /* @__PURE__ */ e(Hg, { component: "a", href: E.CARTS, onClick: () => {
    C(bI.CLICK_CART_AT_HEADER, {
      course_count: c
    });
  }, variant: "light", size: "n-md", color: "gray", radius: "xl", "aria-label": `cart ${A}`, tabIndex: ng.MENU_LIST, children: /* @__PURE__ */ e(K, { icon: gi.faShoppingCart }) }) });
}, mZ = () => {
  var b, l, i;
  const {
    data: I,
    isLoading: g
  } = ci(), {
    trackEvent: C
  } = sI(), A = (((b = I == null ? void 0 : I.items) == null ? void 0 : b.length) ?? 0) > 9 ? "9+" : (l = I == null ? void 0 : I.items) == null ? void 0 : l.length, c = ((i = I == null ? void 0 : I.items) == null ? void 0 : i.length) ?? 0;
  return /* @__PURE__ */ e(eg, { color: "red", size: 16, offset: 6, disabled: g || c === 0, label: A, children: /* @__PURE__ */ e(Hg, { component: "a", href: E.CARTS, onClick: () => {
    C(bI.CLICK_CART_AT_HEADER, {
      course_count: c
    });
  }, variant: "light", size: "n-sm", color: "gray", radius: "xl", "aria-label": `cart ${A}`, tabIndex: ng.MENU_LIST, children: /* @__PURE__ */ e(K, { icon: Ai.faShoppingCart }) }) });
};
var bi = {};
(function(I) {
  Object.defineProperty(I, "__esModule", { value: !0 });
  var g = "far", C = "globe", A = 512, c = 512, b = [127760], l = "f0ac", i = "M256 464c7.4 0 27-7.2 47.6-48.4c8.8-17.7 16.4-39.2 22-63.6H186.4c5.6 24.4 13.2 45.9 22 63.6C229 456.8 248.6 464 256 464zM178.5 304h155c1.6-15.3 2.5-31.4 2.5-48s-.9-32.7-2.5-48h-155c-1.6 15.3-2.5 31.4-2.5 48s.9 32.7 2.5 48zm7.9-144H325.6c-5.6-24.4-13.2-45.9-22-63.6C283 55.2 263.4 48 256 48s-27 7.2-47.6 48.4c-8.8 17.7-16.4 39.2-22 63.6zm195.3 48c1.5 15.5 2.2 31.6 2.2 48s-.8 32.5-2.2 48h76.7c3.6-15.4 5.6-31.5 5.6-48s-1.9-32.6-5.6-48H381.8zm58.8-48c-21.4-41.1-56.1-74.1-98.4-93.4c14.1 25.6 25.3 57.5 32.6 93.4h65.9zm-303.3 0c7.3-35.9 18.5-67.7 32.6-93.4c-42.3 19.3-77 52.3-98.4 93.4h65.9zM53.6 208c-3.6 15.4-5.6 31.5-5.6 48s1.9 32.6 5.6 48h76.7c-1.5-15.5-2.2-31.6-2.2-48s.8-32.5 2.2-48H53.6zM342.1 445.4c42.3-19.3 77-52.3 98.4-93.4H374.7c-7.3 35.9-18.5 67.7-32.6 93.4zm-172.2 0c-14.1-25.6-25.3-57.5-32.6-93.4H71.4c21.4 41.1 56.1 74.1 98.4 93.4zM256 512A256 256 0 1 1 256 0a256 256 0 1 1 0 512z";
  I.definition = {
    prefix: g,
    iconName: C,
    icon: [
      A,
      c,
      b,
      l,
      i
    ]
  }, I.faGlobe = I.definition, I.prefix = g, I.iconName = C, I.width = A, I.height = c, I.ligatures = b, I.unicode = l, I.svgPathData = i, I.aliases = b;
})(bi);
const WZ = () => {
  const {
    lang: I
  } = Yg(), [g, C] = UI(!1);
  return /* @__PURE__ */ O(eI, { children: [
    /* @__PURE__ */ e(Hg, { "aria-label": "change-language", "aria-haspopup": "dialog", "aria-expanded": g, variant: "light", size: "n-md", color: "gray", radius: "xl", tabIndex: ng.MENU_LIST, onClick: C.open, children: /* @__PURE__ */ e(K, { icon: bi.faGlobe }) }),
    g && /* @__PURE__ */ e(nl, { lang: I, opened: g, onClose: C.close })
  ] });
}, oZ = () => {
  const {
    t: I
  } = BA(), {
    isKo: g
  } = Yg(), {
    trackEvent: C
  } = sI(), [A, {
    open: c,
    close: b
  }] = ql(!1), l = () => {
    C(bI.CLICK_LOGIN_AT_HEADER), c();
  };
  return /* @__PURE__ */ O(eI, { children: [
    /* @__PURE__ */ e(mC, { w: g ? 94 : "auto", variant: "light", size: "md", color: "gray", radius: "xl", tabIndex: ng.MENU_LIST, onClick: l, children: I("로그인") }),
    /* @__PURE__ */ e(eb, { opened: A, onClose: b })
  ] });
}, li = () => {
  var l, i;
  const {
    t: I
  } = MI(), {
    profile: g
  } = yI(), {
    trackEvent: C
  } = sI(), A = (g == null ? void 0 : g.isGroupManager) && ((l = g == null ? void 0 : g.managedGroup) == null ? void 0 : l.id), c = g == null ? void 0 : g.isInstructor;
  return /* @__PURE__ */ O(eI, { children: [
    !A && /* @__PURE__ */ e(mC, { component: "a", href: c ? E.INSTRUCTOR : Zb.OPEN_KNOWLEDGE, size: "md", radius: "xl", variant: "subtle", color: "gray", css: /* @__PURE__ */ CI({
      paddingRight: 12,
      paddingLeft: 12,
      [ZI("desktop")]: {
        display: "none"
      },
      [ZI("tablet")]: {
        display: "inline-block",
        height: 36,
        fontSize: 14
      }
    }, process.env.NODE_ENV === "production" ? "" : ";label:RoleButton;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), onClick: () => C(bI.CLICK_HEADER_MENU, {
      label: "instructor"
    }), children: I("지식공유") }),
    A && /* @__PURE__ */ e(sC, { children: /* @__PURE__ */ e(mC, { component: "a", href: (i = g == null ? void 0 : g.managedGroup) != null && i.id ? E.BUSINESS(g.managedGroup.id) : "#", size: "md", radius: "xl", variant: "subtle", color: "gray", css: /* @__PURE__ */ CI({
      paddingRight: 12,
      paddingLeft: 12,
      [ZI("desktop")]: {
        display: "none"
      },
      [ZI("tablet")]: {
        display: "inline-block",
        height: 36,
        fontSize: 14
      }
    }, process.env.NODE_ENV === "production" ? "" : ";label:RoleButton;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), onClick: () => C(bI.CLICK_HEADER_MENU, {
      label: "business"
    }), children: "비즈니스" }) })
  ] });
}, rZ = ({
  showLanguageSectionButton: I
}) => {
  const C = Nb(db.CREATE_COURSE_LOCALIZATION) ? nb : sC;
  return /* @__PURE__ */ O(BI, { spacing: 10, w: ab, position: "right", noWrap: !0, children: [
    /* @__PURE__ */ e(C, { children: /* @__PURE__ */ e(li, {}) }),
    /* @__PURE__ */ e(sC, { children: /* @__PURE__ */ e(qG, {}) }),
    I && /* @__PURE__ */ e(WZ, {}),
    /* @__PURE__ */ O(jI.Login, { children: [
      /* @__PURE__ */ e(sZ, {}),
      /* @__PURE__ */ e(iZ, {})
    ] }),
    /* @__PURE__ */ e(jI.NotLogin, { children: /* @__PURE__ */ e(oZ, {}) })
  ] });
}, yZ = ({
  showLanguageSectionButton: I
}) => /* @__PURE__ */ O(BI, { spacing: 8, position: "right", noWrap: !0, children: [
  /* @__PURE__ */ e(sC, { children: /* @__PURE__ */ e(li, {}) }),
  /* @__PURE__ */ O(jI.Login, { children: [
    /* @__PURE__ */ e(mZ, {}),
    /* @__PURE__ */ e($c, { showLanguageSectionButton: I })
  ] }),
  /* @__PURE__ */ e(jI.NotLogin, { children: /* @__PURE__ */ e($c, { showLanguageSectionButton: I }) })
] }), hZ = ({
  isAntMan: I
}) => {
  const {
    showMenuList: g,
    isSearchBarVisible: C
  } = Ei();
  return C ? /* @__PURE__ */ e(Pi, { children: /* @__PURE__ */ e(BI, { position: "center", css: ji({
    showMenuList: g,
    isAntMan: I
  }), children: /* @__PURE__ */ e(Mi, {}) }) }) : null;
};
function JZ() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var xZ = process.env.NODE_ENV === "production" ? {
  name: "s2a4s9",
  styles: "flex-shrink:1"
} : {
  name: "1cgzy7k-DesktopHeader",
  styles: "flex-shrink:1;label:DesktopHeader;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: JZ
};
function BZ({
  styles: I,
  showLanguageSectionButton: g,
  isAntMan: C = !1
}) {
  const {
    isTop: A
  } = _C(), c = SC(), b = Rg(() => c ? A ? "translateY(0)" : "translateY(-49px)" : "translateY(0)", [A, c]);
  return /* @__PURE__ */ O(BI, { h: 44, pos: "relative", position: "apart", align: "center", spacing: 0, noWrap: !0, w: "100%", miw: "100%", css: [/* @__PURE__ */ CI({
    [ZI("tablet")]: {
      display: "none"
    }
  }, process.env.NODE_ENV === "production" ? "" : ";label:DesktopHeader;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), I, process.env.NODE_ENV === "production" ? "" : ";label:DesktopHeader;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"], children: [
    /* @__PURE__ */ e(BI, { w: ab, align: "center", mt: -4, css: xZ, children: /* @__PURE__ */ e(Vb, {}) }),
    /* @__PURE__ */ O(gI, { css: /* @__PURE__ */ CI({
      position: "relative",
      transition: "transform 0.2s ease-out",
      transform: b
    }, process.env.NODE_ENV === "production" ? "" : ";label:DesktopHeader;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL3J1bm5lci93b3JrL2ZlLXNoYXJlZC9mZS1zaGFyZWQvcGFja2FnZXMvYXBwLXNoZWxsL3NyYy9jb21wb25lbnRzL25leHQvSGVhZGVyL0Rlc2t0b3BIZWFkZXIudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQTJEUSIsImZpbGUiOiIvaG9tZS9ydW5uZXIvd29yay9mZS1zaGFyZWQvZmUtc2hhcmVkL3BhY2thZ2VzL2FwcC1zaGVsbC9zcmMvY29tcG9uZW50cy9uZXh0L0hlYWRlci9EZXNrdG9wSGVhZGVyLnRzeCIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB0eXBlIHsgSW50ZXJwb2xhdGlvbiwgVGhlbWUgfSBmcm9tICdAZW1vdGlvbi9yZWFjdCc7XG5pbXBvcnQgeyBjc3MgfSBmcm9tICdAZW1vdGlvbi9yZWFjdCc7XG5pbXBvcnQgeyBCb3gsIEdyb3VwIH0gZnJvbSAnQGluZmxlYXJuL2RzLXJlYWN0JztcbmltcG9ydCB7IHVzZU1lbW8gfSBmcm9tICdyZWFjdCc7XG5cbmltcG9ydCB7IEhlYWRlckJyYW5kTG9nbyB9IGZyb20gJy4vY29tcG9uZW50cy9IZWFkZXJCcmFuZExvZ28nO1xuaW1wb3J0IHsgTWVudUxpc3QgfSBmcm9tICcuL2NvbXBvbmVudHMvTWVudUxpc3QnO1xuaW1wb3J0IHsgUmlnaHRTZWN0aW9uIH0gZnJvbSAnLi9jb21wb25lbnRzL1JpZ2h0U2VjdGlvbic7XG5pbXBvcnQgeyB1c2VTY3JvbGxNb2RlQ29udGV4dCB9IGZyb20gJy4vdXNlU2Nyb2xsTW9kZUNvbnRleHQnO1xuaW1wb3J0IHsgU2VhcmNoQmFyUHJvdmlkZXIgfSBmcm9tICcuL3VzZVNlYXJjaEJhckNvbnRleHQnO1xuaW1wb3J0IHsgbWVkaWFRdWVyaWVzIH0gZnJvbSAnLi4vLi4vLi4vc3R5bGVzL21lZGlhUXVlcmllcyc7XG5pbXBvcnQgeyBBcHBTaGVsbFNlYXJjaEJhciB9IGZyb20gJy4uL1NlYXJjaEJhci9BcHBTaGVsbFNlYXJjaEJhcic7XG5pbXBvcnQgeyB1c2VTZWFyY2hCYXJWaXNpYmxlIH0gZnJvbSAnLi4vdXNlU2VhcmNoQmFyVmlzaWJsZSc7XG5pbXBvcnQgeyBHTkJfU0lERV9XSURUSCB9IGZyb20gJy4vY29uc3RhbnRzJztcblxudHlwZSBEZXNrdG9wSGVhZGVyUHJvcHMgPSB7XG4gIHN0eWxlcz86IEludGVycG9sYXRpb248VGhlbWU+IHwgSW50ZXJwb2xhdGlvbjxUaGVtZT5bXTtcbiAgc2hvd0xhbmd1YWdlU2VjdGlvbkJ1dHRvbjogYm9vbGVhbjtcbiAgaXNBbnRNYW4/OiBib29sZWFuO1xufTtcblxuZXhwb3J0IGZ1bmN0aW9uIERlc2t0b3BIZWFkZXIoe1xuICBzdHlsZXMsXG4gIHNob3dMYW5ndWFnZVNlY3Rpb25CdXR0b24sXG4gIGlzQW50TWFuID0gZmFsc2UsXG59OiBEZXNrdG9wSGVhZGVyUHJvcHMpIHtcbiAgY29uc3QgeyBpc1RvcCB9ID0gdXNlU2Nyb2xsTW9kZUNvbnRleHQoKTtcbiAgY29uc3Qgc2hvdWxkU2hvd1NlYXJjaEJhciA9IHVzZVNlYXJjaEJhclZpc2libGUoKTtcblxuICBjb25zdCBtb3Rpb24gPSB1c2VNZW1vKCgpID0+IHtcbiAgICBpZiAoIXNob3VsZFNob3dTZWFyY2hCYXIpIHtcbiAgICAgIHJldHVybiAndHJhbnNsYXRlWSgwKSc7XG4gICAgfVxuXG4gICAgcmV0dXJuIGlzVG9wID8gJ3RyYW5zbGF0ZVkoMCknIDogJ3RyYW5zbGF0ZVkoLTQ5cHgpJztcbiAgfSwgW2lzVG9wLCBzaG91bGRTaG93U2VhcmNoQmFyXSk7XG5cbiAgcmV0dXJuIChcbiAgICA8R3JvdXBcbiAgICAgIGg9ezQ0fVxuICAgICAgcG9zPVwicmVsYXRpdmVcIlxuICAgICAgcG9zaXRpb249XCJhcGFydFwiXG4gICAgICBhbGlnbj1cImNlbnRlclwiXG4gICAgICBzcGFjaW5nPXswfVxuICAgICAgbm9XcmFwXG4gICAgICB3PVwiMTAwJVwiXG4gICAgICBtaXc9XCIxMDAlXCJcbiAgICAgIGNzcz17W1xuICAgICAgICBjc3Moe1xuICAgICAgICAgIFttZWRpYVF1ZXJpZXMoJ3RhYmxldCcpXToge1xuICAgICAgICAgICAgZGlzcGxheTogJ25vbmUnLFxuICAgICAgICAgIH0sXG4gICAgICAgIH0pLFxuICAgICAgICBzdHlsZXMsXG4gICAgICBdfT5cbiAgICAgIDxHcm91cCB3PXtHTkJfU0lERV9XSURUSH0gYWxpZ249XCJjZW50ZXJcIiBtdD17LTR9IGNzcz17eyBmbGV4U2hyaW5rOiAxIH19PlxuICAgICAgICA8SGVhZGVyQnJhbmRMb2dvIC8+XG4gICAgICA8L0dyb3VwPlxuICAgICAgPEJveFxuICAgICAgICBjc3M9e3tcbiAgICAgICAgICBwb3NpdGlvbjogJ3JlbGF0aXZlJyxcbiAgICAgICAgICB0cmFuc2l0aW9uOiAndHJhbnNmb3JtIDAuMnMgZWFzZS1vdXQnLFxuICAgICAgICAgIHRyYW5zZm9ybTogbW90aW9uLFxuICAgICAgICB9fT5cbiAgICAgICAgPE1lbnVMaXN0IC8+XG4gICAgICAgIDxTZWFyY2hCYXJQcm92aWRlciBzaG93TWVudUxpc3Q9e2lzVG9wfT5cbiAgICAgICAgICA8QXBwU2hlbGxTZWFyY2hCYXIgaXNBbnRNYW49e2lzQW50TWFufSAvPlxuICAgICAgICA8L1NlYXJjaEJhclByb3ZpZGVyPlxuICAgICAgPC9Cb3g+XG4gICAgICA8UmlnaHRTZWN0aW9uIHNob3dMYW5ndWFnZVNlY3Rpb25CdXR0b249e3Nob3dMYW5ndWFnZVNlY3Rpb25CdXR0b259IC8+XG4gICAgPC9Hcm91cD5cbiAgKTtcbn1cbiJdfQ== */"), children: [
      /* @__PURE__ */ e(Ki, {}),
      /* @__PURE__ */ e(sb, { showMenuList: A, children: /* @__PURE__ */ e(hZ, { isAntMan: C }) })
    ] }),
    /* @__PURE__ */ e(rZ, { showLanguageSectionButton: g })
  ] });
}
var ii = {};
(function(I) {
  Object.defineProperty(I, "__esModule", { value: !0 });
  var g = "fas", C = "circle-exclamation", A = 512, c = 512, b = ["exclamation-circle"], l = "f06a", i = "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-384c13.3 0 24 10.7 24 24V264c0 13.3-10.7 24-24 24s-24-10.7-24-24V152c0-13.3 10.7-24 24-24zM224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z";
  I.definition = {
    prefix: g,
    iconName: C,
    icon: [
      A,
      c,
      b,
      l,
      i
    ]
  }, I.faCircleExclamation = I.definition, I.prefix = g, I.iconName = C, I.width = A, I.height = c, I.ligatures = b, I.unicode = l, I.svgPathData = i, I.aliases = b;
})(ii);
function ni() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var RZ = process.env.NODE_ENV === "production" ? {
  name: "1yjx7km",
  styles: "padding:20px"
} : {
  name: "16j07t-ErrorFallback",
  styles: "padding:20px;label:ErrorFallback;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL3J1bm5lci93b3JrL2ZlLXNoYXJlZC9mZS1zaGFyZWQvcGFja2FnZXMvYXBwLXNoZWxsL3NyYy9jb21wb25lbnRzL0Vycm9yQm91bmRhcnkvRXJyb3JCb3VuZGFyeS50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBWVMiLCJmaWxlIjoiL2hvbWUvcnVubmVyL3dvcmsvZmUtc2hhcmVkL2ZlLXNoYXJlZC9wYWNrYWdlcy9hcHAtc2hlbGwvc3JjL2NvbXBvbmVudHMvRXJyb3JCb3VuZGFyeS9FcnJvckJvdW5kYXJ5LnRzeCIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IEFsZXJ0LCBJY29uIH0gZnJvbSAnQGluZmxlYXJuL2RzLXJlYWN0JztcbmltcG9ydCB7IHNvbGlkIH0gZnJvbSAnQGluZmxlYXJuL2ZvbnRhd2Vzb21lLXN2Zy1jb3JlL2ltcG9ydC5tYWNybyc7XG5pbXBvcnQgdHlwZSB7IFJlYWN0Tm9kZSB9IGZyb20gJ3JlYWN0JztcbmltcG9ydCB0eXBlIHsgRmFsbGJhY2tQcm9wcyB9IGZyb20gJ3JlYWN0LWVycm9yLWJvdW5kYXJ5JztcbmltcG9ydCB7IEVycm9yQm91bmRhcnkgYXMgUmVhY3RFcnJvckJvdW5kYXJ5IH0gZnJvbSAncmVhY3QtZXJyb3ItYm91bmRhcnknO1xuXG5pbnRlcmZhY2UgRXJyb3JCb3VuZGFyeVByb3BzIHtcbiAgY2hpbGRyZW4/OiBSZWFjdE5vZGU7XG59XG5cbmZ1bmN0aW9uIEVycm9yRmFsbGJhY2soeyBlcnJvciB9OiBGYWxsYmFja1Byb3BzKSB7XG4gIHJldHVybiAoXG4gICAgPGRpdiBjc3M9e3sgcGFkZGluZzogMjAgfX0+XG4gICAgICA8QWxlcnRcbiAgICAgICAgaWNvbj17PEljb24gaWNvbj17c29saWQoJ2NpcmNsZS1leGNsYW1hdGlvbicpfSAvPn1cbiAgICAgICAgdGl0bGU9XCLwn5qo8J+aqPCfmqjwn5qo8J+aqPCfmqhcIlxuICAgICAgICBjb2xvcj1cInJlZFwiXG4gICAgICAgIHJhZGl1cz1cIm1kXCI+XG4gICAgICAgIHsvKiBlc2xpbnQtZGlzYWJsZS1uZXh0LWxpbmUgQHR5cGVzY3JpcHQtZXNsaW50L25vLXVuc2FmZS1tZW1iZXItYWNjZXNzICovfVxuICAgICAgICA8cHJlIGNzcz17eyBmb250U2l6ZTogJzFyZW0nIH19PkVycm9yIE1lc3NhZ2U6IHtlcnJvci5tZXNzYWdlfTwvcHJlPlxuICAgICAgPC9BbGVydD5cbiAgICA8L2Rpdj5cbiAgKTtcbn1cblxuZnVuY3Rpb24gRXJyb3JCb3VuZGFyeSh7IGNoaWxkcmVuIH06IEVycm9yQm91bmRhcnlQcm9wcykge1xuICAvLyBlc2xpbnQtZGlzYWJsZS1uZXh0LWxpbmUgQHR5cGVzY3JpcHQtZXNsaW50L2Jhbi10cy1jb21tZW50XG4gIC8vIEB0cy1pZ25vcmVcbiAgcmV0dXJuIDxSZWFjdEVycm9yQm91bmRhcnkgRmFsbGJhY2tDb21wb25lbnQ9e0Vycm9yRmFsbGJhY2t9PntjaGlsZHJlbn08L1JlYWN0RXJyb3JCb3VuZGFyeT47XG59XG5cbmV4cG9ydCBkZWZhdWx0IEVycm9yQm91bmRhcnk7XG4iXX0= */",
  toString: ni
}, vZ = process.env.NODE_ENV === "production" ? {
  name: "rkiwex",
  styles: "font-size:1rem"
} : {
  name: "dg4lfm-ErrorFallback",
  styles: "font-size:1rem;label:ErrorFallback;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL3J1bm5lci93b3JrL2ZlLXNoYXJlZC9mZS1zaGFyZWQvcGFja2FnZXMvYXBwLXNoZWxsL3NyYy9jb21wb25lbnRzL0Vycm9yQm91bmRhcnkvRXJyb3JCb3VuZGFyeS50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBbUJhIiwiZmlsZSI6Ii9ob21lL3J1bm5lci93b3JrL2ZlLXNoYXJlZC9mZS1zaGFyZWQvcGFja2FnZXMvYXBwLXNoZWxsL3NyYy9jb21wb25lbnRzL0Vycm9yQm91bmRhcnkvRXJyb3JCb3VuZGFyeS50c3giLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeyBBbGVydCwgSWNvbiB9IGZyb20gJ0BpbmZsZWFybi9kcy1yZWFjdCc7XG5pbXBvcnQgeyBzb2xpZCB9IGZyb20gJ0BpbmZsZWFybi9mb250YXdlc29tZS1zdmctY29yZS9pbXBvcnQubWFjcm8nO1xuaW1wb3J0IHR5cGUgeyBSZWFjdE5vZGUgfSBmcm9tICdyZWFjdCc7XG5pbXBvcnQgdHlwZSB7IEZhbGxiYWNrUHJvcHMgfSBmcm9tICdyZWFjdC1lcnJvci1ib3VuZGFyeSc7XG5pbXBvcnQgeyBFcnJvckJvdW5kYXJ5IGFzIFJlYWN0RXJyb3JCb3VuZGFyeSB9IGZyb20gJ3JlYWN0LWVycm9yLWJvdW5kYXJ5JztcblxuaW50ZXJmYWNlIEVycm9yQm91bmRhcnlQcm9wcyB7XG4gIGNoaWxkcmVuPzogUmVhY3ROb2RlO1xufVxuXG5mdW5jdGlvbiBFcnJvckZhbGxiYWNrKHsgZXJyb3IgfTogRmFsbGJhY2tQcm9wcykge1xuICByZXR1cm4gKFxuICAgIDxkaXYgY3NzPXt7IHBhZGRpbmc6IDIwIH19PlxuICAgICAgPEFsZXJ0XG4gICAgICAgIGljb249ezxJY29uIGljb249e3NvbGlkKCdjaXJjbGUtZXhjbGFtYXRpb24nKX0gLz59XG4gICAgICAgIHRpdGxlPVwi8J+aqPCfmqjwn5qo8J+aqPCfmqjwn5qoXCJcbiAgICAgICAgY29sb3I9XCJyZWRcIlxuICAgICAgICByYWRpdXM9XCJtZFwiPlxuICAgICAgICB7LyogZXNsaW50LWRpc2FibGUtbmV4dC1saW5lIEB0eXBlc2NyaXB0LWVzbGludC9uby11bnNhZmUtbWVtYmVyLWFjY2VzcyAqL31cbiAgICAgICAgPHByZSBjc3M9e3sgZm9udFNpemU6ICcxcmVtJyB9fT5FcnJvciBNZXNzYWdlOiB7ZXJyb3IubWVzc2FnZX08L3ByZT5cbiAgICAgIDwvQWxlcnQ+XG4gICAgPC9kaXY+XG4gICk7XG59XG5cbmZ1bmN0aW9uIEVycm9yQm91bmRhcnkoeyBjaGlsZHJlbiB9OiBFcnJvckJvdW5kYXJ5UHJvcHMpIHtcbiAgLy8gZXNsaW50LWRpc2FibGUtbmV4dC1saW5lIEB0eXBlc2NyaXB0LWVzbGludC9iYW4tdHMtY29tbWVudFxuICAvLyBAdHMtaWdub3JlXG4gIHJldHVybiA8UmVhY3RFcnJvckJvdW5kYXJ5IEZhbGxiYWNrQ29tcG9uZW50PXtFcnJvckZhbGxiYWNrfT57Y2hpbGRyZW59PC9SZWFjdEVycm9yQm91bmRhcnk+O1xufVxuXG5leHBvcnQgZGVmYXVsdCBFcnJvckJvdW5kYXJ5O1xuIl19 */",
  toString: ni
};
function NZ({
  error: I
}) {
  return /* @__PURE__ */ e("div", { css: RZ, children: /* @__PURE__ */ e(yb, { icon: /* @__PURE__ */ e(K, { icon: ii.faCircleExclamation }), title: "🚨🚨🚨🚨🚨🚨", color: "red", radius: "md", children: /* @__PURE__ */ O("pre", { css: vZ, children: [
    "Error Message: ",
    I.message
  ] }) }) });
}
function ei({
  children: I
}) {
  return /* @__PURE__ */ e(vb, { FallbackComponent: NZ, children: I });
}
function pZ() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var FZ = process.env.NODE_ENV === "production" ? {
  name: "82a6rk",
  styles: "flex:1"
} : {
  name: "pzcps5-MobileHeader",
  styles: "flex:1;label:MobileHeader;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: pZ
};
function YZ({
  showLanguageSectionButton: I = !0,
  styles: g
}) {
  const {
    isTop: C
  } = _C(), A = SC();
  return /* @__PURE__ */ e(ei, { children: /* @__PURE__ */ e(hA, { fallback: /* @__PURE__ */ e(Wb, { isAntMan: !0 }), children: /* @__PURE__ */ e(ob, { children: /* @__PURE__ */ O(PI, { id: VI.HEADER_MOBILE_TOP, pos: "relative", w: "100%", css: /* @__PURE__ */ CI({
    transform: `${A && !C ? `translateY(-${fg.MOBILE.DEFAULT}px)` : "translateY(0)"}`,
    transition: "transform 0.2s ease-out"
  }, process.env.NODE_ENV === "production" ? "" : ";label:MobileHeader;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), children: [
    /* @__PURE__ */ O(BI, { css: [HZ, g == null ? void 0 : g.root, process.env.NODE_ENV === "production" ? "" : ";label:MobileHeader;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"], noWrap: !0, children: [
      /* @__PURE__ */ e(BI, { mt: -4, children: /* @__PURE__ */ e(Vb, { isMobile: !0 }) }),
      /* @__PURE__ */ e(BI, { position: "right", spacing: 8, ml: 10, noWrap: !0, css: FZ, children: /* @__PURE__ */ e(yZ, { showLanguageSectionButton: I }) })
    ] }),
    /* @__PURE__ */ e(gI, { pos: "absolute", top: mb, left: 0, right: 0, bottom: 0, children: /* @__PURE__ */ e(sb, { showMenuList: C, children: /* @__PURE__ */ e(_i, {}) }) })
  ] }) }) }) });
}
const HZ = /* @__PURE__ */ CI({
  display: "none !important",
  width: "100%",
  height: mb,
  [ZI("tablet")]: {
    display: "flex !important",
    alignItems: "center"
  }
}, process.env.NODE_ENV === "production" ? "" : ";label:styleHeaderMobile;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), zZ = ({
  showBorder: I
}) => /* @__PURE__ */ e(gI, { id: VI.HEADER_DIVIDER_DESKTOP, pos: "absolute", bottom: 0, left: 0, w: "100%", h: 1, opacity: I ? 1 : 0, css: /* @__PURE__ */ CI({
  backgroundColor: P.gray[2],
  marginBottom: -1,
  transition: "opacity 0.2s ease-out",
  [ZI("tablet")]: {
    display: "none"
  }
}, process.env.NODE_ENV === "production" ? "" : ";label:DesktopDivider;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */") }), UZ = ({
  showBorder: I
}) => /* @__PURE__ */ e(gI, { id: VI.HEADER_DIVIDER_MOBILE, pos: "absolute", bottom: 0, left: 0, w: "100%", h: 1, opacity: I ? 1 : 0, css: /* @__PURE__ */ CI({
  display: "none",
  backgroundColor: P.gray[2],
  transition: "opacity 0.2s ease-out",
  [ZI("tablet")]: {
    display: "inline-block",
    zIndex: 1
  }
}, process.env.NODE_ENV === "production" ? "" : ";label:MobileDivider;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */") }), Ib = {
  Desktop: zZ,
  Mobile: UZ
};
function LZ({
  showLanguageSectionButton: I = !0,
  styles: g,
  disabledSticky: C = !1,
  isAntMan: A = !1
}) {
  var l, i, u, n, t;
  const {
    isTop: c
  } = _C(), b = SC();
  return /* @__PURE__ */ O(eI, { children: [
    /* @__PURE__ */ O(gb, { isDesktop: !0, disabledSticky: C, isAntMan: A, styles: g, children: [
      /* @__PURE__ */ e(Ib.Desktop, { showBorder: !b || !c }),
      /* @__PURE__ */ e(gI, { w: "100%", css: [gc, (l = g == null ? void 0 : g.header) == null ? void 0 : l.container, process.env.NODE_ENV === "production" ? "" : ";label:FixedHeader;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"], children: /* @__PURE__ */ e(BZ, { isAntMan: A, styles: (u = (i = g == null ? void 0 : g.header) == null ? void 0 : i.desktop) == null ? void 0 : u.root, showLanguageSectionButton: I }) })
    ] }),
    /* @__PURE__ */ e(gb, { isDesktop: !1, disabledSticky: C, isAntMan: A, styles: g, children: /* @__PURE__ */ O(gI, { w: "100%", css: [gc, (n = g == null ? void 0 : g.header) == null ? void 0 : n.container, process.env.NODE_ENV === "production" ? "" : ";label:FixedHeader;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"], children: [
      /* @__PURE__ */ e(Ib.Mobile, { showBorder: !b || !c }),
      /* @__PURE__ */ e(YZ, { showLanguageSectionButton: I, styles: (t = g == null ? void 0 : g.header) == null ? void 0 : t.mobile })
    ] }) })
  ] });
}
const gb = ({
  isDesktop: I,
  styles: g,
  disabledSticky: C,
  isAntMan: A,
  children: c
}) => {
  var b;
  return /* @__PURE__ */ e(PI, { id: I ? VI.HEADER_CONTAINER_DESKTOP : VI.HEADER_CONTAINER_MOBILE, component: "header", justify: "start", align: "center", w: "100%", css: [SZ(C, A), {
    display: I ? "flex" : "none",
    [ZI("tablet")]: {
      display: I ? "none" : "flex"
    }
  }, (b = g == null ? void 0 : g.header) == null ? void 0 : b.root, process.env.NODE_ENV === "production" ? "" : ";label:FixedHeaderWrapper;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"], children: c });
}, SZ = (I, g) => /* @__PURE__ */ CI({
  top: 0,
  left: 0,
  right: 0,
  height: "auto",
  position: I ? "relative" : "sticky",
  zIndex: RA(g).HEADER,
  transition: "all 0.2s ease-out",
  [ZI("tablet")]: {
    height: "auto"
  }
}, process.env.NODE_ENV === "production" ? "" : ";label:styleHeaderContainer;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL3J1bm5lci93b3JrL2ZlLXNoYXJlZC9mZS1zaGFyZWQvcGFja2FnZXMvYXBwLXNoZWxsL3NyYy9jb21wb25lbnRzL25leHQvSGVhZGVyL0ZpeGVkSGVhZGVyLnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFvR0UiLCJmaWxlIjoiL2hvbWUvcnVubmVyL3dvcmsvZmUtc2hhcmVkL2ZlLXNoYXJlZC9wYWNrYWdlcy9hcHAtc2hlbGwvc3JjL2NvbXBvbmVudHMvbmV4dC9IZWFkZXIvRml4ZWRIZWFkZXIudHN4Iiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgY3NzIH0gZnJvbSAnQGVtb3Rpb24vcmVhY3QnO1xuaW1wb3J0IHsgQm94LCBkZXNrdG9wRmlyc3RRdWVyeSwgU3RhY2sgfSBmcm9tICdAaW5mbGVhcm4vZHMtcmVhY3QnO1xuXG5pbXBvcnQgeyBEZXNrdG9wSGVhZGVyIH0gZnJvbSAnLi9EZXNrdG9wSGVhZGVyJztcbmltcG9ydCB0eXBlIHsgSGVhZGVyUHJvcHMgfSBmcm9tICcuL0hlYWRlcic7XG5pbXBvcnQgeyBIRUFERVJfRUxFTUVOVF9JRFMsIHN0eWxlSGVhZGVyQ29udGVudCB9IGZyb20gJy4vc3R5bGVzJztcbmltcG9ydCB7IHVzZVNjcm9sbE1vZGVDb250ZXh0IH0gZnJvbSAnLi91c2VTY3JvbGxNb2RlQ29udGV4dCc7XG5pbXBvcnQgeyBnZXRaSW5kZXgsIG1lZGlhUXVlcmllcyB9IGZyb20gJy4uLy4uLy4uL3N0eWxlcyc7XG5pbXBvcnQgeyBNb2JpbGVIZWFkZXIgfSBmcm9tICcuLi9Nb2JpbGVIZWFkZXInO1xuaW1wb3J0IHsgdXNlU2VhcmNoQmFyVmlzaWJsZSB9IGZyb20gJy4uL3VzZVNlYXJjaEJhclZpc2libGUnO1xuaW1wb3J0IHsgSGVhZGVyRGl2aWRlciB9IGZyb20gJy4vY29tcG9uZW50cy9IZWFkZXJEaXZpZGVyJztcbmltcG9ydCB7IHVzZU1lZGlhUXVlcnkgfSBmcm9tICdAbWFudGluZS9ob29rcyc7XG5cbmV4cG9ydCBmdW5jdGlvbiBGaXhlZEhlYWRlcih7XG4gIHNob3dMYW5ndWFnZVNlY3Rpb25CdXR0b24gPSB0cnVlLFxuICBzdHlsZXMsXG4gIGRpc2FibGVkU3RpY2t5ID0gZmFsc2UsXG4gIGlzQW50TWFuID0gZmFsc2UsXG59OiB7XG4gIHNob3dMYW5ndWFnZVNlY3Rpb25CdXR0b24/OiBib29sZWFuO1xuICBzdHlsZXM/OiBIZWFkZXJQcm9wc1snc3R5bGVzJ107XG4gIGRpc2FibGVkU3RpY2t5PzogYm9vbGVhbjtcbiAgaXNBbnRNYW4/OiBib29sZWFuO1xufSkge1xuICBjb25zdCB7IGlzVG9wIH0gPSB1c2VTY3JvbGxNb2RlQ29udGV4dCgpO1xuICBjb25zdCBzaG91bGRTaG93U2VhcmNoQmFyID0gdXNlU2VhcmNoQmFyVmlzaWJsZSgpO1xuXG4gIHJldHVybiAoXG4gICAgPD5cbiAgICAgIDxGaXhlZEhlYWRlcldyYXBwZXJcbiAgICAgICAgaXNEZXNrdG9wPXt0cnVlfVxuICAgICAgICBkaXNhYmxlZFN0aWNreT17ZGlzYWJsZWRTdGlja3l9XG4gICAgICAgIGlzQW50TWFuPXtpc0FudE1hbn1cbiAgICAgICAgc3R5bGVzPXtzdHlsZXN9PlxuICAgICAgICA8SGVhZGVyRGl2aWRlci5EZXNrdG9wIHNob3dCb3JkZXI9eyFzaG91bGRTaG93U2VhcmNoQmFyIHx8ICFpc1RvcH0gLz5cbiAgICAgICAgPEJveCB3PVwiMTAwJVwiIGNzcz17W3N0eWxlSGVhZGVyQ29udGVudCwgc3R5bGVzPy5oZWFkZXI/LmNvbnRhaW5lcl19PlxuICAgICAgICAgIDxEZXNrdG9wSGVhZGVyXG4gICAgICAgICAgICBpc0FudE1hbj17aXNBbnRNYW59XG4gICAgICAgICAgICBzdHlsZXM9e3N0eWxlcz8uaGVhZGVyPy5kZXNrdG9wPy5yb290fVxuICAgICAgICAgICAgc2hvd0xhbmd1YWdlU2VjdGlvbkJ1dHRvbj17c2hvd0xhbmd1YWdlU2VjdGlvbkJ1dHRvbn1cbiAgICAgICAgICAvPlxuICAgICAgICA8L0JveD5cbiAgICAgIDwvRml4ZWRIZWFkZXJXcmFwcGVyPlxuICAgICAgPEZpeGVkSGVhZGVyV3JhcHBlclxuICAgICAgICBpc0Rlc2t0b3A9e2ZhbHNlfVxuICAgICAgICBkaXNhYmxlZFN0aWNreT17ZGlzYWJsZWRTdGlja3l9XG4gICAgICAgIGlzQW50TWFuPXtpc0FudE1hbn1cbiAgICAgICAgc3R5bGVzPXtzdHlsZXN9PlxuICAgICAgICA8Qm94IHc9XCIxMDAlXCIgY3NzPXtbc3R5bGVIZWFkZXJDb250ZW50LCBzdHlsZXM/LmhlYWRlcj8uY29udGFpbmVyXX0+XG4gICAgICAgICAgPEhlYWRlckRpdmlkZXIuTW9iaWxlIHNob3dCb3JkZXI9eyFzaG91bGRTaG93U2VhcmNoQmFyIHx8ICFpc1RvcH0gLz5cbiAgICAgICAgICA8TW9iaWxlSGVhZGVyXG4gICAgICAgICAgICBzaG93TGFuZ3VhZ2VTZWN0aW9uQnV0dG9uPXtzaG93TGFuZ3VhZ2VTZWN0aW9uQnV0dG9ufVxuICAgICAgICAgICAgc3R5bGVzPXtzdHlsZXM/LmhlYWRlcj8ubW9iaWxlfVxuICAgICAgICAgIC8+XG4gICAgICAgIDwvQm94PlxuICAgICAgPC9GaXhlZEhlYWRlcldyYXBwZXI+XG4gICAgPC8+XG4gICk7XG59XG5cbmNvbnN0IEZpeGVkSGVhZGVyV3JhcHBlciA9ICh7XG4gIGlzRGVza3RvcCxcbiAgc3R5bGVzLFxuICBkaXNhYmxlZFN0aWNreSxcbiAgaXNBbnRNYW4sXG4gIGNoaWxkcmVuLFxufToge1xuICBpc0Rlc2t0b3A6IGJvb2xlYW47XG4gIHN0eWxlczogSGVhZGVyUHJvcHNbJ3N0eWxlcyddO1xuICBkaXNhYmxlZFN0aWNreTogYm9vbGVhbjtcbiAgaXNBbnRNYW46IGJvb2xlYW47XG4gIGNoaWxkcmVuOiBSZWFjdC5SZWFjdE5vZGU7XG59KSA9PiB7XG4gIHJldHVybiAoXG4gICAgPFN0YWNrXG4gICAgICBpZD17XG4gICAgICAgIGlzRGVza3RvcFxuICAgICAgICAgID8gSEVBREVSX0VMRU1FTlRfSURTLkhFQURFUl9DT05UQUlORVJfREVTS1RPUFxuICAgICAgICAgIDogSEVBREVSX0VMRU1FTlRfSURTLkhFQURFUl9DT05UQUlORVJfTU9CSUxFXG4gICAgICB9XG4gICAgICBjb21wb25lbnQ9XCJoZWFkZXJcIlxuICAgICAganVzdGlmeT1cInN0YXJ0XCJcbiAgICAgIGFsaWduPVwiY2VudGVyXCJcbiAgICAgIHc9XCIxMDAlXCJcbiAgICAgIGNzcz17W1xuICAgICAgICBzdHlsZUhlYWRlckNvbnRhaW5lcihkaXNhYmxlZFN0aWNreSwgaXNBbnRNYW4pLFxuICAgICAgICB7XG4gICAgICAgICAgZGlzcGxheTogaXNEZXNrdG9wID8gJ2ZsZXgnIDogJ25vbmUnLFxuICAgICAgICAgIFttZWRpYVF1ZXJpZXMoJ3RhYmxldCcpXToge1xuICAgICAgICAgICAgZGlzcGxheTogaXNEZXNrdG9wID8gJ25vbmUnIDogJ2ZsZXgnLFxuICAgICAgICAgIH0sXG4gICAgICAgIH0sXG4gICAgICAgIHN0eWxlcz8uaGVhZGVyPy5yb290LFxuICAgICAgXX0+XG4gICAgICB7Y2hpbGRyZW59XG4gICAgPC9TdGFjaz5cbiAgKTtcbn07XG5cbmNvbnN0IHN0eWxlSGVhZGVyQ29udGFpbmVyID0gKGRpc2FibGVkU3RpY2t5OiBib29sZWFuLCBpc0FudE1hbjogYm9vbGVhbikgPT5cbiAgY3NzKHtcbiAgICB0b3A6IDAsXG4gICAgbGVmdDogMCxcbiAgICByaWdodDogMCxcbiAgICBoZWlnaHQ6ICdhdXRvJyxcbiAgICBwb3NpdGlvbjogZGlzYWJsZWRTdGlja3kgPyAncmVsYXRpdmUnIDogJ3N0aWNreScsXG4gICAgekluZGV4OiBnZXRaSW5kZXgoaXNBbnRNYW4pLkhFQURFUixcbiAgICB0cmFuc2l0aW9uOiAnYWxsIDAuMnMgZWFzZS1vdXQnLFxuICAgIFttZWRpYVF1ZXJpZXMoJ3RhYmxldCcpXToge1xuICAgICAgaGVpZ2h0OiAnYXV0bycsXG4gICAgfSxcbiAgfSk7XG4iXX0= */");
function fZ() {
  if (vA()) {
    const I = window.__DS__, g = window.__DS_MODALS__;
    if (!I)
      throw new Error("Please set DS ThemeProvider.");
    if (!g)
      throw new Error("Please set DS ModalsProvider.");
  }
}
function FX({
  isAntMan: I = !1,
  disabledSticky: g,
  showLanguageSectionButton: C,
  showHeaderNotice: A = !0,
  styles: c
}) {
  return fZ(), /* @__PURE__ */ e(ei, { children: /* @__PURE__ */ e(hA, { fallback: /* @__PURE__ */ e(Wb, { isAntMan: I }), children: /* @__PURE__ */ e(ob, { children: /* @__PURE__ */ e(TZ, { showHeaderNotice: A, disabledSticky: g, showLanguageSectionButton: C, styles: c, isAntMan: I }) }) }) });
}
function TZ({
  showHeaderNotice: I = !0,
  disabledSticky: g = !1,
  showLanguageSectionButton: C = !0,
  styles: A,
  isAntMan: c = !1
}) {
  return /* @__PURE__ */ e(OG, { notice: I && /* @__PURE__ */ e(jG, { isAntMan: c }), disabledSticky: g, children: /* @__PURE__ */ e(LZ, { showLanguageSectionButton: C, styles: A, disabledSticky: g, isAntMan: c }) });
}
export {
  fu as $,
  bX as A,
  NI as B,
  ZX as C,
  nX as D,
  eX as E,
  yX as F,
  CX as G,
  FX as H,
  BX as I,
  au as J,
  LI as K,
  aX as L,
  RX as M,
  hX as N,
  oX as O,
  dX as P,
  WX as Q,
  mX as R,
  NX as S,
  sX as T,
  eA as U,
  uX as V,
  lt as W,
  KI as X,
  cX as a,
  JX as b,
  Wn as c,
  tn as d,
  vX as e,
  Fb as f,
  pX as g,
  yn as h,
  AX as i,
  YG as j,
  HG as k,
  Jl as l,
  KA as m,
  vG as n,
  Wu as o,
  Bu as p,
  GX as q,
  iX as r,
  IA as s,
  rn as t,
  xX as u,
  tX as v,
  XX as w,
  rX as x,
  VX as y,
  lX as z
};
